import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        debug: true,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        resources: {
            en: {
                translation: {
                    dashboard: {
                        nameIdentifier: "Name or identifier",
                        efficiencyAll: "Efficiency of all machines",
                        onlyErrors: "Only errors",
                        toggleDisconnected: "Toggle disconnected machines",
                        productionCombined: "Combined production (Wh)",
                        realisedTechnicalEfficiency: "Realised / Technical efficiency (%)",
                        efficiencyCombined: "Realised efficiency (%)",
                        technicalEfficiencyCombined: "Technical efficiency (%)",
                        bgp: "Bgp (m³/ton)",
                        consumption: "Consumption (Wh)",
                        manureLifeTime: "Manure life time (days)",
                        feeding: "Feeding (kg)"
                    },
                    common: {
                        on: "On",
                        off: "Off",
                        add: "Add",
                        save: "Save",
                        monday: "Monday",
                        tuesday: "Tuesday",
                        wednesday: "Wednesday",
                        thursday: "Thursday",
                        friday: "Friday",
                        saturday: "Saturday",
                        sunday: "Sunday",
                        from: "From",
                        to: "To",
                        hours: "hours",
                        reset: "Reset",
                        confirmation: "Confirmation",
                        cancel: "Cancel",
                        yesIAmSure: "Yes, I am sure",
                        set: "Adjust",
                        auto: "Auto",
                        manual: "Manual",
                        minutes: "minutes",
                        seconds: "seconds",
                        turnOn: "Turn on",
                        turnOff: "Turn off",
                        graphLoading: "Graphs loading...",
                        noData: "No data Available...",
                        hoursPerYear: "hours / year",
                        datetime: "Datetime",
                        warning: "Warning",
                        error: "Error",
                        type: "Type",
                        startdate: "Start date",
                        enddate: "End date",
                        all: "All",
                        engine1: "Engine 1",
                        engine2: "Engine 2",
                        ongoing: "Ongoing",
                        both: "Both",
                        days: "Days",
                        today: "Today",
                        sendAnswers: "Send answers",
                        employee: "Employee",
                        customer: "Customer",
                        sales: "Sales",
                        technician: "Technician",
                        admin: "Admin",
                        noDateKnown: "No date known",
                        command: "Command",
                        user: "User",
                        fillInSurvey: "Please fill in the survey",
                        tons: "tons",
                        count: "Count",
                        disabled: "Disabled",
                        addField: "Add field",
                        deleteField: "Delete field",
                        releases: "Release notes",
                        open: "Open",
                        close: "Close",
                        opening: "Opening",
                        closing: "Closing",
                        zoomCancel: "Zoom cancelled, stay inside the graph to zoom",
                        stuck: "Stuck",
                        edit: "Edit",
                        delete: "Delete",
                        update: "Update",
                        actions: "Actions",
                        loading: "Loading..."
                    },
                    errorPage: {
                        title: "Something went wrong.",
                        contact: "Please report this problem to it@biolectric.com and mention which phone or browser you are using.",
                        reload: "Reload"
                    },
                    popups: {
                        engineIdle: "Engine is not idle, please turn of the engine first",
                        valueBetween: "Value must be between {{min}} and {{max}}",
                        valueBetweenCustom: "Value must be between {{min}} and {{max}}",
                        powerTooLow: "The power cannot be set lower than {{watts}}W",
                        powerTooHigh: "The power cannot be set higher than {{maxPower}}",
                        maxCoolingTemp: "Cannot be greater than {{max}}°C",
                        minValue: "Cannot be less than {{min}}",
                        maxAirInjectionTime: "Cannot be greater than {{max}} seconds",
                        minGasBuffer: "Min Gas Buffer Out Of Range. Minimum value for your installation is {{min}}",
                        maxGasBuffer: "Max Gas Buffer Out Of Range. Maximum value for your installation is {{max}}",
                        reactorTemp: "Reactor temperature out of range. Must be between {{min}} and {{max}}",
                        reactorLevel: "Illegal Reactor Level. Maximum value for your installation is {{limit}}",
                        reactorLevelRange: "Value setting the level of the reactor must be between {{min}} and {{max}}",
                        commandFailed: "Failed to send command",
                        commandSent: "Command sent",
                        commandSuccess: "You have successfully updated {{command}} from {{previousValue}} to {{value}}",
                        commandMix1Hour: "The mixer will run for 1 hour",
                    },
                    menu: {
                        dashboard: 'Dashboard',
                        machines: 'Machines',
                        questionnaires: 'Questionnaires',
                        banners: "Banners",
                        errors: "Errors and warnings",
                        pcb: "Printed circuit boards",
                        tasks: "My tasks",
                        installationTasks: "Installation tasks",
                        releases: "Release notes",
                        resellers: "Resellers",
                        users: "Users",
                        recommendations: "Recommendations",
                        suggestions: "Recommendation messages",
                        faultTrees: "Fault trees",
                        assistant: "Assistant",
                        language: "Language",
                        reconnection: "This machine is currently offline. Try getting a new connection with the button below.",
                        profile: "Profile",
                        logout: "Log out",
                        firmware: "Firmware",
                        sms: "SMS",
                        advanced: "Advanced",
                        errorsSingle: "Errors",
                        warnings: "Warnings",
                        blockMachineTitle: "Block machine",
                        blockMachineReasonLabel: "Reason for blocking",
                        blockMachineReasonPlaceholder: "Select a reason…",
                        blockMachineDateLabel: "Blocked since",
                        blockMachineBlockedBy: "Blocked by",
                        blockMachineConfirm: "Block machine",
                        blockMachineReasonRequired: "Please select a reason for blocking.",
                        blockMachineDateRequired: "Please select a blocked date.",
                        blockMachineReasons: {
                            economically_not_viable: "Economically no longer viable – major investments required",
                            operational_burden_high: "Operational burden too high – daily activities take too much time",
                            technical_reliability_insufficient: "Technical reliability insufficient – e.g. continuous malfunctions, no confidence that Biolectric can resolve them",
                            farm_structure_changes: "Farm structure changes – change in business model or manure availability",
                            human_family_factors: "Human / family factors – loss of motivation, health problems, no succession",
                            regulations_permits: "Regulations & permits – restrictions or changes beyond the farmer's control",
                            replaced_by_new_installation: "Replaced by new Biolectric installation",
                            waiting_for_commissioning: "Waiting for commissioning",
                        },
                    },
                    statistics: {
                        label: "Statistics",
                        foamBeaterThermalStatus: "Foam beater thermal protection",
                        exitPumpThermalStatus: "Exit pump thermal protection",
                        thermalStatusOk: "Thermal protection not active, consumer can operate normally",
                        thermalStatusFault: "Thermal protection active, consumer in fault",
                        group1: "Group 1",
                        group2: "Group 2",
                        addProperty: "Add property",
                        removeProperty: "Remove Property",
                        startTutorial: "Start tutorial",
                        exitTutorial: "Exit tutorial",
                        welcomeStep: {
                            title: "Welcome to the statistics page",
                            content: "Here, you can compare different values and trends with ease."
                        },
                        propertyStep: {
                            title: "Property selection",
                            content: "To get started, simply select a property that interests you from the select box."
                        },
                        addPropertyStep: {
                            title: "Adding and removing properties",
                            content: "Try adding or removing a property, you can add up to 4 properties per group."
                        },
                        groupStep: {
                            title: "Enabling group 2",
                            content: "Click the 'Add Property' button to select a property for Group 2. Properties in this group will be shown on the right side of the graph."
                        },
                        dateRangeStep: {
                            title: "Selecting a date range",
                            content: "Use this button to choose a date range."
                        },
                        zoomInStep: {
                            title: "Zooming in",
                            content: "Drag your mouse over the graph to select an area for zooming in."
                        },
                        zoomOutStep: {
                            title: "Zooming out",
                            content: "Reset to the previously selected date range by using the 'Zoom Out' button."
                        },
                        domainStep: {
                            title: "Adjusting domains",
                            content: "You can customize the maximum and minimum domain per group by using these buttons."
                        },
                        csvStep: {
                            title: "Download csv data",
                            content: "Download the currently displayed graph data in CSV format"
                        },
                        imageStep: {
                            title: "Download image",
                            content: "Download the currently displayed graph as an image"
                        },
                        configurationStep: {
                            title: "Preset configuration",
                            content: "You can save your current configuration as a preset. You can also update existing presets or delete them."
                        },
                        controlCardTemp: "Control card temperature",
                        lowTensionError: "Low tension error",
                        overTempFlueGasHeatExch: "Over temperature flue gas heat exchanger",
                        feedingCycleLevel: "Feeding cycle level",
                        batteryVoltage: "Battery voltage",
                        waterPressure: "Water pressure",
                        shortInterval: "10 Minute Intervals",
                        dailyInterval: "Daily Intervals",
                        configurationUpdated: "Your current configuration has been saved to this preset",
                        presets: "Presets",
                        savePreset: "Save as preset",
                        applyPreset: "Apply preset",
                        updatePreset: "Update preset",
                        delete: "Delete",
                        noPresets: "You dont have any presets yet",
                        givePresetName: "Give your preset a name",
                    },
                    smart: {
                        label: "Smart",
                        heightOffset: "Height offset",
                        active: "Active",
                        passive: "Passive",
                        preActive: "Pre Active",
                        prePassive: "Pre Passive",
                        postActive: "Post Active",
                        postPassive: "Post Passive",
                        activeDesc: "During an active period, the planned energy production is maximized. Before each active period, a “pre-active” time slot is automatically provided in which the gas buffer is built up. The maximum duration of an active period is determined by the volume of the gas buffer, the number and type of installed CHP(s) and the biogas production profile of the installation. When the minimum filling level of the gas buffer is reached, energy production will be stopped (post-active period).",
                        passiveDesc: "During a passive period, energy is only produced if there is a surplus of gas. Before each passive period, a time slot is automatically provided during which the gas buffer is reduced. The maximum duration of a passive period is determined by the volume of the gas buffer and the biogas production profile of the installation. When the maximum filling level of the gas buffer is reached, energy production will start (post-passive period).",
                        permanence: "Stimulate constant production by dynamically running on one engine with a non-maximum gas buffer",
                        permanency: "Permanence",
                        copyToAllDays: "Copy to all days",
                        copyToWeekdays: "Copy to weekdays",
                        copyToWeekend: "Copy to weekend days",
                        activateStep: {
                            title: "Activating SMART",
                            content: "Activate SMART to control the production profile of the installation"
                        },
                        timeslotStep: {
                            title: "Add time slot",
                            content: "Add an active or passive time slot"
                        },
                        fromToStep: {
                            title: "From / To",
                            content: "You set both the start and end day and time"
                        },
                        activePassiveStep: {
                            title: "Active or Passive",
                            content: "Select whether you want to set an active or passive time slot"
                        },
                        saveStep: {
                            title: "Save time slots",
                            content: "Save your changed settings"
                        },
                        removeStep: {
                            title: "Remove time slots",
                            content: "Remove your time slot here"
                        },
                        visualStep: {
                            title: "Visual representation",
                            content: "This graph compares the SMART settings with the production profile of the past week"
                        },
                        daySwitchStep: {
                            title: "Visual representation",
                            content: "Easily navigate to the next or previous day"
                        },
                    },
                    gas: {
                        label: "Gas",
                        minGasBufferLevel: "Gas buffer min",
                        maxGasBufferLevel: "Gas buffer max",
                        gasBufferLevel: "Actual gas buffer ",
                        defaultMinGasBufferLevel: "Default gas buffer min",
                        defaultMaxGasBufferLevel: "Default gas buffer max",
                        airInjectionTime: "Aeration",
                        airConcentratorMinutesPerHour: "Air concentrator (min/hour)",
                        maxAirInjectionTime: "Max aeration",
                        airIndexManual: "Aeration control",
                        maxLimitH2SAeration: "H₂S max limit (decrease aeration)",
                        minLimitH2SAeration: "H₂S min limit (increase aeration)",
                        torch: "Flare",
                        torchType: "Flare type",
                        torchStatus: "Flare status",
                        torchError: "Flare error",
                        theoreticalTorchFlow: "Theoretical flare flow",
                        torchRunningTime: "Flare time",
                        torchFlaredVolume: "Flared volume",
                        h2s: "H₂S",
                        h2sLevelReactor: "H₂S reactor",
                        h2sLevelMotor: "H₂S engine",
                        filterLoad: "Carbon filter load",
                        filterLoad2: "Carbon filter load 2",
                        sample: "Sample",
                        latestH2sReadings: "Latest H₂S readings",
                        carbonFilterSize: "Carbon filter size",
                        h2sMeasurements: "H₂S measurements",
                        measurements: "Measurements",
                        changeTo: "Change to",
                        none: "None",
                        container: "Container",
                        extern: "Extern",
                        foamBeaterInstalled: "Foam beater installed",
                        antiFoamInjectionsInstalled: "Anti foam injections installed",
                        containerCombinedOperation: "Container (combined operation)",
                        externCombinedOperation: "Extern (combined operation)",
                        gasTemp: "T1 Temperature After Gascooler",
                        ch4BiogasSupply: "CH4 biogas supply",
                        co2BiogasSupply: "CO2 biogas supply",
                        o2BiogasSupply: "O2 biogas supply",
                        h2sAfterFilter: "H2S after filter",
                        biomethaneFlowNorm: "Biomethane flow norm",
                        ch4Biomethane: "CH4 biomethane",
                        co2Biomethane: "CO2 biomethane",
                        o2Biomethane: "O2 biomethane",
                        h2sBiomethane: "H2S biomethane",
                        bufferRelease: "Buffer release",
                        wobbe: "Wobbe",
                        wobbeAvg: "Wobbe avg",
                        wobbePidSetpoint: "Wobbe pid setpoint",
                        wobbeBiomethanePronova: "Wobbe biomethane pronova",
                    },
                    engine: {
                        label: "engine",
                        startEngine: "Start Engine",
                        stopEngine: "Stop Engine",
                        power: "Power",
                        desiredPower: "Set Power",
                        maxPower: "Maximum power",
                        rpm: "Rotations per minute (RPM)",
                        lambda: "Lambda",
                        throttleValve: "Servo position",
                        engineType: "Engine type",
                        engineStatus: "Engine status",
                        engineError: "Engine Errors",
                        producedEnergy: "Total energy produced",
                        operatingHours: "Operating hours",
                        totalOperatingHours: "Total operating hours",
                        gasUsage: "Gas consumption",
                        throttlePosition: "Throttle position",
                        noErrors: "All systems operational.",
                        production: "Production",
                        servoManually: "Servo is set manually",
                        servoAuto: "Servo is set automatically",
                        servoControl: "Servo control",
                        temperature: "Engine Temperature",
                        restart: "Restart automatically when gas available.",
                        confirmStop: "Are you sure you want to stop engine {{number}}?",
                        confirmStopRestart: "Are you sure you want to stop engine {{number}}? It will restart automatically when gas is available.",
                        idle: "Idle",
                        running: "Running",
                        waiting: "Waiting for boot up",
                        booting: "Booting up",
                        shuttingDown: "Shutting down",
                        advanced: "Advanced",
                        numberOfEngines: "Number of engines",
                        predeterminedRunHours: "Predetermined run hours",
                        easyStart1: "Easy start engine 1",
                        easyStart2: "Easy start engine 2",
                        setError1: "Set error engine 1",
                        setError2: "Set error engine 2",
                        fuel: "Fuel",
                        airIntakeOpen: "Air intake open",
                        airIntakeClosed: "Air intake closed",
                        vfd: "VFD",
                    },
                    service: {
                        label: "Service",
                        lastMaintenance: "Operating hours until next oil change",
                        currentlyInstalled: "Operating hours currently installed",
                        total: "Total operating hours",
                        mixer: "Mixer",
                        foam_beater: "Foam beater",
                        intake_pump: "Intake pump",
                        digestate_pump: "Digestate pump",
                        newEngine: "New engine installed",
                        newMixer: "New mixer installed",
                        newEngine: "New engine installed",
                        newFoamBeater: "New foam beater installed",
                        newIntakePump: "New intake pump installed",
                        newDigestatePump: "New digestate pump installed",
                        confirmationMessage: "Are you sure you want to reset the {{type}}",
                        maintenanceMessage: "Maintenance hours has been reset for {{type}}",
                        newEquipmentMessage: "New equipment installed:",
                        prints: "Prints",
                        firstOnline: "First online",
                        lastOnline: "Last online",
                        serial: "Serial",
                        type: "Type",
                        engine: "Engine",
                        engine1: "Engine 1",
                        engine2: "Engine 2",
                        engine_new1: "Engine 1",
                        engine_new2: "Engine 2",
                        h2s1: "H₂S Engine 1",
                        h2s2: "H₂S Engine 2",
                        resetTo: "Reset to x hours (default 0)",
                        timeFilterReplace: "Time since filter replacement",
                        daysSinceOil: "Days since oil change",
                        newGenerator: "New generator installed",
                        generator: "Generator",
                        generator1: "Generator 1",
                        generator2: "Generator 2",
                        daysSinceOilChange: "Days since oil change",
                        videoMessage: "Video on changing oil => Documents page, under General videos.",
                        videoRoom: "A service technician has opened a video room for this machine, Click here to join",
                        videoButton: "Start a video room for this machine",
                        videoButtonSub: "Users with access can join the call from their service page",
                        videoClose: "Close video room",
                        serialNumber: "Serial number",
                        defaultEngineReset: "Default engine reset",
                        newInstalled: "New {{type}} installed",
                        replace: "Replace",
                        aircover: "Air cover",
                        gascover: "Gas cover",
                        liner: "Liner",
                        flow_meter: "Flow meter",
                        energy_meter1: "Energy meter 1",
                        energy_meter2: "Energy meter 2",
                        energy_meter_own: "Energy meter own consumption",
                        h2sPastille: "Time until H2S sensor replacement",
                        pastille1: "H₂S sensor 1",
                        pastille2: "H₂S sensor 2",
                        engineLabel: "Next engine maintenance after “XX” hours",
                        engine1Conf: "Reset the maintenance interval for engine 1 only after engine maintenance has been performed",
                        engine2Conf: "Reset the maintenance interval for engine 2 only after engine maintenance has been performed",
                        h2s1Conf: "Reset H2S Engine 1 only when the activated carbon in the filter has been replaced",
                        h2s2Conf: "Reset H2S Engine 2 only when the activated carbon in the filter has been replaced",
                        filterResetOffline: "Machine is offline. The filter reset was not saved. Reconnect and try again.",
                        filterResetFailed: "Filter reset failed. The filter reset was not saved.",
                        consumables: {
                            title: "Consumables",
                            belowMin: "Below minimum stock",
                            noneBelow: "No articles below minimum stock",
                            notCounted: "Not counted yet",
                            article: "Article number",
                            description: "Description",
                            onSite: "On site",
                            minimum: "Minimum",
                            engineMaintenance: "Engine maintenance",
                            pendingStock: "{{confirmed}} confirmed + {{pending}} pending validation",
                            send: "Send",
                            shipmentSaved: "Shipment saved. It stays pending until the client confirms it.",
                            shipmentFailed: "Could not save the shipment",
                            confirm: "Confirm receipt",
                            confirmSaved: "Stock confirmed",
                            confirmFailed: "Could not confirm the stock",
                            confirmHint: "Confirm the delivery to add it to the stock on site.",
                            guideTitle: "How this works",
                            guideIntro: "Oil, oil filters and spark plugs stay on each installation. The service page of the installation and this orders page share the same stock.",
                            guide1Role: "Technician",
                            guide1Title: "Count what is on site",
                            guide1Body: "On the installation service page, open Consumables and enter how much of each article is actually present. Saving that count confirms it immediately. A count made on site does not wait for anyone else.",
                            guide2Role: "Automatic",
                            guide2Title: "Engine maintenance uses stock",
                            guide2Body: "Registering engine maintenance subtracts the usage for that engine from the confirmed stock.",
                            guide3Role: "Service manager",
                            guide3Title: "Send what is missing",
                            guide3Body: "This page lists installations whose confirmed stock is at or below the minimum. Enter the quantity to ship and press Send. It stays pending, for example 0.5 confirmed + 5 pending validation, and is not counted as stock yet. The minimum is set per engine type. An installation uses the sum of its installed engines, rounded to a whole number. One piece of oil is one 25 l can.",
                            guide4Role: "Anyone with access",
                            guide4Title: "Confirm the delivery",
                            guide4Body: "When the goods are on site, the client, a technician or an employee confirms receipt on the installation service page. The pending quantity is added to the confirmed stock. 0.5 confirmed and 5 pending then become 5.5 on site.",
                            correction: "Stock correction",
                            save: "Save stock count",
                            saved: "Stock count saved",
                            saveFailed: "Could not save the stock count",
                            minSaved: "Minimum stock saved",
                            minFailed: "Could not save the minimum stock",
                            minHint: "Set the minimum per engine type. An installation uses the sum of its installed engines, rounded to a whole number. It is listed when stock is less than or equal to that minimum. One piece of oil is one 25 l can.",
                            usage: "Usage per engine maintenance",
                            usageHint: "Registering engine maintenance subtracts this usage from the counted stock. DF972 and WG972 share the WG972 column. WG3800-L uses the WG3800 column.",
                            orders: "Service consumables overview",
                            ordersEmpty: "No installations are at or below minimum stock",
                            shortage: "Shortage",
                            installation: "Installation",
                            engines: "Engines",
                        },
                        membranes: {
                            title: "Membranes",
                            overview: "All membranes",
                            overviewTitle: "Installed membranes overview",
                            searchPlaceholder: "Search installation, product, charge, housing…",
                            search: "Search",
                            installation: "Installation",
                            stage: "Stage",
                            scpCo2: "SCP CO2",
                            percent: "%",
                            scpO2: "SCP O2",
                            selO2N2: "Sel O2/N2",
                            selCo2Ch4: "Sel CO2/CH4",
                            scpCo2N: "SCP CO2_n",
                            productName: "Product name",
                            productCode: "Product code",
                            chargeNo: "Charge No.",
                            housingNo: "Housing No.",
                            installationDate: "Installation date",
                            addRow: "Add membrane",
                            none: "No membranes registered",
                            fetchError: "Could not load membranes",
                            saved: "Membrane saved",
                            added: "Membrane added",
                            saveError: "Could not save membrane",
                            deleteConfirm: "Delete this membrane?",
                            deleted: "Membrane deleted",
                            deleteError: "Could not delete membrane",
                        },
                        pastille1Conf: "Reset the lifespan of H2S sensor 1 only when the sensor element has been replaced.",
                        pastille2Conf: "Reset the lifespan of H2S sensor 2 only when the sensor element has been replaced.",
                        pastilleLabel: "Expected sensor element lifespan XX days",
                        valve_interval: "Operating hours until valve clearance check",
                        cylinder_interval: "Operating hours until cylinder head overhaul",
                        valve_interval_engine1: "Operating hours until valve clearance check engine 1",
                        cylinder_interval_engine1: "Operating hours until cylinder head overhaul engine 1",
                        valve_interval_engine2: "Operating hours until valve clearance check engine 2",
                        cylinder_interval_engine2: "Operating hours until cylinder head overhaul engine 2",
                        pipe: "Pipe",
                        transmitter: "Transmitter",
                        elektromotor: "Electric motor",
                        pump: "Pump",
                        roofsolation: "Roof insulation",
                        airPump: "Air injection pump",
                        oxygenConcentrator: "Oxygen concentrator",
                        flowmeterBiogas: "Biogas flowmeter",
                        pronovaBiomethaan: "ProNova biomethane",
                        pronovaBiogas: "ProNova biogas",
                        h2s1Gpi: "Carbon filter 1",
                        h2s2Gpi: "Carbon filter 2",
                        optionUpdated: "Option updated successfully",
                        coolant: "Coolant",
                        daysSinceCoolantReplace: "Days since replacement",
                        coolantConf: "Reset the coolant operating hours only after the coolant has been replaced",
                        daysSinceInhibitor: "Days since inhibitor package",
                        inhibitorPackage: "Inhibitor package",
                        registerInhibitor: "Register",
                        inhibitorConf: "Register only after the coolant has been topped up with an inhibitor package (every 12 months)",
                        restoreValues: {
                            button: "Restore CU values",
                            title: "Restore CU values",
                            description: "Pick a day from the last 7 days that looks correct, review the prefilled values, then send each value to the CU individually.",
                            pickDay: "Select a day",
                            snapshotTime: "Sample time",
                            noSnapshots: "No statistics found for the last 7 days.",
                            send: "Send",
                            sendAll: "Send all",
                            sending: "Sending…",
                            confirmSendAll: "Send all prefilled values to the PLC?",
                            sendAllDone: "Sent {{count}} values to the PLC",
                            emptyValue: "Value is empty",
                            invalidValue: "Value is not a number",
                            invalidEngineCount: "Number of engines must be 1 or 2",
                            noConnection: "Machine has no active connection",
                            readOnly: "read-only",
                            fromMachine: "from machine record",
                            current: "Now",
                            currentHint: "Current live slow/fast value on the CU",
                            ups: "UPS",
                            groupEngines: "Engines",
                            groupReactor: "Reactor & mixing",
                            groupFeeding: "Feeding",
                            groupGas: "Gas",
                            groupEnergy: "Energy counters",
                            groupSsr: "SSR",
                        },
                        tabs: {
                            engine: "Engine",
                            reactor: "Reactor / Container",
                            gas: "Gas / Purification",
                            consumables: "Consumables",
                            options: "Machine options",
                            prints: "Prints",
                            restoreValues: "Restore CU values",
                        },
                    },
                    net: {
                        net: "Grid",
                        meterSettings: "Meter settings",
                        voltagePerPhase1: "Voltage per phase (1)",
                        voltagePerPhase2: "Voltage per phase (2)",
                        voltagePerPhase3: "Voltage per phase (3)",
                        frequencyPerPhase: "Frequency per phase",
                        angleBetweenPhase1And2: "Angle between phase 1 and 2",
                        ownPowerConsumption: "Power own consumption",
                        ownEnergyConsumption: "Energy own consumption",
                        bioguardVersion: "Bioguard version",
                        brutoProducedEnergy: "Gross produced energy",
                        nettoProducedEnergy: "Net produced energy",
                        producedEnergy: "Produced energy",
                        producedEnergyEngine1: "Produced energy engine 1",
                        producedEnergyEngine2: "Produced energy engine 2",
                        monitoringRelay: "Monitoring relay",
                        powerNonFit: "Power own consumption non-FIT",
                        energyMeterNonFit: "Energy meter own consumption non-FIT",
                    },
                    reactor: {
                        label: "Reactor",
                        reactorTemp: "Temperature reactor",
                        reactorTempTarget: "Target reactor temperature",
                        reactorLevel: "Desired reactor level",
                        hydrostaticPressure: "Reactor level actual",
                        siloType: "Silo type",
                        extraHeating: "Extra heating active",
                        antiFrost: "Anti frost",
                        antiFrostIndex: "Anti frost index",
                        antiFrostAuto: "The frost index is set automatically based on the local temperature",
                        antiFrostMessageNew: "Each frost-index cycle will activate the intake pump for 4 s and the exit pump will evacuate approx. 100 l of digestate, based on the set flow rate.",
                        antiFrostMessageOld: "Each frost-index cycle will activate the intake pump for 4 s and the exit pump for 120 s.",
                        coolwater: "Coolwater",
                        statusCoolingValve: "Coolwater valve",
                        waterTempIn: "Temperature coolwater reactor in",
                        waterTempOut: "Temperature coolwater reactor out",
                        waterTempMotorOut: "Temperature coolwater engine 1 out",
                        waterTempMotorOut2: "Temperature coolwater engine 2 out",
                        coolingWaterTemp: "Desired coolwater temperature",
                        maxCoolingWaterTemp: "Maximum coolwater temperature",
                        waterPressure: "Water pressure in the cold water circuit",
                        foamBeater: "Foam",
                        foambeatEveryXMinutes: "Beat foam every",
                        foambeatForXSeconds: "For",
                        mixer: "Mixer",
                        mixerMaxPower: "Mixer maximum power",
                        mixerActive: "Mixer active",
                        mixerBlockedLowLevel: "Mixer blocked due to low reactor level",
                        mixEveryXMinutes: "Mix every",
                        mixForXSeconds: "For",
                        blockMixingFrom: "No mixing from",
                        blockMixingTo: "To",
                        mixerInfo: "Mixer is switched on automatically for selected duration with selected time interval. During mixer block time window, the mixer is stopped when the installed mixer power exceeds the current power production of the installation. Mixer is temporarily stopped during CHP start-up until 50% of nominal power is reached to allow inrush current",
                        mixerInfoGpi: "Mixer is switched on automatically for selected duration with selected time interval. During mixer block time window, the mixer is stopped when the installed mixer power exceeds the current power production of the installation.",
                        mix1Hour: "Mix for 1 hour",
                        coolwaterValveInstalled: "Regulated 3-way valve",
                        coolwaterValveBinary: "Binary 3-way-valve",
                        coolwaterValveMaximizeHeat: "Maximize heat usage",
                        coolwaterValveMaximizeHeatInfo: "Maximization of heat usage can result in periods with no heat availability at the plate heat exchanger",
                        coolwaterValvePlatePriority: "Plate heat exchanger prioritization",
                        coolwaterValvePlatePriorityInfo: "Prioritize heat availability at the plate heat exchanger while maintaining a stable digester temperature",
                        bypassFan: "Control valve by-pass / fan",
                        digester: "Control valve digester / external heat consumption",
                        silo: "Silo",
                        bag: "Bag",
                        plateHeatExchanger: "Plate heat exchanger",
                        timesPerDay: "times / day",
                        intern: "Internally",
                        extern: "Externally",
                        tempHigh: "Temperature high",
                        externMessage: "The following error will not be triggered if mixer is set to externally: Mixer not working, please reset thermal.",
                        bypass: "By-pass",
                        ventilator: "Ventilator",
                        tempCoolHeatExchOut: "Temperature coolwater heat exchanger out",
                        overtempMixer1: "Over temperature mixer 1",
                        overtempMixer2: "Over temperature mixer 2",
                        mixerSettings: "Mixer settings",
                        premixing: "Premixing",
                        intakeMixing: "Intake mixing",
                        premixingInfo: "Premixing is mixing before feeding, i.e. before and during pumping out. The time setting always refers to the mix duration.",
                        intakeMixingInfo: "Intake mixing allows mixing at the same time as pumping in. When OFF, mixing is not performed while feeding is in progress.",
                        gpiMixDuringIntake: "Mix during liquid feeding",
                        gpiMixDuringIntakeInfo: "Mixing during the entire liquid feeding period.",
                        gpiMixDuringIntakeHelp: "Mix during liquid feeding: mixing for the entire feeding period. When OFF, behaviour depends on silo type.\n\nS-types: premix only during exit and mix after feeding for the mixer duration.\n\nC-types: no premix; mix after feeding for the mixer duration.",
                        gpiMixDuringIntakeOffGeneric: "When OFF, behaviour depends on silo type.",
                        gpiMixDuringIntakeOffS: "S-types: premix only during exit and mix after feeding for the mixer duration.",
                        gpiMixDuringIntakeOffC: "C-types: no premix; mix after feeding for the mixer duration.",
                        gpiMixDuringSolidFeedIntake: "Mix during solid feed intake",
                        gpiMixDuringSolidFeedIntakeInfo: "When ON, the mixer runs during the entire solid feed period. When OFF, mixing only occurs before and after solid feeding, each for the duration (in seconds) set in “{{durationSetting}}”.",
                        gpiMixTimeBeforeAfterSolidIntake: "Mix time before/after solid intake",
                    },
                    efficiency: {
                        label: "Efficiency",
                        production: "Energy production last 30 days",
                        consumption: "Energy consumption last 30 days",
                        nettoProduction: "Netto energy production last 30 days",
                        averageEfficiency: "Average efficiency last 30 days",
                        averageTechnicalEfficiency: "Average technical availability last 30 days",
                        bgp: "Manure quality (BGP batch)",
                        top10: "Top 10 projects last month",
                        realised: "Realised efficiency",
                        technical: "Technical availability",
                        bgpInfo: "Estimate of the BGP [m³/ton]. Does not take into account losses caused by downtime, overproduction or flaring.",
                        pointPerDay: "%/day",
                        trendline: "Trend line",
                        injectedGas: "Injected biomethane",
                        fuduraInjectedGas: "Injected biomethane",
                        fuduraInjectedGasScaled: "Injected biomethane",
                        fuduraEfficiency: "Realised efficiency",
                        fuduraEfficiencyScaled: "Realised efficiency",
                        heatProductionKenter: "Heat Production (Kenter)",
                        heatProductionFudura: "Heat Production (Fudura)",
                        fuduraChannels: "Fudura Channels (30d)",
                        noHeatTelemetryData: "No external heat data available for this period.",
                        heatTelemetrySyncHint: "Heat production data will appear here once Kenter or Fudura measurements are synced.",
                    },
                    general: {
                        label: "General",
                        hardwareVersion: "Hardware version",
                        otGenContact: "OT Gen contact",
                        engine1And2Off: "Engine 1 and 2 off",
                        engine1On: "Engine 1 on",
                        engine2On: "Engine 2 on",
                        engine1And2On: "Engine 1 and 2 on",
                        notes: "Notes",
                        h2sSensorFirmwareVersion: "H₂S sensor firmware version",
                        idH2s: "S/N H₂S ID",
                        bioId: "S/N Biotronic ID",
                        identifier: "Installation identifier",
                        collabContract: "Collaboration contract",
                        own: "Maintenance contract",
                        sold: "Sold installation",
                        productionDate: "Production date",
                        commissioningDate: "Commissioning date",
                        controlCardTemp: "Control card temperature",
                        batteryVoltage: "Battery voltage",
                        motorVoltage: "Motor voltage",
                        overtempFlueGasHeatExch: "Over temperature flue gas heat exchanger motor",
                        rebootMainBoard: "Reboot main board",
                        rebootNow: "Reboot now",
                        utcOffset: "UTC offset",
                        location: "Location",
                        network: "Network",
                        ip: "IP",
                        mask: "Mask",
                        gateway: "Gateway",
                        dns: "DNS",
                        pcb: "PCB",
                        firmware: "Firmware",
                        mainControlUnit: "Main control unit",
                        bioguard: "Bioguard",
                        biotronicEngine1: "Biotronic engine 1",
                        biotronicEngine2: "Biotronic engine 2",
                        h2sEngine1: "H₂S engine 1",
                        h2sEngine2: "H₂S engine 2",
                        bioIdEngine1: "Bio id engine 1",
                        bioIdEngine2: "Bio id engine 2",
                        modificationsToMachine: "Modifications to the machine",
                        firmwareOutdated: "Outdated",
                        firmwareCustom: "Custom firmware",
                        firmwareNotFound: "Not found",
                        name: "Name",
                        hostNameFirmware: "Firmware",
                        hostNameDatabase: "Database",
                        normal: "Normal",
                        lowError: "Low (error)",
                        nta8080Title: "NTA 8080 report",
                        nta8080Description: "Download a monthly NTA 8080 report. Data is loaded only when you request the report.",
                        nta8080Month: "Month",
                        nta8080Download: "Download report",
                        nta8080DownloadPdf: "Download PDF",
                        nta8080DownloadCsv: "Download CSV",
                        nta8080Loading: "Preparing…",
                        nta8080SelectMonth: "Select a month first",
                        nta8080InvalidMonth: "Invalid month selected",
                        nta8080DownloadError: "Could not download the report",
                    },
                    feeding: {
                        label: "Feeding",
                        feedingVolume: "Maximum fresh feeding volume per cycle",
                        feedingCyclesPerDay: "Feeding cycles per day",
                        feedingCyclesPerDayInfo: "If the pumped volume is less than 75% of the desired volume, this triggers the feeding error \"no flow when pumping in fresh manure\". If the pumped volume is between 75% and 100% of the desired volume, this triggers the message \"Feeding cycle partially executed. Empty pit detected before the set volume was reached.\"",
                        feedingBalance: "Feeding balance",
                        autoFeedingActive: "Auto feeding active",
                        blockHighElectricalConsumption: "Block heat pump digester heating during mix window",
                        blockHighElectricalConsumptionInfo: "When ON, heat pump digester heating is blocked during the mix window. When OFF, heating is not blocked.",
                        minimizeElectricalConsumptionFrom: "Minimize electrical consumption from",
                        minimizeElectricalConsumptionTo: "to",
                        autoFeedingStartHour: "Auto feeding starting time",
                        exitPumpRunning: "Pump out",
                        feedingCycle: "Feeding cycle",
                        onlyInput: "Pump in only",
                        onlyOutput: "Pump out only",
                        startFeeding: "Start feeding",
                        stopFeeding: "Stop feeding",
                        customAmount: "Custom amount",
                        customAmountHint: "Pre-filled with the configured feeding volume. Change only if you want a custom amount. Max {{maxRiseCm}} cm level rise ({{maxLiters}} l for this silo).",
                        customAmountInvalid: "Enter a value between {{min}} and {{max}} l",
                        customAmountExceedsLevelRise: "The entered amount ({{amount}} l) would raise the tank level by more than {{maxRiseCm}} cm. Maximum for this silo is {{maxLiters}} l.",
                        customAmountUnknownSilo: "Cannot calculate the maximum amount: unknown silo type.",
                        customAmountExceedsWarning: "The entered amount ({{amount}} l) is higher than the configured feeding volume ({{feedingVolume}} l). Are you sure you want to continue?",
                        pumpOutFlowRate: "Theoretical flow rate exit pump",
                        pumpOutFlowRateInfo: "The theoretical pump-out flow rate is used to calculate how long it takes to pump digestate out of the digester. If set too low, too much digestate will be pumped out; if set too high, too little digestate will be pumped out. Typical values are:",
                        pumpOutFlowRateBellowsPump: "Bellows pump: ~ 3 m³/h",
                        pumpOutFlowRateCentrifugalPump: "Centrifugal pump: ~ 50 m³/h",
                        pumpOutFlowRateGravityOutlet: "Gravity outlet: ~ 50 m³/h",
                        kiloPerPulse: "Flow meter pulse",
                        intakeTimeout: "Time-out pumping in",
                        averageDailyFeeding: "Avg. daily feeding last month",
                        retentionTime: "Retention time",
                        statusValvePumpIn: "Valve fresh in - 2",
                        statusValvePumpOut: "Valve exit reactor - 3",
                        statusValveRetourReactor: "Valve retour reactor - 4",
                        valveCurrentActuator: "Valve current",
                        actuatorSetting: "Actuator setting",
                        actuatorSettingV1: "Linak",
                        actuatorSettingV2: "Hiwin / Mikrosystem",
                        lastFeeding: "Actual - last",
                        startHourLastFeeding: "Latest feeding time start",
                        feedingStatus: "Feeding state",
                        feedingError: "Reactor error",
                        intakePumpTime: "Intake time",
                        intakePumpAmount: "Intake amount",
                        exitPumpTime: "Exit time",
                        exitPumpAmount: "Exit amount",
                        feedingHistory: "Feeding history",
                        startedOn: "Started on",
                        temperature: "Temperature",
                        reactorLevel: "Reactor level",
                        balance: "Balance",
                        acknowledge: "Acknowledge error",
                        intakeSpeed: "Intake speed",
                        balanceWarning: "Warning, this will not start a normal feeding cycle but instead pump in the remaining balance value into the reactor",
                        automaticFeedingSettings: "Automatic feeding settings",
                        manualFeeding: "Manual feeding",
                        pumpSettings: "Pump settings",
                        mixBeforeExit: "Mixing before exit",
                        mixDuringExit: "Max. mixing during exit",
                        lastFeedingTime: "Last feeding time",
                        status: {
                            "0": "Idle",
                            "1": "Level sensing",
                            "2": "Exit",
                            "3": "Intake",
                            "5": "Defrost",
                            "6": "Gas release",
                            "7": "Manual exit",
                            "10": "Booting",
                            "2,001": "Exit: Premixing",
                            "2,002": "Exit",
                            "2,003": "Exit: Open exit valve",
                            "2,004": "Exit: Open exit valve",
                            "2,005": "Exit: starting exit pump",
                            "2,006": "Exit",
                            "2,007": "Exit: Pumping manure",
                            "2,008": "Exit: Stop exit",
                            "2,009": "Exit: Stop exit",
                            "2,010": "Exit: Close exit valve",
                            "2,011": "Exit: Close exit valve",
                            "2,012": "Exit: Stop exit",
                            "3,001": "Intake: Preparing",
                            "3,002": "Intake: Preparing",
                            "3,003": "Intake: Preparing",
                            "3,004": "Intake: Pumping manure",
                            "3,005": "Intake: Pumping manure",
                            "3,006": "Intake: Finishing",
                            "3,007": "Intake: Finishing",
                            "3,008": "Intake: Stop pump",
                            "3,009": "Intake: Stop pump",
                            "3,010": "Intake: Stop pump",
                            "3,011": "Intake: Stop pump",
                            "3,012": "Intake: Finishing",
                            "5,001": "Defrost: Testing intake",
                            "5,002": "Defrost: Testing intake",
                            "5,003": "Defrost: Testing intake",
                            "5,004": "Defrost: Testing intake",
                            "5,005": "Defrost: Stopping intake",
                            "5,006": "Defrost: Opening exit valve",
                            "5,007": "Defrost: Opening exit valve",
                            "5,008": "Defrost: Testing exit",
                            "5,009": "Defrost: Testing exit",
                            "5,010": "Defrost: Testing exit",
                            "5,011": "Defrost: Testing exit",
                            "5,012": "Defrost: Testing exit",
                            "5,013": "Defrost: Closing exit valve",
                            "5,014": "Defrost: Closing exit valve",
                            "5,015": "Defrost: Finishing",
                            "6,001": "Gas release: Open exit valve",
                            "6,002": "Gas release: Open exit valve",
                            "6,003": "Gas release: Close exit valve",
                            "6,004": "Gas release: Close exit valve",
                            "6,005": "Gas release",
                            "7,001": "Manual exit: Open exit valve",
                            "7,002": "Manual exit: Open exit valve",
                            "7,003": "Manual exit: Pumping manure",
                            "7,004": "Manual exit: Stop pump",
                            "7,005": "Manual exit: Close exit valve",
                            "7,006": "Manual exit: Close exit valve",
                            "7,007": "Manual exit: Finishing",
                            "7,008": "Manual exit: Finishing",
                            "10,001": "Booting: Close valve 2",
                            "10,002": "Booting: Close valve 2",
                            "10,003": "Booting: Close exit valve",
                            "10,004": "Booting: Close exit valve",
                            "10,005": "Booting: Close valve 4",
                            "10,006": "Booting: Close valve 4",
                            "10,007": "Booting: Checking electrical connection",
                            "10,008": "Booting: Checking electrical connection",
                            "10,009": "Booting"
                        }
                    },
                    users: {
                        label: "Users",
                        customers: "Linked customers",
                        technicians: "Linked technicians",
                        resellers: "Linked resellers",
                    },
                    recommendations: {
                        label: "Recommendations",
                    },
                    machineTasks: {
                        title: "Installation tasks",
                        overviewTitle: "Installation tasks overview",
                        open: "Open",
                        completed: "Completed",
                        linkTask: "Link task to this machine",
                        bulkLinkTask: "Link task to multiple machines",
                        bulkLink: "Link to selected machines",
                        selectMachines: "Machines",
                        selectMachinesPlaceholder: "Select one or more machines…",
                        bulkLinkSuccess: "Task linked to {{count}} machine(s).",
                        bulkLinkPartial: "Task linked to {{linked}} machine(s). {{skipped}} already had this task.",
                        bulkLinkSkipped: "Task was already linked to all selected machines.",
                        filterByMachine: "Filter by machine",
                        allMachines: "All machines",
                        machine: "Machine",
                        openOverview: "Open installation tasks overview (bulk link, all machines)",
                        noOpenTasksOverview: "No open installation tasks found.",
                        selectTask: "Task",
                        selectTaskPlaceholder: "Choose a task…",
                        assignee: "Assignee",
                        unassigned: "Unassigned",
                        link: "Link",
                        newCatalogTask: "Add new task to catalog",
                        newCatalogTaskPlaceholder: "e.g. Antenne IXON router naplaatsen",
                        addToCatalog: "Add to catalog",
                        description: "Description",
                        notes: "Notes",
                        notesPlaceholder: "e.g. Could not complete because parts were missing",
                        completedBy: "Completed by",
                        completedAt: "Completed at",
                        actions: "Actions",
                        complete: "Complete",
                        unlink: "Unlink",
                        reopen: "Reopen",
                        confirmUnlink: "Remove this task from the machine?",
                        noOpenTasks: "No open tasks linked to this machine.",
                        noCompletedTasks: "No completed tasks yet.",
                        quickTask: "Add quick task",
                        quickTaskHelp: "One-off task for this machine only. It will not appear in the shared catalog.",
                        quickTaskPlaceholder: "e.g. Temporary cable fix until spare part arrives",
                        addQuickTask: "Add quick task",
                        quickBadge: "Quick",
                    },
                    firmware: {
                        invalidFile: "Please select a .hex file",
                        uploadStarted: "Firmware upload started",
                        uploadFailed: "Firmware upload failed",
                        uploading: "Uploading…",
                        uploadProgress: "Upload progress: {{progress}}%",
                        currentVersion: "Current version",
                    },
                    documents: {
                        label: "Documents",
                        specificDocuments: "My installation documents",
                        specificImages: "Specific images",
                        generalVideos: "General videos",
                        general: "General documentation",
                        generalDocuments: "General documents",
                        checklists: "Checklists",
                        construction: "Construction Checklist",
                        production: "Production Checklist",
                        upload: "Upload",
                        uploadSuccess: "You have successfully uploaded {{name}}",
                        deleteSuccess: "You have successfully deleted the file: {{name}}",
                        noFilesAvailable: "No files available in {{category}} category.",
                        fileSizeExceeds: "File size exceeds the limit of {{size}}Mb",
                        invalidImageType: "Only JPG and PNG images are allowed",
                        chooseFileFirst: "Please choose a file first.",
                        default: "Default",
                        permits: "Permits",
                        plans: "Plans",
                        planning: "Planning",
                        certification: "Certification",
                        regulations: "Regulations",
                        instructions: "Manuals",
                        templates: "Templates",
                        preCommissioningCustomer: "Pre-commissioning by customer",
                    },
                    warnings: {
                        "W001": "Energy consumption exceeding threshold in the past 24 hours (72 kWh for 10-44kW installation, 250 kWh for 60-74kW installation)",
                        "W002": "Reactor temperature has dropped dramatically",
                        "W003": "Service within 48 hours",
                        "W004": "Carbon filter engine 1 needs to be replaced",
                        "W005": "Carbon filter engine 2 needs to be replaced",
                        "W006": "Gas buffer measurement frozen",
                        "W007": "Gas buffer measurement defect",
                        "W008": "Not fed yesterday",
                        "W009": "Pump speed last feeding was 50% faster than the average for the last month",
                        "W010": "H₂S value too high (>1500)",
                        "W011": "Aeration is 60",
                        "W012": "Aeration is lower than or equal to 3",
                        "W013": "Efficiency yesterday was 0 and autofeed is on",
                        "W014": "H₂S reactor measurement - difference exceeds 400ppm",
                        "W015": "Air injection very high - mind gas quality",
                        "W016": "H₂S measurement failed for 24h",
                        "W017": "Mixer oil too low",
                        "W018": "Engine oil low",
                        "W020": "Water pressure low",
                        "W104": "H₂S value too high (>200) or aeration = 60 or 3",
                        "W105": "Load of the carbon filter to high",
                        "W114": "Efficiency yesterday was not 0 and autofeed is off",
                    },
                    advanced: {
                        language: "LCD Screen Language",
                        lambdaUpperLimit: "Lambda upper limit (narrow range)",
                        lambdaLowerLimit: "Lambda lower limit (narrow range)",
                        coolingValve: "Coolwater valve",
                        maxPower: "Max Power (Database) Engine 1",
                        maxPower2: "Max Power (Database) Engine 2",
                        bioId: "Bio ID Engine 1",
                        bioId2: "Bio ID Engine 2",
                        currentSsrConfiguration: "Current SSR configuration",
                        SSRString: "SSR String",
                        digitalInputs: "Digital inputs",
                        digitalInputsInfo: "Live DI status from the control unit (open = 1, closed = 0). Mapping is stored in the database and is not editable here.",
                        function: "Function",
                        contactType: "Type",
                        diMeaning: "0 / 1 meaning",
                        status: "Status",
                        diOpen: "Open",
                        diClosed: "Closed",
                    },
                    sms: {
                        duringDay: "Receive text messages during the day",
                        duringNight: "Receive text messages during the night",
                        sendSms: "Notify clients by sms",
                        sendTestSms: "Send test message",
                        testSms: "Test SMS",
                        testSmsToAllSenders: "Send test message to all senders (troubleshooting)",
                        recipients: "Recipients",
                        settings: "SMS Settings",
                        enterMessage: "Enter your message here...",
                        smsSentSuccessfully: "SMS messages sent successfully",
                        pleaseSelectAtLeastOneRecipient: "Please select at least one recipient",
                        pleaseEnterAMessage: "Please enter a message",
                        failedToSendSmsMessages: "Failed to send SMS messages",
                        smsSettingsUpdatedSuccessfully: "SMS settings updated successfully",
                        message: "Message",
                        testNotificationToAllSenders: "Send test notification (troubleshooting)",
                        sendTestNotification: "Send test notification",
                        testNotificationsSentSuccessfully: "Test notifications sent successfully",
                        failedToSendTestNotifications: "Failed to send test notifications",
                    },
                    temperatures: {
                        label: "Temperatures",
                        oilCoolerTemp: "Oil cooler temperature",
                        biogasTempAfterReheat: "T5 Temperature After Reheating",
                        blowerOutTemp: "T2 Temperature Inlet Compressor",
                        compressorOutTemp: "T3 Temperature Outlet Compressor",
                        biogasTempAfterCool: "T4 Temperature After Cooling",
                    },
                    pressures: {
                        label: "Pressures",
                        biogasPressureBeforeMembrane: "P4 Pressure Inlet Membranes",
                        stage3Pressure: "P5 Pressure Membrane Stage 3",
                        pressureAfterMembrane: "P6 Pressure Outlet Membranes",
                        blowerPressure: "P1 Pressure Outlet Blower",
                        blowerPressureSetpoint: "Pressure Outlet Blower Setpoint",
                        compressorOutPressure: "P3 Pressure Outlet Compressor",
                    },
                    valves: {
                        label: "Valves",
                        valveCompressor: "Valve compressor",
                        valveMembrane: "Valve membrane",
                        valveGrid: "Valve grid",
                        valveCo2: "Valve CO2",
                    },
                    system: {
                        label: "System",
                        installationState: "Installation state",
                        geuAvailable: "GEU available",
                        geuAlarm: "GEU alarm",
                        geuDelivering: "GEU delivering",
                        gasTotalGeu: "Gas total GEU",
                        gasTotalInternGeu: "Gas total intern GEU",
                        biogasTotalizer: "Biogas totalizer",
                        biomethaneDewpoint: "Biomethane dewpoint",
                        compressorSpeed: "Compressor speed",
                    },
                    filters: {
                        label: "Filters",
                        inletFilterPressuredrop: "Inlet filter pressuredrop",
                        filterTrainPressuredrop: "Filter train pressuredrop",
                        oilFilterPressuredrop: "Oil filter pressuredrop",
                    },
                    calibrationGas: {
                        title: "Calibration Gas Overview",
                        addRecord: "Add Row",
                        editRecord: "Edit Row",
                        date: "Date",
                        zerogasPronovaN2: "Zerogas Pronova (N2)",
                        dragergasGcHe: "Dragergas GC (He)",
                        kalibratiegasPronovaBiogas: "Kalibratiegas Pronova Biogas",
                        kalibratiegasPronovaBiomethaan: "Kalibratiegas Pronova Biomethaan",
                        kalibratiegasGcBiomethaan: "Kalibratiegas GC Biomethaan",
                        stikstofThtN2: "Stikstof THT (N2)",
                        thtWeging: "THT (weging)",
                        minValues: "Minimum values",
                        noRecords: "No records found",
                        fetchError: "Error fetching calibration gas records",
                        createSuccess: "Calibration gas record successfully added",
                        updateSuccess: "Calibration gas record successfully updated",
                        saveError: "Error saving calibration gas record",
                        deleteConfirm: "Are you sure you want to delete this record?",
                        deleteSuccess: "Calibration gas record successfully deleted",
                        deleteError: "Error deleting calibration gas record",
                    },

                    checks: {
                        yourImage: "Your image:",
                        imageCommentsLabel: "Comments on this image (optional):",
                        imageCommentsPlaceholder: "Add comments about this image",
                        exampleImage: "Example image:",
                        textAnswerPlaceholder: "Type your answer here",
                        next: "Next",
                        completedMessage: "You have completed all the construction checks, please submit the checklist.",
                        skip: "Skip",
                        downloadPdf: "Download PDF",
                        answerLabel: "Answer:",
                        commentsLabel: "Comments:",
                        selectedOptionsLabel: "Selected options:",
                        addEntry: "Add entry",
                        newEntryForCheck: "New entry for this check:",
                        commentsOptionalPlaceholder: "Comments (optional)",
                        yourAnswerPlaceholder: "Your answer",
                        saveEntry: "Save entry",
                        cancel: "Cancel",
                        entryAdded: "Entry added.",
                        entryAddFailedPrefix: "Failed to add entry: ",
                        validateBeforeSubmitting: "Please provide an answer before submitting.",
                        validateBeforeNextCheck: "Please provide an answer before proceeding to the next check.",
                        uploadSuccess: "Data sent successfully",
                        uploadFailedPrefix: "Failed to send data: ",
                        serialScanPhotoLabel: "Photo of nameplate / label",
                        serialScanChooseSource: "Take a photo or choose an existing image",
                        serialScanTip: "Fill the frame with the serial number for best results",
                        serialScanTakePhoto: "Take photo",
                        serialScanChooseGallery: "Choose from gallery",
                        serialScanProgressHint: "Trying multiple image enhancements…",
                        serialScanning: "Scanning label…",
                        serialScanSuggestions: "Suggestions from scan",
                        serialScanManualLabel: "Serial number",
                        serialScanManualPlaceholder: "Enter or correct the serial number",
                        serialScanConfirm: "Confirm serial number",
                        serialScanRescan: "Scan again",
                        serialScanConfirmedLabel: "Confirmed",
                        serialScanConfirmed: "Serial number confirmed.",
                        serialScanNoCandidates: "No serial number detected. Enter it manually.",
                        serialScanFailed: "Scan failed. Enter the serial number manually.",
                        serialScanEnterValue: "Enter or select a serial number first.",
                        serialScanInvalidPattern: "This serial number does not match the expected format.",
                    }
                }
            },
            nl: {
                translation: {
                    dashboard: {
                        nameIdentifier: "Naam of identificatie",
                        efficiencyAll: "Efficiëntie van alle machines",
                        onlyErrors: "Alleen fouten",
                        toggleDisconnected: "Wissel losgekoppelde machines",
                        productionCombined: "Gecombineerde productie (Wh)",
                        realisedTechnicalEfficiency: "Gerealiseerde / Technische efficiëntie (%)",
                        efficiencyCombined: "Gerealiseerde efficiëntie (%)",
                        technicalEfficiencyCombined: "Technische efficiëntie (%)",
                        bgp: "Bgp (m³/ton)",
                        consumption: "Verbruik (Wh)",
                        manureLifeTime: "Standtijd (dagen)",
                        feeding: "Voeding (kg)"
                    },
                    common: {
                        on: "Aan",
                        off: "Uit",
                        add: "Toevoegen",
                        save: "Opslaan",
                        monday: "Maandag",
                        tuesday: "Dinsdag",
                        wednesday: "Woensdag",
                        thursday: "Donderdag",
                        friday: "Vrijdag",
                        saturday: "Zaterdag",
                        sunday: "Zondag",
                        from: "Van",
                        to: "Tot",
                        hours: "uren",
                        reset: "Resetten",
                        confirmation: "Bevestiging",
                        cancel: "Annuleren",
                        yesIAmSure: "Ja, ik weet het zeker",
                        set: "instellen",
                        auto: "Auto",
                        manual: "Manueel",
                        minutes: "minuten",
                        seconds: "seconden",
                        turnOn: "Zet aan",
                        turnOff: "Zet uit",
                        graphLoading: "Grafieken laden...",
                        noData: "Geen gegevens beschikbaar...",
                        hoursPerYear: "uren / jaar",
                        datetime: "Datum en tijd",
                        warning: "Waarschuwing",
                        error: "Fout",
                        type: "Type",
                        startdate: "Startdatum",
                        enddate: "Einddatum",
                        all: "Alle",
                        engine1: "Motor 1",
                        engine2: "Motor 2",
                        ongoing: "Lopend",
                        both: "Beide",
                        days: "Dagen",
                        today: "Vandaag",
                        sendAnswers: "Antwoorden versturen",
                        employee: "Medewerker",
                        customer: "Klant",
                        sales: "Verkoop",
                        technician: "Technicus",
                        admin: "Beheerder",
                        noDateKnown: "Geen datum bekend",
                        command: "Opdracht",
                        user: "Gebruiker",
                        fillInSurvey: "Gelieve de enquête in te vullen",
                        tons: "ton",
                        count: "Aantal",
                        disabled: "Uitgeschakeld",
                        addField: "Veld toevoegen",
                        deleteField: "Veld verwijderen",
                        releases: "Releases",
                        open: "Open", // Dutch (NL)
                        close: "Sluit",
                        opening: "Openen",
                        closing: "Sluiten",
                        zoomCancel: "Zoom geannuleerd, blijf binnen de grafiek om te zoomen",
                        stuck: "Vastgelopen"
                    },
                    errorPage: {
                        title: "Er is iets misgegaan.",
                        contact: "Gelieve dit probleem te melden aan it@biolectric.com en vermeld welke gsm of browser u gebruikt.",
                        reload: "Herladen"
                    },
                    popups: {
                        engineIdle: "Motor draait nog, zet eerst de motor uit",
                        valueBetween: "Waarde moet tussen {{min}} en {{max}} liggen",
                        valueBetweenCustom: "Waarde moet tussen {{min}} en {{max}} liggen",
                        powerTooLow: "Het vermogen kan niet lager worden ingesteld dan {{watts}}W",
                        powerTooHigh: "Het vermogen kan niet hoger worden ingesteld dan {{maxPower}}",
                        maxCoolingTemp: "Kan niet hoger zijn dan {{max}}°C",
                        minValue: "Kan niet lager zijn dan {{min}}",
                        maxAirInjectionTime: "Kan niet langer zijn dan {{max}} seconden",
                        minGasBuffer: "Min Gas Buffer buiten bereik. Minimale waarde voor uw installatie is {{min}}",
                        maxGasBuffer: "Max Gas Buffer buiten bereik. Maximale waarde voor uw installatie is {{max}}",
                        reactorTemp: "Reactortemperatuur buiten bereik. Moet tussen {{min}} en {{max}} liggen",
                        reactorLevel: "Ongeldig reactorniveau. Maximale waarde voor uw installatie is {{limit}}",
                        reactorLevelRange: "Waarde voor het reactorniveau moet tussen {{min}} en {{max}} liggen",
                        commandFailed: "Opdracht verzenden mislukt",
                        commandSent: "Commando verzonden",
                        commandSuccess: "U heeft {{command}} succesvol bijgewerkt van {{previousValue}} naar {{value}}",
                        commandMix1Hour: "De mixer zal 1 uur draaien",
                    },
                    menu: {
                        dashboard: 'Dashboard',
                        machines: 'Machines',
                        questionnaires: 'Vragenlijsten',
                        banners: "Banners",
                        errors: "Fouten en waarschuwingen",
                        pcb: "Printplaten",
                        tasks: "Mijn taken",
                        installationTasks: "Installatietaken",
                        releases: "Release notes",
                        resellers: "Wederverkopers",
                        users: "Gebruikers",
                        recommendations: "Aanbevelingen",
                        suggestions: "Aanbevelingsberichten",
                        faultTrees: "Foutbomen",
                        assistant: "Assistent",
                        language: "Taal",
                        reconnection: "Deze machine is momenteel offline. Probeer een nieuwe verbinding te maken met de knop hieronder.",
                        profile: "Profiel",
                        logout: "Uitloggen",
                        firmware: "Firmware",
                        sms: "SMS",
                        advanced: "Geavanceerd",
                        errorsSingle: "Fouten",
                        warnings: "Waarschuwingen",
                        blockMachineTitle: "Machine blokkeren",
                        blockMachineReasonLabel: "Reden voor blokkering",
                        blockMachineReasonPlaceholder: "Selecteer een reden…",
                        blockMachineDateLabel: "Geblokkeerd sinds",
                        blockMachineBlockedBy: "Geblokkeerd door",
                        blockMachineConfirm: "Machine blokkeren",
                        blockMachineReasonRequired: "Selecteer een reden voor de blokkering.",
                        blockMachineDateRequired: "Selecteer een blokkeerdatum.",
                        blockMachineReasons: {
                            economically_not_viable: "Economisch niet langer levensvatbaar – grote investeringen vereist",
                            operational_burden_high: "Operationele last te hoog – dagelijkse activiteiten kosten te veel tijd",
                            technical_reliability_insufficient: "Technische betrouwbaarheid onvoldoende – bv. continue storingen, geen vertrouwen dat Biolectric dit kan oplossen",
                            farm_structure_changes: "Veranderingen in bedrijfsstructuur – wijziging bedrijfsmodel of beschikbaarheid mest",
                            human_family_factors: "Menselijke / familiale factoren – verlies motivatie, gezondheidsproblemen, geen opvolging",
                            regulations_permits: "Regelgeving & vergunningen – beperkingen of wijzigingen buiten controle van de landbouwer",
                            replaced_by_new_installation: "Vervangen door nieuwe Biolectric-installatie",
                            waiting_for_commissioning: "Wachtend op inbedrijfstelling",
                        },
                    },
                    statistics: {
                        label: "Statistieken",
                        foamBeaterThermalStatus: "Thermiek schuimbreker",
                        exitPumpThermalStatus: "Thermiek uitpomp",
                        thermalStatusOk: "Thermiek niet actief, verbruiker kan normaal functioneren",
                        thermalStatusFault: "Thermiek actief, verbruiker staat in fout",
                        group1: "Groep 1",
                        group2: "Groep 2",
                        addProperty: "Eigenschap toevoegen",
                        removeProperty: "Eigenschap verwijderen",
                        startTutorial: "Start tutorial",
                        exitTutorial: "Tutorial verlaten",
                        welcomeStep: {
                            title: "Welkom op de statistiekenpagina",
                            content: "Hier kunt u eenvoudig verschillende waarden en trends vergelijken."
                        },
                        propertyStep: {
                            title: "Selectie van eigenschappen",
                            content: "Om te beginnen, selecteer eenvoudig een eigenschap die u interesseert uit het keuzemenu."
                        },
                        addPropertyStep: {
                            title: "Eigenschappen toevoegen en verwijderen",
                            content: "Probeer een eigenschap toe te voegen of te verwijderen. U kunt maximaal 4 eigenschappen per groep toevoegen."
                        },
                        groupStep: {
                            title: "Groep 2 inschakelen",
                            content: "Klik op de knop 'Eigenschap toevoegen' om een eigenschap te selecteren voor Groep 2. Eigenschappen in deze groep worden aan de rechterkant van de grafiek weergegeven."
                        },
                        dateRangeStep: {
                            title: "Een datumbereik selecteren",
                            content: "Gebruik deze knop om een datumbereik te kiezen."
                        },
                        zoomInStep: {
                            title: "Inzoomen",
                            content: "Sleep met uw muis over de grafiek om een gebied te selecteren om in te zoomen."
                        },
                        zoomOutStep: {
                            title: "Uitzoomen",
                            content: "Herstel naar het eerder geselecteerde datumbereik door de knop 'Uitzoomen' te gebruiken."
                        },
                        domainStep: {
                            title: "Aanpassen van domeinen",
                            content: "U kunt het maximale en minimale domein per groep aanpassen met behulp van deze knoppen."
                        },
                        csvStep: {
                            title: "CSV-gegevens downloaden",
                            content: "Download de momenteel weergegeven grafiekgegevens in CSV-formaat."
                        },
                        imageStep: {
                            title: "Afbeelding downloaden",
                            content: "Download de momenteel weergegeven grafiek als afbeelding."
                        },
                        configurationStep: {
                            title: "Voorinstelling configuratie",
                            content: "Je kunt je huidige configuratie opslaan als een voorinstelling. Je kunt ook bestaande voorinstellingen bijwerken of verwijderen."
                        },
                        controlCardTemp: "Temperatuur besturingskaart",
                        lowTensionError: "Fout lage spanning",
                        overTempFlueGasHeatExch: "Overtemperatuur rookgaswarmtewisselaar",
                        feedingCycleLevel: "Niveaumeting voedercyclus",
                        batteryVoltage: "Batterijspanning",
                        waterPressure: "Waterdruk",
                        shortInterval: "10 Minuten Intervallen",
                        dailyInterval: "Dagelijkse Intervallen",
                        configurationUpdated: "Je huidige configuratie is opgeslagen in deze voorinstelling",
                        presets: "Voorinstellingen",
                        savePreset: "Opslaan als voorinstelling",
                        applyPreset: "Voorinstelling toepassen",
                        updatePreset: "Voorinstelling bijwerken",
                        delete: "Verwijderen",
                        noPresets: "Je hebt nog geen voorinstellingen",
                        givePresetName: "Geef je voorinstelling een naam",

                    },
                    smart: {
                        label: "Smart",
                        heightOffset: "Hoogte afwijking",
                        active: "Actief",
                        passive: "Passief",
                        preActive: "Pre Actief",
                        prePassive: "Pre Passief",
                        postActive: "Post Actief",
                        postPassive: "Post Passief",
                        activeDesc: "Tijdens een actieve periode wordt de geplande energieproductie gemaximaliseerd. Voorafgaand aan elke actieve periode wordt automatisch een “pre-actief” tijdsslot voorzien waarin de gasbuffer opgebouwd wordt. De maximumduur van een actieve periode wordt bepaald door het volume van de gasbuffer, het aantal en type van de geïnstalleerde WKK(s) en het biogas-productieprofiel van de installatie. Wanneer de minimum vulgraad van de gasbuffer bereikt wordt, zal de energieproductie gestopt worden (post-actieve periode).",
                        passiveDesc: "Tijdens een passieve periode wordt enkel energie geproduceerd als er een overschot aan gas is. Voorafgaand aan elke passieve periode wordt automatisch een tijdsslot voorzien waarin de gasbuffer afgebouwd wordt. De maximumduur van een passieve periode wordt bepaald door het volume van de gasbuffer en het biogas-productieprofiel van de installatie. Wanneer de maximum vulgraad van de gasbuffer bereikt wordt, zal de energieproductie gestart worden (post-passieve periode).",
                        permanence: "Constante productie stimuleren door dynamisch op één motor te draaien bij niet maximale gasbuffer",
                        permanency: "Permanentie",
                        activateStep: {
                            title: "Activeren van SMART",
                            content: "Activeer SMART om het productieprofiel van de installatie te sturen"
                        },
                        timeslotStep: {
                            title: "Tijdslot toevoegen",
                            content: "Voeg een actief of passief tijdslot toe"
                        },
                        fromToStep: {
                            title: "Van / Tot",
                            content: "Je stelt zowel de start- als einddag en -tijd in"
                        },
                        activePassiveStep: {
                            title: "Actief of Passief",
                            content: "Selecteer of je een actief of passief tijdslot wil instellen"
                        },
                        saveStep: {
                            title: "Tijdsloten opslaan",
                            content: "Sla je gewijzigde instellingen op"
                        },
                        removeStep: {
                            title: "Tijdslot verwijderen",
                            content: "Verwijder je tijdslot hier"
                        },
                        visualStep: {
                            title: "Visuele representatie",
                            content: "Op deze grafiek worden de SMART-instellingen vergeleken met het productieprofiel van de afgelopen week"
                        },
                        daySwitchStep: {
                            title: "Visuele representatie",
                            content: "Navigeer eenvoudig naar de volgende of vorige dag"
                        },
                    },
                    gas: {
                        label: "Gas",
                        minGasBufferLevel: "Min gasbufferniveau",
                        maxGasBufferLevel: "Max gasbufferniveau",
                        gasBufferLevel: "Actueel gasbufferniveau",
                        defaultMinGasBufferLevel: "Standaard min gasbufferniveau",
                        defaultMaxGasBufferLevel: "Standaard max gasbufferniveau",
                        airInjectionTime: "Beluchting per minuut",
                        airConcentratorMinutesPerHour: "Zuurstofconcentrator (min/uur)",
                        maxAirInjectionTime: "Maximale beluchting per minuut",
                        airIndexManual: "Beluchtingsregeling",
                        maxLimitH2SAeration: "H₂S max. limiet (beluchting verlagen)",
                        minLimitH2SAeration: "H₂S min. limiet (beluchting verhogen)",
                        torch: "Fakkel",
                        torchType: "Fakkel type",
                        torchStatus: "Fakkel status",
                        torchError: "Fakkel fout",
                        theoreticalTorchFlow: "Theoretisch fakkeldebiet",
                        torchRunningTime: "Fakkeltijd",
                        torchFlaredVolume: "Gefakkeld volume",
                        h2s: "H₂S",
                        h2sLevelReactor: "H₂S niveau reactor",
                        h2sLevelMotor: "H₂S niveau motor",
                        filterLoad: "Carbon filter belasting",
                        sample: "Monster",
                        latestH2sReadings: "Laatste H₂S-metingen",
                        carbonFilterSize: "Carbon filter grootte",
                        h2sMeasurements: "H₂S-metingen",
                        measurements: "Metingen",
                        changeTo: "Wijzig naar",
                        none: "Geen",
                        container: "Container",
                        extern: "Extern",
                        foamBeaterInstalled: "Schuimvreter geïnstalleerd",
                        antiFoamInjectionsInstalled: "Antischuim-injecties geïnstalleerd",
                        containerCombinedOperation: "Container (gecombineerde operatie)",
                        externCombinedOperation: "Extern (gecombineerde operatie)",
                        gasTemp: "T1 Temperature After Gascooler",
                        ch4BiogasSupply: "CH4-biogasaanvoer",
                        co2BiogasSupply: "CO2-biogasaanvoer",
                        o2BiogasSupply: "O2-biogasaanvoer",
                        h2sAfterFilter: "H2S na filter",
                        biomethaneFlowNorm: "Norm biomethaanstroom",
                        ch4Biomethane: "CH4-biomethaan",
                        co2Biomethane: "CO2-biomethaan",
                        o2Biomethane: "O2-biomethaan",
                        h2sBiomethane: "H2S-biomethaan",
                        bufferRelease: "Bufferontlading",
                        wobbe: "Wobbe-index",
                        wobbeAvg: "Gemiddelde Wobbe-index",
                        wobbePidSetpoint: "Wobbe PID-instelwaarde",
                        wobbeBiomethanePronova: "Wobbe biomethaan Pronova",

                    },
                    engine: {
                        label: "motor",
                        startEngine: "Start motor",
                        stopEngine: "Stop motor",
                        power: "Vermogen",
                        desiredPower: "Gewenst vermogen",
                        maxPower: "Maximaal vermogen",
                        rpm: "Toerental motor (RPM)",
                        lambda: "Lambda",
                        throttleValve: "Servo positie",
                        engineType: "Motortype",
                        engineStatus: "Status motor",
                        engineError: "Motorfouten",
                        producedEnergy: "Totaal geproduceerde energie",
                        operatingHours: "Draaiuren",
                        totalOperatingHours: "Draaiuren totaal",
                        gasUsage: "Gas verbruik",
                        throttlePosition: "Throttle positie",
                        noErrors: "Alle systemen operationeel.",
                        production: "Productie",
                        servoAuto: "Servo wordt automatisch ingesteld",
                        servoControl: "Aansturing servo",
                        temperature: "Motor temperatuur",
                        restart: "Herstart automatisch wanneer er gas beschikbaar is",
                        confirmStop: "Weet u zeker dat u motor {{number}} wilt stoppen?",
                        confirmStopRestart: "Weet u zeker dat u motor {{number}} wilt stoppen? De motor herstart automatisch wanneer er gas beschikbaar is.",
                        idle: "Inactief",
                        running: "Draait",
                        waiting: "Wachten op opstarten",
                        booting: "Opstarten",
                        shuttingDown: "Afsluiten",
                        advanced: "Geavanceerd",
                        numberOfEngines: "Aantal motoren",
                        predeterminedRunHours: "Vooraf bepaalde draaiuren",
                        easyStart1: "Easy start motor 1",
                        easyStart2: "Easy start motor 2",
                        setError1: "Ingestelde fout motor 1",
                        setError2: "Ingestelde fout motor 2",
                        fuel: "Brandstof",
                        airIntakeOpen: "Luchtinlaat open",
                        airIntakeClosed: "Luchtinlaat gesloten",
                        vfd: "VFD",
                    },
                    service: {
                        label: "Onderhoud",
                        lastMaintenance: "Draaiuren tot volgende oliewissel",
                        currentlyInstalled: "Draaiuren van huidige apparatuur",
                        total: "Totaal aantal draaiuren",
                        mixer: "Mixer",
                        foam_beater: "Schuimvreter",
                        intake_pump: "Invoerpomp",
                        digestate_pump: "Digestaatpomp",
                        newMixer: "Nieuwe mixer geïnstalleerd",
                        newEngine: "Nieuwe motor geïnstalleerd",
                        newFoamBeater: "Nieuwe schuimvreter geïnstalleerd",
                        newIntakePump: "Nieuwe inlaatpomp geïnstalleerd",
                        newDigestatePump: "Nieuwe digestaatpomp geïnstalleerd",
                        confirmationMessage: "Bent u zeker over het resetten van de {{type}}",
                        maintenanceMessage: "Onderhoudsuren zijn gereset voor {{type}}",
                        newEquipmentMessage: "Nieuwe apparatuur geïnstalleerd:",
                        prints: "Prints",
                        firstOnline: "Eerst online",
                        lastOnline: "Laatst online",
                        serial: "Serienummer",
                        type: "Type",
                        engine: "Motor",
                        engine1: "Motor 1",
                        engine2: "Motor 2",
                        engine_new1: "Motor 1",
                        engine_new2: "Motor 2",
                        h2s1: "H₂S Motor 1",
                        h2s2: "H₂S Motor 2",
                        h2s1Gpi: "Carbon filter 1",
                        h2s2Gpi: "Carbon filter 2",
                        resetTo: "Reset naar x uren (standaard 0)",
                        timeFilterReplace: "Tijd sinds vervangen filter",
                        daysSinceOil: "Dagen sinds vervangen olie",
                        newGenerator: "Nieuwe generator geïnstalleerd",
                        generator: "Generator",
                        generator1: "Generator 1",
                        generator2: "Generator 2",
                        daysSinceOilChange: "Dagen sinds olieverversing",
                        videoMessage: "Video over het verversen van olie => Documentenpagina, onder Algemene video's.",
                        videoRoom: "Een servicetechnicus heeft een videozaal voor deze machine geopend. Klik hier om deel te nemen.",
                        videoButton: "Start een videozaal voor deze machine",
                        videoButtonSub: "Gebruikers met toegang kunnen de oproep vanaf hun servicepagina joinen.",
                        videoClose: "Sluit videozaal",
                        serialNumber: "Serienummer",
                        defaultEngineReset: "Standaard onderhoudsinterval",
                        newInstalled: "Nieuwe {{type}} geïnstalleerd",
                        replace: "Vervangen",
                        aircover: "Luchtkap",
                        gascover: "Gaskap",
                        liner: "Liner",
                        flow_meter: "Debietmeter",
                        energy_meter1: "Energie meter 1",
                        energy_meter2: "Energie meter 2",
                        energy_meter_own: "Energie meter eigen verbruik",
                        h2sPastille: "Tijd tot vervangen H2S sensor",
                        pastille1: "H₂S-sensor 1",
                        pastille2: "H₂S-sensor 2",
                        engineLabel: "Volgend motoronderhoud na “XX” uren",
                        engine1Conf: "Reset het onderhoudsinterval voor motor 1 enkel nadat het motoronderhoud uitgevoerd werd",
                        engine2Conf: "Reset het onderhoudsinterval voor motor 2 enkel nadat het motoronderhoud uitgevoerd werd",
                        h2s1Conf: "Reset H2S Motor 1 enkel wanneer het actiefkool in de filter vervangen werd",
                        h2s2Conf: "Reset H2S Motor 2 enkel wanneer het actiefkool in de filter vervangen werd",
                        filterResetOffline: "Machine is offline. De filterreset is niet opgeslagen. Maak opnieuw verbinding en probeer opnieuw.",
                        filterResetFailed: "Filterreset mislukt. De filterreset is niet opgeslagen.",
                        consumables: {
                            title: "Verbruiksartikelen",
                            belowMin: "Onder minimumvoorraad",
                            noneBelow: "Geen artikelen onder de minimumvoorraad",
                            notCounted: "Nog niet geteld",
                            article: "Artikelnummer",
                            description: "Beschrijving",
                            onSite: "Aanwezig",
                            minimum: "Minimum",
                            engineMaintenance: "Motoronderhoud",
                            pendingStock: "{{confirmed}} bevestigd + {{pending}} in afwachting van validatie",
                            send: "Verzenden",
                            shipmentSaved: "Verzending opgeslagen. Deze blijft in afwachting tot de klant bevestigt.",
                            shipmentFailed: "Verzending opslaan mislukt",
                            confirm: "Ontvangst bevestigen",
                            confirmSaved: "Voorraad bevestigd",
                            confirmFailed: "Voorraad bevestigen mislukt",
                            confirmHint: "Bevestig de levering om ze bij de voorraad ter plaatse te tellen.",
                            guideTitle: "Hoe dit werkt",
                            guideIntro: "Olie, oliefilters en ontstekingskaarsen blijven op elke installatie. De servicepagina van de installatie en deze bestelpagina gebruiken dezelfde voorraad.",
                            guide1Role: "Technieker",
                            guide1Title: "Tel wat ter plaatse ligt",
                            guide1Body: "Op de servicepagina van de installatie open je Verbruiksartikelen en vul je in hoeveel van elk artikel aanwezig is. Die telling is meteen bevestigd. Een telling ter plaatse wacht niet op iemand anders.",
                            guide2Role: "Automatisch",
                            guide2Title: "Motoronderhoud verbruikt voorraad",
                            guide2Body: "Bij registratie van motoronderhoud wordt het verbruik van die motor afgetrokken van de bevestigde voorraad. Een WG1605-onderhoud verbruikt 0,28 van een bus olie van 25 l, 1 oliefilter en 4 ontstekingskaarsen. WG972 en WG3800 gebruiken de aantallen in de tabel motoronderhoud. Dit gebeurt wanneer de installatie een statistiekrecord met een motortype heeft.",
                            guide3Role: "Servicemanager",
                            guide3Title: "Verzend wat ontbreekt",
                            guide3Body: "Deze pagina toont installaties waarvan de bevestigde voorraad kleiner of gelijk is aan het minimum. Vul de te verzenden hoeveelheid in en druk op Verzenden. Die blijft in afwachting, bijvoorbeeld 0,5 bevestigd + 5 in afwachting van validatie, en telt nog niet als voorraad. Het minimum stel je in per motortype. Voor een installatie tellen we de geïnstalleerde motoren op en ronden we af op een geheel getal. Eén stuk motorolie is één bus van 25 l.",
                            guide4Role: "Iedereen met toegang",
                            guide4Title: "Bevestig de levering",
                            guide4Body: "Wanneer de goederen ter plaatse zijn, bevestigt de klant, een technieker of een employee de ontvangst op de servicepagina van de installatie. De hoeveelheid in afwachting wordt bij de bevestigde voorraad geteld. 0,5 bevestigd en 5 in afwachting worden dan 5,5 ter plaatse.",
                            correction: "Stockcorrectie",
                            save: "Stocktelling opslaan",
                            saved: "Stocktelling opgeslagen",
                            saveFailed: "Stocktelling opslaan mislukt",
                            minSaved: "Minimumvoorraad opgeslagen",
                            minFailed: "Minimumvoorraad opslaan mislukt",
                            minHint: "Stel het minimum in per motortype. Voor een installatie tellen we de geïnstalleerde motoren op en ronden we af op een geheel getal. De installatie komt op de lijst zodra de voorraad kleiner of gelijk is aan dat minimum. Eén stuk motorolie is één bus van 25 l.",
                            usage: "Verbruik per motoronderhoud",
                            usageHint: "Bij registratie van motoronderhoud wordt dit verbruik automatisch afgetrokken van de getelde voorraad. DF972 en WG972 gebruiken de kolom WG972. WG3800-L gebruikt de kolom WG3800.",
                            orders: "Te lanceren bestellingen",
                            ordersEmpty: "Geen installaties op of onder de minimumvoorraad",
                            shortage: "Tekort",
                            installation: "Installatie",
                            engines: "Motoren",
                        },
                        membranes: {
                            title: "Membranen",
                            overview: "Alle membranen",
                            overviewTitle: "Overzicht geïnstalleerde membranen",
                            searchPlaceholder: "Zoek installatie, product, charge, housing…",
                            search: "Zoeken",
                            installation: "Installatie",
                            stage: "Stage",
                            scpCo2: "SCP CO2",
                            percent: "%",
                            scpO2: "SCP O2",
                            selO2N2: "Sel O2/N2",
                            selCo2Ch4: "Sel CO2/CH4",
                            scpCo2N: "SCP CO2_n",
                            productName: "Product name",
                            productCode: "Product code",
                            chargeNo: "Charge No.",
                            housingNo: "Housing No.",
                            installationDate: "Installatiedatum",
                            addRow: "Membraan toevoegen",
                            none: "Geen membranen geregistreerd",
                            fetchError: "Membranen laden mislukt",
                            saved: "Membraan opgeslagen",
                            added: "Membraan toegevoegd",
                            saveError: "Membraan opslaan mislukt",
                            deleteConfirm: "Dit membraan verwijderen?",
                            deleted: "Membraan verwijderd",
                            deleteError: "Membraan verwijderen mislukt",
                        },
                        pastille1Conf: "Reset de levensduur van de H2S sensor 1 enkel wanneer het sensor element vervangen werd.",
                        pastille2Conf: "Reset de levensduur van de H2S sensor 2 enkel wanneer het sensor element vervangen werd.",
                        pastilleLabel: "Verwachte levensduur sensorelement XX dagen",
                        valve_interval: "Draaiuren tot controle klepspeling",
                        cylinder_interval: "Draaiuren tot revisie cilinderkop",
                        valve_interval_engine1: "Draaiuren tot controle klepspeling motor 1",
                        cylinder_interval_engine1: "Draaiuren tot revisie cilinderkop motor 1",
                        valve_interval_engine2: "Draaiuren tot controle klepspeling motor 2",
                        cylinder_interval_engine2: "Draaiuren tot revisie cilinderkop motor 2",
                        pipe: "Pijp",
                        transmitter: "Zender",
                        elektromotor: "Elektromotor",
                        pump: "Pomp",
                        roofsolation: "Dakisolatie",
                        airPump: "Luchtinjectiepomp",
                        oxygenConcentrator: "Zuurstofconcentrator",
                        flowmeterBiogas: "Flowmeter biogas",
                        pronovaBiomethaan: "ProNova biomethaan",
                        pronovaBiogas: "ProNova biogas",
                        h2s1Gpi: "Koolstoffilter 1",
                        h2s2Gpi: "Koolstoffilter 2",
                        coolant: "Koelmiddel",
                        daysSinceCoolantReplace: "Dagen sinds vervanging",
                        coolantConf: "Reset de bedrijfsuren van het koelmiddel enkel nadat het koelmiddel is vervangen",
                        daysSinceInhibitor: "Dagen sinds inhibitorenpakket",
                        inhibitorPackage: "Inhibitorenpakket",
                        registerInhibitor: "Registreren",
                        inhibitorConf: "Registreer enkel nadat het koelmiddel is aangevuld met een inhibitorenpakket (elke 12 maanden)",
                        restoreValues: {
                            button: "PLC-waarden herstellen",
                            title: "PLC-waarden herstellen",
                            description: "Kies een dag van de laatste 7 dagen die er juist uitziet, controleer de vooraf ingevulde waarden en stuur ze naar de PLC.",
                            pickDay: "Selecteer een dag",
                            snapshotTime: "Sampletijd",
                            noSnapshots: "Geen statistieken gevonden voor de laatste 7 dagen.",
                            send: "Verstuur",
                            sendAll: "Alles versturen",
                            sending: "Bezig…",
                            confirmSendAll: "Alle vooraf ingevulde waarden naar de PLC sturen?",
                            sendAllDone: "{{count}} waarden naar de PLC gestuurd",
                            emptyValue: "Waarde is leeg",
                            invalidValue: "Waarde is geen getal",
                            invalidEngineCount: "Aantal motoren moet 1 of 2 zijn",
                            noConnection: "Machine heeft geen actieve verbinding",
                            readOnly: "alleen-lezen",
                            fromMachine: "uit machinerecord",
                            current: "Nu",
                            currentHint: "Huidige live slow/fast-waarde op de CU",
                            ups: "UPS",
                            groupEngines: "Motoren",
                            groupReactor: "Reactor & mengen",
                            groupFeeding: "Voeding",
                            groupGas: "Gas",
                            groupEnergy: "Energietellers",
                            groupSsr: "SSR",
                        },
                        tabs: {
                            engine: "Motor",
                            reactor: "Reactor / Container",
                            gas: "Gas / Opwerking",
                            consumables: "Verbruiksartikelen",
                            options: "Machine-opties",
                            prints: "Prints",
                            restoreValues: "PLC-waarden herstellen",
                        },
                    },
                    net: {
                        net: "Net",
                        meterSettings: "Meterstanden",
                        voltagePerPhase1: "Spanning per fase (1)",
                        voltagePerPhase2: "Spanning per fase (2)",
                        voltagePerPhase3: "Spanning per fase (3)",
                        frequencyPerPhase: "Frequentie per fase",
                        angleBetweenPhase1And2: "Hoek tussen fase 1 en 2",
                        ownPowerConsumption: "Vermogen eigenverbruik",
                        ownEnergyConsumption: "Tellerstand eigenverbruik",
                        bioguardVersion: "Bioguard versie",
                        brutoProducedEnergy: "Bruto geproduceerde energie",
                        nettoProducedEnergy: "Netto geproduceerde energie",
                        producedEnergy: "Geproduceerde energie",
                        producedEnergyEngine1: "Geproduceerde energie motor 1",
                        producedEnergyEngine2: "Geproduceerde energie motor 2",
                        monitoringRelay: "Monitoringsrelais",
                        powerNonFit: "Stroom eigen verbruik niet-FIT",
                        energyMeterNonFit: "Energiemeter eigen verbruik niet-FIT",
                    },
                    reactor: {
                        label: "Reactor",
                        reactorTemp: "Reactortemperatuur",
                        reactorTempTarget: "Gewenste reactortemperatuur",
                        reactorLevel: "Gewenst reactorniveau",
                        hydrostaticPressure: "Actueel reactorniveau",
                        siloType: "Silo type",
                        extraHeating: "Extra verwarming actief",
                        antiFrost: "Antivries",
                        antiFrostIndex: "Antivries index",
                        antiFrostAuto: "De vorstindex wordt automatisch ingesteld op basis van de plaatselijke temperatuur",
                        antiFrostMessageNew: "Elke vorst-indexcyclus activeert de inlaatpomp gedurende 4 s en de uitlaatpomp voert ongeveer 100 l digestaat af, gebaseerd op het ingestelde debiet.",
                        antiFrostMessageOld: "Elke vorst-indexcyclus activeert de inlaatpomp gedurende 4 s en de uitlaatpomp gedurende 120 s.",
                        coolwater: "Koelwater",
                        statusCoolingValve: "Koelwater klep",
                        waterTempIn: "Koelwatertemperatuur reactor in",
                        waterTempOut: "Koelwatertemperatuur reactor uit",
                        waterTempMotorOut: "Koelwatertemperatuur motor 1 uit",
                        waterTempMotorOut2: "Koelwatertemperatuur motor 2 uit",
                        coolingWaterTemp: "Gewenste koelwatertemperatuur",
                        maxCoolingWaterTemp: "Maximum koelwatertemperatuur",
                        waterPressure: "Waterdruk in het koelwatercircuit",
                        foamBeater: "Schuim",
                        foambeatEveryXMinutes: "Breekt schuim om de",
                        foambeatForXSeconds: "Gedurende",
                        mixer: "Mixer",
                        mixerMaxPower: "Mixer maximum vermogen",
                        mixerActive: "Mixer actief",
                        mixerBlockedLowLevel: "Mixer geblokkeerd vanwege laag reactorniveau",
                        mixEveryXMinutes: "Mix iedere",
                        mixForXSeconds: "Gedurende",
                        blockMixingFrom: "Niet Mixen van",
                        blockMixingTo: "Tot",
                        mixerInfo: "Mixer wordt automatisch ingeschakeld voor geselecteerde duur met geselecteerd tijdsinterval. Tijdens het tijdvenster van het mixerblok wordt de mixer gestopt wanneer het geïnstalleerde mixervermogen de huidige stroomproductie van de installatie overschrijdt. De menger wordt tijdens het opstarten van de WKK tijdelijk gestopt totdat 50% van het nominale vermogen is bereikt om inschakelstroom mogelijk te maken",
                        mixerInfoGpi: "Mixer wordt automatisch ingeschakeld voor geselecteerde duur met geselecteerd tijdsinterval. Tijdens het tijdvenster van het mixerblok wordt de mixer gestopt wanneer het geïnstalleerde mixervermogen de huidige stroomproductie van de installatie overschrijdt.",
                        mix1Hour: "Mix voor 1 uur",
                        coolwaterValveInstalled: "Regelbare 3-weg klep",
                        coolwaterValveBinary: "Niet-regelbare driewegklep",
                        coolwaterValveMaximizeHeat: "Warmtegebruik maximaliseren",
                        coolwaterValveMaximizeHeatInfo: "Maximalisatie van warmtegebruik kan leiden tot periodes zonder warmtebeschikbaarheid bij de platenwarmtewisselaar",
                        coolwaterValvePlatePriority: "Prioriteit platenwarmtewisselaar",
                        coolwaterValvePlatePriorityInfo: "Prioriteer warmtebeschikbaarheid bij de platenwarmtewisselaar terwijl een stabiele vergistertemperatuur behouden blijft",
                        bypassFan: "Regelklep by-pass / ventilator",
                        digester: "Regelklep vergister / externe afname warmte",
                        silo: "Silo",
                        bag: "Zak",
                        plateHeatExchanger: "Platenwarmtewisselaar",
                        timesPerDay: "keer / dag",
                        intern: "Intern",
                        extern: "Extern",
                        tempHigh: "Temperatuur hoog",
                        externMessage: "De volgende foutmelding zal niet worden getriggerd als de mixer op extern staat: Mixer werkt niet, gelieve thermisch te resetten.",
                        bypass: "Bypass",
                        ventilator: "Ventilator",
                        tempCoolHeatExchOut: "Koelwatertemperatuur platenwarmtewisselaar uit",
                        overtempMixer1: "Overtemperatuur mixer 1",
                        overtempMixer2: "Overtemperatuur mixer 2",
                        mixerSettings: "Mixerinstellingen",
                        premixing: "Premixen",
                        intakeMixing: "Intake mixing",
                        premixingInfo: "Premixen is mixen voor de voeding, dus voor en tijdens het uitpompen. Tijd is steeds de mixtijd.",
                        intakeMixingInfo: "Intake mixing laat toe of je mixt tegelijkertijd met het inpompen. Bij OFF wordt het mixen niet uitgevoerd als de voeding bezig is.",
                        gpiMixDuringIntake: "Mix tijdens liquid feeding",
                        gpiMixDuringIntakeInfo: "Mixen tijdens de volledige liquid feeding.",
                        gpiMixDuringIntakeHelp: "Mix tijdens liquid feeding: mix tijdens liquid feeding, hele tijd van de voeding. OFF = afhankelijk van silotype.\n\nS-types: enkel premix tijdens exit en mixen na de voeding voor de duur van de mixertijd.\n\nC-types: geen premix en mixen na de voeding voor de duur van de mixertijd.",
                        gpiMixDuringIntakeOffGeneric: "Bij OFF: afhankelijk van silotype.",
                        gpiMixDuringIntakeOffS: "S-types: enkel premix tijdens exit en mixen na de voeding voor de duur van de mixertijd.",
                        gpiMixDuringIntakeOffC: "C-types: geen premix en mixen na de voeding voor de duur van de mixertijd.",
                        gpiMixDuringSolidFeedIntake: "Mix tijdens solid feed intake",
                        gpiMixDuringSolidFeedIntakeInfo: "Bij ON: mixen tijdens de volledige solid feed. Bij OFF: enkel mixen vóór en na de solid feed, telkens gedurende de tijd (in seconden) ingesteld bij “{{durationSetting}}”.",
                        gpiMixTimeBeforeAfterSolidIntake: "Mixtijd vóór/na solid feed",
                    },
                    efficiency: {
                        label: "Rendement",
                        production: "Energie productie afgelopen 30 dagen",
                        consumption: "Eigen energie verbruik afgelopen 30 dagen",
                        nettoProduction: "Netto energie productie afgelopen 30 dagen",
                        averageEfficiency: "Gemiddeld rendement afgelopen 30 dagen",
                        averageTechnicalEfficiency: "Gemiddelde technische beschikbaarheid afgelopen 30 dagen",
                        bgp: "Mestkwaliteit (BGP batch)",
                        top10: "Top 10 projecten afgelopen maand",
                        realised: "Gerealiseerd rendement",
                        technical: "Technische beschikbaarheid",
                        bgpInfo: "Schatting van de BGP [m³/ton]. Houdt geen rekening met verliezen door stilstand, overproductie of affakkelen.",
                        pointPerDay: "%/dag",
                        trendline: "Trendlijn",
                        injectedGas: "Geïnjecteerd biomethaan",
                        fuduraInjectedGas: "Geïnjecteerd biomethaan",
                        fuduraInjectedGasScaled: "Geïnjecteerd biomethaan",
                        fuduraEfficiency: "Gerealiseerd rendement",
                        fuduraEfficiencyScaled: "Gerealiseerd rendement",
                        heatProductionKenter: "Warmteproductie (Kenter)",
                        heatProductionFudura: "Warmteproductie (Fudura)",
                        fuduraChannels: "Fudura kanalen (30d)",
                        noHeatTelemetryData: "Geen externe warmtedata beschikbaar voor deze periode.",
                        heatTelemetrySyncHint: "Warmteproductie verschijnt hier zodra Kenter- of Fudura-metingen gesynchroniseerd zijn.",
                    },
                    general: {
                        label: "Algemeen",
                        hardwareVersion: "Hardware versie",
                        otGenContact: "OT Gen-contact",
                        engine1And2Off: "Motor 1 en 2 uit",
                        engine1On: "Motor 1 aan",
                        engine2On: "Motor 2 aan",
                        engine1And2On: "Motor 1 en 2 aan",
                        notes: "Notities",
                        h2sSensorFirmwareVersion: "H₂S-sensor firmwareversie",
                        idH2s: "S/N H₂S ID",
                        bioId: "S/N Biotronic ID",
                        identifier: "Installatie-ID",
                        collabContract: "Samenwerkingscontract",
                        own: "Onderhoudscontract",
                        sold: "Verkochte installatie",
                        productionDate: "Productiedatum",
                        commissioningDate: "Ingebruiknamedatum",
                        controlCardTemp: "Stuurkaart temperatuur",
                        batteryVoltage: "Batterij spanning",
                        motorVoltage: "Spanning motor",
                        overtempFlueGasHeatExch: "Overtemperatuur rookgaswarmtewisselaar motor",
                        rebootMainBoard: "Herstart hoofdbord",
                        rebootNow: "Nu herstarten",
                        utcOffset: "UTC-offset",
                        location: "Locatie",
                        network: "Netwerk",
                        ip: "IP",
                        mask: "Masker",
                        gateway: "Gateway",
                        dns: "DNS",
                        pcb: "PCB",
                        firmware: "Firmware",
                        mainControlUnit: "Hoofd besturingseenheid",
                        bioguard: "Bioguard",
                        biotronicEngine1: "Biotronic motor 1",
                        biotronicEngine2: "Biotronic motor 2",
                        h2sEngine1: "H₂S motor 1",
                        h2sEngine2: "H₂S motor 2",
                        bioIdEngine1: "Bio ID motor 1",
                        bioIdEngine2: "Bio ID motor 2",
                        modificationsToMachine: "Aanpassingen aan de machine",
                        firmwareOutdated: "Verouderd",
                        firmwareCustom: "Custom firmware",
                        firmwareNotFound: "Niet gevonden",
                        name: "Naam",
                        hostNameFirmware: "Firmware",
                        hostNameDatabase: "Database",
                        normal: "Normaal",
                        lowError: "Laag (fout)",
                        nta8080Title: "NTA 8080 rapport",
                        nta8080Description: "Download een maandelijks NTA 8080-rapport. Data wordt pas opgehaald wanneer je het rapport opvraagt.",
                        nta8080Month: "Maand",
                        nta8080Download: "Rapport ophalen",
                        nta8080DownloadPdf: "Download PDF",
                        nta8080DownloadCsv: "Download CSV",
                        nta8080Loading: "Bezig…",
                        nta8080SelectMonth: "Selecteer eerst een maand",
                        nta8080InvalidMonth: "Ongeldige maand geselecteerd",
                        nta8080DownloadError: "Rapport downloaden mislukt",
                    },
                    feeding: {
                        label: "Voeding",
                        feedingVolume: "Maximumvolume verse voeding per cyclus",
                        feedingCyclesPerDay: "Dagelijkse voedingscycli",
                        feedingCyclesPerDayInfo: "Verpompt volume minder dan 75% van het gewenst volume geeft aanleiding tot voedingserror \"geen debiet bij inpompen verse mest\". Verpompt volume 75 tot 100% gewenst volume geeft aanleiding tot melding \"Voedingscyclus gedeeltelijk uitgevoerd. Lege put gedetecteerd voordat het ingestelde volume is bereikt.\"",
                        feedingBalance: "Voeding saldo",
                        autoFeedingActive: "Automatische voeding",
                        blockHighElectricalConsumption: "Blokkeer warmtepomp verwarming vergister tijdens mixvenster",
                        blockHighElectricalConsumptionInfo: "Bij ON: warmtepomp verwarming van de vergister wordt geblokkeerd tijdens het mixvenster. Bij OFF: niet blokkeren.",
                        minimizeElectricalConsumptionFrom: "Elektrisch verbruik minimaliseren van",
                        minimizeElectricalConsumptionTo: "tot",
                        autoFeedingStartHour: "Automatische voeding startuur",
                        exitPumpRunning: "Uitpompen",
                        feedingCycle: "Voedingscyclus",
                        onlyInput: "Enkel inpompen",
                        onlyOutput: "Enkel uitpompen",
                        startFeeding: "Start voeding",
                        stopFeeding: "Stop voeding",
                        customAmount: "Aangepaste hoeveelheid",
                        customAmountHint: "Vooraf ingevuld met de ingestelde voeding. Pas enkel aan voor een aangepaste hoeveelheid. Max. {{maxRiseCm}} cm niveau-stijging ({{maxLiters}} l voor deze silo).",
                        customAmountInvalid: "Geef een waarde tussen {{min}} en {{max}} l in",
                        customAmountExceedsLevelRise: "De ingevoerde hoeveelheid ({{amount}} l) zou het tankniveau met meer dan {{maxRiseCm}} cm laten stijgen. Maximum voor deze silo is {{maxLiters}} l.",
                        customAmountUnknownSilo: "Maximumhoeveelheid kan niet berekend worden: onbekend silotype.",
                        customAmountExceedsWarning: "De ingevoerde hoeveelheid ({{amount}} l) is hoger dan de ingestelde voeding ({{feedingVolume}} l). Weet je zeker dat je wilt doorgaan?",
                        pumpOutFlowRate: "Theoretisch uitpomp debiet",
                        pumpOutFlowRateInfo: "Theoretisch uitpompdebiet wordt gebruikt in de berekening van de duur om digestaat uit de vergister te pompen. Bij een te lage instelling zal teveel digestaat uitgepompt worden, bij een te hoge instelling zal te weinig digestaat uitgepompt worden. Typische waarden zijn:",
                        pumpOutFlowRateBellowsPump: "Balgpomp: ± 3 m³/u",
                        pumpOutFlowRateCentrifugalPump: "Centrifugaalpomp: ± 50 m³/u",
                        pumpOutFlowRateGravityOutlet: "Gravitaire uitloop: ± 50 m³/u",
                        kiloPerPulse: "Debietmeter puls",
                        intakeTimeout: "Voeding: time-out verse voeding",
                        averageDailyFeeding: "Gem. dagelijkse voeding laatste maand",
                        retentionTime: "Standtijd",
                        statusValvePumpIn: "Klep vers in - 2",
                        statusValvePumpOut: "Klep reactor uit - 3",
                        statusValveRetourReactor: "Klep retour reactor - 4",
                        valveCurrentActuator: "Stroom klep actuator",
                        actuatorSetting: "Actuator-instelling",
                        actuatorSettingV1: "Linak",
                        actuatorSettingV2: "Hiwin / Mikrosystem",
                        lastFeeding: "Huidige / Laatste voeding",
                        startHourLastFeeding: "Start van laatste voeding",
                        feedingStatus: "Voedingspompen status",
                        feedingError: "Reactor error",
                        intakePumpTime: "Inpomp tijd",
                        intakePumpAmount: "Inpomp volume",
                        exitPumpTime: "Uitpomp tijd",
                        exitPumpAmount: "Theoretisch uitpompvolume",
                        feedingHistory: "Voeding geschiedenis",
                        startedOn: "Gestart op",
                        temperature: "Temperatuur",
                        reactorLevel: "Reactorniveau",
                        balance: "Saldo",
                        acknowledge: "Erken error",
                        intakeSpeed: "Pompsnelheid",
                        balanceWarning: "Waarschuwing, dit zal geen normale voedcyclus starten maar in plaats daarvan de resterende balanswaarde in de reactor pompen",
                        automaticFeedingSettings: "Instellingen automatische voeding",
                        manualFeeding: "Handmatige voeding",
                        pumpSettings: "Pompinstellingen",
                        lastFeedingTime: "Laatste voedingstijd",
                        status: {
                            "0": "Inactief",
                            "1": "Niveaumeting",
                            "2": "Uitpompen",
                            "3": "Inpompen",
                            "5": "Ontdooien",
                            "6": "Gasverwijdering",
                            "7": "Manueel uitpompen",
                            "10": "Opstart",
                            "2,001": "Uitpompen: Voormixen",
                            "2,002": "Uitpompen",
                            "2,003": "Uitpompen: Open uitklep",
                            "2,004": "Uitpompen: Open uitklep",
                            "2,005": "Uitpompen: Starten pomp",
                            "2,006": "Uitpompen",
                            "2,007": "Uitpompen: Mest pompen",
                            "2,008": "Uitpompen: Stop uitpompcyclus",
                            "2,009": "Uitpompen: Stop uitpompcyclus",
                            "2,010": "Uitpompen: Sluit uitklep",
                            "2,011": "Uitpompen: Sluit uitklep",
                            "2,012": "Uitpompen: Stop uitpompcyclus",
                            "3,001": "Inpompen: Voorbereiden",
                            "3,002": "Inpompen: Voorbereiden",
                            "3,003": "Inpompen: Voorbereiden",
                            "3,004": "Inpompen: Mest pompen",
                            "3,005": "Inpompen: Mest pompen",
                            "3,006": "Inpompen: Afronden",
                            "3,007": "Inpompen: Afronden",
                            "3,008": "Inpompen: Stop pomp",
                            "3,009": "Inpompen: Stop pomp",
                            "3,010": "Inpompen: Stop pomp",
                            "3,011": "Inpompen: Stop pomp",
                            "3,012": "Inpompen: Afronden",
                            "5,001": "Ontdooien: Inpompen testen",
                            "5,002": "Ontdooien: Inpompen testen",
                            "5,003": "Ontdooien: Inpompen testen",
                            "5,004": "Ontdooien: Inpompen testen",
                            "5,005": "Ontdooien: Inpompen stoppen",
                            "5,006": "Ontdooien: Open uitklep",
                            "5,007": "Ontdooien: Open uitklep",
                            "5,008": "Ontdooien: Uitpompen testen",
                            "5,009": "Ontdooien: Uitpompen testen",
                            "5,010": "Ontdooien: Uitpompen testen",
                            "5,011": "Ontdooien: Uitpompen testen",
                            "5,012": "Ontdooien: Uitpompen testen",
                            "5,013": "Ontdooien: Sluit uitklep",
                            "5,014": "Ontdooien: Sluit uitklep",
                            "5,015": "Ontdooien: Afronden",
                            "6,001": "Gasverwijdering: Open uitklep",
                            "6,002": "Gasverwijdering: Open uitklep",
                            "6,003": "Gasverwijdering: Sluit uitklep",
                            "6,004": "Gasverwijdering: Sluit uitklep",
                            "6,005": "Gasverwijdering",
                            "7,001": "Manueel uitpompen: Open uitklep",
                            "7,002": "Manueel uitpompen: Open uitklep",
                            "7,003": "Manueel uitpompen: Mest pompen",
                            "7,004": "Manueel uitpompen: Stop pomp",
                            "7,005": "Manueel uitpompen: Sluit uitklep",
                            "7,006": "Manueel uitpompen: Sluit uitklep",
                            "7,007": "Manueel uitpompen: Afronden",
                            "7,008": "Manueel uitpompen: Afronden",
                            "10,001": "Opstart: Sluit klep 2",
                            "10,002": "Opstart: Sluit klep 2",
                            "10,003": "Opstart: Sluit uitklep",
                            "10,004": "Opstart: Sluit uitklep",
                            "10,005": "Opstart: Sluit klep 4",
                            "10,006": "Opstart: Sluit klep 4",
                            "10,007": "Opstart: Controleren net verbinding",
                            "10,008": "Opstart: Controleren net verbinding",
                            "10,009": "Booting"
                        }
                    },
                    users: {
                        label: "Gebruikers",
                        customers: "gekoppelde klanten",
                        technicians: "gekoppelde techniekers",
                        resellers: "gekoppelde resellers",
                    },
                    recommendations: {
                        label: "Aanbevelingen",
                    },
                    machineTasks: {
                        title: "Installatietaken",
                        overviewTitle: "Overzicht installatietaken",
                        open: "Open",
                        completed: "Afgewerkt",
                        linkTask: "Taak koppelen aan deze installatie",
                        bulkLinkTask: "Taak koppelen aan meerdere installaties",
                        bulkLink: "Koppelen aan geselecteerde installaties",
                        selectMachines: "Installaties",
                        selectMachinesPlaceholder: "Selecteer een of meer installaties…",
                        bulkLinkSuccess: "Taak gekoppeld aan {{count}} installatie(s).",
                        bulkLinkPartial: "Taak gekoppeld aan {{linked}} installatie(s). {{skipped}} hadden deze taak al.",
                        bulkLinkSkipped: "Taak was al gekoppeld aan alle geselecteerde installaties.",
                        filterByMachine: "Filter op installatie",
                        allMachines: "Alle installaties",
                        machine: "Installatie",
                        openOverview: "Open overzicht installatietaken (bulk koppelen, alle installaties)",
                        noOpenTasksOverview: "Geen open installatietaken gevonden.",
                        selectTask: "Taak",
                        selectTaskPlaceholder: "Kies een taak…",
                        assignee: "Uitvoerder",
                        unassigned: "Niet toegewezen",
                        link: "Koppelen",
                        newCatalogTask: "Nieuwe taak toevoegen aan catalogus",
                        newCatalogTaskPlaceholder: "bv. Antenne IXON router naplaatsen",
                        addToCatalog: "Toevoegen aan catalogus",
                        description: "Omschrijving",
                        notes: "Notities",
                        notesPlaceholder: "bv. Kon niet uitgevoerd worden omdat onderdelen ontbraken",
                        completedBy: "Afgewerkt door",
                        completedAt: "Afgewerkt op",
                        actions: "Acties",
                        complete: "Afmaken",
                        unlink: "Ontkoppelen",
                        reopen: "Heropenen",
                        confirmUnlink: "Deze taak van de installatie verwijderen?",
                        noOpenTasks: "Geen open taken gekoppeld aan deze installatie.",
                        noCompletedTasks: "Nog geen afgewerkte taken.",
                        quickTask: "Snelle taak toevoegen",
                        quickTaskHelp: "Eenmalige taak voor deze installatie alleen. Verschijnt niet in de gedeelde catalogus.",
                        quickTaskPlaceholder: "bv. Tijdelijke kabeloplossing tot wisselstuk er is",
                        addQuickTask: "Snelle taak toevoegen",
                        quickBadge: "Snel",
                    },
                    firmware: {
                        invalidFile: "Selecteer een .hex-bestand",
                        uploadStarted: "Firmware-upload gestart",
                        uploadFailed: "Firmware-upload mislukt",
                        uploading: "Bezig met uploaden…",
                        uploadProgress: "Uploadvoortgang: {{progress}}%",
                        currentVersion: "Huidige versie",
                    },
                    documents: {
                        label: "Documenten",
                        specificDocuments: "Specifieke documenten",
                        specificImages: "Specifieke afbeeldingen",
                        generalVideos: "Algemene video's",
                        general: "Algemene documentatie",
                        generalDocuments: "Algemene documenten",
                        checklists: "Checklists",
                        construction: "Constructie checklist",
                        production: "Productie checklist",
                        upload: "Uploaden",
                        uploadSuccess: "U heeft {{name}} succesvol geüpload",
                        deleteSuccess: "U heeft het bestand {{name}} succesvol verwijderd",
                        noFilesAvailable: "Geen bestanden beschikbaar in de categorie {{category}}.",
                        fileSizeExceeds: "Bestandsgrootte overschrijdt de limiet van {{size}}Mb",
                        invalidImageType: "Alleen JPG- en PNG-afbeeldingen zijn toegestaan",
                        chooseFileFirst: "Kies eerst een bestand.",
                        default: "Standaard",
                        permits: "Vergunningen",
                        plans: "Plannen",
                        planning: "Planning",
                        certification: "Certificering",
                        regulations: "Regelgeving",
                        instructions: "Handleidingen",
                        templates: "Sjablonen"
                    },
                    warnings: {
                        "W001": "Eigen verbruik groter dan drempelwaarde in de afgelopen 24 uren (72 kWh voor 10-44kW installatie, 250 kWh for 60-74kW installatie)",
                        "W002": "Reactortemperatuur is dramatisch gezakt",
                        "W003": "Service binnen de 48 uren",
                        "W004": "Carbonfilter motor 1 te vervangen",
                        "W005": "Carbonfilter motor 2 te vervangen",
                        "W006": "Gasbuffer meting bevroren",
                        "W007": "Gasbuffer meting defect",
                        "W008": "Gisteren niet gevoed",
                        "W009": "Pompsnelheid laatste voeding ging 50% sneller dan het gemiddelde van de laatste maand",
                        "W010": "H₂S waarde te hoog (>1500)",
                        "W011": "Aeratie is 60",
                        "W012": "Aeratie is lager of gelijk aan 3",
                        "W013": "Rendement was gisteren 0 en autofeed staat aan",
                        "W014": "H₂S reactor meting - afwijking overschrijdt 400ppm",
                        "W015": "Luchtinjectie zeer hoog - opgepast voor gaskwaliteit",
                        "W016": "H₂S meting faalt gedurende 24h",
                        "W017": "Mixer olie te laag",
                        "W018": "Motorolie te laag",
                        "W020": "Lage waterdruk",
                        "W104": "H₂S waarde te hoog (>200) of aeratie is 60 of 3",
                        "W105": "Belading van de carbon filter te hoog",
                        "W114": "Rendement was gisteren geen 0 en autofeed staat uit"
                    },
                    advanced: {
                        language: "LCD Scherm Taal",
                        lambdaUpperLimit: "Lambda bovengrens (narrow range)",
                        lambdaLowerLimit: "Lambda ondergrens (narrow range)",
                        coolingValve: "Koelwater klep",
                        maxPower: "Max Vermogen (Database) Motor 1",
                        maxPower2: "Max Vermogen (Database) Motor 2",
                        bioId: "Bio ID Motor 1",
                        bioId2: "Bio ID Motor 2",
                        currentSsrConfiguration: "Huidige SSR configuratie",
                        SSRString: "SSR-tekenreeks",
                        digitalInputs: "Digitale inputs",
                        digitalInputsInfo: "Live DI-status van de control unit (open = 1, gesloten = 0). De mapping staat in de database en is hier niet te wijzigen.",
                        function: "Functie",
                        contactType: "Type",
                        diMeaning: "Betekenis 0 / 1",
                        status: "Status",
                        diOpen: "Open",
                        diClosed: "Gesloten",
                    },
                    sms: {
                        duringDay: "Ontvang sms berichten overdag",
                        duringNight: "Ontvang sms berichten 's nachts",
                        sendSms: "Verwittig klanten via sms",
                        sendTestSms: "Testbericht versturen",
                        testSms: "Test SMS",
                        testSmsToAllSenders: "Verstuur testbericht naar alle afzenders (probleemoplossing)",
                        recipients: "Ontvangers",
                        settings: "SMS-instellingen",
                        enterMessage: "Voer hier uw bericht in...",
                        smsSentSuccessfully: "SMS-berichten succesvol verzonden",
                        pleaseSelectAtLeastOneRecipient: "Selecteer ten minste één ontvanger",
                        pleaseEnterAMessage: "Voer een bericht in",
                        failedToSendSmsMessages: "SMS-berichten verzenden mislukt",
                        smsSettingsUpdatedSuccessfully: "SMS-instellingen succesvol bijgewerkt",
                        message: "Bericht",
                        testNotificationToAllSenders: "Verstuur testmelding naar alle afzenders (probleemoplossing)",
                        sendTestNotification: "Testmelding versturen",
                        testNotificationsSentSuccessfully: "Testmeldingen succesvol verzonden",
                        failedToSendTestNotifications: "Testmeldingen verzenden mislukt",
                    },
                    temperatures: {
                        label: "Temperaturen",
                        oilCoolerTemp: "Oliekoeler temperatuur",
                        biogasTempAfterReheat: "T5 Temperature After Reheating",
                        blowerOutTemp: "T2 Temperature Inlet Compressor",
                        compressorOutTemp: "T3 Temperature Outlet Compressor",
                        biogasTempAfterCool: "T4 Temperature After Cooling",
                    },
                    pressures: {
                        label: "Drukken",
                        biogasPressureBeforeMembrane: "P4 Pressure Inlet Membranes",
                        stage3Pressure: "P5 Pressure Membrane Stage 3",
                        pressureAfterMembrane: "P6 Pressure Outlet Membranes",
                        blowerPressure: "P1 Pressure Outlet Blower",
                        blowerPressureSetpoint: "Pressure Outlet Blower Setpoint",
                        compressorOutPressure: "P3 Pressure Outlet Compressor",
                    },
                    valves: {
                        label: "Kleppen",
                        valveCompressor: "Klep compressor",
                        valveMembrane: "Klep membraan",
                        valveGrid: "Klep net",
                        valveCo2: "Klep CO2",
                    },
                    system: {
                        label: "Systeem",
                        installationState: "Installatiestatus",
                        geuAvailable: "GEU beschikbaar",
                        geuAlarm: "GEU alarm",
                        geuDelivering: "GEU levert",
                        gasTotalGeu: "Gas totaal GEU",
                        gasTotalInternGeu: "Gas totaal intern GEU",
                        biogasTotalizer: "Biogastotalisator",
                        biomethaneDewpoint: "Biomethaan dauwpunt",
                        compressorSpeed: "Compressorsnelheid",
                    },
                    filters: {
                        label: "Filters",
                        inletFilterPressuredrop: "Drukval inlaatfilter",
                        filterTrainPressuredrop: "Drukval filtertrein",
                        oilFilterPressuredrop: "Drukval oliefilter",
                    },
                    checks: {
                        yourImage: "Uw afbeelding:",
                        imageCommentsLabel: "Opmerkingen bij deze afbeelding (optioneel):",
                        imageCommentsPlaceholder: "Voeg opmerkingen over deze afbeelding toe",
                        exampleImage: "Voorbeeldafbeelding:",
                        textAnswerPlaceholder: "Typ hier uw antwoord",
                        next: "Volgende",
                        completedMessage: "U hebt alle constructiecontroles voltooid, gelieve de checklist te versturen.",
                        skip: "Overslaan",
                        downloadPdf: "PDF downloaden",
                        answerLabel: "Antwoord:",
                        commentsLabel: "Opmerkingen:",
                        selectedOptionsLabel: "Geselecteerde opties:",
                        addEntry: "Invoer toevoegen",
                        newEntryForCheck: "Nieuwe invoer voor deze controle:",
                        commentsOptionalPlaceholder: "Opmerkingen (optioneel)",
                        yourAnswerPlaceholder: "Uw antwoord",
                        saveEntry: "Invoer opslaan",
                        cancel: "Annuleren",
                        entryAdded: "Invoer toegevoegd.",
                        entryAddFailedPrefix: "Toevoegen van invoer mislukt: ",
                        validateBeforeSubmitting: "Gelieve een antwoord in te vullen voordat u verstuurt.",
                        validateBeforeNextCheck: "Gelieve een antwoord in te vullen voordat u naar de volgende controle gaat.",
                        uploadSuccess: "Gegevens succesvol verzonden",
                        uploadFailedPrefix: "Verzenden van gegevens mislukt: ",
                        serialScanPhotoLabel: "Foto van typeplaatje / label",
                        serialScanChooseSource: "Maak een foto of kies een bestaande afbeelding",
                        serialScanTip: "Vul het kader zo veel mogelijk met het serienummer voor het beste resultaat",
                        serialScanTakePhoto: "Foto nemen",
                        serialScanChooseGallery: "Kiezen uit galerij",
                        serialScanProgressHint: "Meerdere beeldverbeteringen proberen…",
                        serialScanning: "Label scannen…",
                        serialScanSuggestions: "Suggesties van scan",
                        serialScanManualLabel: "Serienummer",
                        serialScanManualPlaceholder: "Voer het serienummer in of corrigeer het",
                        serialScanConfirm: "Serienummer bevestigen",
                        serialScanRescan: "Opnieuw scannen",
                        serialScanConfirmedLabel: "Bevestigd",
                        serialScanConfirmed: "Serienummer bevestigd.",
                        serialScanNoCandidates: "Geen serienummer gedetecteerd. Voer het handmatig in.",
                        serialScanFailed: "Scan mislukt. Voer het serienummer handmatig in.",
                        serialScanEnterValue: "Selecteer of voer eerst een serienummer in.",
                        serialScanInvalidPattern: "Dit serienummer komt niet overeen met het verwachte formaat.",
                    }
                }
            },
            fr: {
                translation: {
                    dashboard: {
                        nameIdentifier: "Nom ou identifiant",
                        efficiencyAll: "Efficacité de toutes les machines",
                        onlyErrors: "Uniquement les erreurs",
                        toggleDisconnected: "Basculer les machines déconnectées",
                        productionCombined: "Production combinée (Wh)",
                        realisedTechnicalEfficiency: "Efficacité réalisée / Efficacité technique (%)",
                        efficiencyCombined: "Efficacité réalisée (%)",
                        technicalEfficiencyCombined: "Efficacité technique (%)",
                        bgp: "Bgp (m³/tonne)",
                        consumption: "Consommation (Wh)",
                        manureLifeTime: "Durée de vie du fumier (jours)",
                        feeding: "Alimentation (kg)"
                    },
                    common: {
                        on: "Allumé",
                        off: "Éteint",
                        add: "Ajouter",
                        save: "Enregistrer",
                        monday: "Lundi",
                        tuesday: "Mardi",
                        wednesday: "Mercredi",
                        thursday: "Jeudi",
                        friday: "Vendredi",
                        saturday: "Samedi",
                        sunday: "Dimanche",
                        from: "De",
                        to: "À",
                        hours: "heures",
                        reset: "Réinitialiser",
                        confirmation: "Confirmation",
                        cancel: "Annuler",
                        yesIAmSure: "Oui, je suis sûr",
                        set: "Ajuster",
                        auto: "Auto",
                        manual: "Manuel",
                        minutes: "minutes",
                        seconds: "secondes",
                        turnOn: "Allumer",
                        turnOff: "Éteindre",
                        graphLoading: "Chargement des graphiques...",
                        noData: "Pas de données disponibles...",
                        hoursPerYear: "heures / année",
                        datetime: "Date et heure",
                        warning: "Avertissement",
                        error: "Erreur",
                        type: "Type",
                        startdate: "Date de début",
                        enddate: "Date de fin",
                        all: "Tous",
                        engine1: "Moteur 1",
                        engine2: "Moteur 2",
                        ongoing: "En cours",
                        both: "Les deux",
                        days: "Jours",
                        today: "Aujourd'hui",
                        sendAnswers: "Envoyer les réponses",
                        employee: "Employé",
                        customer: "Client",
                        sales: "Ventes",
                        technician: "Technicien",
                        admin: "Administrateur",
                        noDateKnown: "Date inconnue",
                        command: "Commande",
                        user: "Utilisateur",
                        fillInSurvey: "Veuillez remplir le sondage",
                        tons: "tonne",
                        count: "Compte",
                        disabled: "Désactivé",
                        addField: "Ajouter un champ",
                        deleteField: "Supprimer le champ",
                        releases: "Versions",
                        open: "Ouvrir",
                        close: "Fermer",
                        opening: "Ouverture",
                        closing: "Fermeture",
                        zoomCancel: "Zoom annulé, restez à l'intérieur du graphique pour zoomer",
                        stuck: "Bloqué"
                    },
                    errorPage: {
                        title: "Une erreur s'est produite.",
                        contact: "Veuillez signaler ce problème à it@biolectric.com en indiquant quel téléphone ou navigateur vous utilisez.",
                        reload: "Recharger"
                    },
                    popups: {
                        engineIdle: "Le moteur n'est pas au ralenti, veuillez d'abord éteindre le moteur",
                        valueBetween: "La valeur doit être comprise entre {{min}} et {{max}}",
                        valueBetweenCustom: "La valeur doit être comprise entre {{min}} et {{max}}",
                        powerTooLow: "La puissance ne peut pas être réglée en dessous de {{watts}}W",
                        powerTooHigh: "La puissance ne peut pas être réglée au-dessus de {{maxPower}}",
                        maxCoolingTemp: "Ne peut pas être supérieur à {{max}}°C",
                        minValue: "Ne peut pas être inférieur à {{min}}",
                        maxAirInjectionTime: "Ne peut pas être supérieur à {{max}} secondes",
                        minGasBuffer: "Tampon de gaz minimum hors limites. La valeur minimale pour votre installation est {{min}}",
                        maxGasBuffer: "Tampon de gaz maximum hors limites. La valeur maximale pour votre installation est {{max}}",
                        reactorTemp: "Température du réacteur hors limites. Doit être comprise entre {{min}} et {{max}}",
                        reactorLevel: "Niveau du réacteur non valide. La valeur maximale pour votre installation est {{limit}}",
                        reactorLevelRange: "La valeur du niveau du réacteur doit être comprise entre {{min}} et {{max}}",
                        commandFailed: "Échec de l'envoi de la commande",
                        commandSent: "Commande envoyée",
                        commandSuccess: "Vous avez mis à jour avec succès {{command}} de {{previousValue}} à {{value}}",
                        commandMix1Hour: "Le mélangeur fonctionnera pendant 1 heure",
                    },
                    menu: {
                        dashboard: 'Tableau de bord',
                        machines: 'Machinerie',
                        questionnaires: 'Des questionnaires',
                        banners: "Bannières",
                        errors: "Erreurs et avertissements",
                        firmware: "Historique du micrologiciel",
                        tasks: "Mes tâches",
                        releases: "Notes de version",
                        resellers: "Revendeurs",
                        users: "Utilisateurs",
                        recommendations: "Recommandations",
                        suggestions: "Messages de recommandation",
                        faultTrees: "Arbres de defauts",
                        assistant: "Assistant",
                        language: "Langue",
                        reconnection: "Cette machine est actuellement hors ligne. Essayez d'établir une nouvelle connexion avec le bouton ci-dessus.",
                        profile: "Profil",
                        logout: "Se déconnecter",
                        firmware: "Firmware",
                        sms: "SMS",
                        advanced: "Avancé",
                        errorsSingle: "Erreurs",
                        warnings: "Avertissements"
                    },
                    statistics: {
                        label: "Statistiques",
                        foamBeaterThermalStatus: "Thermique batteur de mousse",
                        exitPumpThermalStatus: "Thermique pompe d'évacuation",
                        thermalStatusOk: "Thermique inactif, le consommateur peut fonctionner normalement",
                        thermalStatusFault: "Thermique actif, le consommateur est en défaut",
                        group1: "Groupe 1",
                        group2: "Groupe 2",
                        addProperty: "Ajouter une propriété",
                        removeProperty: "Supprimer la propriété",
                        startTutorial: "Commencer le tutoriel",
                        exitTutorial: "Quitter le tutoriel",

                        welcomeStep: {
                            title: "Bienvenue sur la page des statistiques",
                            content: "Ici, vous pouvez comparer différentes valeurs et tendances facilement."
                        },
                        propertyStep: {
                            title: "Sélection de propriété",
                            content: "Pour commencer, il vous suffit de sélectionner une propriété qui vous intéresse dans la liste déroulante."
                        },
                        addPropertyStep: {
                            title: "Ajout et suppression de propriétés",
                            content: "Essayez d'ajouter ou de supprimer une propriété. Vous pouvez ajouter jusqu'à 4 propriétés par groupe."
                        },
                        groupStep: {
                            title: "Activation du groupe 2",
                            content: "Cliquez sur le bouton 'Ajouter une propriété' pour sélectionner une propriété pour le Groupe 2. Les propriétés de ce groupe seront affichées à droite du graphique."
                        },
                        dateRangeStep: {
                            title: "Sélection d'une plage de dates",
                            content: "Utilisez ce bouton pour choisir une plage de dates."
                        },
                        zoomInStep: {
                            title: "Zoomer",
                            content: "Faites glisser votre souris sur le graphique pour sélectionner une zone à zoomer."
                        },
                        zoomOutStep: {
                            title: "Dézoomer",
                            content: "Réinitialisez la plage de dates précédemment sélectionnée en utilisant le bouton 'Dézoomer'."
                        },
                        domainStep: {
                            title: "Ajustement des domaines",
                            content: "Vous pouvez personnaliser le domaine maximal et minimal par groupe en utilisant ces boutons."
                        },
                        csvStep: {
                            title: "Télécharger les données au format CSV",
                            content: "Téléchargez les données du graphique actuellement affichées au format CSV."
                        },
                        imageStep: {
                            title: "Télécharger une image",
                            content: "Téléchargez le graphique actuellement affiché sous forme d'image."
                        },
                        configurationStep: {
                            title: "Configuration du préréglage",
                            content: "Vous pouvez enregistrer votre configuration actuelle en tant que préréglage. Vous pouvez également mettre à jour ou supprimer les préréglages existants."
                        },
                        controlCardTemp: "Température de la carte de contrôle",
                        lowTensionError: "Erreur de tension basse",
                        overTempFlueGasHeatExch: "Surchauffe de l'échangeur de chaleur des gaz de combustion",
                        feedingCycleLevel: "Niveau du cycle d'alimentation",
                        batteryVoltage: "Tension de la batterie",
                        waterPressure: "Pression de l'eau",
                        shortInterval: "Intervalles de 10 minutes",
                        dailyInterval: "Intervalles quotidiens",
                        configurationUpdated: "Votre configuration actuelle a été enregistrée dans ce préréglage",
                        presets: "Préréglages",
                        savePreset: "Enregistrer en tant que préréglage",
                        applyPreset: "Appliquer le préréglage",
                        updatePreset: "Mettre à jour le préréglage",
                        delete: "Supprimer",
                        noPresets: "Vous n'avez pas encore de préréglages",
                        givePresetName: "Donnez un nom à votre préréglage",

                    },
                    smart: {
                        label: "Smart",
                        heightOffset: "Décalage de hauteur",
                        active: "Actif",
                        passive: "Passif",
                        preActive: "Pré-actif",
                        prePassive: "Pré-passif",
                        postActive: "Post-actif",
                        postPassive: "Post-passif",
                        activeDesc: "Pendant une période active, la production d'énergie prévue est maximisée. Avant chaque période active, un créneau temporel « pré-actif » est automatiquement prévu pour accumuler du gaz dans le tampon. La durée maximale d'une période active est déterminée par le volume du tampon de gaz, le nombre et le type de CHP installés, ainsi que le profil de production de biogaz de l'installation. Lorsque le niveau de remplissage minimum du tampon de gaz est atteint, la production d'énergie s'arrête (période post-active).",
                        passiveDesc: "Pendant une période passive, l'énergie n'est produite que s'il y a un excédent de gaz. Avant chaque période passive, un créneau temporel est automatiquement prévu pour réduire le tampon de gaz. La durée maximale d'une période passive est déterminée par le volume du tampon de gaz et le profil de production de biogaz de l'installation. Lorsque le niveau de remplissage maximum du tampon de gaz est atteint, la production d'énergie démarre (période post-passive).",
                        permanence: "Stimuler la production constante en fonctionnant dynamiquement sur un moteur avec un tampon de gaz non maximal",
                        permanency: "Permanence",
                        activateStep: {
                            title: "Activation de l'option SMART",
                            content: "Activez l'option SMART pour contrôler le profil de production de l'installation"
                        },
                        timeslotStep: {
                            title: "Ajouter une période",
                            content: "Ajoutez une période active ou passive"
                        },
                        fromToStep: {
                            title: "De / À",
                            content: "Vous définissez à la fois le jour de début et de fin ainsi que l'heure"
                        },
                        activePassiveStep: {
                            title: "Actif ou Passif",
                            content: "Sélectionnez si vous souhaitez définir une période active ou passive"
                        },
                        saveStep: {
                            title: "Enregistrer les périodes",
                            content: "Enregistrez vos paramètres modifiés"
                        },
                        removeStep: {
                            title: "Supprimer les périodes",
                            content: "Supprimez votre période ici"
                        },
                        visualStep: {
                            title: "Représentation visuelle",
                            content: "Ce graphique compare les paramètres SMART avec le profil de production de la semaine passée"
                        },
                        daySwitchStep: {
                            title: "Représentation visuelle",
                            content: "Naviguez facilement vers le jour suivant ou précédent"
                        },
                    },
                    gas: {
                        label: "Gaz",
                        minGasBufferLevel: "Niveau de gaz minimum",
                        maxGasBufferLevel: "Niveau de gaz maximum",
                        gasBufferLevel: "Niveau actuel du réservoir de gaz",
                        defaultMinGasBufferLevel: "Défaut niveau de gaz minimum",
                        defaultMaxGasBufferLevel: "Défaut niveau de gaz maximum",
                        airInjectionTime: "Aération",
                        maxAirInjectionTime: "Aération maximum",
                        torch: "Torche",
                        torchType: "Type de torche",
                        torchStatus: "Etat de la torche",
                        torchError: "Erreur de la torche",
                        theoreticalTorchFlow: "Débit théorique de la torche",
                        torchRunningTime: "Temps de torchère",
                        torchFlaredVolume: "Volume torché",
                        h2s: "H₂S",
                        h2sLevelReactor: "H₂S réacteur",
                        h2sLevelMotor: "H₂S Moteur",
                        filterLoad: "Chargement du filtre",
                        sample: "Échantillon",
                        latestH2sReadings: "Dernières mesures H₂S",
                        carbonFilterSize: "Taille du filtre à charbon",
                        h2sMeasurements: "Mesures H₂S",
                        measurements: "Mesures",
                        changeTo: "Changer en",
                        none: "Aucun",
                        container: "Conteneur",
                        extern: "Externe",
                        foamBeaterInstalled: "Battre-mousse installé",
                        antiFoamInjectionsInstalled: "Injections anti-mousse installées",
                        containerCombinedOperation: "Conteneur (opération combinée)",
                        externCombinedOperation: "Externe (opération combinée)",
                        gasTemp: "T1 Temperature After Gascooler",
                        ch4BiogasSupply: "Alimentation en biogaz CH4",
                        co2BiogasSupply: "Alimentation en biogaz CO2",
                        o2BiogasSupply: "Alimentation en biogaz O2",
                        h2sAfterFilter: "H2S après filtre",
                        biomethaneFlowNorm: "Débit normalisé de biométhane",
                        ch4Biomethane: "CH4 biométhane",
                        co2Biomethane: "CO2 biométhane",
                        o2Biomethane: "O2 biométhane",
                        h2sBiomethane: "H2S biométhane",
                        bufferRelease: "Libération du tampon",
                        wobbe: "Indice de Wobbe",
                        wobbeAvg: "Indice de Wobbe moyen",
                        wobbePidSetpoint: "Consigne PID indice de Wobbe",
                        wobbeBiomethanePronova: "Indice de Wobbe biométhane Pronova",

                    },
                    engine: {
                        label: "moteur",
                        startEngine: "Démarrage moteur",
                        stopEngine: "Arrêt moteur",
                        power: "Puissance",
                        desiredPower: "Puissance désirée",
                        maxPower: "Puissance maximale",
                        rpm: "Tours par minute (RPM)",
                        lambda: "Lambda",
                        throttleValve: "Position du servo",
                        engineType: "Type de moteur",
                        engineStatus: "État moteur",
                        engineError: "Erreurs moteur",
                        producedEnergy: "Énergie totale produite",
                        operatingHours: "Heures de marche du moteur",
                        totalOperatingHours: "Heures de marche totale du moteur",
                        gasUsage: "Consommation de gaz",
                        throttlePosition: "Position du throttle",
                        noErrors: "Tous les systèmes sont opérationnels.",
                        production: "Production",
                        servoAuto: "Le servo est réglé automatiquement",
                        servoControl: "Contrôle servo",
                        temperature: "Température moteur",
                        restart: "Redémarrage automatique lorsque du gaz sera disponible",
                        confirmStop: "Êtes-vous sûr de vouloir arrêter le moteur {{number}} ?",
                        confirmStopRestart: "Êtes-vous sûr de vouloir arrêter le moteur {{number}} ? Il redémarrera automatiquement lorsque du gaz sera disponible.",
                        idle: "Inactif",
                        running: "En cours",
                        waiting: "En attente de démarrage",
                        booting: "Démarrage",
                        shuttingDown: "Arrêt",
                        advanced: "Avancé",
                        numberOfEngines: "Nombre de moteurs",
                        predeterminedRunHours: "Heures de fonctionnement prédéterminées",
                        easyStart1: "Easy start moteur 1",
                        easyStart2: "Easy start moteur 2",
                        setError1: "Erreur de réglage moteur 1",
                        setError2: "Erreur de réglage moteur 1",
                        fuel: "Carburant",
                        airIntakeOpen: "Prise d'air ouverte",
                        airIntakeClosed: "Prise d'air fermée",
                        vfd: "VFD",
                    },
                    service: {
                        label: "Entretien",
                        lastMaintenance: "Heures de fonctionnement jusqu'à la prochaine vidange d'huile",
                        currentlyInstalled: "Heures de fonctionnement actuellement installées",
                        total: "Nombre total d'heures de fonctionnement",
                        mixer: "Mélangeur",
                        foam_beater: "Batteur à mousse",
                        intake_pump: "Pompe d'admission",
                        digestate_pump: "Pompe de digestat",
                        newMixer: "Nouveau mélangeur installé",
                        newEngine: "Nouveau moteur installé",
                        newFoamBeater: "Nouveau batteur à mousse installé",
                        newIntakePump: "Nouvelle pompe d'admission installée",
                        newDigestatePump: "Nouvelle pompe de digestat installée",
                        confirmationMessage: "Êtes-vous sûr de vouloir réinitialiser le {{type}}",
                        maintenanceMessage: "Les heures de maintenance ont été réinitialisées pour {{type}}",
                        newEquipmentMessage: "Nouvel équipement installé :",
                        prints: "Prints",
                        firstOnline: "Première connexion en ligne",
                        lastOnline: "Dernière connexion en ligne",
                        serial: "Numéro de série",
                        type: "Type",
                        engine: "Moteur",
                        engine1: "Moteur 1",
                        engine2: "Moteur 2",
                        engine_new1: "Moteur 1",
                        engine_new2: "Moteur 2",
                        h2s1: "Moteur H₂S 1",
                        h2s2: "Moteur H₂S 2",
                        resetTo: "Réinitialiser à x heures (par défaut 0)",
                        timeFilterReplace: "Temps écoulé depuis le remplacement du filtre",
                        daysSinceOil: "Jours depuis le changement d'huile",
                        newGenerator: "Nouvelle génératrice installée",
                        generator: "Générateur",
                        generator1: "Générateur 1",
                        generator2: "Générateur 2",
                        daysSinceOilChange: "Jours depuis la vidange d'huile",
                        videoMessage: "Vidéo sur le changement d'huile => Page des documents, sous Vidéos générales.",
                        videoRoom: "Un technicien de service a ouvert une salle vidéo pour cette machine. Cliquez ici pour rejoindre.",
                        videoButton: "Démarrer une salle vidéo pour cette machine",
                        videoButtonSub: "Les utilisateurs ayant accès peuvent rejoindre l'appel depuis leur page de service.",
                        videoClose: "Fermer la salle vidéo",
                        serialNumber: "Numéro de série",
                        defaultEngineReset: "Réinitialisation du moteur par défaut",
                        newInstalled: "Nouveau {{type}} installé",
                        replace: "Remplacer",
                        aircover: "Protection contre l'air",
                        gascover: "Protection contre le gaz",
                        liner: "Doublure",
                        flow_meter: "Compteur de débit",
                        energy_meter1: "Compteur d'énergie 1",
                        energy_meter2: "Compteur d'énergie 2",
                        energy_meter_own: "Compteur d'énergie propre consommation",
                        h2sPastille: "Temps avant le remplacement du capteur H2S",
                        pastille1: "Capteur H₂S 1",
                        pastille2: "Capteur H₂S 2",
                        engineLabel: "Prochain entretien moteur après “XX” heures",
                        engine1Conf: "Réinitialiser l’intervalle d’entretien du moteur 1 uniquement après que l’entretien a été effectué",
                        engine2Conf: "Réinitialiser l’intervalle d’entretien du moteur 2 uniquement après que l’entretien a été effectué",
                        h2s1Conf: "Réinitialiser H2S Moteur 1 uniquement lorsque le charbon actif du filtre a été remplacé",
                        h2s2Conf: "Réinitialiser H2S Moteur 2 uniquement lorsque le charbon actif du filtre a été remplacé",
                        filterResetOffline: "La machine est hors ligne. La réinitialisation du filtre n'a pas été enregistrée. Reconnectez-vous et réessayez.",
                        filterResetFailed: "Échec de la réinitialisation du filtre. La réinitialisation n'a pas été enregistrée.",
                        consumables: {
                            title: "Consommables",
                            belowMin: "Sous le stock minimum",
                            noneBelow: "Aucun article sous le stock minimum",
                            notCounted: "Pas encore compté",
                            article: "Numéro d'article",
                            description: "Description",
                            onSite: "Présent",
                            minimum: "Minimum",
                            engineMaintenance: "Entretien moteur",
                            pendingStock: "{{confirmed}} confirmé + {{pending}} en attente de validation",
                            send: "Envoyer",
                            shipmentSaved: "Expédition enregistrée. Elle reste en attente jusqu'à la confirmation du client.",
                            shipmentFailed: "Impossible d'enregistrer l'expédition",
                            confirm: "Confirmer la réception",
                            confirmSaved: "Stock confirmé",
                            confirmFailed: "Impossible de confirmer le stock",
                            confirmHint: "Confirmez la livraison pour l'ajouter au stock sur place.",
                            guideTitle: "Comment ça fonctionne",
                            guideIntro: "L'huile, les filtres à huile et les bougies restent sur chaque installation. La page service de l'installation et cette page de commandes partagent le même stock.",
                            guide1Role: "Technicien",
                            guide1Title: "Compter ce qui est sur place",
                            guide1Body: "Sur la page service de l'installation, ouvrez Consommables et indiquez la quantité réellement présente de chaque article. Cet inventaire est confirmé tout de suite. Un comptage sur place n'attend l'accord de personne.",
                            guide2Role: "Automatique",
                            guide2Title: "L'entretien moteur consomme le stock",
                            guide2Body: "Enregistrer un entretien moteur retire la consommation de ce moteur du stock confirmé. Un entretien WG1605 utilise 0,28 d'un bidon d'huile de 25 l, 1 filtre à huile et 4 bougies. WG972 et WG3800 utilisent les quantités du tableau d'entretien moteur. Cela se produit lorsque l'installation a un enregistrement statistique avec un type de moteur.",
                            guide3Role: "Responsable service",
                            guide3Title: "Envoyer ce qui manque",
                            guide3Body: "Cette page liste les installations dont le stock confirmé est inférieur ou égal au minimum. Saisissez la quantité à expédier et appuyez sur Envoyer. Elle reste en attente, par exemple 0,5 confirmé + 5 en attente de validation, et ne compte pas encore comme stock. Le minimum se définit par type de moteur. Une installation utilise la somme de ses moteurs installés, arrondie à un nombre entier. Une pièce d'huile est un bidon de 25 l.",
                            guide4Role: "Toute personne ayant accès",
                            guide4Title: "Confirmer la livraison",
                            guide4Body: "Quand les articles sont sur place, le client, un technicien ou un employé confirme la réception sur la page service de l'installation. La quantité en attente est ajoutée au stock confirmé. 0,5 confirmé et 5 en attente deviennent alors 5,5 sur place.",
                            correction: "Correction de stock",
                            save: "Enregistrer le comptage",
                            saved: "Comptage enregistré",
                            saveFailed: "Impossible d'enregistrer le comptage",
                            minSaved: "Stock minimum enregistré",
                            minFailed: "Impossible d'enregistrer le stock minimum",
                            minHint: "Définissez le minimum par type de moteur. Une installation utilise la somme de ses moteurs installés, arrondie à un nombre entier. Elle apparaît dès que le stock est inférieur ou égal à ce minimum. Une pièce d'huile est un bidon de 25 l.",
                            usage: "Consommation par entretien moteur",
                            usageHint: "L'enregistrement d'un entretien moteur déduit cette consommation du stock compté. DF972 et WG972 partagent la colonne WG972. WG3800-L utilise la colonne WG3800.",
                            orders: "Commandes à lancer",
                            ordersEmpty: "Aucune installation au stock minimum ou en dessous",
                            shortage: "Manque",
                            installation: "Installation",
                            engines: "Moteurs",
                        },
                        membranes: {
                            title: "Membranes",
                            overview: "Toutes les membranes",
                            overviewTitle: "Aperçu des membranes installées",
                            searchPlaceholder: "Rechercher installation, produit, charge, housing…",
                            search: "Rechercher",
                            installation: "Installation",
                            stage: "Stage",
                            scpCo2: "SCP CO2",
                            percent: "%",
                            scpO2: "SCP O2",
                            selO2N2: "Sel O2/N2",
                            selCo2Ch4: "Sel CO2/CH4",
                            scpCo2N: "SCP CO2_n",
                            productName: "Nom du produit",
                            productCode: "Code produit",
                            chargeNo: "Charge No.",
                            housingNo: "Housing No.",
                            installationDate: "Date d'installation",
                            addRow: "Ajouter une membrane",
                            none: "Aucune membrane enregistrée",
                            fetchError: "Impossible de charger les membranes",
                            saved: "Membrane enregistrée",
                            added: "Membrane ajoutée",
                            saveError: "Impossible d'enregistrer la membrane",
                            deleteConfirm: "Supprimer cette membrane ?",
                            deleted: "Membrane supprimée",
                            deleteError: "Impossible de supprimer la membrane",
                        },
                        pastille1Conf: "Réinitialiser la durée de vie du capteur H2S 1 uniquement lorsque l’élément du capteur a été remplacé.",
                        pastille2Conf: "Réinitialiser la durée de vie du capteur H2S 2 uniquement lorsque l’élément du capteur a été remplacé.",
                        pastilleLabel: "Durée de vie prévue de l’élément de capteur XX jours",
                        valve_interval: "Heures de fonctionnement avant contrôle du jeu de soupapes",
                        cylinder_interval: "Heures de fonctionnement avant révision de la culasse",
                        valve_interval_engine1: "Heures de fonctionnement avant contrôle du jeu de soupapes moteur 1",
                        cylinder_interval_engine1: "Heures de fonctionnement avant révision de la culasse moteur 1",
                        valve_interval_engine2: "Heures de fonctionnement avant contrôle du jeu de soupapes moteur 2",
                        cylinder_interval_engine2: "Heures de fonctionnement avant révision de la culasse moteur 2",
                        pipe: "Tuyau",
                        transmitter: "Transmetteur",
                        elektromotor: "Moteur électrique",
                        pump: "Pompe",
                        roofsolation: "Isolation du toit",
                        airPump: "Pompe d’injection d’air",
                        oxygenConcentrator: "Concentrateur d’oxygène",
                        flowmeterBiogas: "Débitmètre biogaz",
                        pronovaBiomethaan: "ProNova biométhane",
                        pronovaBiogas: "ProNova biogaz",
                        h2s1Gpi: "Filtre à charbon 1",
                        h2s2Gpi: "Filtre à charbon 2",
                        coolant: "Liquide de refroidissement",
                        daysSinceCoolantReplace: "Jours depuis le remplacement",
                        coolantConf: "Réinitialisez les heures de fonctionnement du liquide de refroidissement uniquement après son remplacement",
                        daysSinceInhibitor: "Jours depuis le pack d'inhibiteurs",
                        inhibitorPackage: "Pack d'inhibiteurs",
                        registerInhibitor: "Enregistrer",
                        inhibitorConf: "Enregistrez uniquement après avoir complété le liquide de refroidissement avec un pack d'inhibiteurs (tous les 12 mois)",
                        restoreValues: {
                            button: "Restaurer les valeurs PLC",
                            title: "Restaurer les valeurs PLC",
                            description: "Choisissez un jour des 7 derniers jours qui semble correct, vérifiez les valeurs préremplies, puis envoyez-les au PLC.",
                            pickDay: "Sélectionner un jour",
                            snapshotTime: "Heure de l'échantillon",
                            noSnapshots: "Aucune statistique trouvée pour les 7 derniers jours.",
                            send: "Envoyer",
                            sendAll: "Tout envoyer",
                            sending: "Envoi…",
                            confirmSendAll: "Envoyer toutes les valeurs préremplies au PLC ?",
                            sendAllDone: "{{count}} valeurs envoyées au PLC",
                            emptyValue: "La valeur est vide",
                            invalidValue: "La valeur n'est pas un nombre",
                            invalidEngineCount: "Le nombre de moteurs doit être 1 ou 2",
                            noConnection: "La machine n'a pas de connexion active",
                            readOnly: "lecture seule",
                            fromMachine: "depuis la fiche machine",
                            current: "Actuel",
                            currentHint: "Valeur slow/fast actuelle sur le CU",
                            ups: "UPS",
                            groupEngines: "Moteurs",
                            groupReactor: "Réacteur et mélange",
                            groupFeeding: "Alimentation",
                            groupGas: "Gaz",
                            groupEnergy: "Compteurs d'énergie",
                            groupSsr: "SSR",
                        },
                        tabs: {
                            engine: "Moteur",
                            reactor: "Réacteur / Conteneur",
                            gas: "Gaz / Purification",
                            consumables: "Consommables",
                            options: "Options machine",
                            prints: "Impressions",
                            restoreValues: "Restaurer les valeurs PLC",
                        },
                    },
                    net: {
                        net: "Réseau",
                        meterSettings: "Valeur du compteur",
                        voltagePerPhase1: "Voltage par phase (1)",
                        voltagePerPhase2: "Voltage par phase (2)",
                        voltagePerPhase3: "Voltage par phase (3)",
                        frequencyPerPhase: "Frequance par phase",
                        angleBetweenPhase1And2: "Angle entre phase (1) et (2)",
                        ownPowerConsumption: "Puissance de consommation propre",
                        ownEnergyConsumption: "Consommation propre d'énergie",
                        bioguardVersion: "Version bioguard",
                        brutoProducedEnergy: "Énergie brute produite",
                        nettoProducedEnergy: "Énergie nette produite",
                        producedEnergyEngine1: "Énergie produite du moteur 1",
                        producedEnergyEngine2: "Énergie produite du moteur 2",
                        monitoringRelay: "Relais de surveillance ",
                        powerNonFit: "Consommation propre d’électricité hors-FIT",
                        energyMeterNonFit: "Consommation propre d’énergie hors-FIT",
                    },
                    reactor: {
                        label: "Réacteur",
                        reactorTemp: "Témperature du réacteur",
                        reactorTempTarget: "Température du réacteur désirée",
                        reactorLevel: "Niveau désiré",
                        hydrostaticPressure: "Niveau du réacteur actuel",
                        siloType: "Silo type",
                        extraHeating: "Chauffage",
                        antiFrost: "Antigel",
                        antiFrostIndex: "Index antigel",
                        antiFrostAuto: "Le index de gel est configure automatiquement et se base sur les températures locales",
                        antiFrostMessageNew: "Chaque cycle d'index de gel activera la pompe à lisier frais pour 4'' et la pompe à digestat évacuera approximativement 100l de digestat, base sur les flux pré-paramétrés.",
                        antiFrostMessageOld: "Chaque cycle d'index de gel activera la pompe à lisier frais pour 4'' et la pompe à digestat pour 120’’",
                        coolwater: "Eau de refroidissement",
                        statusCoolingValve: "Vanne d'eau de refroidissement",
                        waterTempIn: "Température d'eau de refroidissement entré du réacteur",
                        waterTempOut: "Température d'eau de refroidissement à la sortie réacteur",
                        waterTempMotorOut: "Température d'eau de refroidissement à la sortie moteur 1",
                        waterTempMotorOut2: "Température d'eau de refroidissement à la sortie moteur 2",
                        coolingWaterTemp: "Réglage de la température d'eau de refroidissement",
                        maxCoolingWaterTemp: "Température d'eau de refroidissement maximum",
                        waterPressure: "Pression dans le circuit d'eau de refroidissement",
                        foamBeater: "Mousse",
                        foambeatEveryXMinutes: "Détruire mousse toutes les",
                        foambeatForXSeconds: "Pour",
                        mixer: "Mélangeur",
                        mixerMaxPower: "Puissance maximale du mélangeur",
                        mixerActive: "Mélangeur actif",
                        mixerBlockedLowLevel: "Mélangeur bloqué en raison d'un niveau de réacteur trop bas",
                        mixEveryXMinutes: "Mélanger toutes les",
                        mixForXSeconds: "Pour",
                        blockMixingFrom: "Ne pas mélanger de",
                        blockMixingTo: "à",
                        mixerInfo: "Le mélangeur est allumé automatiquement pour la durée sélectionnée avec l'intervalle de temps sélectionné. Pendant la fenêtre de temps de blocage du mélangeur, le mélangeur est arrêté lorsque la puissance installée du mélangeur dépasse la production électrique actuelle de l'installation. Le mélangeur est temporairement arrêté pendant le démarrage de la cogénération jusqu'à ce que 50 % de la puissance nominale soient atteints pour permettre le courant d'appel",
                        mixerInfoGpi: "Le mélangeur est allumé automatiquement pour la durée sélectionnée avec l'intervalle de temps sélectionné. Pendant la fenêtre de temps de blocage du mélangeur, le mélangeur est arrêté lorsque la puissance installée du mélangeur dépasse la production électrique actuelle de l'installation.",
                        mix1Hour: "Mélanger 1 heure",
                        coolwaterValveInstalled: "Vanne 3 voies réglée",
                        coolwaterValveBinary: "Vanne 3 voies binaire",
                        coolwaterValveMaximizeHeat: "Maximiser l'utilisation de la chaleur",
                        coolwaterValveMaximizeHeatInfo: "La maximisation de l'utilisation de la chaleur peut entraîner des périodes sans disponibilité de chaleur à l'échangeur à plaques",
                        coolwaterValvePlatePriority: "Priorité à l'échangeur à plaques",
                        coolwaterValvePlatePriorityInfo: "Prioriser la disponibilité de chaleur à l'échangeur à plaques tout en maintenant une température stable du digesteur",
                        bypassFan: "Contrôle soupape by-pass / ventilateur",
                        digester: "Contrôle soupape digesteur/consummation chaleur externe",
                        silo: "Silo",
                        bag: "Sac",
                        plateHeatExchanger: "Échangeur de chaleur à plaques",
                        timesPerDay: "fois / jour",
                        intern: "Interne",
                        extern: "Externe",
                        tempHigh: "Température élevée",
                        externMessage: "L'erreur suivante ne sera pas déclenchée si le mélangeur est réglé sur externe : Mélangeur ne fonctionne pas, veuillez réinitialiser le thermique.",
                        bypass: "Dérivation",
                        ventilator: "Ventilateur",
                        tempCoolHeatExchOut: "Température d'eau de refroidissement à la sortie de l'échangeur de chaleur",
                        overtempMixer1: "Surchauffe mélangeur 1",
                        overtempMixer2: "Surchauffe mélangeur 2",
                        mixerSettings: "Paramètres du mélangeur",
                        premixing: "Prémélange",
                        intakeMixing: "Mélange à l'entrée",
                        premixingInfo: "Le prémélange consiste à mélanger avant l'alimentation, donc avant et pendant l'évacuation. Le temps correspond toujours à la durée de mélange.",
                        intakeMixingInfo: "Le mélange à l'entrée permet de mélanger en même temps que l'aspiration. Si OFF, le mélange n'est pas effectué pendant que l'alimentation est en cours.",
                        gpiMixDuringIntake: "Mélange pendant l'alimentation liquide",
                        gpiMixDuringIntakeInfo: "Mélange pendant toute la durée de l'alimentation liquide.",
                        gpiMixDuringIntakeHelp: "Mélange pendant l'alimentation liquide : mélange pendant toute la durée de l'alimentation. Si OFF : comportement selon le type de silo.\n\nTypes S : prémélange uniquement pendant la sortie et mélange après l'alimentation pendant la durée du mélangeur.\n\nTypes C : pas de prémélange ; mélange après l'alimentation pendant la durée du mélangeur.",
                        gpiMixDuringIntakeOffGeneric: "Si OFF : comportement selon le type de silo.",
                        gpiMixDuringIntakeOffS: "Types S : prémélange uniquement pendant la sortie et mélange après l'alimentation pendant la durée du mélangeur.",
                        gpiMixDuringIntakeOffC: "Types C : pas de prémélange ; mélange après l'alimentation pendant la durée du mélangeur.",
                        gpiMixDuringSolidFeedIntake: "Mélange pendant l'alimentation solide",
                        gpiMixDuringSolidFeedIntakeInfo: "Si ON : mélange pendant toute l'alimentation solide. Si OFF : mélange uniquement avant et après l'alimentation solide, chaque fois pendant la durée (en secondes) définie dans « {{durationSetting}} ».",
                        gpiMixTimeBeforeAfterSolidIntake: "Durée de mélange avant/après alimentation solide",
                    },
                    efficiency: {
                        label: "Efficacité",
                        production: "Production d'énergie des 30 derniers jours",
                        consumption: "Consommation d'énergie des 30 derniers jours",
                        nettoProduction: "Netto production d'énergie des 30 derniers jours",
                        averageEfficiency: "Éfficacité moyen des 30 derniers jours",
                        averageTechnicalEfficiency: "Disponibilité technique moyen des 30 derniers jours",
                        bgp: "Qualité du fumier (BGP batch)",
                        top10: "Top 10 projets du mois dernier",
                        realised: "Efficacité réalisée",
                        technical: "Disponibilité technique",
                        bgpInfo: "Estimation BGP. Ne prend pas en compte les partes causées par les arrêts moteur, la surproduction de gaz ou le fonctionnement de la torchère",
                        pointPerDay: "%/jour",
                        trendline: "Ligne de tendance",
                    },
                    general: {
                        label: "Général",
                        hardwareVersion: "Version matérielle",
                        otGenContact: "OT Gen-contact",
                        engine1And2Off: "Moteur 1 et 2 arrêtés",
                        engine1On: "Moteur 1 en marche",
                        engine2On: "Moteur 2 en marche",
                        engine1And2On: "Moteur 1 et 2 en marche",
                        notes: "Notes",
                        h2sSensorFirmwareVersion: "Version du firmware du capteur H₂S",
                        idH2s: "S/N ID H₂S",
                        bioId: "S/N ID Biotronic",
                        identifier: "Identifiant de l'installation",
                        collabContract: "Contrat de collaboration",
                        own: "Contrat de maintenance",
                        sold: "Installation vendue",
                        productionDate: "Date de production",
                        commissioningDate: "Date de mise en service",
                        controlCardTemp: "Température de la carte de contrôle",
                        batteryVoltage: "Tension de la batterie",
                        motorVoltage: "Tension du moteur",
                        overtempFlueGasHeatExch: "Surchauffe moteur de l'échangeur de chaleur des gaz de fumée",
                        rebootMainBoard: "Redémarrage de la carte principale",
                        rebootNow: "Redémarrer maintenant",
                        utcOffset: "Décalage UTC",
                        location: "Emplacement",
                        network: "Réseau",
                        ip: "IP",
                        mask: "Masque",
                        gateway: "Passerelle",
                        dns: "DNS",
                        pcb: "PCB",
                        firmware: "Firmware",
                        mainControlUnit: "Unité de contrôle principale",
                        bioguard: "Bioguard",
                        biotronicEngine1: "Moteur Biotronic 1",
                        biotronicEngine2: "Moteur Biotronic 2",
                        h2sEngine1: "Moteur H₂S 1",
                        h2sEngine2: "Moteur H₂S 2",
                        bioIdEngine1: "Moteur Bio ID 1",
                        bioIdEngine2: "Moteur Bio ID 2",
                        modificationsToMachine: "Modifications à la machine",
                        name: "Nom",
                        hostNameFirmware: "Firmware",
                        hostNameDatabase: "Base de données",
                        normal: "Normal",
                        lowError: "Bas (erreur)",
                        nta8080Title: "Rapport NTA 8080",
                        nta8080Description: "Téléchargez un rapport mensuel NTA 8080. Les données ne sont chargées que lorsque vous demandez le rapport.",
                        nta8080Month: "Mois",
                        nta8080Download: "Télécharger le rapport",
                        nta8080DownloadPdf: "Télécharger PDF",
                        nta8080DownloadCsv: "Télécharger CSV",
                        nta8080Loading: "Préparation…",
                        nta8080SelectMonth: "Sélectionnez d'abord un mois",
                        nta8080InvalidMonth: "Mois sélectionné invalide",
                        nta8080DownloadError: "Échec du téléchargement du rapport",
                    },
                    feeding: {
                        label: "Pompage",
                        feedingVolume: "Volume maximum d'alimentation fraîche par cycle",
                        feedingCyclesPerDay: "Cycles de pompage par jour",
                        feedingCyclesPerDayInfo: "Un volume pompé inférieur à 75 % du volume souhaité déclenche l'erreur d'alimentation « pas de débit lors de l'aspiration de fumier frais ». Un volume pompé entre 75 % et 100 % du volume souhaité déclenche le message « Cycle d'alimentation partiellement exécuté. Fosse vide détectée avant d'atteindre le volume réglé ».",
                        feedingBalance: "Solde de pompage",
                        autoFeedingActive: "Pompage automatique",
                        blockHighElectricalConsumption: "Bloquer le chauffage de la cuve par la pompe à chaleur pendant la fenêtre de mélange",
                        blockHighElectricalConsumptionInfo: "Si ON : le chauffage de la cuve par la pompe à chaleur est bloqué pendant la fenêtre de mélange. Si OFF : pas de blocage.",
                        minimizeElectricalConsumptionFrom: "Minimiser la consommation électrique de",
                        minimizeElectricalConsumptionTo: "à",
                        autoFeedingStartHour: "Pompage automatique heure de début",
                        exitPumpRunning: "Evacuation",
                        feedingCycle: "Cycle de pompage",
                        onlyInput: "Seulement alimentation",
                        onlyOutput: "Seulement évacuation",
                        startFeeding: "Démarrage",
                        stopFeeding: "Arrêt pompage",
                        customAmount: "Quantité personnalisée",
                        customAmountHint: "Prérempli avec le volume d'alimentation configuré. Modifiez uniquement pour une quantité personnalisée. Hausse max. {{maxRiseCm}} cm ({{maxLiters}} l pour ce silo).",
                        customAmountInvalid: "Entrez une valeur entre {{min}} et {{max}} l",
                        customAmountExceedsLevelRise: "La quantité saisie ({{amount}} l) ferait monter le niveau du réservoir de plus de {{maxRiseCm}} cm. Maximum pour ce silo : {{maxLiters}} l.",
                        customAmountUnknownSilo: "Impossible de calculer la quantité maximale : type de silo inconnu.",
                        customAmountExceedsWarning: "La quantité saisie ({{amount}} l) est supérieure au volume d'alimentation configuré ({{feedingVolume}} l). Voulez-vous vraiment continuer ?",
                        pumpOutFlowRate: "Débit d'évacuation",
                        pumpOutFlowRateInfo: "Le débit théorique d'évacuation est utilisé pour calculer la durée nécessaire pour pomper le digestat hors du digesteur. Si le réglage est trop bas, trop de digestat sera pompé ; s'il est trop élevé, pas assez de digestat sera pompé. Valeurs typiques :",
                        pumpOutFlowRateBellowsPump: "Pompe à membrane : ± 3 m³/h",
                        pumpOutFlowRateCentrifugalPump: "Pompe centrifuge : ± 50 m³/h",
                        pumpOutFlowRateGravityOutlet: "Sortie gravitaire : ± 50 m³/h",
                        kiloPerPulse: "Pulse du débitmètre",
                        intakeTimeout: "Time-out alimentation",
                        averageDailyFeeding: "Alimentation quotidienne moyenne du mois dernier",
                        retentionTime: "Rétention",
                        statusValvePumpIn: "Vanne lisier frais - 2",
                        statusValvePumpOut: "Vanne sortie réacteur - 3",
                        statusValveRetourReactor: "Vanne retour réacteur - 4",
                        valveCurrentActuator: "Courant actuateur de vanne",
                        actuatorSetting: "Réglage actionneur",
                        actuatorSettingV1: "Linak",
                        actuatorSettingV2: "Hiwin / Mikrosystem",
                        lastFeeding: "Actuel - dernier",
                        startHourLastFeeding: "Temps de pompage dernier",
                        feedingStatus: "État de pompage",
                        feedingError: "Erreur du réacteur",
                        intakePumpTime: "Temps alimentation",
                        intakePumpAmount: "Quantité d'alimentation",
                        exitPumpTime: "Temps d'évacuation",
                        exitPumpAmount: "Quantité d'évacuation",
                        feedingHistory: "Histoire de pompage",
                        startedOn: "Commencé à",
                        temperature: "Température",
                        reactorLevel: "Niveau",
                        balance: "Solde",
                        acknowledge: "Reconnaissance de l'erreur",
                        intakeSpeed: "Vitesse du pompage",
                        balanceWarning: "Avertissement, cela ne lancera pas un cycle d'alimentation normal mais pompera à la place la valeur restante du solde dans le réacteur",
                        automaticFeedingSettings: "Paramètres d'alimentation automatique",
                        manualFeeding: "Alimentation manuelle",
                        pumpSettings: "Paramètres de la pompe",
                        lastFeedingTime: "Dernière heure de pompage",
                        status: {
                            "0": "Inactif",
                            "1": "Détection de niveau",
                            "2": "Sortie",
                            "3": "Admission",
                            "5": "Déverrouillage",
                            "6": "Libération de gaz",
                            "7": "Sortie manuelle",
                            "10": "Démarrage",
                            "2,001": "Sortie : pré-mélange",
                            "2,002": "Sortie",
                            "2,003": "Sortie : ouverture de la vanne de sortie",
                            "2,004": "Sortie : ouverture de la vanne de sortie",
                            "2,005": "Sortie : démarrage de la pompe de sortie",
                            "2,006": "Sortie",
                            "2,007": "Sortie : pompage du lisier",
                            "2,008": "Sortie : arrêt de la sortie",
                            "2,009": "Sortie : arrêt de la sortie",
                            "2,010": "Sortie : fermeture de la vanne de sortie",
                            "2,011": "Sortie : fermeture de la vanne de sortie",
                            "2,012": "Sortie : arrêt de la sortie",
                            "3,001": "Admission : préparation",
                            "3,002": "Admission : préparation",
                            "3,003": "Admission : préparation",
                            "3,004": "Admission : pompage du lisier",
                            "3,005": "Admission : pompage du lisier",
                            "3,006": "Admission : finition",
                            "3,007": "Admission : finition",
                            "3,008": "Admission : arrêt de la pompe",
                            "3,009": "Admission : arrêt de la pompe",
                            "3,010": "Admission : arrêt de la pompe",
                            "3,011": "Admission : arrêt de la pompe",
                            "3,012": "Admission : finition",
                            "5,001": "Déverrouillage : test de l'admission",
                            "5,002": "Déverrouillage : test de l'admission",
                            "5,003": "Déverrouillage : test de l'admission",
                            "5,004": "Déverrouillage : test de l'admission",
                            "5,005": "Déverrouillage : arrêt de l'admission",
                            "5,006": "Déverrouillage : ouverture de la vanne de sortie",
                            "5,007": "Déverrouillage : ouverture de la vanne de sortie",
                            "5,008": "Déverrouillage : test de sortie",
                            "5,009": "Déverrouillage : test de sortie",
                            "5,010": "Déverrouillage : test de sortie",
                            "5,011": "Déverrouillage : test de sortie",
                            "5,012": "Déverrouillage : test de sortie",
                            "5,013": "Déverrouillage : fermeture de la vanne de sortie",
                            "5,014": "Déverrouillage : fermeture de la vanne de sortie",
                            "5,015": "Déverrouillage : finition",
                            "6,001": "Libération de gaz : ouverture de la vanne de sortie",
                            "6,002": "Libération de gaz : ouverture de la vanne de sortie",
                            "6,003": "Libération de gaz : fermeture de la vanne de sortie",
                            "7,001": "Sortie manuelle : Ouvrir la vanne de sortie",
                            "7,002": "Sortie manuelle : Ouvrir la vanne de sortie",
                            "7,003": "Sortie manuelle : Pomper le lisier",
                            "7,004": "Sortie manuelle : Arrêter la pompe",
                            "7,005": "Sortie manuelle : Fermer la vanne de sortie",
                            "7,006": "Sortie manuelle : Fermer la vanne de sortie",
                            "7,007": "Sortie manuelle : Terminer",
                            "7,008": "Sortie manuelle : Terminer",
                            "10,001": "Démarrage : Fermer la vanne 2",
                            "10,002": "Démarrage : Fermer la vanne 2",
                            "10,003": "Démarrage : Fermer la vanne de sortie",
                            "10,004": "Démarrage : Fermer la vanne de sortie",
                            "10,005": "Démarrage : Fermer la vanne 4",
                            "10,006": "Démarrage : Fermer la vanne 4",
                            "10,007": "Démarrage : Vérifier la connexion électrique",
                            "10,008": "Démarrage : Vérifier la connexion électrique",
                            "10,009": "Démarrage"
                        }
                    },
                    users: {
                        label: "Utilisateurs",
                        customers: "Clients connectés",
                        technicians: "Techniciens connectés",
                        resellers: "Partenaires connectés",
                    },
                    recommendations: {
                        label: "Recommandations",
                    },
                    firmware: {
                        invalidFile: "Veuillez sélectionner un fichier .hex",
                        uploadStarted: "Téléversement du firmware démarré",
                        uploadFailed: "Échec du téléversement du firmware",
                        uploading: "Téléversement…",
                        uploadProgress: "Progression : {{progress}}%",
                        currentVersion: "Version actuelle",
                    },
                    documents: {
                        label: "Documents",
                        specificDocuments: "Documents spécifiques",
                        specificImages: "Images spécifiques",
                        generalVideos: "Vidéos générales",
                        general: "Documentation générale",
                        generalDocuments: "Documents généraux",
                        checklists: "Listes de contrôle",
                        construction: "Liste de contrôle de construction",
                        production: "Liste de contrôle de production",
                        upload: "Télécharger",
                        uploadSuccess: "Vous avez téléchargé {{name}} avec succès",
                        deleteSuccess: "Vous avez supprimé le fichier {{name}} avec succès",
                        noFilesAvailable: "Aucun fichier disponible dans la catégorie {{category}}.",
                        fileSizeExceeds: "La taille du fichier dépasse la limite de {{size}}Mb",
                        invalidImageType: "Seules les images JPG et PNG sont autorisées",
                        chooseFileFirst: "Veuillez d'abord choisir un fichier.",
                        default: "Par défaut",
                        permits: "Permis",
                        plans: "Plans",
                        planning: "Planification",
                        certification: "Certification",
                        regulations: "Réglementations",
                        instructions: "Manuels",
                        templates: "Modèles"
                    },
                    warnings: {
                        "W001": "Consommation d'énergie dépassant le seuil au cours des dernières 24 heures (72 kWh pour une installation de 10 à 44 kW, 250 kWh pour une installation de 60 à 74 kW)",
                        "W002": "La température du réacteur a chuté de façon spectaculaire",
                        "W003": "Service dans les 48 heures",
                        "W004": "Filtre à charbon moteur 1 à remplacer",
                        "W005": "Filtre à charbon moteur 2 à remplacer",
                        "W006": "Mesure du tampon de gaz congelé",
                        "W007": "Défaut de mesure du tampon de gaz",
                        "W008": "Non nourri hier",
                        "W009": "Dernier repas de vitesse de la pompe était de 50% plus rapide que la moyenne pour le dernier mois",
                        "W010": "H₂S valeur trop élevée (>1500)",
                        "W011": "Aération est 60",
                        "W012": "Aération est moins ou égal à 3",
                        "W013": "Efficacité était 0 hier et pompage automatique est allumé",
                        "W014": "H₂S réacteur - difference au dela de 400ppm",
                        "W015": "Injection d'air tres elevee - attention pour la qualite du gaz",
                        "W016": "Defaut de mesure de H₂S",
                        "W017": "Huile du mixer trop fabre",
                        "W018": "Huile moteur bas",
                        "W020": "Basse pression de l'eau",
                        "W104": "H₂S valeur trop élevée (>200) ou aération est 60 ou 3",
                        "W105": "Charge du filtre à charbon à haut",
                        "W114": "Efficacité n'était pas 0 hier et pompage automatique est éteint",
                    },
                    advanced: {
                        language: "Langue de l'écran LCD",
                        lambdaUpperLimit: "Limite supérieure lambda (narrow range)",
                        lambdaLowerLimit: "Limite inférieure lambda (narrow range)",
                        coolingValve: "Vanne chaleur",
                        maxPower: "Puissance max (Base de données) Moteur 1",
                        maxPower2: "Puissance max (Base de données) Moteur 2",
                        bioId: "Bio ID Moteur 1",
                        bioId2: "Bio ID Moteur 2",
                        currentSsrConfiguration: "Configuration actuelle du SSR",
                        SSRString: "Chaîne SSR",
                    },
                    sms: {
                        duringDay: "Reçu des messages texte pendant la journée",
                        duringNight: "Reçu des messages texte pendant la nuit",
                        sendSms: "Informer les clients par SMS",
                        sendTestSms: "Envoyer message test",
                        testSms: "SMS test",
                        testSmsToAllSenders: "Envoyer un message test à tous les expéditeurs (dépannage)",
                        recipients: "Destinataires",
                        settings: "Paramètres SMS",
                        enterMessage: "Saisissez votre message ici...",
                        smsSentSuccessfully: "SMS envoyés avec succès",
                        pleaseSelectAtLeastOneRecipient: "Veuillez sélectionner au moins un destinataire",
                        pleaseEnterAMessage: "Veuillez saisir un message",
                        failedToSendSmsMessages: "Échec de l'envoi des SMS",
                        smsSettingsUpdatedSuccessfully: "Paramètres SMS mis à jour avec succès",
                        message: "Message",
                        testNotificationToAllSenders: "Envoyer une notification test à tous les expéditeurs (dépannage)",
                        sendTestNotification: "Envoyer notification test",
                        testNotificationsSentSuccessfully: "Notifications test envoyées avec succès",
                        failedToSendTestNotifications: "Échec de l'envoi des notifications test",
                    },
                    temperatures: {
                        label: "Températures",
                        oilCoolerTemp: "Température du refroidisseur d'huile",
                        biogasTempAfterReheat: "T5 Temperature After Reheating",
                        blowerOutTemp: "T2 Temperature Inlet Compressor",
                        compressorOutTemp: "T3 Temperature Outlet Compressor",
                        biogasTempAfterCool: "T4 Temperature After Cooling",
                    },
                    pressures: {
                        label: "Pressions",
                        biogasPressureBeforeMembrane: "P4 Pressure Inlet Membranes",
                        stage3Pressure: "P5 Pressure Membrane Stage 3",
                        pressureAfterMembrane: "P6 Pressure Outlet Membranes",
                        blowerPressure: "P1 Pressure Outlet Blower",
                        blowerPressureSetpoint: "Pressure Outlet Blower Setpoint",
                        compressorOutPressure: "P3 Pressure Outlet Compressor",
                    },
                    valves: {
                        label: "Vannes",
                        valveCompressor: "Vanne compresseur",
                        valveMembrane: "Vanne membrane",
                        valveGrid: "Vanne réseau",
                        valveCo2: "Vanne CO2",
                    },
                    system: {
                        label: "Système",
                        installationState: "État de l'installation",
                        geuAvailable: "GEU disponible",
                        geuAlarm: "Alarme GEU",
                        geuDelivering: "GEU en service",
                        gasTotalGeu: "Gaz total GEU",
                        gasTotalInternGeu: "Gaz total interne GEU",
                        biogasTotalizer: "Totalisateur de biogaz",
                        biomethaneDewpoint: "Point de rosée biométhane",
                        compressorSpeed: "Vitesse du compresseur",
                    },
                    filters: {
                        label: "Filtres",
                        inletFilterPressuredrop: "Perte de charge du filtre d'entrée",
                        filterTrainPressuredrop: "Perte de charge de la batterie de filtres",
                        oilFilterPressuredrop: "Perte de charge du filtre à huile",
                    },
                    checks: {
                        yourImage: "Votre image :",
                        imageCommentsLabel: "Commentaires sur cette image (optionnel) :",
                        imageCommentsPlaceholder: "Ajoutez des commentaires sur cette image",
                        exampleImage: "Image d’exemple :",
                        textAnswerPlaceholder: "Saisissez votre réponse ici",
                        next: "Suivant",
                        completedMessage: "Vous avez terminé tous les contrôles de construction, veuillez envoyer la liste de contrôle.",
                        skip: "Passer",
                        downloadPdf: "Télécharger le PDF",
                        answerLabel: "Réponse :",
                        commentsLabel: "Commentaires :",
                        selectedOptionsLabel: "Options sélectionnées :",
                        addEntry: "Ajouter une entrée",
                        newEntryForCheck: "Nouvelle entrée pour ce contrôle :",
                        commentsOptionalPlaceholder: "Commentaires (facultatif)",
                        yourAnswerPlaceholder: "Votre réponse",
                        saveEntry: "Enregistrer l’entrée",
                        cancel: "Annuler",
                        entryAdded: "Entrée ajoutée.",
                        entryAddFailedPrefix: "Échec de l’ajout de l’entrée : ",
                        validateBeforeSubmitting: "Veuillez fournir une réponse avant d’envoyer.",
                        validateBeforeNextCheck: "Veuillez fournir une réponse avant de passer au contrôle suivant.",
                        uploadSuccess: "Données envoyées avec succès",
                        uploadFailedPrefix: "Échec de l’envoi des données : ",
                    }
                }
            },
            de: {
                translation: {
                    dashboard: {
                        nameIdentifier: "Name oder Kennung",
                        efficiencyAll: "Effizienz aller Maschinen",
                        onlyErrors: "Nur Fehler",
                        toggleDisconnected: "Getrennte Maschinen umschalten",
                        productionCombined: "Kombinierte Produktion (Wh)",
                        realisedTechnicalEfficiency: "Realisierte / Technische Effizienz (%)",
                        efficiencyCombined: "Realisierte Effizienz (%)",
                        technicalEfficiencyCombined: "Technische Effizienz (%)",
                        bgp: "Bgp (m³/Tonne)",
                        consumption: "Verbrauch (Wh)",
                        manureLifeTime: "Lebensdauer des Mistes (Tage)",
                        feeding: "Fütterung (kg)"
                    },
                    common: {
                        on: "An",
                        off: "Aus",
                        add: "Hinzufügen",
                        save: "Speichern",
                        monday: "Montag",
                        tuesday: "Dienstag",
                        wednesday: "Mittwoch",
                        thursday: "Donnerstag",
                        friday: "Freitag",
                        saturday: "Samstag",
                        sunday: "Sonntag",
                        from: "Von",
                        to: "Bis",
                        hours: "Stunden",
                        reset: "Zurücksetzen",
                        confirmation: "Bestätigung",
                        cancel: "Abbrechen",
                        yesIAmSure: "Ja, ich bin sicher",
                        set: "Anpassen",
                        auto: "Automatisch",
                        manual: "Manuell",
                        minutes: "Minuten",
                        seconds: "Sekunden",
                        turnOn: "Anmachen",
                        turnOff: "Abschalten",
                        graphLoading: "Laden von Diagrammen...",
                        noData: "Keine Daten verfügbar...",
                        hoursPerYear: "Stunden / Jahr",
                        datetime: "Datum und Uhrzeit",
                        warning: "Warnung",
                        error: "Fehler",
                        type: "Typ",
                        startdate: "Startdatum",
                        enddate: "Enddatum",
                        all: "Alle",
                        engine1: "Motor 1",
                        engine2: "Motor 2",
                        ongoing: "Laufend",
                        both: "Beide",
                        days: "Tage",
                        today: "Heute",
                        sendAnswers: "Antworten senden",
                        employee: "Mitarbeiter",
                        customer: "Kunde",
                        sales: "Vertrieb",
                        technician: "Techniker",
                        admin: "Administrator",
                        noDateKnown: "Kein Datum bekannt",
                        command: "Befehl",
                        user: "Benutzer",
                        fillInSurvey: "Bitte füllen Sie die Umfrage aus",
                        tons: "Tonne",
                        count: "Zählen",
                        disabled: "Deaktiviert",
                        addField: "Feld hinzufügen",
                        deleteField: "Feld löschen",
                        releases: "Veröffentlichungen",
                        open: "Öffnen",
                        close: "Schließen",
                        opening: "Öffnen",
                        closing: "Schließen",
                        zoomCancel: "Zoom abgebrochen, bleiben Sie zum Zoomen innerhalb des Diagramms",
                        stuck: "Festgefahren"
                    },
                    errorPage: {
                        title: "Etwas ist schiefgelaufen.",
                        contact: "Bitte melden Sie dieses Problem an it@biolectric.com und geben Sie an, welches Handy oder welchen Browser Sie verwenden.",
                        reload: "Neu laden"
                    },
                    popups: {
                        engineIdle: "Motor läuft noch, bitte schalten Sie zuerst den Motor aus",
                        valueBetween: "Der Wert muss zwischen {{min}} und {{max}} liegen",
                        valueBetweenCustom: "Der Wert muss zwischen {{min}} und {{max}} liegen",
                        powerTooLow: "Die Leistung kann nicht niedriger als {{watts}}W eingestellt werden",
                        powerTooHigh: "Die Leistung kann nicht höher als {{maxPower}} eingestellt werden",
                        maxCoolingTemp: "Darf nicht höher als {{max}}°C sein",
                        minValue: "Darf nicht weniger als {{min}} sein",
                        maxAirInjectionTime: "Darf nicht länger als {{max}} Sekunden sein",
                        minGasBuffer: "Min. Gaspuffer außerhalb des Bereichs. Minimalwert für Ihre Anlage ist {{min}}",
                        maxGasBuffer: "Max. Gaspuffer außerhalb des Bereichs. Maximalwert für Ihre Anlage ist {{max}}",
                        reactorTemp: "Reaktortemperatur außerhalb des Bereichs. Muss zwischen {{min}} und {{max}} liegen",
                        reactorLevel: "Ungültiger Reaktorfüllstand. Maximalwert für Ihre Anlage ist {{limit}}",
                        reactorLevelRange: "Der Wert für den Reaktorfüllstand muss zwischen {{min}} und {{max}} liegen",
                        commandFailed: "Befehl konnte nicht gesendet werden",
                        commandSent: "Befehl gesendet",
                        commandSuccess: "Sie haben {{command}} erfolgreich von {{previousValue}} auf {{value}} aktualisiert",
                        commandMix1Hour: "Der Mixer wird für 1 Stunde laufen",
                    },
                    menu: {
                        dashboard: 'Armaturenbrett',
                        machines: 'Maschinen',
                        questionnaires: 'Fragebögen',
                        banners: "Banner",
                        errors: "Fehlermeldungen",
                        pcb: "Cartes de circuits imprimés",
                        tasks: "Meine Aufgaben",
                        releases: "Versionshinweise",
                        resellers: "Wiederverkäufer",
                        users: "Benutzer",
                        recommendations: "Empfehlungen",
                        suggestions: "Empfehlungsnachrichten",
                        faultTrees: "Fehlerbaume",
                        assistant: "Assistent",
                        language: "Sprache",
                        reconnection: "Diese Maschine ist derzeit offline. Versuchen Sie, mit der Schaltfläche oben eine neue Verbindung herzustellen.",
                        profile: "Profil",
                        logout: "Abmelden",
                        firmware: "Firmware",
                        sms: "SMS",
                        advanced: "Erweitert",
                        errorsSingle: "Fehler",
                        warnings: "Warnungen"
                    },
                    statistics: {
                        label: "Statistiken",
                        foamBeaterThermalStatus: "Thermik Schaumschläger",
                        exitPumpThermalStatus: "Thermik Abpumpe",
                        thermalStatusOk: "Thermik nicht aktiv, Verbraucher kann normal funktionieren",
                        thermalStatusFault: "Thermik aktiv, Verbraucher im Fehler",
                        group1: "Gruppe 1",
                        group2: "Gruppe 2",
                        addProperty: "Eigenschaft hinzufügen",
                        removeProperty: "Eigenschaft entfernen",
                        startTutorial: "Tutorial starten",
                        exitTutorial: "Tutorial verlassen",
                        welcomeStep: {
                            title: "Willkommen auf der Statistikseite",
                            content: "Hier können Sie verschiedene Werte und Trends einfach vergleichen."
                        },
                        propertyStep: {
                            title: "Eigenschaftsauswahl",
                            content: "Um zu beginnen, wählen Sie einfach eine Eigenschaft aus, die Sie interessiert, aus dem Auswahlfeld."
                        },
                        addPropertyStep: {
                            title: "Hinzufügen und Entfernen von Eigenschaften",
                            content: "Versuchen Sie, eine Eigenschaft hinzuzufügen oder zu entfernen. Sie können bis zu 4 Eigenschaften pro Gruppe hinzufügen."
                        },
                        groupStep: {
                            title: "Aktivieren von Gruppe 2",
                            content: "Klicken Sie auf die Schaltfläche 'Eigenschaft hinzufügen', um eine Eigenschaft für Gruppe 2 auszuwählen. Eigenschaften in dieser Gruppe werden auf der rechten Seite des Diagramms angezeigt."
                        },
                        dateRangeStep: {
                            title: "Auswahl eines Datumsbereichs",
                            content: "Verwenden Sie diese Schaltfläche, um einen Datumsbereich auszuwählen."
                        },
                        zoomInStep: {
                            title: "Hineinzoomen",
                            content: "Ziehen Sie Ihre Maus über das Diagramm, um einen Bereich zum Hineinzoomen auszuwählen."
                        },
                        zoomOutStep: {
                            title: "Herauszoomen",
                            content: "Setzen Sie die zuvor ausgewählte Datumsbereich durch Verwenden der 'Herauszoomen'-Schaltfläche zurück."
                        },
                        domainStep: {
                            title: "Anpassen von Domänen",
                            content: "Sie können das maximale und minimale Domänen pro Gruppe anpassen, indem Sie diese Schaltflächen verwenden."
                        },
                        csvStep: {
                            title: "CSV-Daten herunterladen",
                            content: "Laden Sie die aktuell angezeigten Diagrammdaten im CSV-Format herunter."
                        },
                        imageStep: {
                            title: "Bild herunterladen",
                            content: "Laden Sie das aktuell angezeigte Diagramm als Bild herunter."
                        },
                        configurationStep: {
                            title: "Voreinstellungs-Konfiguration",
                            content: "Sie können Ihre aktuelle Konfiguration als Voreinstellung speichern. Sie können auch bestehende Voreinstellungen aktualisieren oder löschen."
                        },
                        controlCardTemp: "Temperatur der Steuerkarte",
                        lowTensionError: "Niederspannungsfehler",
                        overTempFlueGasHeatExch: "Überhitzung des Abgaswärmetauschers",
                        feedingCycleLevel: "Fütterungszykluspegel",
                        batteryVoltage: "Batteriespannung",
                        waterPressure: "Wasserdruck",
                        shortInterval: "10 Minuten Intervalle",
                        dailyInterval: "Tägliche Intervalle",
                        configurationUpdated: "Ihre aktuelle Konfiguration wurde in dieser Voreinstellung gespeichert",
                        presets: "Voreinstellungen",
                        savePreset: "Als Voreinstellung speichern",
                        applyPreset: "Voreinstellung anwenden",
                        updatePreset: "Voreinstellung aktualisieren",
                        delete: "Löschen",
                        noPresets: "Sie haben noch keine Voreinstellungen",
                        givePresetName: "Geben Sie Ihrer Voreinstellung einen Namen",

                    },
                    smart: {
                        label: "Smart",
                        heightOffset: "Höhenversatz",
                        active: "Aktiv",
                        passive: "Passiv",
                        preActive: "Vor-Aktiv",
                        prePassive: "Vor-Passiv",
                        postActive: "Nach-Aktiv",
                        postPassive: "Nach-Passiv",
                        activeDesc: "Während einer aktiven Phase wird die geplante Energieerzeugung maximiert. Vor jeder aktiven Phase wird automatisch ein „Vor-Aktiv“-Zeitfenster bereitgestellt, in dem der Gaspuffer aufgebaut wird. Die maximale Dauer einer aktiven Phase wird durch das Volumen des Gaspuffers, die Anzahl und Art der installierten BHKW sowie das Biogasproduktionsprofil der Anlage bestimmt. Wenn der minimale Füllstand des Gaspuffers erreicht ist, wird die Energieerzeugung gestoppt (nach der aktiven Phase).",
                        passiveDesc: "Während einer passiven Phase wird Energie nur erzeugt, wenn ein Gasüberschuss besteht. Vor jeder passiven Phase wird automatisch ein Zeitfenster eingerichtet, in dem der Gaspuffer reduziert wird. Die maximale Dauer einer passiven Phase wird durch das Volumen des Gaspuffers und das Biogasproduktionsprofil der Anlage bestimmt. Wenn der maximale Füllstand des Gaspuffers erreicht ist, startet die Energieerzeugung (nach der passiven Phase).",
                        permanence: "Ständige Produktion anregen, indem dynamisch auf einem Motor bei nicht maximalem Gasvorrat betrieben wird",
                        permanency: "Dauerhafter Betrieb",
                        activateStep: {
                            title: "SMART aktivieren",
                            content: "Aktivieren Sie SMART, um das Produktionsprofil der Anlage zu steuern"
                        },
                        timeslotStep: {
                            title: "Zeitfenster hinzufügen",
                            content: "Fügen Sie ein aktives oder passives Zeitfenster hinzu"
                        },
                        fromToStep: {
                            title: "Von / Bis",
                            content: "Sie legen sowohl den Start- als auch den Endtag sowie die Uhrzeit fest"
                        },
                        activePassiveStep: {
                            title: "Aktiv oder Passiv",
                            content: "Wählen Sie, ob Sie ein aktives oder passives Zeitfenster festlegen möchten"
                        },
                        saveStep: {
                            title: "Zeitfenster speichern",
                            content: "Speichern Sie Ihre geänderten Einstellungen"
                        },
                        removeStep: {
                            title: "Zeitfenster entfernen",
                            content: "Entfernen Sie hier Ihr Zeitfenster"
                        },
                        visualStep: {
                            title: "Visuelle Darstellung",
                            content: "Dieses Diagramm vergleicht die SMART-Einstellungen mit dem Produktionsprofil der letzten Woche"
                        },
                        daySwitchStep: {
                            title: "Visuelle Darstellung",
                            content: "Wechseln Sie einfach zum nächsten oder vorherigen Tag"
                        },
                    },
                    gas: {
                        label: "Gas",
                        minGasBufferLevel: "Gaspuffer min",
                        maxGasBufferLevel: "Gaspuffer max",
                        gasBufferLevel: "Gaspuffer aktuell",
                        defaultMinGasBufferLevel: "Standardmäßiger gaspuffer min",
                        defaultMaxGasBufferLevel: "Standardmäßiger gaspuffer min",
                        airInjectionTime: "Belüftung",
                        maxAirInjectionTime: "Maximale Belüftung",
                        torch: "Fackel",
                        torchType: "Fackel-Typ",
                        torchStatus: "Status Fackel",
                        torchError: "Fehler Fackel",
                        theoreticalTorchFlow: "Theoretischer Fackeldurchsatz",
                        torchRunningTime: "Fackelzeit",
                        torchFlaredVolume: "Abgefackeltes Volumen",
                        h2s: "H₂S",
                        h2sLevelReactor: "H₂S-Reaktor",
                        h2sLevelMotor: "H₂S Motor",
                        filterLoad: "Filterbelastung",
                        sample: "Probe",
                        latestH2sReadings: "Letzte H₂S-Messungen",
                        carbonFilterSize: "Größe Kohlefilter",
                        h2sMeasurements: "H₂S-Messungen",
                        measurements: "Messungen",
                        changeTo: "Ändern zu",
                        none: "Keine",
                        container: "Behälter",
                        extern: "Extern",
                        foamBeaterInstalled: "Schaumschläger installiert",
                        antiFoamInjectionsInstalled: "Antischauminjektionen installiert",
                        containerCombinedOperation: "Behälter (kombinierter Vorgang)",
                        externCombinedOperation: "Extern (kombinierter Vorgang)",
                        gasTemp: "T1 Temperature After Gascooler",
                        ch4BiogasSupply: "CH4-Biogaszufuhr",
                        co2BiogasSupply: "CO2-Biogaszufuhr",
                        o2BiogasSupply: "O2-Biogaszufuhr",
                        h2sAfterFilter: "H2S nach Filter",
                        biomethaneFlowNorm: "Normierter Biomethanfluss",
                        ch4Biomethane: "CH4-Biomethan",
                        co2Biomethane: "CO2-Biomethan",
                        o2Biomethane: "O2-Biomethan",
                        h2sBiomethane: "H2S-Biomethan",
                        bufferRelease: "Pufferentladung",
                        wobbe: "Wobbe-Index",
                        wobbeAvg: "Durchschnittlicher Wobbe-Index",
                        wobbePidSetpoint: "Wobbe-PID-Sollwert",
                        wobbeBiomethanePronova: "Wobbe-Biomethan Pronova",
                    },
                    engine: {
                        label: "motor",
                        startEngine: "Motor starten",
                        stopEngine: "Motor abstellen",
                        power: "Leistung",
                        desiredPower: "Leistung einstellen",
                        maxPower: "Maximum power",
                        rpm: "Drehzahl (n/min)",
                        lambda: "Lambda",
                        throttleValve: "Position Servo",
                        engineType: "Engine type",
                        engineStatus: "Motorzustand",
                        engineError: "Motorfehler",
                        producedEnergy: "Produzierte grüne Energie",
                        operatingHours: "Betriebsstunden des Motors",
                        totalOperatingHours: "Gesamtbetriebsstunden des Motors",
                        gasUsage: "Gasverbrauch",
                        throttlePosition: "Position Throttle",
                        noErrors: "All systems operational.",
                        production: "Production",
                        servoAuto: "Der Servo wird automatisch eingestellt",
                        servoControl: "Servosteuerung",
                        temperature: "Motortemperatur",
                        restart: "Automatischer Motorstart, wenn Gas verfügbar ist",
                        confirmStop: "Sind Sie sicher, dass Sie Motor {{number}} abstellen möchten?",
                        confirmStopRestart: "Sind Sie sicher, dass Sie Motor {{number}} abstellen möchten? Er startet automatisch neu, wenn Gas verfügbar ist.",
                        idle: "Leerlauf",
                        running: "Läuft",
                        waiting: "Warten auf das Hochfahren",
                        booting: "Hochfahren",
                        shuttingDown: "Herunterfahren",
                        advanced: "Erweitert",
                        numberOfEngines: "Anzahl der Motoren",
                        predeterminedRunHours: "Vorgegebene Betriebsstunden",
                        easyStart1: "Easy start motor 1",
                        easyStart2: "Easy start motor 2",
                        setError1: "Fehler Motor 1 einstellen",
                        setError2: "Fehler Motor 2 einstellen",
                        fuel: "Kraftstoff",
                        airIntakeOpen: "Lufteinlass offen",
                        airIntakeClosed: "Lufteinlass geschlossen",
                        vfd: "VFD",
                    },
                    service: {
                        label: "Wartung",
                        lastMaintenance: "Betriebsstunden bis zum nächsten Ölwechsel",
                        currentlyInstalled: "Aktuell installierte Betriebsstunden",
                        total: "Gesamt-Betriebsstunden",
                        mixer: "Mischer",
                        foam_beater: "Schaumschläger",
                        intake_pump: "Einsaugpumpe",
                        digestate_pump: "Gärrestpumpe",
                        newMixer: "Neuer Mischer installiert",
                        newEngine: "Neuer motor installiert",
                        newFoamBeater: "Neuer Schaumschläger installiert",
                        newIntakePump: "Neue Einsaugpumpe installiert",
                        newDigestatePump: "Neue Gärrestpumpe installiert",
                        confirmationMessage: "Sind Sie sicher, dass Sie zurücksetzen wollen, den {{type}}",
                        maintenanceMessage: "Wartungsstunden wurden zurückgesetzt für {{type}}",
                        newEquipmentMessage: "Neue Ausrüstung installiert:",
                        prints: "Prints",
                        firstOnline: "Erstes Online",
                        lastOnline: "Letztes Online",
                        serial: "Seriennummer",
                        type: "Typ",
                        engine: "Motor",
                        engine1: "Motor 1",
                        engine2: "Motor 2",
                        engine_new1: "Motor 1",
                        engine_new2: "Motor 2",
                        h2s1: "H₂S-Motor 1",
                        h2s2: "H₂S-Motor 2",
                        resetTo: "Zurücksetzen auf x Stunden (Standard 0)",
                        timeFilterReplace: "Zeit seit Filterwechsel",
                        daysSinceOil: "Tage seit Ölwechsel",
                        newGenerator: "Neuer Generator installiert",
                        generator: "Generator",
                        generator1: "Generator 1",
                        generator2: "Generator 2",
                        daysSinceOilChange: "Tage seit dem Ölwechsel",
                        videoMessage: "Video zum Ölwechsel => Dokumentenseite, unter Allgemeine Videos.",
                        videoRoom: "Ein Servicetechniker hat einen Video-Raum für diese Maschine geöffnet. Klicken Sie hier, um beizutreten.",
                        videoButton: "Einen Video-Raum für diese Maschine starten",
                        videoButtonSub: "Benutzer mit Zugriff können den Anruf von ihrer Service-Seite aus beitreten.",
                        videoClose: "Video-Raum schließen",
                        serialNumber: "Seriennummer",
                        defaultEngineReset: "Standard-Motorreset",
                        newInstalled: "Neue {{type}} installiert",
                        replace: "Ersetzen",
                        aircover: "Luftabdeckung",
                        gascover: "Gasabdeckung",
                        liner: "Auskleidung",
                        flow_meter: "Durchflussmesser",
                        energy_meter1: "Energiezähler 1",
                        energy_meter2: "Energiezähler 2",
                        energy_meter_own: "Energiezähler Eigenverbrauch",
                        h2sPastille: "Zeit bis zum Austausch des H2S-Sensors",
                        pastille1: "H₂S-Sensor 1",
                        pastille2: "H₂S-Sensor 2",
                        engineLabel: "Nächste Motorwartung nach “XX” Stunden",
                        engine1Conf: "Wartungsintervall für Motor 1 nur zurücksetzen, nachdem die Motorwartung durchgeführt wurde",
                        engine2Conf: "Wartungsintervall für Motor 2 nur zurücksetzen, nachdem die Motorwartung durchgeführt wurde",
                        h2s1Conf: "H2S Motor 1 nur zurücksetzen, wenn die Aktivkohle im Filter ersetzt wurde",
                        h2s2Conf: "H2S Motor 2 nur zurücksetzen, wenn die Aktivkohle im Filter ersetzt wurde",
                        filterResetOffline: "Maschine ist offline. Der Filter-Reset wurde nicht gespeichert. Stellen Sie die Verbindung wieder her und versuchen Sie es erneut.",
                        filterResetFailed: "Filter-Reset fehlgeschlagen. Der Filter-Reset wurde nicht gespeichert.",
                        consumables: {
                            title: "Verbrauchsmaterial",
                            belowMin: "Unter Mindestbestand",
                            noneBelow: "Keine Artikel unter dem Mindestbestand",
                            notCounted: "Noch nicht gezählt",
                            article: "Artikelnummer",
                            description: "Beschreibung",
                            onSite: "Vorhanden",
                            minimum: "Minimum",
                            engineMaintenance: "Motorwartung",
                            pendingStock: "{{confirmed}} bestätigt + {{pending}} wartet auf Validierung",
                            send: "Senden",
                            shipmentSaved: "Versand gespeichert. Er bleibt ausstehend, bis der Kunde bestätigt.",
                            shipmentFailed: "Versand konnte nicht gespeichert werden",
                            confirm: "Empfang bestätigen",
                            confirmSaved: "Bestand bestätigt",
                            confirmFailed: "Bestand konnte nicht bestätigt werden",
                            confirmHint: "Bestätigen Sie die Lieferung, damit sie zum Bestand vor Ort zählt.",
                            guideTitle: "So funktioniert es",
                            guideIntro: "Öl, Ölfilter und Zündkerzen bleiben an jeder Installation. Die Serviceseite der Installation und diese Bestellseite nutzen denselben Bestand.",
                            guide1Role: "Techniker",
                            guide1Title: "Zählen, was vor Ort ist",
                            guide1Body: "Auf der Serviceseite der Installation öffnen Sie Verbrauchsmaterial und tragen ein, wie viel von jedem Artikel tatsächlich vorhanden ist. Diese Zählung ist sofort bestätigt. Eine Zählung vor Ort wartet auf niemanden sonst.",
                            guide2Role: "Automatisch",
                            guide2Title: "Motorwartung verbraucht Bestand",
                            guide2Body: "Beim Erfassen einer Motorwartung wird der Verbrauch dieses Motors vom bestätigten Bestand abgezogen. Eine WG1605-Wartung verbraucht 0,28 einer 25-l-Ölkanne, 1 Ölfilter und 4 Zündkerzen. WG972 und WG3800 nutzen die Mengen in der Tabelle Motorwartung. Das geschieht, wenn die Installation einen Statistikdatensatz mit Motortyp hat.",
                            guide3Role: "Servicemanager",
                            guide3Title: "Fehlendes senden",
                            guide3Body: "Diese Seite zeigt Installationen, deren bestätigter Bestand kleiner oder gleich dem Minimum ist. Tragen Sie die zu versendende Menge ein und drücken Sie Senden. Sie bleibt ausstehend, zum Beispiel 0,5 bestätigt + 5 wartet auf Validierung, und zählt noch nicht als Bestand. Das Minimum wird je Motortyp festgelegt. Eine Installation verwendet die Summe der eingebauten Motoren, gerundet auf eine ganze Zahl. Ein Stück Öl ist ein 25-l-Kanister.",
                            guide4Role: "Jeder mit Zugriff",
                            guide4Title: "Lieferung bestätigen",
                            guide4Body: "Wenn die Ware vor Ort ist, bestätigt der Kunde, ein Techniker oder ein Mitarbeiter den Empfang auf der Serviceseite der Installation. Die ausstehende Menge wird zum bestätigten Bestand addiert. 0,5 bestätigt und 5 ausstehend werden dann 5,5 vor Ort.",
                            correction: "Bestandskorrektur",
                            save: "Bestandszählung speichern",
                            saved: "Bestandszählung gespeichert",
                            saveFailed: "Bestandszählung konnte nicht gespeichert werden",
                            minSaved: "Mindestbestand gespeichert",
                            minFailed: "Mindestbestand konnte nicht gespeichert werden",
                            minHint: "Legen Sie das Minimum je Motortyp fest. Eine Installation verwendet die Summe der eingebauten Motoren, gerundet auf eine ganze Zahl. Sie erscheint, sobald der Bestand kleiner oder gleich diesem Minimum ist. Ein Stück Öl ist ein 25-l-Kanister.",
                            usage: "Verbrauch pro Motorwartung",
                            usageHint: "Beim Erfassen einer Motorwartung wird dieser Verbrauch vom gezählten Bestand abgezogen. DF972 und WG972 nutzen die Spalte WG972. WG3800-L nutzt die Spalte WG3800.",
                            orders: "Zu startende Bestellungen",
                            ordersEmpty: "Keine Installationen auf oder unter dem Mindestbestand",
                            shortage: "Fehlmenge",
                            installation: "Installation",
                            engines: "Motoren",
                        },
                        pastille1Conf: "Lebensdauer des H2S-Sensors 1 nur zurücksetzen, wenn das Sensorelement ersetzt wurde.",
                        pastille2Conf: "Lebensdauer des H2S-Sensors 2 nur zurücksetzen, wenn das Sensorelement ersetzt wurde.",
                        pastilleLabel: "Erwartete Lebensdauer des Sensorelements XX Tage",
                        valve_interval: "Betriebsstunden bis Ventilspielkontrolle",
                        cylinder_interval: "Betriebsstunden bis Zylinderkopfüberholung",
                        valve_interval_engine1: "Betriebsstunden bis Ventilspielkontrolle Motor 1",
                        cylinder_interval_engine1: "Betriebsstunden bis Zylinderkopfüberholung Motor 1",
                        valve_interval_engine2: "Betriebsstunden bis Ventilspielkontrolle Motor 2",
                        cylinder_interval_engine2: "Betriebsstunden bis Zylinderkopfüberholung Motor 2",
                        pipe: "Rohr",
                        transmitter: "Transmitter",
                        elektromotor: "Elektromotor",
                        pump: "Pumpe",
                        roofsolation: "Dachisolierung",
                        airPump: "Lufteinspritzpumpe",
                        oxygenConcentrator: "Sauerstoffkonzentrator",
                        flowmeterBiogas: "Biogas-Durchflussmesser",
                        pronovaBiomethaan: "ProNova Biomethan",
                        pronovaBiogas: "ProNova Biogas",
                        h2s1Gpi: "Kohlefilter 1",
                        h2s2Gpi: "Kohlefilter 2",
                        coolant: "Kühlmittel",
                        daysSinceCoolantReplace: "Tage seit dem Austausch",
                        coolantConf: "Setzen Sie die Betriebsstunden des Kühlmittels nur zurück, nachdem das Kühlmittel ausgetauscht wurde",
                        daysSinceInhibitor: "Tage seit Inhibitorenpaket",
                        inhibitorPackage: "Inhibitorenpaket",
                        registerInhibitor: "Registrieren",
                        inhibitorConf: "Nur registrieren, nachdem das Kühlmittel mit einem Inhibitorenpaket aufgefüllt wurde (alle 12 Monate)",
                        restoreValues: {
                            button: "PLC-Werte wiederherstellen",
                            title: "PLC-Werte wiederherstellen",
                            description: "Wählen Sie einen Tag der letzten 7 Tage, der korrekt aussieht, prüfen Sie die vorausgefüllten Werte und senden Sie sie an die PLC.",
                            pickDay: "Tag auswählen",
                            snapshotTime: "Abtastzeit",
                            noSnapshots: "Keine Statistiken für die letzten 7 Tage gefunden.",
                            send: "Senden",
                            sendAll: "Alles senden",
                            sending: "Senden…",
                            confirmSendAll: "Alle vorausgefüllten Werte an die PLC senden?",
                            sendAllDone: "{{count}} Werte an die PLC gesendet",
                            emptyValue: "Wert ist leer",
                            invalidValue: "Wert ist keine Zahl",
                            invalidEngineCount: "Anzahl der Motoren muss 1 oder 2 sein",
                            noConnection: "Maschine hat keine aktive Verbindung",
                            readOnly: "nur lesen",
                            fromMachine: "aus Maschinenstammdaten",
                            current: "Aktuell",
                            currentHint: "Aktueller Slow/Fast-Wert auf der CU",
                            ups: "UPS",
                            groupEngines: "Motoren",
                            groupReactor: "Reaktor & Mischen",
                            groupFeeding: "Fütterung",
                            groupGas: "Gas",
                            groupEnergy: "Energiezähler",
                            groupSsr: "SSR",
                        },
                        tabs: {
                            engine: "Motor",
                            reactor: "Reaktor / Container",
                            gas: "Gas / Aufbereitung",
                            consumables: "Verbrauchsmaterial",
                            options: "Maschinenoptionen",
                            prints: "Drucke",
                            restoreValues: "PLC-Werte wiederherstellen",
                        },
                    },
                    net: {
                        net: "Netzanschluss",
                        meterSettings: "Zählereinstellungen",
                        voltagePerPhase1: "Spannung pro Phase (1)",
                        voltagePerPhase2: "Spannung pro Phase (2)",
                        voltagePerPhase3: "Spannung pro Phase (3)",
                        frequencyPerPhase: "Frequenz pro Phase",
                        angleBetweenPhase1And2: "Winkel zwischen Phase 1 und 2",
                        ownPowerConsumption: "Eigener Stromverbrauch",
                        ownEnergyConsumption: "Eigener Energieverbrauch",
                        bioguardVersion: "Bioguard-Version",
                        brutoProducedEnergy: "Brutto produzierte Energie",
                        nettoProducedEnergy: "Netto produzierte Energie",
                        producedEnergy: "Produzierte Energie",
                        producedEnergyEngine1: "Produzierte Energie Motor 1",
                        producedEnergyEngine2: "Produzierte Energie Motor 2",
                        monitoringRelay: "Überwachungsrelais",
                        powerNonFit: "Eigenverbrauch Strom ohne FIT",
                        energyMeterNonFit: "Energiezähler Eigenverbrauch ohne FIT",
                    },
                    reactor: {
                        label: "Reaktor",
                        reactorTemp: "Temperatur Reaktor",
                        reactorTempTarget: "Soll-Reaktortemperatur",
                        reactorLevel: "Sollwert Reaktorfüllstand",
                        hydrostaticPressure: "Reaktorfüllstand aktuell",
                        siloType: "Silo-Typ",
                        extraHeating: "Zusätzliche Heizung",
                        antiFrost: "Anti frost",
                        antiFrostIndex: "Anti frost index",
                        antiFrostAuto: "Der Frostindex wird automatisch basierend auf der lokalen Temperatur eingestellt",
                        antiFrostMessageNew: "Bei jedem Frostindexzyklus wird die Güllepumpe für 4 Sekunden aktiviert und die Gärrestpumpe pimpt ca. 100 l Gärrest, bezogen auf den eingestellten Durchfluss.",
                        antiFrostMessageOld: "Bei jedem Frostindexzyklus wird die Güllepumpe für 4 s und die Gärrestpumpe für 120 s aktiviert.",
                        coolwater: "Kühlwasser",
                        statusCoolingValve: "Kühlwasserventil",
                        waterTempIn: "Kühlwassertemperatur Reaktoreingang",
                        waterTempOut: "Kühlwassertemperatur Reaktorausgang",
                        waterTempMotorOut: "Kühlwassertemperatur Ausgang Motor 1",
                        waterTempMotorOut2: "Kühlwassertemperatur Ausgang Motor 2",
                        coolingWaterTemp: "Einstellung Kühlwassertemperatur",
                        maxCoolingWaterTemp: "Grenzwert Kühlwassertemperatur",
                        waterPressure: "Wasserdruck im Kaltwasserkreislauf",
                        foamBeater: "Antischaum",
                        foambeatEveryXMinutes: "Schaum brechen alle",
                        foambeatForXSeconds: "Für",
                        mixer: "Mixer",
                        mixerMaxPower: "Maximale Leistung Mixer",
                        mixerActive: "Mixer aktiv",
                        mixerBlockedLowLevel: "Mischer blockiert aufgrund eines niedrigen Reaktorfüllstands",
                        mixEveryXMinutes: "Mischzeitpunkt: Alle",
                        mixForXSeconds: "Mischdauer",
                        blockMixingFrom: "Kein Mischen ab ",
                        blockMixingTo: "Bis",
                        mixerInfo: "Der Mixer wird automatisch für die ausgewählte Dauer mit dem ausgewählten Zeitintervall eingeschaltet. Während des Mischersperrzeitfensters wird der Mischer gestoppt, wenn die Mischerleistung die aktuelle Stromerzeugung der Anlage übersteigt. Der Mischer wird während des BHKW-Starts vorübergehend angehalten, bis 50 % der Nennleistung erreicht sind, um den Einschaltstrom zu ermöglichen",
                        mixerInfoGpi: "Der Mixer wird automatisch für die ausgewählte Dauer mit dem ausgewählten Zeitintervall eingeschaltet. Während des Mischersperrzeitfensters wird der Mischer gestoppt, wenn die Mischerleistung die aktuelle Stromerzeugung der Anlage übersteigt.",
                        mix1Hour: "Mix 1 stunde",
                        coolwaterValveInstalled: "Geregeltes 3-Wege-Ventil",
                        coolwaterValveBinary: "Binäres 3-Wege-Ventil",
                        coolwaterValveMaximizeHeat: "Wärmenutzung maximieren",
                        coolwaterValveMaximizeHeatInfo: "Die Maximierung der Wärmenutzung kann zu Zeiträumen ohne Wärmeverfügbarkeit am Plattenwärmetauscher führen",
                        coolwaterValvePlatePriority: "Priorität Plattenwärmetauscher",
                        coolwaterValvePlatePriorityInfo: "Wärmeverfügbarkeit am Plattenwärmetauscher priorisieren und dabei eine stabile Fermentertemperatur aufrechterhalten",
                        bypassFan: "Steuerventil-Bypass/Lüfter",
                        digester: "Regelventil Fermenter / externer Wärmeverbrauch",
                        silo: "Silo",
                        bag: "Beutel",
                        plateHeatExchanger: "Plattenwärmetauscher",
                        timesPerDay: "mal / Tag",
                        intern: "Intern",
                        extern: "Extern",
                        tempHigh: "Temperatur hoch",
                        externMessage: "Der folgende Fehler wird nicht ausgelöst, wenn der Mischer auf extern eingestellt ist: Mischer funktioniert nicht, bitte thermisch zurücksetzen.",
                        bypass: "Bypass",
                        ventilator: "Ventilator",
                        tempCoolHeatExchOut: "Kühlwassertemperatur Ausgang Plattenwärmetauscher",
                        overtempMixer1: "Übertemperatur Mischer 1",
                        overtempMixer2: "Übertemperatur Mischer 2",
                        mixerSettings: "Mischereinstellungen",
                        premixing: "Vormischen",
                        intakeMixing: "Einlassmischen",
                        premixingInfo: "Vormischen ist das Mischen vor der Fütterung, also vor und während des Auspumpens. Die Zeit bezieht sich immer auf die Mischdauer.",
                        intakeMixingInfo: "Einlassmischen erlaubt gleichzeitiges Mischen beim Einfördern. Bei OFF wird nicht gemischt, solange die Fütterung läuft.",
                        gpiMixDuringIntake: "Mischen während der Flüssigfütterung",
                        gpiMixDuringIntakeInfo: "Mischen während der gesamten Flüssigfütterung.",
                        gpiMixDuringIntakeHelp: "Mischen während der Flüssigfütterung: Mischen während der gesamten Fütterung. Bei OFF: abhängig vom Silotyp.\n\nS-Typen: nur Vormischen beim Auspumpen und Mischen nach der Fütterung für die Mischerdauer.\n\nC-Typen: kein Vormischen; Mischen nach der Fütterung für die Mischerdauer.",
                        gpiMixDuringIntakeOffGeneric: "Bei OFF: abhängig vom Silotyp.",
                        gpiMixDuringIntakeOffS: "S-Typen: nur Vormischen beim Auspumpen und Mischen nach der Fütterung für die Mischerdauer.",
                        gpiMixDuringIntakeOffC: "C-Typen: kein Vormischen; Mischen nach der Fütterung für die Mischerdauer.",
                        gpiMixDuringSolidFeedIntake: "Mischen während der Feststofffütterung",
                        gpiMixDuringSolidFeedIntakeInfo: "Bei ON: Mischen während der gesamten Feststofffütterung. Bei OFF: nur vor und nach der Feststofffütterung, jeweils für die Dauer (in Sekunden) aus „{{durationSetting}}“.",
                        gpiMixTimeBeforeAfterSolidIntake: "Mischzeit vor/nach Feststofffütterung",
                    },
                    efficiency: {
                        label: "Effizienz",
                        production: "Energieerzeugung der letzten 30 Tage",
                        consumption: "Energieverbrauch der letzten 30 Tage",
                        nettoProduction: "Nettoenergieerzeugung der letzten 30 Tage",
                        averageEfficiency: "Durchschnittliche Effizienz der letzten 30 Tage",
                        averageTechnicalEfficiency: "Durchschnittliche technische Verfügbarkeit der letzten 30 Tage",
                        bgp: "Güllequalität (BGP-Charge)",
                        top10: "Top 10 Projekte letzte Woche",
                        realised: "Realisierte Effizienz",
                        technical: "Technische Verfügbarkeit",
                        bgpInfo: "Schätzung des Biogaspotenzials [m³/Tonne]. Verluste, die durch Ausfallzeiten, Überproduktion und oder Abfackeln entstehen, werden nicht berücksichtigt",
                        pointPerDay: "%/Tag",
                        trendline: "Trendlinie",
                    },
                    general: {
                        label: "Allgemein",
                        hardwareVersion: "Hardwareversion",
                        otGenContact: "OT-Gen-Kontakt",
                        engine1And2Off: "Motor 1 und 2 aus",
                        engine1On: "Motor 1 an",
                        engine2On: "Motor 2 an",
                        engine1And2On: "Motor 1 und 2 an",
                        notes: "Notizen",
                        h2sSensorFirmwareVersion: "H₂S-Sensor Firmware-Version",
                        idH2s: "S/N H₂S-ID",
                        bioId: "S/N Biotronic-ID",
                        identifier: "Installationskennung",
                        collabContract: "Kooperationsvertrag",
                        own: "Wartungsvertrag",
                        sold: "Verkaufte Installation",
                        productionDate: "Produktionsdatum",
                        commissioningDate: "Inbetriebnahmedatum",
                        controlCardTemp: "Steuerkartentemperatur",
                        batteryVoltage: "Batteriespannung",
                        motorVoltage: "Motorspannung",
                        overtempFlueGasHeatExch: "Übertemperatur Rauchgaswärmetauscher Motor",
                        rebootMainBoard: "Hauptplatine neu starten",
                        rebootNow: "Jetzt neu starten",
                        utcOffset: "UTC-Offset",
                        location: "Standort",
                        network: "Netzwerk",
                        ip: "IP",
                        mask: "Maske",
                        gateway: "Gateway",
                        dns: "DNS",
                        pcb: "Leiterplatte",
                        firmware: "Firmware",
                        mainControlUnit: "Hauptsteuerungseinheit",
                        bioguard: "Bioguard",
                        biotronicEngine1: "Biotronic Motor 1",
                        biotronicEngine2: "Biotronic Motor 2",
                        h2sEngine1: "H₂S Motor 1",
                        h2sEngine2: "H₂S Motor 2",
                        bioIdEngine1: "Bio ID Motor 1",
                        bioIdEngine2: "Bio ID Motor 2",
                        modificationsToMachine: "Änderungen an der Maschine",
                        name: "Name",
                        hostNameFirmware: "Firmware",
                        hostNameDatabase: "Datenbank",
                        normal: "Normal",
                        lowError: "Niedrig (Fehler)",
                        nta8080Title: "NTA 8080 Bericht",
                        nta8080Description: "Laden Sie einen monatlichen NTA 8080-Bericht herunter. Daten werden erst geladen, wenn Sie den Bericht anfordern.",
                        nta8080Month: "Monat",
                        nta8080Download: "Bericht herunterladen",
                        nta8080DownloadPdf: "PDF herunterladen",
                        nta8080DownloadCsv: "CSV herunterladen",
                        nta8080Loading: "Wird vorbereitet…",
                        nta8080SelectMonth: "Zuerst einen Monat auswählen",
                        nta8080InvalidMonth: "Ungültiger Monat ausgewählt",
                        nta8080DownloadError: "Bericht konnte nicht heruntergeladen werden",
                    },
                    feeding: {
                        label: "Fütterung",
                        feedingVolume: "Maximales Frischgüllevolumen pro Zyklus",
                        feedingCyclesPerDay: "Fütterungszyklen pro Tag",
                        feedingCyclesPerDayInfo: "Ein gepumptes Volumen von weniger als 75 % des Sollvolumens löst den Fütterungsfehler „kein Durchfluss beim Einfördern von Frischgülle“ aus. Ein gepumptes Volumen von 75 bis 100 % des Sollvolumens löst die Meldung „Fütterungszyklus teilweise ausgeführt. Leere Grube erkannt, bevor das eingestellte Volumen erreicht wurde“ aus.",
                        feedingBalance: "Fütterungssaldo",
                        autoFeedingActive: "Automatische Fütterung",
                        blockHighElectricalConsumption: "Wärmepumpen-Fermenterheizung während des Mischfensters blockieren",
                        blockHighElectricalConsumptionInfo: "Bei ON: Wärmepumpen-Fermenterheizung wird während des Mischfensters blockiert. Bei OFF: keine Blockierung.",
                        minimizeElectricalConsumptionFrom: "Stromverbrauch minimieren von",
                        minimizeElectricalConsumptionTo: "bis",
                        autoFeedingStartHour: "Automatische Fütterung",
                        exitPumpRunning: "Abpumpen",
                        feedingCycle: "Fütterungszyklus",
                        onlyInput: "Nur Einpumpen",
                        onlyOutput: "Nur Auspumpen",
                        startFeeding: "Anfang",
                        stopFeeding: "Fütterung stoppen",
                        customAmount: "Benutzerdefinierte Menge",
                        customAmountHint: "Vorausgefüllt mit dem eingestellten Fütterungsvolumen. Nur ändern für eine benutzerdefinierte Menge. Max. {{maxRiseCm}} cm Niveauanstieg ({{maxLiters}} l für diesen Silo).",
                        customAmountInvalid: "Geben Sie einen Wert zwischen {{min}} und {{max}} l ein",
                        customAmountExceedsLevelRise: "Die eingegebene Menge ({{amount}} l) würde den Tankfüllstand um mehr als {{maxRiseCm}} cm anheben. Maximum für diesen Silo: {{maxLiters}} l.",
                        customAmountUnknownSilo: "Maximale Menge kann nicht berechnet werden: unbekannter Silotyp.",
                        customAmountExceedsWarning: "Die eingegebene Menge ({{amount}} l) ist höher als das eingestellte Fütterungsvolumen ({{feedingVolume}} l). Möchten Sie wirklich fortfahren?",
                        pumpOutFlowRate: "Auspump-Einstellungen",
                        pumpOutFlowRateInfo: "Der theoretische Auspumpdurchfluss wird zur Berechnung der Dauer verwendet, um Digestat aus dem Fermenter zu pumpen. Bei zu niedriger Einstellung wird zu viel Digestat ausgepumpt, bei zu hoher Einstellung zu wenig. Typische Werte sind:",
                        pumpOutFlowRateBellowsPump: "Balgpumpe: ± 3 m³/h",
                        pumpOutFlowRateCentrifugalPump: "Kreiselpumpe: ± 50 m³/h",
                        pumpOutFlowRateGravityOutlet: "Schwerkraftablauf: ± 50 m³/h",
                        kiloPerPulse: "Impuls des Durchflussmessers",
                        intakeTimeout: "Fütterung: Zeitüberschreitung Fütterung",
                        averageDailyFeeding: "Durchschn. Fütterung pro Tag im letzten Monat",
                        retentionTime: "Aufbewahrungszeit",
                        statusValvePumpIn: "Ventil Reaktoreingang - 2",
                        statusValvePumpOut: "Ventil Reaktorausgang - 3",
                        statusValveRetourReactor: "Ventil Reaktorrücklauf - 4",
                        valveCurrentActuator: "Ventilstrom",
                        actuatorSetting: "Aktuatoreinstellung",
                        actuatorSettingV1: "Linak",
                        actuatorSettingV2: "Hiwin / Mikrosystem",
                        lastFeeding: "Tatsächlich - zuletzt",
                        startHourLastFeeding: "Beginn der letzten Fütterung",
                        feedingStatus: "Fütterungszustand",
                        feedingError: "Reaktor Fehler",
                        intakePumpTime: "Fütterungsdauer",
                        intakePumpAmount: "Einnahmemenge",
                        exitPumpTime: "Auspumpdauer",
                        exitPumpAmount: "Auspumpmenge",
                        feedingHistory: "Fütterungsverlauf",
                        startedOn: "Begann am",
                        temperature: "Temperatur",
                        reactorLevel: "Reaktorfüllstand3",
                        balance: "Balance",
                        acknowledge: "Fehler quittieren",
                        intakeSpeed: "Fütterungsgeschwindigkeit",
                        balanceWarning: "Warnung, dies wird keinen normalen Fütterungszyklus starten sondern stattdessen den verbleibenden Restwert in den Reaktor pumpen",
                        automaticFeedingSettings: "Automatische Fütterungseinstellungen",
                        manualFeeding: "Manuelle Fütterung",
                        pumpSettings: "Pumpeneinstellungen",
                        lastFeedingTime: "Letzte Fütterungszeit",
                        status: {
                            "0": "Leerlauf",
                            "1": "Füllstandsmessung",
                            "2": "Auspumpen",
                            "3": "Einpumpen",
                            "5": "Abtauen",
                            "6": "Gasabgabe",
                            "7": "Manuelles Auspumpen",
                            "10": "Starten",
                            "2,001": "Auspumpen: Vormischung",
                            "2,002": "Auspumpen",
                            "2,003": "Auspumpen: Auslassventil öffnen",
                            "2,004": "Auspumpen: Auslassventil öffnen",
                            "2,005": "Auspumpen: Starten der Gärrestpumpe",
                            "2,006": "Auspumpen",
                            "2,007": "Auspumpen: Pumpen von Gülle",
                            "2,008": "Auspumpen: Auspumpen stoppen",
                            "2,009": "Auspumpen: Auspumpen stoppen",
                            "2,010": "Auspumpen: Auslassventil schließen",
                            "2,011": "Auspumpen: Auslassventil schließen",
                            "2,012": "Auspumpen: Auspumpen stoppen",
                            "3,001": "Einpumpen: Vorbereitung",
                            "3,002": "Einpumpen: Vorbereitung",
                            "3,003": "Einpumpen: Vorbereitung",
                            "3,004": "Einpumpen: Pumpen von Gülle",
                            "3,005": "Einpumpen: Pumpen von Gülle",
                            "3,006": "Einpumpen: Abschließen",
                            "3,007": "Einpumpen: Abschließen",
                            "3,008": "Einpumpen: Pumpe stoppen",
                            "3,009": "Einpumpen: Pumpe stoppen",
                            "3,010": "Einpumpen: Pumpe stoppen",
                            "3,011": "Einpumpen: Pumpe stoppen",
                            "3,012": "Einpumpen: Abschließen",
                            "5,001": "Abtauen: Einpumpen testen",
                            "5,002": "Abtauen: Einpumpen testen",
                            "5,003": "Abtauen: Einpumpen testen",
                            "5,004": "Abtauen: Einpumpen testen",
                            "5,005": "Abtauen: Einpumpen stoppen",
                            "5,006": "Abtauen: Auslassventil öffnen",
                            "5,007": "Abtauen: Auslassventil öffnen",
                            "5,008": "Abtauen: Auspumpen testen",
                            "5,009": "Abtauen: Auspumpen testen",
                            "5,010": "Abtauen: Auspumpen testen",
                            "5,011": "Abtauen: Auspumpen testen",
                            "5,012": "Abtauen: Auspumpen testen",
                            "5,013": "Abtauen: Auslassventil schließen",
                            "5,014": "Abtauen: Auslassventil schließen",
                            "5,015": "Abtauen: Abschließen",
                            "6,001": "Gasabgabe: Auslassventil öffnen",
                            "6,002": "Gasabgabe: Auslassventil öffnen",
                            "6,003": "Gasabgabe: Auslassventil schließen",
                            "6,004": "Gasabgabe: Auslassventil schließen",
                            "6,005": "Gasabgabe",
                            "7,001": "Manuelles Auspumpen: Auslassventil öffnen",
                            "7,002": "Manuelles Auspumpen: Auslassventil öffnen",
                            "7,003": "Manuelles Auspumpen: Gülle pumpen",
                            "7,004": "Manuelles Auspumpen: Pumpe stoppen",
                            "7,005": "Manuelles Auspumpen: Auslassventil schließen",
                            "7,006": "Manuelles Auspumpen: Auslassventil schließen",
                            "7,007": "Manuelles Auspumpen: Abschließen",
                            "7,008": "Manuelles Auspumpen: Abschließen",
                            "10,001": "Starten: Ventil 2 schließen",
                            "10,002": "Starten: Ventil 2 schließen",
                            "10,003": "Starten: Auslassventil schließen",
                            "10,004": "Starten: Auslassventil schließen",
                            "10,005": "Starten: Ventil 4 schließen",
                            "10,006": "Starten: Ventil 4 schließen",
                            "10,007": "Starten: Elektrische Verbindung prüfen",
                            "10,008": "Starten: Elektrische Verbindung prüfen",
                            "10,009": "Starten"
                        }
                    },
                    users: {
                        label: "Benutzer",
                        customers: "Verknüpfung Kunde",
                        technicians: "Link zum Techniker",
                        resellers: "Link zum Wiederverkäufer",
                    },
                    recommendations: {
                        label: "Empfehlungen",
                    },
                    firmware: {
                        invalidFile: "Bitte wählen Sie eine .hex-Datei",
                        uploadStarted: "Firmware-Upload gestartet",
                        uploadFailed: "Firmware-Upload fehlgeschlagen",
                        uploading: "Wird hochgeladen…",
                        uploadProgress: "Upload-Fortschritt: {{progress}}%",
                        currentVersion: "Aktuelle Version",
                    },
                    documents: {
                        label: "Dokumente",
                        specificDocuments: "Spezifische Dokumente",
                        specificImages: "Spezifische Bilder",
                        generalVideos: "Allgemeine Videos",
                        general: "Allgemeine Dokumentation",
                        generalDocuments: "Allgemeine Dokumente",
                        checklists: "Checklisten",
                        construction: "Bau-Checkliste",
                        production: "Produktions-Checkliste",
                        upload: "Hochladen",
                        uploadSuccess: "Sie haben {{name}} erfolgreich hochgeladen",
                        deleteSuccess: "Sie haben die Datei {{name}} erfolgreich gelöscht",
                        noFilesAvailable: "Keine Dateien in der Kategorie {{category}} verfügbar.",
                        fileSizeExceeds: "Dateigröße überschreitet das Limit von {{size}}Mb",
                        invalidImageType: "Nur JPG- und PNG-Bilder sind erlaubt",
                        chooseFileFirst: "Bitte wählen Sie zuerst eine Datei aus.",
                        default: "Standard",
                        permits: "Genehmigungen",
                        plans: "Pläne",
                        planning: "Planung",
                        certification: "Zertifizierung",
                        regulations: "Vorschriften",
                        instructions: "Anleitungen",
                        templates: "Vorlagen"
                    },
                    warnings: {
                        "W001": "Energieverbrauch über dem Schwellenwert in den letzten 24 Stunden (72 kWh für 10-44-kW-Installation, 250 kWh für 60-74-kW-Installation)",
                        "W002": "Die Reaktortemperatur ist dramatisch gesunken",
                        "W003": "Service innerhalb von 48 Stunden",
                        "W004": "Kohlefilter Motor 1 muss ersetzt werden",
                        "W005": "Kohlefilter Motor 2 muss ersetzt werden",
                        "W006": "Gaspuffermessung eingefroren",
                        "W007": "Gaspuffermessung defekt",
                        "W008": "Gestern nicht gefüttert",
                        "W009": "Die Geschwindigkeit der letzten Fütterung lag 50% über de Durchschnitt des letzten Monats",
                        "W010": "H₂S-Wert zu hoch (>1500 ppm)",
                        "W011": "Belüftung ist 60",
                        "W012": "Die Belüftung ist kleiner oder gleich 3",
                        "W013": "Effizienz lag gestern bei 0% und Autofeed ist eingeschaltet",
                        "W014": "H₂S-Reaktormessung – Differenz übersteigt 400 ppm",
                        "W015": "Luftzufuhr sehr hoch - Gasqualität beachten",
                        "W016": "H₂S-Messung seit 24 h fehlgeschlagen",
                        "W017": "Mischeröl zu niedrig",
                        "W018": "Motoröl niedrig",
                        "W020": "Wasserdruck niedrig",
                        "W104": "H₂S-Wert zu hoch (>200) oder Belüftung = 60 oder 3",
                        "W105": "Belastung des Kohlefilters zu hoch",
                        "W114": "Effizienz war gestern nicht 0 und Autofeed ist aus",
                    },
                    advanced: {
                        language: "LCD-Bildschirmsprache",
                        lambdaUpperLimit: "Lambda-Obergrenze (narrow range)",
                        lambdaLowerLimit: "Lambda-Untergrenze (narrow range)",
                        coolingValve: "Kühlwasserventil",
                        maxPower: "Max. Leistung (Datenbank) Motor 1",
                        maxPower2: "Max. Leistung (Datenbank) Motor 2",
                        bioId: "Bio ID Motor 1",
                        bioId2: "Bio ID Motor 2",
                        currentSsrConfiguration: "Aktuelle SSR-Konfiguration",
                        SSRString: "SSR-Zeichenfolge",
                    },
                    sms: {
                        duringDay: "Tagsüber Textnachrichten empfangen",
                        duringNight: "Nachts SMS empfangen",
                        sendSms: "Kunden per SMS benachrichtigen",
                        sendTestSms: "Testnachricht senden",
                        testSms: "Test-SMS",
                        testSmsToAllSenders: "Testnachricht an alle Absender senden (Fehlerbehebung)",
                        recipients: "Empfänger",
                        settings: "SMS-Einstellungen",
                        enterMessage: "Geben Sie hier Ihre Nachricht ein...",
                        smsSentSuccessfully: "SMS-Nachrichten erfolgreich gesendet",
                        pleaseSelectAtLeastOneRecipient: "Bitte wählen Sie mindestens einen Empfänger aus",
                        pleaseEnterAMessage: "Bitte geben Sie eine Nachricht ein",
                        failedToSendSmsMessages: "SMS-Nachrichten konnten nicht gesendet werden",
                        smsSettingsUpdatedSuccessfully: "SMS-Einstellungen erfolgreich aktualisiert",
                        message: "Nachricht",
                        testNotificationToAllSenders: "Testbenachrichtigung an alle Absender senden (Fehlerbehebung)",
                        sendTestNotification: "Testbenachrichtigung senden",
                        testNotificationsSentSuccessfully: "Testbenachrichtigungen erfolgreich gesendet",
                        failedToSendTestNotifications: "Testbenachrichtigungen konnten nicht gesendet werden",
                    },
                    temperatures: {
                        label: "Temperaturen",
                        oilCoolerTemp: "Ölkühlertemperatur",
                        biogasTempAfterReheat: "T5 Temperature After Reheating",
                        blowerOutTemp: "T2 Temperature Inlet Compressor",
                        compressorOutTemp: "T3 Temperature Outlet Compressor",
                        biogasTempAfterCool: "T4 Temperature After Cooling",
                    },
                    pressures: {
                        label: "Drücke",
                        biogasPressureBeforeMembrane: "P4 Pressure Inlet Membranes",
                        stage3Pressure: "P5 Pressure Membrane Stage 3",
                        pressureAfterMembrane: "P6 Pressure Outlet Membranes",
                        blowerPressure: "P1 Pressure Outlet Blower",
                        blowerPressureSetpoint: "Pressure Outlet Blower Setpoint",
                        compressorOutPressure: "P3 Pressure Outlet Compressor",
                    },
                    valves: {
                        label: "Ventile",
                        valveCompressor: "Ventil Kompressor",
                        valveMembrane: "Ventil Membran",
                        valveGrid: "Ventil Netz",
                        valveCo2: "Ventil CO2",
                    },
                    system: {
                        label: "System",
                        installationState: "Installationsstatus",
                        geuAvailable: "GEU verfügbar",
                        geuAlarm: "GEU-Alarm",
                        geuDelivering: "GEU liefert",
                        gasTotalGeu: "Gas gesamt GEU",
                        gasTotalInternGeu: "Gas gesamt intern GEU",
                        biogasTotalizer: "Biogaszähler",
                        biomethaneDewpoint: "Biomethan-Taupunkt",
                        compressorSpeed: "Kompressordrehzahl",
                    },
                    filters: {
                        label: "Filter",
                        inletFilterPressuredrop: "Druckverlust Einlassfilter",
                        filterTrainPressuredrop: "Druckverlust Filtereinheit",
                        oilFilterPressuredrop: "Druckverlust Ölfilter",
                    },
                    checks: {
                        yourImage: "Ihr Bild:",
                        imageCommentsLabel: "Kommentare zu diesem Bild (optional):",
                        imageCommentsPlaceholder: "Fügen Sie Kommentare zu diesem Bild hinzu",
                        exampleImage: "Beispielbild:",
                        textAnswerPlaceholder: "Geben Sie hier Ihre Antwort ein",
                        next: "Weiter",
                        completedMessage: "Sie haben alle Bau-Checklisten abgeschlossen, bitte senden Sie die Checkliste.",
                        skip: "Überspringen",
                        downloadPdf: "PDF herunterladen",
                        answerLabel: "Antwort:",
                        commentsLabel: "Kommentare:",
                        selectedOptionsLabel: "Ausgewählte Optionen:",
                        addEntry: "Eintrag hinzufügen",
                        newEntryForCheck: "Neuer Eintrag für diese Prüfung:",
                        commentsOptionalPlaceholder: "Kommentare (optional)",
                        yourAnswerPlaceholder: "Ihre Antwort",
                        saveEntry: "Eintrag speichern",
                        cancel: "Abbrechen",
                        entryAdded: "Eintrag hinzugefügt.",
                        entryAddFailedPrefix: "Fehler beim Hinzufügen des Eintrags: ",
                        validateBeforeSubmitting: "Bitte geben Sie eine Antwort an, bevor Sie senden.",
                        validateBeforeNextCheck: "Bitte geben Sie eine Antwort an, bevor Sie zur nächsten Prüfung weitergehen.",
                        uploadSuccess: "Daten erfolgreich gesendet",
                        uploadFailedPrefix: "Fehler beim Senden der Daten: ",
                    }
                }
            },
            it: {
                translation: {
                    dashboard: {
                        nameIdentifier: "Nome o identificatore",
                        efficiencyAll: "Efficienza di tutte le macchine",
                        onlyErrors: "Solo errori",
                        toggleDisconnected: "Attiva/disattiva macchine scollegate",
                        productionCombined: "Produzione combinata (Wh)",
                        realisedTechnicalEfficiency: "Efficienza realizzata / Efficienza tecnica (%)",
                        efficiencyCombined: "Efficienza realizzata (%)",
                        technicalEfficiencyCombined: "Efficienza tecnica (%)",
                        bgp: "Bgp (m³/ton)",
                        consumption: "Consumo (Wh)",
                        manureLifeTime: "Durata del letame (giorni)",
                        feeding: "Alimentazione (kg)"
                    },
                    common: {
                        on: "Acceso",
                        off: "Spento",
                        add: "Aggiungi",
                        save: "Salva",
                        monday: "Lunedì",
                        tuesday: "Martedì",
                        wednesday: "Mercoledì",
                        thursday: "Giovedì",
                        friday: "Venerdì",
                        saturday: "Sabato",
                        sunday: "Domenica",
                        from: "Da",
                        to: "A",
                        hours: "ore",
                        reset: "Reset",
                        confirmation: "Conferma",
                        cancel: "Annulla",
                        yesIAmSure: "Sì, sono sicuro",
                        set: "Regola",
                        auto: "Auto",
                        manual: "Manual",
                        minutes: "minuti",
                        seconds: "secondi",
                        turnOn: "Accendere",
                        turnOff: "Spegnere",
                        graphLoading: "Caricamento dei grafici...",
                        noData: "Nessun dato disponibile...",
                        hoursPerYear: "ore / anno",
                        datetime: "Data e ora",
                        warning: "Avvertimento",
                        error: "Errore",
                        type: "Tipo",
                        startdate: "Data di inizio",
                        enddate: "Data di fine",
                        all: "Tutti",
                        engine1: "Motore 1",
                        engine2: "Motore 2",
                        ongoing: "In corso",
                        both: "Entrambi",
                        days: "Giorni",
                        today: "Oggi",
                        sendAnswers: "Invia risposte",
                        employee: "Dipendente",
                        customer: "Cliente",
                        sales: "Vendite",
                        technician: "Tecnico",
                        admin: "Amministratore",
                        noDateKnown: "Data sconosciuta",
                        command: "Comando",
                        user: "Utente",
                        fillInSurvey: "Per favore, compila il sondaggio",
                        tons: "tonnellata",
                        count: "Conteggio",
                        disabled: "Disabilitato",
                        addField: "Aggiungi campo",
                        deleteField: "Elimina campo",
                        releases: "Rilasci",
                        open: "Aprire",
                        close: "Chiudere",
                        opening: "Apertura",
                        closing: "Chiusura",
                        zoomCancel: "Zoom annullato, rimani all'interno del grafico per zoomare",
                        stuck: "Bloccato"
                    },
                    errorPage: {
                        title: "Qualcosa è andato storto.",
                        contact: "Segnala questo problema a it@biolectric.com e indica quale telefono o browser stai utilizzando.",
                        reload: "Ricarica"
                    },
                    popups: {
                        engineIdle: "Il motore non è al minimo, spegnere prima il motore",
                        valueBetween: "Il valore deve essere compreso tra {{min}} e {{max}}",
                        valueBetweenCustom: "Il valore deve essere compreso tra {{min}} e {{max}}",
                        powerTooLow: "La potenza non può essere impostata al di sotto di {{watts}}W",
                        powerTooHigh: "La potenza non può essere impostata al di sopra di {{maxPower}}",
                        maxCoolingTemp: "Non può essere superiore a {{max}}°C",
                        minValue: "Non può essere inferiore a {{min}}",
                        maxAirInjectionTime: "Non può essere superiore a {{max}} secondi",
                        minGasBuffer: "Buffer gas minimo fuori intervallo. Il valore minimo per il tuo impianto è {{min}}",
                        maxGasBuffer: "Buffer gas massimo fuori intervallo. Il valore massimo per il tuo impianto è {{max}}",
                        reactorTemp: "Temperatura del reattore fuori intervallo. Deve essere compresa tra {{min}} e {{max}}",
                        reactorLevel: "Livello del reattore non valido. Il valore massimo per il tuo impianto è {{limit}}",
                        reactorLevelRange: "Il valore del livello del reattore deve essere compreso tra {{min}} e {{max}}",
                        commandFailed: "Invio comando fallito",
                        commandSent: "Comando inviato",
                        commandSuccess: "Hai aggiornato con successo {{command}} da {{previousValue}} a {{value}}",
                        commandMix1Hour: "Il miscelatore funzionerà per 1 ora",
                    },
                    menu: {
                        dashboard: 'Pannello di controllo',
                        machines: 'Macchinari',
                        questionnaires: 'Questionari',
                        banners: "Banner",
                        errors: "Fehler und warnungen",
                        pcb: "Circuiti stampati",
                        tasks: "I miei compiti",
                        releases: "Note di rilascio",
                        resellers: "Rivenditori",
                        users: "Utenti",
                        recommendations: "Raccomandazioni",
                        suggestions: "Messaggi di raccomandazione",
                        faultTrees: "Alberi errori",
                        assistant: "Assistente",
                        language: "Lingua",
                        reconnection: "Questa macchina è attualmente offline. Prova a ottenere una nuova connessione con il pulsante sopra.",
                        profile: "Profilo",
                        logout: "Disconnettersi",
                        firmware: "Firmware",
                        sms: "SMS",
                        advanced: "Avanzato",
                        errorsSingle: "Errori",
                        warnings: "Avvisi"
                    },
                    statistics: {
                        label: "Statistiche",
                        foamBeaterThermalStatus: "Termica battitore di schiuma",
                        exitPumpThermalStatus: "Termica pompa di scarico",
                        thermalStatusOk: "Termica non attiva, l'utenza può funzionare normalmente",
                        thermalStatusFault: "Termica attiva, l'utenza è in errore",
                        group1: "Gruppo 1",
                        group2: "Gruppo 2",
                        addProperty: "Aggiungi proprietà",
                        removeProperty: "Rimuovi Proprietà",
                        startTutorial: "Inizia il tutorial",
                        exitTutorial: "Esci dal tutorial",

                        welcomeStep: {
                            title: "Benvenuti nella pagina delle statistiche",
                            content: "Qui è possibile confrontare facilmente diversi valori e tendenze."
                        },
                        propertyStep: {
                            title: "Selezione della proprietà",
                            content: "Per iniziare, selezionate semplicemente una proprietà che vi interessa dalla casella di selezione."
                        },
                        addPropertyStep: {
                            title: "Aggiunta e rimozione di proprietà",
                            content: "Provate ad aggiungere o rimuovere una proprietà, è possibile aggiungere fino a 4 proprietà per gruppo."
                        },
                        groupStep: {
                            title: "Attivazione del gruppo 2",
                            content: "Fare clic sul pulsante 'Aggiungi proprietà' per selezionare una proprietà per il Gruppo 2. Le proprietà in questo gruppo verranno mostrate sul lato destro del grafico."
                        },
                        dateRangeStep: {
                            title: "Selezione di un intervallo di date",
                            content: "Usate questo pulsante per scegliere un intervallo di date."
                        },
                        zoomInStep: {
                            title: "Ingrandimento",
                            content: "Trascinate il mouse sul grafico per selezionare un'area da ingrandire."
                        },
                        zoomOutStep: {
                            title: "Riduzione",
                            content: "Ripristinate l'intervallo di date precedentemente selezionato utilizzando il pulsante 'Riduzione'."
                        },
                        domainStep: {
                            title: "Regolazione dei domini",
                            content: "È possibile personalizzare il dominio massimo e minimo per gruppo utilizzando questi pulsanti."
                        },
                        csvStep: {
                            title: "Scarica dati in formato CSV",
                            content: "Scarica i dati attualmente visualizzati nel grafico in formato CSV."
                        },
                        imageStep: {
                            title: "Scarica immagine",
                            content: "Scarica il grafico attualmente visualizzato come immagine."
                        },
                        configurationStep: {
                            title: "Configurazione della preimpostazione",
                            content: "Puoi salvare la tua configurazione attuale come preimpostazione. Puoi anche aggiornare o eliminare le preimpostazioni esistenti."
                        },
                        controlCardTemp: "Temperatura della scheda di controllo",
                        lowTensionError: "Errore di bassa tensione",
                        overTempFlueGasHeatExch: "Sovratermostato scambiatore di calore dei gas di scarico",
                        feedingCycleLevel: "Livello del ciclo di alimentazione",
                        batteryVoltage: "Tensione della batteria",
                        waterPressure: "Pressione dell'acqua",
                        shortInterval: "Intervalli di 10 minuti",
                        dailyInterval: "Intervalli giornalieri",
                        configurationUpdated: "La configurazione corrente è stata salvata in questa preimpostazione",
                        presets: "Preimpostazioni",
                        savePreset: "Salva come preimpostazione",
                        applyPreset: "Applica preimpostazione",
                        updatePreset: "Aggiorna preimpostazione",
                        delete: "Elimina",
                        noPresets: "Non hai ancora alcuna preimpostazione",
                        givePresetName: "Assegna un nome alla tua preimpostazione",

                    },
                    smart: {
                        label: "Smart",
                        heightOffset: "Offset altezza",
                        active: "Attivo",
                        passive: "Passivo",
                        preActive: "Pre-attivo",
                        prePassive: "Pre-passivo",
                        postActive: "Post-attivo",
                        postPassive: "Post-passivo",
                        activeDesc: "Durante un periodo attivo, la produzione energetica pianificata viene massimizzata. Prima di ogni periodo attivo, viene automaticamente fornito uno slot temporale 'pre-attivo' in cui viene accumulato il gas nel buffer. La durata massima di un periodo attivo è determinata dal volume del buffer del gas, dal numero e tipo di CHP installati e dal profilo di produzione del biogas dell'installazione. Quando viene raggiunto il livello minimo di riempimento del buffer del gas, la produzione di energia si interromperà (periodo post-attivo).",
                        passiveDesc: "Durante un periodo passivo, l'energia viene prodotta solo se c'è un surplus di gas. Prima di ogni periodo passivo, viene automaticamente fornito uno slot temporale durante il quale il buffer del gas viene ridotto. La durata massima di un periodo passivo è determinata dal volume del buffer del gas e dal profilo di produzione del biogas dell'installazione. Quando viene raggiunto il livello massimo di riempimento del buffer del gas, inizia la produzione di energia (periodo post-passivo).",
                        permanence: "Stimolare la produzione costante funzionando dinamicamente su un motore con un buffer di gas non massimo",
                        permanency: "Permanenza",
                        activateStep: {
                            title: "Attivazione di SMART",
                            content: "Attiva SMART per controllare il profilo di produzione dell'installazione"
                        },
                        timeslotStep: {
                            title: "Aggiungi slot temporale",
                            content: "Aggiungi uno slot temporale attivo o passivo"
                        },
                        fromToStep: {
                            title: "Da / A",
                            content: "Imposta sia l'inizio che la fine del giorno e l'ora"
                        },
                        activePassiveStep: {
                            title: "Attivo o Passivo",
                            content: "Seleziona se vuoi impostare uno slot temporale attivo o passivo"
                        },
                        saveStep: {
                            title: "Salva slot temporali",
                            content: "Salva le tue impostazioni modificate"
                        },
                        removeStep: {
                            title: "Rimuovi slot temporali",
                            content: "Rimuovi qui il tuo slot temporale"
                        },
                        visualStep: {
                            title: "Rappresentazione visuale",
                            content: "Questo grafico confronta le impostazioni SMART con il profilo di produzione della settimana scorsa"
                        },
                        daySwitchStep: {
                            title: "Rappresentazione visuale",
                            content: "Passa facilmente al giorno successivo o precedente"
                        },
                    },
                    gas: {
                        label: "Gas",
                        minGasBufferLevel: "Livello gas min",
                        maxGasBufferLevel: "Livello gas max",
                        gasBufferLevel: "Livello gas attuale",
                        defaultMinGasBufferLevel: "Predefinito livello gas min",
                        defaultMaxGasBufferLevel: "Predefinito livello gas max",
                        airInjectionTime: "Aerazione",
                        maxAirInjectionTime: "Aerazione massima",
                        torch: "Flare",
                        torchType: "Flare type",
                        torchStatus: "Flare status",
                        torchError: "Flare errore",
                        theoreticalTorchFlow: "Portata teorica della torcia",
                        torchRunningTime: "Tempo torcia",
                        torchFlaredVolume: "Volume in torcia",
                        h2s: "H₂S",
                        h2sLevelReactor: "H₂S reattore",
                        h2sLevelMotor: "H₂S Motore",
                        filterLoad: "Saturazione filtro",
                        sample: "Campiona",
                        latestH2sReadings: "Ultime letture H₂S",
                        carbonFilterSize: "Dimensioni del filtro al carbone",
                        h2sMeasurements: "Misurazioni H₂S",
                        measurements: "Misurazioni",
                        changeTo: "Cambia in",
                        none: "Nessuno",
                        container: "Contenitore",
                        extern: "Esterno",
                        foamBeaterInstalled: "Battitore di schiuma installato",
                        antiFoamInjectionsInstalled: "Iniezioni antischiuma installate",
                        containerCombinedOperation: "Contenitore (operazione combinata)",
                        externCombinedOperation: "Esterno (operazione combinata)",
                        gasTemp: "T1 Temperature After Gascooler",
                        ch4BiogasSupply: "Alimentazione biogas CH4",
                        co2BiogasSupply: "Alimentazione biogas CO2",
                        o2BiogasSupply: "Alimentazione biogas O2",
                        h2sAfterFilter: "H2S dopo filtro",
                        biomethaneFlowNorm: "Flusso normalizzato di biometano",
                        ch4Biomethane: "CH4 biometano",
                        co2Biomethane: "CO2 biometano",
                        o2Biomethane: "O2 biometano",
                        h2sBiomethane: "H2S biometano",
                        bufferRelease: "Rilascio buffer",
                        wobbe: "Indice di Wobbe",
                        wobbeAvg: "Indice di Wobbe medio",
                        wobbePidSetpoint: "Setpoint PID indice di Wobbe",
                        wobbeBiomethanePronova: "Indice di Wobbe biometano Pronova",
                    },
                    engine: {
                        label: "motore",
                        startEngine: "Start motore",
                        stopEngine: "Arresta motore",
                        power: "Potenza",
                        desiredPower: "Potenza impostata",
                        maxPower: "Potenza massima",
                        rpm: "Giri/min",
                        lambda: "Lambda",
                        throttleValve: "Posizione del servo",
                        engineType: "Tipo di motore",
                        engineStatus: "Stato motore",
                        engineError: "Errore del motore",
                        producedEnergy: "Produzione di energia pulita",
                        operatingHours: "Ore motore in marcia",
                        totalOperatingHours: "Ore totali funzionamento motore",
                        gasUsage: "Consumo di gas",
                        throttlePosition: "Posizione del throttle",
                        noErrors: "Tutti i sistemi operativi.",
                        production: "Produzione",
                        servoAuto: "Il servo è impostato automaticamente",
                        servoControl: "Servocomando",
                        temperature: "Temperatura del motore",
                        restart: "Riavvio automatico quando il gas è disponibile.",
                        confirmStop: "Sei sicuro di voler arrestare il motore {{number}}?",
                        confirmStopRestart: "Sei sicuro di voler arrestare il motore {{number}}? Si riavvierà automaticamente quando il gas è disponibile.",
                        idle: "Inattivo",
                        running: "In esecuzione",
                        waiting: "In attesa di avvio",
                        booting: "Avvio",
                        shuttingDown: "Spegnimento",
                        advanced: "Avanzato",
                        numberOfEngines: "Numero di motori",
                        predeterminedRunHours: "Ore di funzionamento predeterminate",
                        easyStart1: "Easy start motore 1",
                        easyStart2: "Easy start motore 2",
                        setError1: "Errore di impostazione motore 1",
                        setError2: "Errore di impostazione motore 2",
                        fuel: "Carburante",
                        airIntakeOpen: "Presa d'aria aperta",
                        airIntakeClosed: "Presa d'aria chiusa",
                        vfd: "VFD",
                    },
                    service: {
                        label: "Manutenzione",
                        lastMaintenance: "Ore di funzionamento fino al prossimo cambio dell'olio",
                        currentlyInstalled: "Ore di funzionamento attualmente installate",
                        total: "Totale ore di funzionamento",
                        mixer: "Miscelatore",
                        foam_beater: "Frustino per schiuma",
                        intake_pump: "Pompa di aspirazione",
                        digestate_pump: "Pompa di digestato",
                        newMixer: "Nuovo miscelatore installato",
                        newEngine: "Nuovo motore installato",
                        newFoamBeater: "Nuovo frustino per schiuma installato",
                        newIntakePump: "Nuova pompa di aspirazione installata",
                        newDigestatePump: "Nuova pompa di digestato installata",
                        confirmationMessage: "Sei sicuro di voler ripristinare il {{type}}",
                        maintenanceMessage: "Le ore di manutenzione sono state ripristinate per {{type}}",
                        newEquipmentMessage: "Nuova attrezzatura installata:",
                        prints: "Prints",
                        firstOnline: "Primo online",
                        lastOnline: "Ultimo online",
                        serial: "Numero seriale",
                        type: "Tipo",
                        engine: "Motore",
                        engine1: "Motore 1",
                        engine2: "Motore 2",
                        engine_new1: "Motore 1",
                        engine_new2: "Motore 2",
                        h2s1: "Motore H₂S 1",
                        h2s2: "Motore H₂S 2",
                        resetTo: "Resetta a x ore (predefinito 0)",
                        timeFilterReplace: "Tempo trascorso dalla sostituzione del filtro",
                        daysSinceOil: "Giorni dal cambio dell'olio",
                        newGenerator: "Installazione di un nuovo generatore",
                        generator: "Generatore",
                        generator1: "Generatore 1",
                        generator2: "Generatore 2",
                        daysSinceOilChange: "Giorni dall'ultimo cambio dell'olio",
                        videoMessage: "Video sul cambio dell'olio => Pagina dei documenti, sotto Video generali.",
                        videoRoom: "Un tecnico di servizio ha aperto una stanza video per questa macchina. Clicca qui per partecipare.",
                        videoButton: "Avvia una stanza video per questa macchina",
                        videoButtonSub: "Gli utenti con accesso possono unirsi alla chiamata dalla loro pagina di servizio.",
                        videoClose: "Chiudi la stanza video",
                        serialNumber: "Numero di serie",
                        defaultEngineReset: "Ripristino motore predefinito",
                        newInstalled: "Nuovo {{type}} installato",
                        replace: "Sostituire",
                        aircover: "Copertura dell'aria",
                        gascover: "Copertura del gas",
                        liner: "Rivestimento",
                        flow_meter: "Misuratore di portata",
                        energy_meter1: "Misuratore di energia 1",
                        energy_meter2: "Misuratore di energia 2",
                        energy_meter_own: "Contatore di energia autoconsumo",
                        h2sPastille: "Tempo fino alla sostituzione del sensore H2S",
                        pastille1: "Sensore H₂S 1",
                        pastille2: "Sensore H₂S 2",
                        engineLabel: "Prossima manutenzione motore tra “XX” ore",
                        engine1Conf: "Reimpostare l’intervallo di manutenzione del motore 1 solo dopo che è stata effettuata la manutenzione",
                        engine2Conf: "Reimpostare l’intervallo di manutenzione del motore 2 solo dopo che è stata effettuata la manutenzione",
                        h2s1Conf: "Reimpostare H2S Motore 1 solo quando il carbone attivo nel filtro è stato sostituito",
                        h2s2Conf: "Reimpostare H2S Motore 2 solo quando il carbone attivo nel filtro è stato sostituito",
                        filterResetOffline: "La macchina è offline. Il reset del filtro non è stato salvato. Riconnettiti e riprova.",
                        filterResetFailed: "Reset del filtro non riuscito. Il reset del filtro non è stato salvato.",
                        consumables: {
                            title: "Consumabili",
                            belowMin: "Sotto la scorta minima",
                            noneBelow: "Nessun articolo sotto la scorta minima",
                            notCounted: "Non ancora contato",
                            article: "Numero articolo",
                            description: "Descrizione",
                            onSite: "Presente",
                            minimum: "Minimo",
                            engineMaintenance: "Manutenzione motore",
                            pendingStock: "{{confirmed}} confermato + {{pending}} in attesa di validazione",
                            send: "Invia",
                            shipmentSaved: "Spedizione salvata. Resta in attesa finché il cliente non conferma.",
                            shipmentFailed: "Impossibile salvare la spedizione",
                            confirm: "Conferma ricezione",
                            confirmSaved: "Scorta confermata",
                            confirmFailed: "Impossibile confermare la scorta",
                            confirmHint: "Conferma la consegna per aggiungerla alla scorta in loco.",
                            guideTitle: "Come funziona",
                            guideIntro: "Olio, filtri olio e candele restano su ogni impianto. La pagina service dell'impianto e questa pagina ordini usano la stessa scorta.",
                            guide1Role: "Tecnico",
                            guide1Title: "Contare ciò che c'è in loco",
                            guide1Body: "Nella pagina service dell'impianto apri Consumabili e indica quanto di ogni articolo è davvero presente. Quel conteggio è confermato subito. Un conteggio in loco non aspetta nessun altro.",
                            guide2Role: "Automatico",
                            guide2Title: "La manutenzione motore consuma la scorta",
                            guide2Body: "Registrare la manutenzione motore sottrae il consumo di quel motore dalla scorta confermata. Una manutenzione WG1605 usa 0,28 di una tanica d'olio da 25 l, 1 filtro olio e 4 candele. WG972 e WG3800 usano le quantità della tabella manutenzione motore. Succede quando l'impianto ha un record statistico con il tipo di motore.",
                            guide3Role: "Responsabile service",
                            guide3Title: "Inviare ciò che manca",
                            guide3Body: "Questa pagina elenca gli impianti la cui scorta confermata è minore o uguale al minimo. Inserisci la quantità da spedire e premi Invia. Resta in attesa, per esempio 0,5 confermato + 5 in attesa di validazione, e non conta ancora come scorta. Il minimo si imposta per tipo di motore. Un impianto usa la somma dei motori installati, arrotondata a un numero intero. Un pezzo di olio è una tanica da 25 l.",
                            guide4Role: "Chiunque abbia accesso",
                            guide4Title: "Confermare la consegna",
                            guide4Body: "Quando la merce è in loco, il cliente, un tecnico o un dipendente conferma la ricezione nella pagina service dell'impianto. La quantità in attesa si somma alla scorta confermata. 0,5 confermato e 5 in attesa diventano 5,5 in loco.",
                            correction: "Correzione scorta",
                            save: "Salva conteggio",
                            saved: "Conteggio salvato",
                            saveFailed: "Impossibile salvare il conteggio",
                            minSaved: "Scorta minima salvata",
                            minFailed: "Impossibile salvare la scorta minima",
                            minHint: "Imposta il minimo per tipo di motore. Un impianto usa la somma dei motori installati, arrotondata a un numero intero. Compare quando la scorta è minore o uguale a quel minimo. Un pezzo di olio è una tanica da 25 l.",
                            usage: "Consumo per manutenzione motore",
                            usageHint: "La registrazione della manutenzione motore sottrae questo consumo dalla scorta contata. DF972 e WG972 condividono la colonna WG972. WG3800-L usa la colonna WG3800.",
                            orders: "Ordini da lanciare",
                            ordersEmpty: "Nessun impianto alla scorta minima o sotto",
                            shortage: "Mancanza",
                            installation: "Impianto",
                            engines: "Motori",
                        },
                        pastille1Conf: "Reimpostare la durata del sensore H2S 1 solo quando l’elemento sensore è stato sostituito.",
                        pastille2Conf: "Reimpostare la durata del sensore H2S 2 solo quando l’elemento sensore è stato sostituito.",
                        pastilleLabel: "Durata prevista dell’elemento sensore XX giorni",
                        valve_interval: "Ore di funzionamento fino al controllo gioco valvole",
                        cylinder_interval: "Ore di funzionamento fino alla revisione della testata",
                        valve_interval_engine1: "Ore di funzionamento fino al controllo gioco valvole motore 1",
                        cylinder_interval_engine1: "Ore di funzionamento fino alla revisione della testata motore 1",
                        valve_interval_engine2: "Ore di funzionamento fino al controllo gioco valvole motore 2",
                        cylinder_interval_engine2: "Ore di funzionamento fino alla revisione della testata motore 2",
                        pipe: "Tubo",
                        transmitter: "Trasmettitore",
                        elektromotor: "Motore elettrico",
                        pump: "Pompa",
                        roofsolation: "Isolamento del tetto",
                        airPump: "Pompa di iniezione aria",
                        oxygenConcentrator: "Concentratore di ossigeno",
                        flowmeterBiogas: "Flussometro biogas",
                        pronovaBiomethaan: "ProNova biometano",
                        pronovaBiogas: "ProNova biogas",
                        h2s1Gpi: "Filtro a carbone 1",
                        h2s2Gpi: "Filtro a carbone 2",
                        coolant: "Liquido refrigerante",
                        daysSinceCoolantReplace: "Giorni dalla sostituzione",
                        coolantConf: "Reimpostare le ore di funzionamento del liquido refrigerante solo dopo la sostituzione",
                        daysSinceInhibitor: "Giorni dal pacchetto inibitori",
                        inhibitorPackage: "Pacchetto inibitori",
                        registerInhibitor: "Registra",
                        inhibitorConf: "Registrare solo dopo aver rabboccato il liquido refrigerante con un pacchetto inibitori (ogni 12 mesi)",
                        restoreValues: {
                            button: "Ripristina valori PLC",
                            title: "Ripristina valori PLC",
                            description: "Scegli un giorno degli ultimi 7 giorni che sembra corretto, controlla i valori precompilati e inviali al PLC.",
                            pickDay: "Seleziona un giorno",
                            snapshotTime: "Ora campione",
                            noSnapshots: "Nessuna statistica trovata per gli ultimi 7 giorni.",
                            send: "Invia",
                            sendAll: "Invia tutto",
                            sending: "Invio…",
                            confirmSendAll: "Inviare tutti i valori precompilati al PLC?",
                            sendAllDone: "{{count}} valori inviati al PLC",
                            emptyValue: "Il valore è vuoto",
                            invalidValue: "Il valore non è un numero",
                            invalidEngineCount: "Il numero di motori deve essere 1 o 2",
                            noConnection: "La macchina non ha una connessione attiva",
                            readOnly: "sola lettura",
                            fromMachine: "dal record macchina",
                            current: "Attuale",
                            currentHint: "Valore slow/fast attuale sulla CU",
                            ups: "UPS",
                            groupEngines: "Motori",
                            groupReactor: "Reattore e miscelazione",
                            groupFeeding: "Alimentazione",
                            groupGas: "Gas",
                            groupEnergy: "Contatori energia",
                            groupSsr: "SSR",
                        },
                        tabs: {
                            engine: "Motore",
                            reactor: "Reattore / Contenitore",
                            gas: "Gas / Purificazione",
                            consumables: "Consumabili",
                            options: "Opzioni macchina",
                            prints: "Stampe",
                            restoreValues: "Ripristina valori PLC",
                        },
                    },
                    net: {
                        net: "Rete",
                        meterSettings: "Impostazioni contatore",
                        voltagePerPhase1: "Voltaggio per fase (1)",
                        voltagePerPhase2: "Voltaggio per fase (2)",
                        voltagePerPhase3: "Voltaggio per fase (3)",
                        frequencyPerPhase: "Frequenza per fase",
                        angleBetweenPhase1And2: "Angolo tra fase 1 e 2",
                        ownPowerConsumption: "Potenza autoconsumo",
                        ownEnergyConsumption: "Energia autoconsumo",
                        bioguardVersion: "Versione bioguard",
                        brutoProducedEnergy: "Energia prodotta lorda",
                        nettoProducedEnergy: "Energia prodotta netta",
                        producedEnergy: "Energia prodotta",
                        producedEnergyEngine1: "Energia prodotta motore 1",
                        producedEnergyEngine2: "Energia prodotta motore 2",
                        monitoringRelay: "Relè di monitoraggio",
                        powerNonFit: "Potenza autoconsumo non-FIT",
                        energyMeterNonFit: "Energia autoconsumo non-FIT",
                    },
                    reactor: {
                        label: "Reattore",
                        reactorTemp: "Temperatura reattore",
                        reactorTempTarget: "Temperatura reattore obiettivo",
                        reactorLevel: "Livello impostato",
                        hydrostaticPressure: "Livello reattore attuale",
                        siloType: "Tipo reattore",
                        extraHeating: "Riscaldamento extra",
                        antiFrost: "Anticongelamento",
                        antiFrostIndex: "Indice anticongelamento",
                        antiFrostAuto: "L'indice di gelo viene impostato automaticamente in base alla temperatura locale.",
                        antiFrostMessageNew: "Ogni ciclo di indice di gelo attiverà la pompa di alimentazione per 4 s e la pompa di uscita scarica circa 100 l di digestato, in base alla portata impostata.",
                        antiFrostMessageOld: "Ogni ciclo di indice di gelo attiverà la pompa di alimentazione per 4 s e la pompa di uscita per 120 s.",
                        coolwater: "Acqua di raffreddamento",
                        statusCoolingValve: "Valvola a 3 vie acqua",
                        waterTempIn: "Temperatura acqua ingresso reattore",
                        waterTempOut: "Temperatura acqua uscita reattore",
                        waterTempMotorOut: "Temperatura acqua uscita motore 1",
                        waterTempMotorOut2: "Temperatura acqua uscita motore 2",
                        coolingWaterTemp: "Impostazione temperatura acqua",
                        maxCoolingWaterTemp: "Limite temperatura acqua",
                        waterPressure: "Pressione dell'acqua nel circuito idraulico",
                        foamBeater: "Schiuma",
                        foambeatEveryXMinutes: "Rompere la schiuma ogni",
                        foambeatForXSeconds: "Per",
                        mixer: "Miscelatore",
                        mixerMaxPower: "Potenza massima del mixer",
                        mixerActive: "Mixer aktiv",
                        mixerBlockedLowLevel: "Mixer bloccato a causa del basso livello del reattore",
                        mixEveryXMinutes: "Miscelare ogni",
                        mixForXSeconds: "Per",
                        blockMixingFrom: "Nessuna miscelazione da",
                        blockMixingTo: "A",
                        mixerInfo: "Il mixer si accende automaticamente per la durata selezionata con l'intervallo di tempo selezionato. Durante la finestra temporale di blocco del mixer, il mixer viene arrestato quando la potenza installata del mixer supera l'attuale produzione di energia dell'impianto. Il miscelatore viene temporaneamente arrestato durante l'avvio CHP fino al raggiungimento del 50% della potenza nominale per consentire la corrente di spunto",
                        mixerInfoGpi: "Il mixer si accende automaticamente per la durata selezionata con l'intervallo di tempo selezionato. Durante la finestra temporale di blocco del mixer, il mixer viene arrestato quando la potenza installata del mixer supera l'attuale produzione di energia dell'impianto.",
                        mix1Hour: "Miscelare 1 ora",
                        coolwaterValveInstalled: "Valvola a 3 vie regolabile",
                        coolwaterValveBinary: "Valvola a 3 vie binaria",
                        coolwaterValveMaximizeHeat: "Massimizza l'uso del calore",
                        coolwaterValveMaximizeHeatInfo: "La massimizzazione dell'uso del calore può comportare periodi senza disponibilità di calore allo scambiatore a piastre",
                        coolwaterValvePlatePriority: "Priorità scambiatore a piastre",
                        coolwaterValvePlatePriorityInfo: "Priorizzare la disponibilità di calore allo scambiatore a piastre mantenendo una temperatura stabile del digestore",
                        bypassFan: "Valvola di controllo by-pass / ventilatore",
                        digester: "Valvola di controllo digestore / consumo di calore esterno",
                        silo: "Silo",
                        bag: "Sacco",
                        plateHeatExchanger: "Scambiatore di calore a piastre",
                        timesPerDay: "volte / giorno",
                        intern: "Internamente",
                        extern: "Esternamente",
                        tempHigh: "Temperatura alta",
                        externMessage: "Il seguente errore non verrà attivato se il miscelatore è impostato su esterno: Miscelatore non funziona, si prega di resettare il termico.",
                        bypass: "Bypass",
                        ventilator: "Ventilatore",
                        tempCoolHeatExchOut: "Temperatura acqua uscita del scambiatore di calore",
                        overtempMixer1: "Surriscaldamento miscelatore 1",
                        overtempMixer2: "Surriscaldamento miscelatore 2",
                        mixerSettings: "Impostazioni mixer",
                        premixing: "Premiscelazione",
                        intakeMixing: "Miscelazione in ingresso",
                        premixingInfo: "La premiscelazione è la miscelazione prima dell'alimentazione, quindi prima e durante lo scarico. Il tempo si riferisce sempre alla durata di miscelazione.",
                        intakeMixingInfo: "La miscelazione in ingresso consente di mescolare contemporaneamente all'immissione. Con OFF, la miscelazione non viene eseguita mentre l'alimentazione è in corso.",
                        gpiMixDuringIntake: "Miscelazione durante alimentazione liquida",
                        gpiMixDuringIntakeInfo: "Miscelazione durante l'intera alimentazione liquida.",
                        gpiMixDuringIntakeHelp: "Miscelazione durante alimentazione liquida: miscelazione per tutta la durata dell'alimentazione. Con OFF: dipende dal tipo di silo.\n\nTipi S: solo premiscelazione durante l'uscita e miscelazione dopo l'alimentazione per la durata del mixer.\n\nTipi C: nessuna premiscelazione; miscelazione dopo l'alimentazione per la durata del mixer.",
                        gpiMixDuringIntakeOffGeneric: "Con OFF: dipende dal tipo di silo.",
                        gpiMixDuringIntakeOffS: "Tipi S: solo premiscelazione durante l'uscita e miscelazione dopo l'alimentazione per la durata del mixer.",
                        gpiMixDuringIntakeOffC: "Tipi C: nessuna premiscelazione; miscelazione dopo l'alimentazione per la durata del mixer.",
                        gpiMixDuringSolidFeedIntake: "Miscelazione durante alimentazione solida",
                        gpiMixDuringSolidFeedIntakeInfo: "Con ON: miscelazione per tutta l'alimentazione solida. Con OFF: miscelazione solo prima e dopo l'alimentazione solida, ciascuna per la durata (in secondi) impostata in “{{durationSetting}}”.",
                        gpiMixTimeBeforeAfterSolidIntake: "Tempo di miscelazione prima/dopo alimentazione solida",
                    },
                    efficiency: {
                        label: "Efficienza",
                        production: "Produzione di energia negli ultimi 30 giorni",
                        consumption: "Consumo di energia negli ultimi 30 giorni",
                        nettoProduction: "Produzione enlettrica netta negli ultimi 30 giorni",
                        averageEfficiency: "Efficienza media negli ultimi 30 giorni",
                        averageTechnicalEfficiency: "Disponibilità tecnica media negli ultimi 30 giorni",
                        bgp: "Qualità del letame (BGP batch)",
                        top10: "I migliori 10 impianti della settimana",
                        realised: "Efficienza normalizzata",
                        technical: "Disponibilità tecnica",
                        bgpInfo: "Stima del BGP [m³/ton]. Non tiene conto delle perdite causate da tempi di inattività, sovrapproduzione o combustione alla torcia",
                        pointPerDay: "%/giorno",
                        trendline: "Linea di tendenza",
                    },
                    general: {
                        label: "Generale",
                        hardwareVersion: "Versione hardware",
                        engine1And2Off: "Motore 1 e 2 spenti",
                        engine1On: "Motore 1 acceso",
                        engine2On: "Motore 2 acceso",
                        engine1And2On: "Motore 1 e 2 accesi",
                        otGenContact: "Contatto OT Gen",
                        notes: "Note",
                        h2sSensorFirmwareVersion: "Versione firmware sensore H₂S",
                        idH2s: "S/N ID H₂S",
                        bioId: "S/N ID Biotronic",
                        identifier: "Identificatore installazione",
                        collabContract: "Contratto di collaborazione",
                        own: "Contratto di manutenzione",
                        sold: "Installazione venduta",
                        productionDate: "Data di produzione",
                        commissioningDate: "Data di messa in servizio",
                        controlCardTemp: "Temperatura della scheda di controllo",
                        batteryVoltage: "Tensione della batteria",
                        motorVoltage: "Tensione del motore",
                        overtempFlueGasHeatExch: "Surriscaldamento motore scambiatore di calore dei fumi",
                        rebootMainBoard: "Riavvio scheda principale",
                        rebootNow: "Riavvia ora",
                        utcOffset: "Offset UTC",
                        location: "Posizione",
                        network: "Rete",
                        ip: "IP",
                        mask: "Maschera",
                        gateway: "Gateway",
                        dns: "DNS",
                        pcb: "PCB",
                        firmware: "Firmware",
                        mainControlUnit: "Unità di controllo principale",
                        bioguard: "Bioguard",
                        biotronicEngine1: "Motore Biotronic 1",
                        biotronicEngine2: "Motore Biotronic 2",
                        h2sEngine1: "Motore H₂S 1",
                        h2sEngine2: "Motore H₂S 2",
                        bioIdEngine1: "Motore Bio ID 1",
                        bioIdEngine2: "Motore Bio ID 2",
                        modificationsToMachine: "Modifiche alla macchina",
                        name: "Nome",
                        hostNameFirmware: "Firmware",
                        hostNameDatabase: "Database",
                        normal: "Normale",
                        lowError: "Basso (errore)",
                        nta8080Title: "Rapporto NTA 8080",
                        nta8080Description: "Scarica un rapporto mensile NTA 8080. I dati vengono caricati solo quando richiedi il rapporto.",
                        nta8080Month: "Mese",
                        nta8080Download: "Scarica rapporto",
                        nta8080DownloadPdf: "Scarica PDF",
                        nta8080DownloadCsv: "Scarica CSV",
                        nta8080Loading: "Preparazione…",
                        nta8080SelectMonth: "Seleziona prima un mese",
                        nta8080InvalidMonth: "Mese selezionato non valido",
                        nta8080DownloadError: "Download del rapporto non riuscito",
                    },
                    feeding: {
                        label: "Alimentazione",
                        feedingVolume: "Volume massimo di alimentazione fresca per ciclo",
                        feedingCyclesPerDay: "Cicli di alimentazione per giorno",
                        feedingCyclesPerDayInfo: "Un volume pompato inferiore al 75% del volume desiderato genera l'errore di alimentazione \"nessun flusso durante l'immissione di letame fresco\". Un volume pompato tra il 75% e il 100% del volume desiderato genera il messaggio \"Ciclo di alimentazione parzialmente eseguito. Fossa vuota rilevata prima di raggiungere il volume impostato\".",
                        feedingBalance: "Bilancio alimentazione",
                        autoFeedingActive: "Alimentazione automatica",
                        blockHighElectricalConsumption: "Blocca riscaldamento digestore con pompa di calore durante finestra di miscelazione",
                        blockHighElectricalConsumptionInfo: "Con ON: il riscaldamento del digestore con pompa di calore è bloccato durante la finestra di miscelazione. Con OFF: nessun blocco.",
                        minimizeElectricalConsumptionFrom: "Minimizza consumo elettrico da",
                        minimizeElectricalConsumptionTo: "a",
                        autoFeedingStartHour: "Alimentazione automatica",
                        exitPumpRunning: "Avviare il pompaggio",
                        feedingCycle: "Ciclo di alimentazione",
                        onlyInput: "Solo carico",
                        onlyOutput: "Solo scarico",
                        startFeeding: "Start alimentazione",
                        stopFeeding: "Stop alimentazione",
                        customAmount: "Quantità personalizzata",
                        customAmountHint: "Precompilato con il volume di alimentazione configurato. Modifica solo per una quantità personalizzata. Max {{maxRiseCm}} cm di aumento livello ({{maxLiters}} l per questo silo).",
                        customAmountInvalid: "Inserire un valore tra {{min}} e {{max}} l",
                        customAmountExceedsLevelRise: "La quantità inserita ({{amount}} l) alzerebbe il livello del serbatoio di più di {{maxRiseCm}} cm. Massimo per questo silo: {{maxLiters}} l.",
                        customAmountUnknownSilo: "Impossibile calcolare la quantità massima: tipo di silo sconosciuto.",
                        customAmountExceedsWarning: "La quantità inserita ({{amount}} l) è superiore al volume di alimentazione impostato ({{feedingVolume}} l). Sei sicuro di voler continuare?",
                        pumpOutFlowRate: "Impostazione portata di scarico",
                        pumpOutFlowRateInfo: "La portata teorica di scarico viene utilizzata per calcolare il tempo necessario a pompare il digestato fuori dal digestore. Se impostata troppo bassa, verrà pompato troppo digestato; se troppo alta, troppo poco. Valori tipici:",
                        pumpOutFlowRateBellowsPump: "Pompa a soffietto: ± 3 m³/h",
                        pumpOutFlowRateCentrifugalPump: "Pompa centrifuga: ± 50 m³/h",
                        pumpOutFlowRateGravityOutlet: "Scarico per gravità: ± 50 m³/h",
                        kiloPerPulse: "Pulsazione flussometro",
                        intakeTimeout: "Alimentazione: time-out alimentazione",
                        averageDailyFeeding: "Alimentazione giornaliera media il mese scorso",
                        retentionTime: "Ritenzione",
                        statusValvePumpIn: "Valvola liquame fresco - 2",
                        statusValvePumpOut: "Valvola scarico reattore - 3",
                        statusValveRetourReactor: "Valvola ricircolo reattore - 4",
                        valveCurrentActuator: "Corrente valvola",
                        actuatorSetting: "Impostazione attuatore",
                        actuatorSettingV1: "Linak",
                        actuatorSettingV2: "Hiwin / Mikrosystem",
                        lastFeeding: "Attuale - ultimo",
                        startHourLastFeeding: "Ora di inizio ultimo ciclo",
                        feedingStatus: "Stato del ciclo",
                        feedingError: "Errore di alimentazione",
                        intakePumpTime: "Tempo di alimentazione",
                        intakePumpAmount: "Quantità alimenata",
                        exitPumpTime: "Tempo di scarico",
                        exitPumpAmount: "Quantità scaricata",
                        feedingHistory: "Storico alimentazione",
                        startedOn: "Avviato il",
                        temperature: "Temperatura",
                        reactorLevel: "Livello",
                        balance: "Recupera",
                        acknowledge: "Identificazione dell'errore",
                        intakeSpeed: "Velocità di alimentazione",
                        balanceWarning: "Avviso, questo non avvierà un ciclo di alimentazione normale ma invece pomperà il valore rimanente del saldo nel reattore",
                        automaticFeedingSettings: "Impostazioni di alimentazione automatica",
                        manualFeeding: "Alimentazione manuale",
                        pumpSettings: "Impostazioni della pompa",
                        lastFeedingTime: "Tempo di alimentazione ultimo",
                        status: {
                            "0": "Inattivo",
                            "1": "Rilevamento del livello",
                            "2": "Uscita",
                            "3": "Aspirazione",
                            "5": "Sbrinamento",
                            "6": "Rilascio gas",
                            "7": "Uscita manuale",
                            "10": "Avvio",
                            "2,001": "Uscita: Pre-miscelazione",
                            "2,002": "Uscita",
                            "2,003": "Uscita: Apertura valvola di uscita",
                            "2,004": "Uscita: Apertura valvola di uscita",
                            "2,005": "Uscita: Avvio pompa di uscita",
                            "2,006": "Uscita",
                            "2,007": "Uscita: Pompa liquame in uscita",
                            "2,008": "Uscita: Stop uscita",
                            "2,009": "Uscita: Stop uscita",
                            "2,010": "Uscita: Chiusura valvola di uscita",
                            "2,011": "Uscita: Chiusura valvola di uscita",
                            "2,012": "Uscita: Stop uscita",
                            "3,001": "Aspirazione: Preparazione",
                            "3,002": "Aspirazione: Preparazione",
                            "3,003": "Aspirazione: Preparazione",
                            "3,004": "Aspirazione: Pompa liquame in aspirazione",
                            "3,005": "Aspirazione: Pompa liquame in aspirazione",
                            "3,006": "Aspirazione: Finitura",
                            "3,007": "Aspirazione: Finitura",
                            "3,008": "Aspirazione: Stop pompa",
                            "3,009": "Aspirazione: Stop pompa",
                            "3,010": "Aspirazione: Stop pompa",
                            "3,011": "Aspirazione: Stop pompa",
                            "3,012": "Aspirazione: Finitura",
                            "5,001": "Sbrinamento: Verifica aspirazione",
                            "5,002": "Sbrinamento: Verifica aspirazione",
                            "5,003": "Sbrinamento: Verifica aspirazione",
                            "5,004": "Sbrinamento: Verifica aspirazione",
                            "5,005": "Sbrinamento: Stop aspirazione",
                            "5,006": "Sbrinamento: Apertura valvola di uscita",
                            "5,007": "Sbrinamento: Apertura valvola di uscita",
                            "5,008": "Sbrinamento: Verifica aspirazione",
                            "5,009": "Sbrinamento: Verifica aspirazione",
                            "5,010": "Sbrinamento: Verifica aspirazione",
                            "5,011": "Sbrinamento: Verifica aspirazione",
                            "5,012": "Sbrinamento: Verifica aspirazione",
                            "5,013": "Sbrinamento: Chiusura valvola di uscita",
                            "5,014": "Sbrinamento: Chiusura valvola di uscita",
                            "5,015": "Sbrinamento: Finitura",
                            "6,001": "Rilascio gas: Apertura valvola di uscita",
                            "6,002": "Rilascio gas: Apertura valvola di uscita",
                            "6,003": "Rilascio gas: Chiusura valvola di uscita",
                            "6,004": "Rilascio gas: Chiusura valvola di uscita",
                            "6,005": "Rilascio gas",
                            "7,001": "Uscita manuale: Apertura valvola di uscita",
                            "7,002": "Uscita manuale: Apertura valvola di uscita",
                            "7,003": "Uscita manuale: Pompa di liquami",
                            "7,004": "Uscita manuale: Arresto pompa",
                            "7,005": "Uscita manuale: Chiusura valvola di uscita",
                            "7,006": "Uscita manuale: Chiusura valvola di uscita",
                            "7,007": "Uscita manuale: Finitura",
                            "7,008": "Uscita manuale: Finitura",
                            "10,001": "Avvio: Chiusura valvola 2",
                            "10,002": "Avvio: Chiusura valvola 2",
                            "10,003": "Avvio: Chiusura valvola di uscita",
                            "10,004": "Avvio: Chiusura valvola di uscita",
                            "10,005": "Avvio: Chiusura valvola 4",
                            "10,006": "Avvio: Chiusura valvola 4",
                            "10,007": "Avvio: Verifica connessione elettrica",
                            "10,008": "Avvio: Verifica connessione elettrica",
                            "10,009": "Avvio"
                        }
                    },
                    users: {
                        label: "Utenti",
                        customers: "Clienti collegati",
                        technicians: "Tecnici collegati",
                        resellers: "Rivenditori collegati",
                    },
                    recommendations: {
                        label: "Raccomandazioni",
                    },
                    firmware: {
                        invalidFile: "Seleziona un file .hex",
                        uploadStarted: "Caricamento firmware avviato",
                        uploadFailed: "Caricamento firmware non riuscito",
                        uploading: "Caricamento…",
                        uploadProgress: "Avanzamento: {{progress}}%",
                        currentVersion: "Versione attuale",
                    },
                    documents: {
                        label: "Documenti",
                        specificDocuments: "Documenti specifici",
                        specificImages: "Immagini specifiche",
                        generalVideos: "Video generali",
                        general: "Documentazione generale",
                        generalDocuments: "Documenti generali",
                        checklists: "Liste di controllo",
                        construction: "Checklist costruzione",
                        production: "Checklist produzione",
                        upload: "Carica",
                        uploadSuccess: "Hai caricato {{name}} con successo",
                        deleteSuccess: "Hai eliminato con successo il file: {{name}}",
                        noFilesAvailable: "Nessun file disponibile nella categoria {{category}}.",
                        fileSizeExceeds: "La dimensione del file supera il limite di {{size}}Mb",
                        invalidImageType: "Sono consentite solo immagini JPG e PNG",
                        chooseFileFirst: "Seleziona prima un file.",
                        default: "Predefinito",
                        permits: "Permessi",
                        plans: "Piani",
                        planning: "Pianificazione",
                        certification: "Certificazione",
                        regulations: "Regolamenti",
                        instructions: "Istruzioni",
                        templates: "Modelli"
                    },
                    warnings: {
                        "W001": "Consumo energetico superiore alla soglia nelle ultime 24 ore (72 kWh per installazione 10-44kW, 250 kWh per installazione 60-74kW)",
                        "W002": "Temperatura del reattore diminuita drasticamente",
                        "W003": "Intervallo di manutenzione entro 48 ore",
                        "W004": "I carboni attivi del motore 1 devono essere sostituiti",
                        "W005": "I carboni attivi del motore 2 devono essere sostituiti",
                        "W006": "Misurazione del livello gas congelata",
                        "W007": "Misurazione del livello gas difettosa",
                        "W008": "Non alimentato ieri",
                        "W009": "La velocità di alimentazione dell'ultimo pompaggio è stata del 50% più veloce della media mensile",
                        "W010": "Valore H₂S troppo alto (> 1500)",
                        "W011": "L'aerazione è a 60",
                        "W012": "L'aerazione è inferiore o uguale a 3",
                        "W013": "Ieri l'efficienza è stata 0 e l'alimentazione automatica è attiva",
                        "W014": "H₂S reactor measurement - difference exceeds 400ppm",
                        "W015": "Iniezione dell'aria molto alta - ricorda la qualità del gas",
                        "W016": "Misurazione H₂S fallita da 24 ore",
                        "W017": "Olio del mixer troppo basso",
                        "W018": "Olio del motore basso",
                        "W020": "Pressione dell'acqua bassa",
                        "W104": "Valore H₂S troppo alto (> 200) o aerazione = 60 o 3",
                        "W105": "Saturazione del filtro a carboni alta",
                        "W114": "Ieri l'efficienza non è stata 0 e l'alimentazione automatica era spenta",
                    },
                    advanced: {
                        language: "Lingua schermo LCD",
                        lambdaUpperLimit: "Limite superiore lambda (narrow range)",
                        lambdaLowerLimit: "Limite inferiore lambda (narrow range)",
                        coolingValve: "valvola a 3 vie acqua",
                        maxPower: "Potenza massima (Database) Motore 1",
                        maxPower2: "Potenza massima (Database) Motore 2",
                        bioId: "Bio ID Motore 1",
                        bioId2: "Bio ID Motore 2",
                        currentSsrConfiguration: "Configurazione SSR attuale",
                        SSRString: "Stringa SSR",
                    },
                    sms: {
                        duringDay: "Ricevere messaggi durante il giorno",
                        duringNight: "Ricevere messaggi durante la notte",
                        sendSms: "Notifica clienti con sms",
                        sendTestSms: "Invia messaggio di prova",
                        testSms: "SMS di prova",
                        testSmsToAllSenders: "Invia messaggio di prova a tutti i mittenti (risoluzione problemi)",
                        recipients: "Destinatari",
                        settings: "Impostazioni SMS",
                        enterMessage: "Inserisci il tuo messaggio qui...",
                        smsSentSuccessfully: "SMS inviati con successo",
                        pleaseSelectAtLeastOneRecipient: "Seleziona almeno un destinatario",
                        pleaseEnterAMessage: "Inserisci un messaggio",
                        failedToSendSmsMessages: "Invio SMS fallito",
                        smsSettingsUpdatedSuccessfully: "Impostazioni SMS aggiornate con successo",
                        message: "Messaggio",
                        testNotificationToAllSenders: "Invia notifica di prova a tutti i mittenti (risoluzione problemi)",
                        sendTestNotification: "Invia notifica di prova",
                        testNotificationsSentSuccessfully: "Notifiche di prova inviate con successo",
                        failedToSendTestNotifications: "Invio notifiche di prova fallito",
                    },
                    temperatures: {
                        label: "Temperature",
                        oilCoolerTemp: "Temperatura del raffreddatore dell'olio",
                        biogasTempAfterReheat: "T5 Temperature After Reheating",
                        blowerOutTemp: "T2 Temperature Inlet Compressor",
                        compressorOutTemp: "T3 Temperature Outlet Compressor",
                        biogasTempAfterCool: "T4 Temperature After Cooling",
                    },
                    pressures: {
                        label: "Pressioni",
                        biogasPressureBeforeMembrane: "P4 Pressure Inlet Membranes",
                        stage3Pressure: "P5 Pressure Membrane Stage 3",
                        pressureAfterMembrane: "P6 Pressure Outlet Membranes",
                        blowerPressure: "P1 Pressure Outlet Blower",
                        blowerPressureSetpoint: "Pressure Outlet Blower Setpoint",
                        compressorOutPressure: "P3 Pressure Outlet Compressor",
                    },
                    valves: {
                        label: "Valvole",
                        valveCompressor: "Valvola compressore",
                        valveMembrane: "Valvola membrana",
                        valveGrid: "Valvola rete",
                        valveCo2: "Valvola CO2",
                    },
                    system: {
                        label: "Sistema",
                        installationState: "Stato dell'installazione",
                        geuAvailable: "GEU disponibile",
                        geuAlarm: "Allarme GEU",
                        geuDelivering: "GEU in funzione",
                        gasTotalGeu: "Gas totale GEU",
                        gasTotalInternGeu: "Gas totale interno GEU",
                        biogasTotalizer: "Totalizzatore biogas",
                        biomethaneDewpoint: "Punto di rugiada del biometano",
                        compressorSpeed: "Velocità compressore",
                    },
                    filters: {
                        label: "Filtri",
                        inletFilterPressuredrop: "Caduta di pressione filtro di ingresso",
                        filterTrainPressuredrop: "Caduta di pressione batteria filtri",
                        oilFilterPressuredrop: "Caduta di pressione filtro olio",
                    },
                    checks: {
                        yourImage: "La tua immagine:",
                        imageCommentsLabel: "Commenti su questa immagine (opzionale):",
                        imageCommentsPlaceholder: "Aggiungi commenti su questa immagine",
                        exampleImage: "Immagine di esempio:",
                        textAnswerPlaceholder: "Scrivi qui la tua risposta",
                        next: "Avanti",
                        completedMessage: "Hai completato tutti i controlli di costruzione, invia la checklist.",
                        skip: "Salta",
                        downloadPdf: "Scarica PDF",
                        answerLabel: "Risposta:",
                        commentsLabel: "Commenti:",
                        selectedOptionsLabel: "Opzioni selezionate:",
                        addEntry: "Aggiungi voce",
                        newEntryForCheck: "Nuova voce per questo controllo:",
                        commentsOptionalPlaceholder: "Commenti (opzionale)",
                        yourAnswerPlaceholder: "La tua risposta",
                        saveEntry: "Salva voce",
                        cancel: "Annulla",
                        entryAdded: "Voce aggiunta.",
                        entryAddFailedPrefix: "Impossibile aggiungere la voce: ",
                        validateBeforeSubmitting: "Inserisci una risposta prima di inviare.",
                        validateBeforeNextCheck: "Inserisci una risposta prima di passare al controllo successivo.",
                        uploadSuccess: "Dati inviati con successo",
                        uploadFailedPrefix: "Invio dei dati non riuscito: ",
                    }
                }
            },
            se: {
                translation: {
                    dashboard: {
                        nameIdentifier: "Namn eller identifierare",
                        efficiencyAll: "Effektivitet för alla maskiner",
                        onlyErrors: "Endast fel",
                        toggleDisconnected: "Växla bortkopplade maskiner",
                        productionCombined: "Kombinerad produktion (Wh)",
                        realisedTechnicalEfficiency: "Uppnådd / Teknisk effektivitet (%)",
                        efficiencyCombined: "Uppnådd effektivitet (%)",
                        technicalEfficiencyCombined: "Teknisk effektivitet (%)",
                        bgp: "Bgp (m³/ton)",
                        consumption: "Förbrukning (Wh)",
                        manureLifeTime: "Gödsellivstid (dagar)",
                        feeding: "Utfodring (kg)"
                    },
                    common: {
                        on: "På",
                        off: "Av",
                        add: "Lägg till",
                        save: "Spara",
                        monday: "Måndag",
                        tuesday: "Tisdag",
                        wednesday: "Onsdag",
                        thursday: "Torsdag",
                        friday: "Fredag",
                        saturday: "Lördag",
                        sunday: "Söndag",
                        from: "Från",
                        to: "Till",
                        hours: "timmar",
                        reset: "Återställ",
                        confirmation: "Bekräftelse",
                        cancel: "Avbryt",
                        yesIAmSure: "Ja, jag är säker",
                        set: "Justera",
                        auto: "Auto",
                        manual: "Manuel",
                        minutes: "Minuter",
                        seconds: "Sekunder",
                        turnOn: "Sätta på",
                        turnOff: "Stäng av",
                        graphLoading: "Laddning av grafer...",
                        noData: "Ingen data tillgänglig...",
                        hoursPerYear: "timmar / år",
                        datetime: "Datum och tid",
                        warning: "Varning",
                        error: "Fel",
                        type: "Typ",
                        startdate: "Startdatum",
                        enddate: "Slutdatum",
                        all: "Alla",
                        engine1: "Motor 1",
                        engine2: "Motor 2",
                        ongoing: "Pågående",
                        both: "Båda",
                        days: "Dagar",
                        today: "Idag",
                        sendAnswers: "Skicka svar",
                        employee: "Anställd",
                        customer: "Kund",
                        sales: "Försäljning",
                        technician: "Tekniker",
                        admin: "Administratör",
                        noDateKnown: "Inget datum känt",
                        command: "Kommando",
                        user: "Användare",
                        fillInSurvey: "Vänligen fyll i undersökningen",
                        tons: "ton",
                        count: "Räkna",
                        disabled: "Inaktiverad",
                        addField: "Lägg till fält",
                        deleteField: "Ta bort fält",
                        releases: "Utgåvor",
                        open: "Öppna",
                        close: "Stänga",
                        opening: "Öppnar",
                        closing: "Stänger",
                        zoomCancel: "Zoom avbruten, stanna innanför grafen för att zooma",
                        stuck: "Fastnat"
                    },
                    errorPage: {
                        title: "Något gick fel.",
                        contact: "Rapportera problemet till it@biolectric.com och ange vilken mobiltelefon eller webbläsare du använder.",
                        reload: "Ladda om"
                    },
                    popups: {
                        engineIdle: "Motorn går fortfarande, stäng av motorn först",
                        valueBetween: "Värdet måste vara mellan {{min}} och {{max}}",
                        valueBetweenCustom: "Värdet måste vara mellan {{min}} och {{max}}",
                        powerTooLow: "Effekten kan inte ställas in lägre än {{watts}}W",
                        powerTooHigh: "Effekten kan inte ställas in högre än {{maxPower}}",
                        maxCoolingTemp: "Kan inte vara högre än {{max}}°C",
                        minValue: "Kan inte vara mindre än {{min}}",
                        maxAirInjectionTime: "Kan inte vara längre än {{max}} sekunder",
                        minGasBuffer: "Min gasbuffert utanför intervall. Minimivärdet för din anläggning är {{min}}",
                        maxGasBuffer: "Max gasbuffert utanför intervall. Maximivärdet för din anläggning är {{max}}",
                        reactorTemp: "Reaktortemperatur utanför intervall. Måste vara mellan {{min}} och {{max}}",
                        reactorLevel: "Ogiltig reaktornivå. Maximivärdet för din anläggning är {{limit}}",
                        reactorLevelRange: "Värdet för reaktornivån måste vara mellan {{min}} och {{max}}",
                        commandFailed: "Kunde inte skicka kommando",
                        commandSent: "Kommando skickat",
                        commandSuccess: "Du har framgångsrikt uppdaterat {{command}} från {{previousValue}} till {{value}}",
                        commandMix1Hour: "Blandaren kommer att köras i 1 timme",
                    },
                    menu: {
                        dashboard: 'Instrumentbräda',
                        machines: 'Maskineri',
                        questionnaires: 'Frågeformulär',
                        banners: "Banderoller",
                        errors: "Fel och varningar",
                        pcb: "Tryckta kretskort",
                        tasks: "Mina uppgifter",
                        releases: "Utgivningsanteckningar",
                        resellers: "Återförsäljare",
                        users: "Användare",
                        recommendations: "Rekommendationer",
                        suggestions: "Rekommendationsmeddelanden",
                        faultTrees: "Feltrad",
                        assistant: "Assistent",
                        language: "Språk",
                        reconnection: "Denna maskin är för närvarande offline. Försök att få en ny anslutning med knappen ovan.",
                        profile: "Profil",
                        logout: "Logga ut",
                        firmware: "Firmware",
                        sms: "SMS",
                        advanced: "Avancerad",
                        errorsSingle: "Fel",
                        warnings: "Varningar"
                    },
                    statistics: {
                        label: "Statistik",
                        foamBeaterThermalStatus: "Termik skumslagare",
                        exitPumpThermalStatus: "Termik utpumpning",
                        thermalStatusOk: "Termik inte aktiv, förbrukaren kan fungera normalt",
                        thermalStatusFault: "Termik aktiv, förbrukaren är i fel",
                        group1: "Grupp 1",
                        group2: "Grupp 2",
                        addProperty: "Lägg till egenskap",
                        removeProperty: "Ta bort egenskap",
                        startTutorial: "Börja handledning",
                        exitTutorial: "Avsluta handledning",

                        welcomeStep: {
                            title: "Välkommen till statistiksidan",
                            content: "Här kan du enkelt jämföra olika värden och trender."
                        },
                        propertyStep: {
                            title: "Val av egenskap",
                            content: "För att komma igång, välj helt enkelt en egenskap som intresserar dig från rullgardinsmenyn."
                        },
                        addPropertyStep: {
                            title: "Lägga till och ta bort egenskaper",
                            content: "Prova att lägga till eller ta bort en egenskap. Du kan lägga till upp till 4 egenskaper per grupp."
                        },
                        groupStep: {
                            title: "Aktivera grupp 2",
                            content: "Klicka på knappen 'Lägg till egenskap' för att välja en egenskap för Grupp 2. Egenskaper i denna grupp kommer att visas på höger sida av grafen."
                        },
                        dateRangeStep: {
                            title: "Val av datumintervall",
                            content: "Använd den här knappen för att välja ett datumintervall."
                        },
                        zoomInStep: {
                            title: "Zooma in",
                            content: "Dra musen över grafen för att välja ett område att zooma in på."
                        },
                        zoomOutStep: {
                            title: "Zooma ut",
                            content: "Återställ till det tidigare valda datumintervallet genom att använda knappen 'Zooma ut'."
                        },
                        domainStep: {
                            title: "Justera domäner",
                            content: "Du kan anpassa den maximala och minimala domänen per grupp med hjälp av dessa knappar."
                        },
                        csvStep: {
                            title: "Ladda ner CSV-data",
                            content: "Ladda ner de för närvarande visade grafdata i CSV-format."
                        },
                        imageStep: {
                            title: "Ladda ner bild",
                            content: "Ladda ner den för närvarande visade grafen som en bild."
                        },
                        configurationStep: {
                            title: "Förinställningskonfiguration",
                            content: "Du kan spara din nuvarande konfiguration som en förinställning. Du kan också uppdatera eller radera befintliga förinställningar."
                        },
                        controlCardTemp: "Temperatur för kontrollkort",
                        lowTensionError: "Fel på låg spänning",
                        overTempFlueGasHeatExch: "Övertemperatur på rökgasväxlaren",
                        feedingCycleLevel: "Matningscykelnivå",
                        batteryVoltage: "Batterispänning",
                        waterPressure: "Vattentryck",
                        shortInterval: "10 Minuters intervaller",
                        dailyInterval: "Dagliga intervaller",
                        configurationUpdated: "Din nuvarande konfiguration har sparats till denna förinställning",
                        presets: "Förinställningar",
                        savePreset: "Spara som förinställning",
                        applyPreset: "Använd förinställning",
                        updatePreset: "Uppdatera förinställning",
                        delete: "Radera",
                        noPresets: "Du har inte några förinställningar än",
                        givePresetName: "Ange ett namn för din förinställning",

                    },
                    smart: {
                        label: "Smart",
                        heightOffset: "Höjdavvikelse",
                        active: "Aktiv",
                        passive: "Passiv",
                        preActive: "Föraktiv",
                        prePassive: "Förpassiv",
                        postActive: "Efteraktiv",
                        postPassive: "Efterpassiv",
                        activeDesc: "Under en aktiv period maximeras den planerade energiproduktionen. Före varje aktiv period tillhandahålls automatiskt en 'föraktiv' tidsperiod där gasbufferten byggs upp. Den maximala varaktigheten av en aktiv period bestäms av volymen av gasbufferten, antalet och typen av installerade CHP-enheter samt produktionsprofilen för biogasen vid installationen. När den minimala fyllnadsnivån för gasbufferten nås kommer energiproduktionen att stoppas (efter den aktiva perioden).",
                        passiveDesc: "Under en passiv period produceras endast energi om det finns ett överskott av gas. Före varje passiv period tillhandahålls automatiskt en tidsperiod där gasbufferten minskas. Den maximala varaktigheten av en passiv period bestäms av volymen av gasbufferten samt produktionsprofilen för biogasen vid installationen. När den maximala fyllnadsnivån för gasbufferten nås kommer energiproduktionen att starta (efter den passiva perioden).",
                        permanence: "Stimulera konstant produktion genom att dynamiskt köra på en motor med en icke-maximal gasbuffert",
                        permanency: "Beständighet",
                        activateStep: {
                            title: "Aktivera SMART",
                            content: "Aktivera SMART för att styra produktionsprofilen för installationen"
                        },
                        timeslotStep: {
                            title: "Lägg till tidsperiod",
                            content: "Lägg till en aktiv eller passiv tidsperiod"
                        },
                        fromToStep: {
                            title: "Från / Till",
                            content: "Du anger både start- och slutdagen samt tidpunkten"
                        },
                        activePassiveStep: {
                            title: "Aktiv eller Passiv",
                            content: "Välj om du vill ange en aktiv eller passiv tidsperiod"
                        },
                        saveStep: {
                            title: "Spara tidsperioder",
                            content: "Spara dina ändrade inställningar"
                        },
                        removeStep: {
                            title: "Ta bort tidsperioder",
                            content: "Ta bort din tidsperiod här"
                        },
                        visualStep: {
                            title: "Visuell representation",
                            content: "Denna graf jämför SMART-inställningarna med produktionsprofilen från föregående vecka"
                        },
                        daySwitchStep: {
                            title: "Visuell representation",
                            content: "Navigera enkelt till nästa eller föregående dag"
                        },
                    },
                    gas: {
                        label: "Gas",
                        minGasBufferLevel: "Min Nivå gasbuffert",
                        maxGasBufferLevel: "Max Nivå gasbuffert",
                        gasBufferLevel: "Nivå gasbuffert",
                        defaultMinGasBufferLevel: "Förinställd min gasbuffert",
                        defaultMaxGasBufferLevel: "Förinställd max gasbuffert",
                        airInjectionTime: "Luftinpumpning",
                        maxAirInjectionTime: "Max luftinpumpning",
                        torch: "Flare",
                        torchType: "Flare type",
                        torchStatus: "Flare status",
                        torchError: "Flare fel",
                        theoreticalTorchFlow: "Teoretiskt flödesflöde för flare",
                        torchRunningTime: "Flaretid",
                        torchFlaredVolume: "Flarad volym",
                        h2s: "H₂S",
                        h2sLevelReactor: "H₂S rötkammare",
                        h2sLevelMotor: "H₂S Motor",
                        filterLoad: "Mättningsgrad filter",
                        sample: "Provtagning",
                        latestH2sReadings: "Senaste H₂S-mätningar",
                        carbonFilterSize: "Storlek på kolfilter",
                        h2sMeasurements: "H₂S-mätningar",
                        measurements: "Mätningar",
                        changeTo: "Byt till",
                        none: "Ingen",
                        container: "Behållare",
                        extern: "Extern",
                        foamBeaterInstalled: "Skumslagare installerad",
                        antiFoamInjectionsInstalled: "Antiskum-injektioner installerade",
                        containerCombinedOperation: "Behållare (kombinerad operation)",
                        externCombinedOperation: "Extern (kombinerad operation)",
                        gasTemp: "T1 Temperature After Gascooler",
                        ch4BiogasSupply: "CH4-biogastillförsel",
                        co2BiogasSupply: "CO2-biogastillförsel",
                        o2BiogasSupply: "O2-biogastillförsel",
                        h2sAfterFilter: "H2S efter filter",
                        biomethaneFlowNorm: "Normaliserat biometanflöde",
                        ch4Biomethane: "CH4-biometan",
                        co2Biomethane: "CO2-biometan",
                        o2Biomethane: "O2-biometan",
                        h2sBiomethane: "H2S-biometan",
                        bufferRelease: "Buffertutsläpp",
                        wobbe: "Wobbe-index",
                        wobbeAvg: "Genomsnittligt Wobbe-index",
                        wobbePidSetpoint: "Wobbe PID-börvärde",
                        wobbeBiomethanePronova: "Wobbe biometan Pronova",

                    },
                    engine: {
                        label: "motor",
                        startEngine: "Start motor",
                        stopEngine: "Stop motor",
                        power: "Effekt",
                        desiredPower: "Ställ in effekt",
                        maxPower: "Max effekt",
                        rpm: "RPM",
                        lambda: "Lambda",
                        throttleValve: "Position servo",
                        engineType: "Motortyp",
                        engineStatus: "Status motor",
                        engineError: "Motorfel",
                        producedEnergy: "Producerad förnybar energi",
                        operatingHours: "Drifttimmar motor",
                        totalOperatingHours: "Total antal drifttimmar",
                        gasUsage: "Gasförbrukning",
                        throttlePosition: "Position throttle",
                        noErrors: "Alla system i drift.",
                        production: "Produktion",
                        servoAuto: "Servot ställs in automatiskt",
                        servoControl: "Servo kontroll",
                        temperature: "Motor temperatur",
                        restart: "Automatisk återstart när gas är tillgängligt.",
                        confirmStop: "Är du säker på att du vill stoppa motor {{number}}?",
                        confirmStopRestart: "Är du säker på att du vill stoppa motor {{number}}? Den startar om automatiskt när gas är tillgängligt.",
                        idle: "Tomgång",
                        running: "Körning",
                        waiting: "Väntar på uppstart",
                        booting: "Startar upp",
                        shuttingDown: "Stänger ner",
                        advanced: "Avancerad",
                        numberOfEngines: "Antal motorer",
                        predeterminedRunHours: "Förutbestämda körtimmar",
                        easyStart1: "Easy start motor 1",
                        easyStart2: "Easy start motor 2",
                        setError1: "Inställt fel motor 1",
                        setError2: "Inställt fel motor 2",
                        fuel: "Bränsle",
                        airIntakeOpen: "Luftintag öppet",
                        airIntakeClosed: "Luftintag stängt",
                        vfd: "VFD",

                    },
                    service: {
                        label: "Underhåll",
                        lastMaintenance: "Driftstimmar till nästa oljebyte",
                        currentlyInstalled: "Driftstimmar för närvarande installerade",
                        total: "Totalt antal driftstimmar",
                        mixer: "Mixer",
                        foam_beater: "Skumslagare",
                        intake_pump: "Inloppspump",
                        digestate_pump: "Digestatpump",
                        newMixer: "Ny mixer installerad",
                        newEngine: "Ny motor installerad",
                        newFoamBeater: "Ny skumslagare installerad",
                        newIntakePump: "Ny inloppspump installerad",
                        newDigestatePump: "Ny digestatpump installerad",
                        confirmationMessage: "Är du säker på att du vill återställa {{type}}",
                        maintenanceMessage: "Underhållstimmar har återställts för {{type}}",
                        newEquipmentMessage: "Ny utrustning installerad:",
                        prints: "Prints",
                        firstOnline: "Först online",
                        lastOnline: "Senast online",
                        serial: "Serienummer",
                        type: "Typ",
                        engine: "Motor",
                        engine1: "Motor 1",
                        engine2: "Motor 2",
                        engine_new1: "Motor 1",
                        engine_new2: "Motor 2",
                        h2s1: "H₂S Motor 1",
                        h2s2: "H₂S Motor 2",
                        resetTo: "Återställ till x timmar (standard 0)",
                        timeFilterReplace: "Tid sedan filterbyte",
                        daysSinceOil: "Dagar sedan oljebyte",
                        newGenerator: "Ny generator installerad",
                        generator: "Generator",
                        generator1: "Generator 1",
                        generator2: "Generator 2",
                        daysSinceOilChange: "Dagar sedan oljebyte",
                        videoMessage: "Video om oljebyte => Dokumentsida, under Allmänna videor.",
                        videoRoom: "En servicetekniker har öppnat ett videorum för denna maskin. Klicka här för att gå med.",
                        videoButton: "Starta ett videorum för denna maskin",
                        videoButtonSub: "Användare med åtkomst kan delta i samtalet från sin service-sida.",
                        videoClose: "Stäng videorum",
                        serialNumber: "Serienummer",
                        defaultEngineReset: "Standard motoråterställning",
                        newInstalled: "Ny {{type}} installerad",
                        replace: "Byt ut",
                        aircover: "Luftskydd",
                        gascover: "Gas skydd",
                        liner: "Foder",
                        flow_meter: "Flödesmätare",
                        energy_meter1: "Energimätare 1",
                        energy_meter2: "Energimätare 2",
                        energy_meter_own: "Energimätare egen förbrukning",
                        h2sPastille: "Tid tills H2S-sensorn byts ut",
                        pastille1: "H₂S-sensor 1",
                        pastille2: "H₂S-sensor 2",
                        engineLabel: "Nästa motorunderhåll om “XX” timmar",
                        engine1Conf: "Återställ underhållsintervallet för motor 1 endast efter att motorunderhåll har utförts",
                        engine2Conf: "Återställ underhållsintervallet för motor 2 endast efter att motorunderhåll har utförts",
                        h2s1Conf: "Återställ H2S Motor 1 endast när aktivt kol i filtret har bytts ut",
                        h2s2Conf: "Återställ H2S Motor 2 endast när aktivt kol i filtret har bytts ut",
                        filterResetOffline: "Maskinen är offline. Filteråterställningen sparades inte. Anslut igen och försök igen.",
                        filterResetFailed: "Filteråterställningen misslyckades. Filteråterställningen sparades inte.",
                        consumables: {
                            title: "Förbrukningsmaterial",
                            belowMin: "Under minimilager",
                            noneBelow: "Inga artiklar under minimilagret",
                            notCounted: "Inte räknat ännu",
                            article: "Artikelnummer",
                            description: "Beskrivning",
                            onSite: "På plats",
                            minimum: "Minimum",
                            engineMaintenance: "Motorunderhåll",
                            pendingStock: "{{confirmed}} bekräftat + {{pending}} väntar på validering",
                            send: "Skicka",
                            shipmentSaved: "Leverans sparad. Den väntar tills kunden bekräftar.",
                            shipmentFailed: "Kunde inte spara leveransen",
                            confirm: "Bekräfta mottagning",
                            confirmSaved: "Lager bekräftat",
                            confirmFailed: "Kunde inte bekräfta lagret",
                            confirmHint: "Bekräfta leveransen för att lägga den till lagret på plats.",
                            guideTitle: "Så här fungerar det",
                            guideIntro: "Olja, oljefilter och tändstift finns kvar på varje installation. Installationens servicesida och den här beställningssidan använder samma lager.",
                            guide1Role: "Tekniker",
                            guide1Title: "Räkna vad som finns på plats",
                            guide1Body: "På installationens servicesida öppnar du Förbrukningsmaterial och fyller i hur mycket av varje artikel som faktiskt finns. Den räkningen bekräftas direkt. En räkning på plats väntar inte på någon annan.",
                            guide2Role: "Automatiskt",
                            guide2Title: "Motorunderhåll förbrukar lager",
                            guide2Body: "När motorunderhåll registreras dras den motorns förbrukning av från det bekräftade lagret. Ett WG1605-underhåll använder 0,28 av en 25 l oljedunk, 1 oljefilter och 4 tändstift. WG972 och WG3800 använder mängderna i tabellen för motorunderhåll. Det sker när installationen har en statistikpost med motortyp.",
                            guide3Role: "Servicechef",
                            guide3Title: "Skicka det som saknas",
                            guide3Body: "Den här sidan listar installationer vars bekräftade lager är mindre än eller lika med minimum. Fyll i mängden som ska skickas och tryck på Skicka. Den förblir väntande, till exempel 0,5 bekräftat + 5 väntar på validering, och räknas ännu inte som lager. Minimivärdet anges per motortyp. En installation använder summan av de installerade motorerna, avrundad till ett heltal. En enhet olja är en dunk på 25 l.",
                            guide4Role: "Alla med åtkomst",
                            guide4Title: "Bekräfta leveransen",
                            guide4Body: "När varorna är på plats bekräftar kunden, en tekniker eller en medarbetare mottagandet på installationens servicesida. Den väntande mängden läggs till det bekräftade lagret. 0,5 bekräftat och 5 väntande blir då 5,5 på plats.",
                            correction: "Lagerkorrigering",
                            save: "Spara lagerräkning",
                            saved: "Lagerräkning sparad",
                            saveFailed: "Kunde inte spara lagerräkningen",
                            minSaved: "Minimilager sparat",
                            minFailed: "Kunde inte spara minimilagret",
                            minHint: "Ange minimum per motortyp. En installation använder summan av de installerade motorerna, avrundad till ett heltal. Den visas när lagret är mindre än eller lika med det minimumet. En enhet olja är en dunk på 25 l.",
                            usage: "Förbrukning per motorunderhåll",
                            usageHint: "När motorunderhåll registreras dras denna förbrukning av från det räknade lagret. DF972 och WG972 delar kolumnen WG972. WG3800-L använder kolumnen WG3800.",
                            orders: "Beställningar att starta",
                            ordersEmpty: "Inga installationer på eller under minimilagret",
                            shortage: "Brist",
                            installation: "Installation",
                            engines: "Motorer",
                        },
                        pastille1Conf: "Återställ livslängden för H2S-sensor 1 endast när sensorelementet har bytts ut.",
                        pastille2Conf: "Återställ livslängden för H2S-sensor 2 endast när sensorelementet har bytts ut.",
                        pastilleLabel: "Förväntad livslängd för sensorelement XX dagar",
                        valve_interval: "Drifttimmar till kontroll av ventilspel",
                        cylinder_interval: "Drifttimmar till översyn av topplock",
                        valve_interval_engine1: "Drifttimmar till kontroll av ventilspel motor 1",
                        cylinder_interval_engine1: "Drifttimmar till översyn av topplock motor 1",
                        valve_interval_engine2: "Drifttimmar till kontroll av ventilspel motor 2",
                        cylinder_interval_engine2: "Drifttimmar till översyn av topplock motor 2",
                        pipe: "Rör",
                        transmitter: "Sändare",
                        elektromotor: "Elektrisk motor",
                        pump: "Pump",
                        roofsolation: "Takisolering",
                        airPump: "Luftinjektionspump",
                        oxygenConcentrator: "Syrekoncentrator",
                        flowmeterBiogas: "Biogas-flödesmätare",
                        pronovaBiomethaan: "ProNova biometan",
                        pronovaBiogas: "ProNova biogas",
                        h2s1Gpi: "Kolfilter 1",
                        h2s2Gpi: "Kolfilter 2",
                        coolant: "Kylmedel",
                        daysSinceCoolantReplace: "Dagar sedan byte",
                        coolantConf: "Återställ kylmedlets drifttimmar endast efter att kylmedlet har bytts ut",
                        daysSinceInhibitor: "Dagar sedan inhibitorpaket",
                        inhibitorPackage: "Inhibitorpaket",
                        registerInhibitor: "Registrera",
                        inhibitorConf: "Registrera endast efter att kylmedlet har fyllts på med ett inhibitorpaket (var 12:e månad)",
                        restoreValues: {
                            button: "Återställ PLC-värden",
                            title: "Återställ PLC-värden",
                            description: "Välj en dag från de senaste 7 dagarna som ser korrekt ut, kontrollera de förifyllda värdena och skicka dem till PLC:n.",
                            pickDay: "Välj en dag",
                            snapshotTime: "Samplings tid",
                            noSnapshots: "Inga statistik hittades för de senaste 7 dagarna.",
                            send: "Skicka",
                            sendAll: "Skicka alla",
                            sending: "Skickar…",
                            confirmSendAll: "Skicka alla förifyllda värden till PLC:n?",
                            sendAllDone: "{{count}} värden skickade till PLC:n",
                            emptyValue: "Värdet är tomt",
                            invalidValue: "Värdet är inte ett tal",
                            invalidEngineCount: "Antal motorer måste vara 1 eller 2",
                            noConnection: "Maskinen har ingen aktiv anslutning",
                            readOnly: "skrivskyddad",
                            fromMachine: "från maskinpost",
                            current: "Nu",
                            currentHint: "Aktuellt slow/fast-värde på CU",
                            ups: "UPS",
                            groupEngines: "Motorer",
                            groupReactor: "Reaktor och blandning",
                            groupFeeding: "Utfodring",
                            groupGas: "Gas",
                            groupEnergy: "Energimätare",
                            groupSsr: "SSR",
                        },
                        tabs: {
                            engine: "Motor",
                            reactor: "Reaktor / Container",
                            gas: "Gas / Renning",
                            consumables: "Förbrukningsmaterial",
                            options: "Maskinalternativ",
                            prints: "Utskrifter",
                            restoreValues: "Återställ PLC-värden",
                        },
                    },
                    net: {
                        net: "Net",
                        meterSettings: "Inställningar mätare",
                        voltagePerPhase1: "Spänning per fas (1)",
                        voltagePerPhase2: "Spänning per fas (2)",
                        voltagePerPhase3: "Spänning per fas (3)",
                        frequencyPerPhase: "Frekvens per fas",
                        angleBetweenPhase1And2: "Vinkel mellan fas 1 och 2",
                        ownPowerConsumption: "Egen effektförbrukning",
                        ownEnergyConsumption: "Egen energiförbrukning",
                        bioguardVersion: "Bioguard version",
                        brutoProducedEnergy: "Brutto producerad energi",
                        nettoProducedEnergy: "Netto producerad energi",
                        producedEnergy: "Producerad energi",
                        producedEnergyEngine1: "Producerad energi motor 1",
                        producedEnergyEngine2: "Producerad energi motor 2",
                        monitoringRelay: "Övervakningsrelä",
                        powerNonFit: "Egenverbrauch Strom ohne FIT",
                        energyMeterNonFit: "Energiezähler Eigenverbrauch ohne FIT",
                    },
                    reactor: {
                        label: "Rötkammare",
                        reactorTemp: "Temperatur rötkammare",
                        reactorTempTarget: "Inställning temperatur rötkammare",
                        reactorLevel: "Inställning nivå",
                        hydrostaticPressure: "Rötkammare nivå",
                        siloType: "Typ rötkammare",
                        extraHeating: "Extra värme",
                        antiFrost: "Anti-frost",
                        antiFrostIndex: "Anti-frost program",
                        antiFrostAuto: "Frostindexet sätts automatiskt baserad lokal temperatur.",
                        antiFrostMessageNew: "Varje frost -index cykel aktivera inpumpning i 4 sekunder och utpumpningen pumpar cirka 100 L av rötrest, baserat på uppskattat pumpflöde.",
                        antiFrostMessageOld: "Varje frost-index cykel kommer aktivera inpumpning i 4 sek och utpumpning i 120 sek.",
                        coolwater: "Kylvatten",
                        statusCoolingValve: "Kylvattenventil",
                        waterTempIn: "Temperatur vatten rötkammare in",
                        waterTempOut: "Temperatur vatten rötkammare retur",
                        waterTempMotorOut: "Temperatur vatten motor 1 ut",
                        waterTempMotorOut2: "Temperatur vatten motor 2 ut",
                        coolingWaterTemp: "Inställningar kylvatten temperatur",
                        maxCoolingWaterTemp: "Max temperatur kylvatten",
                        waterPressure: "Tryck kylvattensystem",
                        foamBeater: "Skumm",
                        foambeatEveryXMinutes: "Bekämpa skumm varje",
                        foambeatForXSeconds: "I",
                        mixer: "Omrörare",
                        mixerMaxPower: "Mixer maximal effekt",
                        mixerActive: "Omrörare aktiva",
                        mixerBlockedLowLevel: "Mixer blockerad på grund av låg reaktornivå",
                        mixEveryXMinutes: "Omrörning varje",
                        mixForXSeconds: "I",
                        blockMixingFrom: "Ingen omrörning från",
                        blockMixingTo: "Till",
                        mixerInfo: "Mixern slås på automatiskt under vald tid med valt tidsintervall. Under mixerblockets tidsfönster stoppas mixern när den installerade mixereffekten överstiger installationens nuvarande kraftproduktion. Blandaren stoppas tillfälligt under kraftvärmestart tills 50 % av nominell effekt uppnås för att tillåta startström",
                        mixerInfoGpi: "Mixern slås på automatiskt under vald tid med valt tidsintervall. Under mixerblockets tidsfönster stoppas mixern när den installerade mixereffekten överstiger installationens nuvarande kraftproduktion.",
                        mix1Hour: "Omrörning 1 timme",
                        coolwaterValveInstalled: "Gradvis trevägsventil",
                        coolwaterValveBinary: "Binär trevägsventil",
                        coolwaterValveMaximizeHeat: "Maximera värmeanvändning",
                        coolwaterValveMaximizeHeatInfo: "Maximering av värmeanvändning kan leda till perioder utan värmetillgänglighet vid plattvärmeväxlaren",
                        coolwaterValvePlatePriority: "Prioritering plattvärmeväxlare",
                        coolwaterValvePlatePriorityInfo: "Prioritera värmetillgänglighet vid plattvärmeväxlaren samtidigt som en stabil rötkammartemperatur bibehålls",
                        bypassFan: "Kontroll ventil by-pass / fläkt",
                        digester: "Kontroll ventil Rötrest / extern värmekonsumtion ",
                        silo: "Silo",
                        bag: "Påse",
                        plateHeatExchanger: "Plattvärmeväxlare",
                        timesPerDay: "gånger / dag",
                        intern: "Internt",
                        extern: "Externt",
                        tempHigh: "Hög temperatur",
                        externMessage: "Följande fel kommer inte att utlösas om mixern är inställd på externt: Mixer fungerar inte, vänligen återställ termiskt.",
                        bypass: "Bypass",
                        ventilator: "Fläkt",
                        tempCoolHeatExchOut: "Temperatur vatten plattvärmeväxlare ut",
                        overtempMixer1: "Övertemperatur mixer 1",
                        overtempMixer2: "Övertemperatur mixer 2",
                        mixerSettings: "Mixerinställningar",
                        premixing: "Förblandning",
                        intakeMixing: "Intagsblandning",
                        premixingInfo: "Förblandning är blandning före matning, dvs. före och under utpumpning. Tiden avser alltid blandningstiden.",
                        intakeMixingInfo: "Intagsblandning tillåter blandning samtidigt som inmatning. Vid OFF utförs inte blandning medan matning pågår.",
                        gpiMixDuringIntake: "Blandning under vätskeutfodring",
                        gpiMixDuringIntakeInfo: "Blandning under hela vätskeutfodringen.",
                        gpiMixDuringIntakeHelp: "Blandning under vätskeutfodring: blandning under hela utfodringen. Vid OFF: beror på silotyp.\n\nS-typer: endast förblandning vid utpumpning och blandning efter utfodring under mixertiden.\n\nC-typer: ingen förblandning; blandning efter utfodring under mixertiden.",
                        gpiMixDuringIntakeOffGeneric: "Vid OFF: beror på silotyp.",
                        gpiMixDuringIntakeOffS: "S-typer: endast förblandning vid utpumpning och blandning efter utfodring under mixertiden.",
                        gpiMixDuringIntakeOffC: "C-typer: ingen förblandning; blandning efter utfodring under mixertiden.",
                        gpiMixDuringSolidFeedIntake: "Blandning under fast utfodring",
                        gpiMixDuringSolidFeedIntakeInfo: "Vid ON: blandning under hela fast utfodring. Vid OFF: blandning endast före och efter fast utfodring, varje gång under den tid (i sekunder) som anges i ”{{durationSetting}}”.",
                        gpiMixTimeBeforeAfterSolidIntake: "Blandningstid före/efter fast utfodring",
                    },
                    efficiency: {
                        label: "Verkningsgrad",
                        production: "Energi producerad senaste 30 dagarna",
                        consumption: "Egenförbrukning senaste 30 dagarna",
                        nettoProduction: "Netto produktion senaste 30 dagarna",
                        averageEfficiency: "Genomsnitt effektivitet senaste 30 dagarna",
                        averageTechnicalEfficiency: "Genomsnitt teknisk tillgänglighet senaste 30 dagarna",
                        bgp: "Gödselkvalitet (BGP batch)",
                        top10: "Top 10 anläggningar senaste månad",
                        realised: "Realiserad effektivitet",
                        technical: "Teknisk tillgänglighet",
                        bgpInfo: "Uppskattad gaspotential BGP (m3/ton). Tar ej med i beräkning förluster vid nedstängning, överproduktion eller fackling.",
                        pointPerDay: "%/dag",
                        trendline: "Trendlinje",
                    },
                    general: {
                        label: "Allmänt",
                        hardwareVersion: "Hårdvaruversion",
                        otGenContact: "OT Gen-kontakt",
                        engine1And2Off: "Motor 1 och 2 av",
                        engine1On: "Motor 1 på",
                        engine2On: "Motor 2 på",
                        engine1And2On: "Motor 1 och 2 på",
                        notes: "Anteckningar",
                        h2sSensorFirmwareVersion: "H₂S-sensor firmware-version",
                        idH2s: "S/N H₂S-ID",
                        bioId: "S/N Biotronic-ID",
                        identifier: "Installationsidentifierare",
                        collabContract: "Samarbetskontrakt",
                        own: "Underhållskontrakt",
                        sold: "Såld installation",
                        productionDate: "Produktionsdatum",
                        commissioningDate: "Drifttagningsdatum",
                        controlCardTemp: "Styrkortstemperatur",
                        batteryVoltage: "Batterispänning",
                        motorVoltage: "Motorspänning",
                        overtempFlueGasHeatExch: "Övertemperatur rökgasvärmeväxlare motor",
                        rebootMainBoard: "Starta om huvudkortet",
                        rebootNow: "Starta om nu",
                        utcOffset: "UTC-offset",
                        location: "Plats",
                        network: "Nätverk",
                        ip: "IP",
                        mask: "Mask",
                        gateway: "Gateway",
                        dns: "DNS",
                        pcb: "PCB",
                        firmware: "Firmware",
                        mainControlUnit: "Huvudkontrollenhet",
                        bioguard: "Bioguard",
                        biotronicEngine1: "Biotronic motor 1",
                        biotronicEngine2: "Biotronic motor 2",
                        h2sEngine1: "H₂S motor 1",
                        h2sEngine2: "H₂S motor 2",
                        bioIdEngine1: "Bio ID motor 1",
                        bioIdEngine2: "Bio ID motor 2",
                        modificationsToMachine: "Ändringar på maskinen",
                        name: "Namn",
                        hostNameFirmware: "Firmware",
                        hostNameDatabase: "Databas",
                        normal: "Normal",
                        lowError: "Låg (fel)",
                        nta8080Title: "NTA 8080-rapport",
                        nta8080Description: "Ladda ner en månatlig NTA 8080-rapport. Data hämtas först när du begär rapporten.",
                        nta8080Month: "Månad",
                        nta8080Download: "Hämta rapport",
                        nta8080DownloadPdf: "Ladda ner PDF",
                        nta8080DownloadCsv: "Ladda ner CSV",
                        nta8080Loading: "Förbereder…",
                        nta8080SelectMonth: "Välj en månad först",
                        nta8080InvalidMonth: "Ogiltig månad vald",
                        nta8080DownloadError: "Kunde inte ladda ner rapporten",
                    },
                    feeding: {
                        label: "Matning",
                        feedingVolume: "Maximal volym färsk matning per cykel",
                        feedingCyclesPerDay: "Matningscykler per dag",
                        feedingCyclesPerDayInfo: "Pumpat volym under 75 % av önskad volym ger matningsfel \"inget flöde vid inmatning av färskt gödsel\". Pumpat volym 75 till 100 % av önskad volym ger meddelandet \"Matningscykel delvis utförd. Tom grop upptäckt innan inställd volym uppnåtts\".",
                        feedingBalance: "Matning saldo",
                        autoFeedingActive: "Automatisk matning",
                        blockHighElectricalConsumption: "Blockera värmepumps uppvärmning av reaktor under blandningsfönster",
                        blockHighElectricalConsumptionInfo: "Vid ON: värmepumps uppvärmning av reaktorn blockeras under blandningsfönstret. Vid OFF: ingen blockering.",
                        minimizeElectricalConsumptionFrom: "Minimera elförbrukning från",
                        minimizeElectricalConsumptionTo: "till",
                        autoFeedingStartHour: "Automatisk matning",
                        exitPumpRunning: "Starta utpumpning",
                        feedingCycle: "Matningscykel",
                        onlyInput: "Bara inpumpning",
                        onlyOutput: "Bara utpumpning",
                        startFeeding: "Start av inpumpning",
                        stopFeeding: "Stäng av inpumpning",
                        customAmount: "Anpassad mängd",
                        customAmountHint: "Förifylld med den inställda matningsvolymen. Ändra bara för en anpassad mängd. Max {{maxRiseCm}} cm nivåökning ({{maxLiters}} l för denna silo).",
                        customAmountInvalid: "Ange ett värde mellan {{min}} och {{max}} l",
                        customAmountExceedsLevelRise: "Den angivna mängden ({{amount}} l) skulle höja tanknivån med mer än {{maxRiseCm}} cm. Maximum för denna silo är {{maxLiters}} l.",
                        customAmountUnknownSilo: "Kan inte beräkna maxmängd: okänd silotyp.",
                        customAmountExceedsWarning: "Den angivna mängden ({{amount}} l) är högre än den inställda matningsvolymen ({{feedingVolume}} l). Är du säker på att du vill fortsätta?",
                        pumpOutFlowRate: "Flöde utpumpning",
                        pumpOutFlowRateInfo: "Det teoretiska utpumpningsflödet används för att beräkna hur lång tid det tar att pumpa ut digestat från rötaren. Om inställningen är för låg pumpas för mycket digestat ut; om den är för hög pumpas för lite. Typiska värden är:",
                        pumpOutFlowRateBellowsPump: "Bälgpump: ± 3 m³/h",
                        pumpOutFlowRateCentrifugalPump: "Centrifugalpump: ± 50 m³/h",
                        pumpOutFlowRateGravityOutlet: "Gravitationsutlopp: ± 50 m³/h",
                        kiloPerPulse: "Puls flödesmätare",
                        intakeTimeout: "Matning: Time-out inpumpning",
                        averageDailyFeeding: "Genomsnittlig daglig utfodring förra månaden",
                        retentionTime: "Bibehållande",
                        statusValvePumpIn: "Ventil substrat in -2",
                        statusValvePumpOut: "Ventil rötkammare ut -3",
                        statusValveRetourReactor: "Ventil retur rötkammare -4",
                        valveCurrentActuator: "Spänning ventilstyrning",
                        actuatorSetting: "Ställning ventilaktuator",
                        actuatorSettingV1: "Linak",
                        actuatorSettingV2: "Hiwin / Mikrosystem",
                        lastFeeding: "Nuvarande - senaste",
                        startHourLastFeeding: "Start senaste matning",
                        feedingStatus: "Status matning",
                        feedingError: "Fel rötkammare",
                        intakePumpTime: "Tid inpumpning",
                        intakePumpAmount: "Total volym inpumpning",
                        exitPumpTime: "Tid utpumpning",
                        exitPumpAmount: "Volym utpumpning",
                        feedingHistory: "Matningshistorik",
                        startedOn: "Tidpunkt uppstart",
                        temperature: "Temperatur",
                        reactorLevel: "Nivå",
                        balance: "Saldo",
                        acknowledge: "Kvitterat larm",
                        intakeSpeed: "Pumphastighet",
                        balanceWarning: "Varning, detta kommer inte att starta en normal matningscykel utan istället pumpa in återstående balansvärde i reaktorn",
                        automaticFeedingSettings: "Automatiska matningsinställningar",
                        manualFeeding: "Manuell matning",
                        pumpSettings: "Pumpinställningar",
                        lastFeedingTime: "Tid matning senaste",
                        status: {
                            "0": "Tomgång",
                            "1": "Nivådetektering",
                            "2": "Utgång",
                            "3": "Intag",
                            "5": "Avfrostning",
                            "6": "Gasfrisättning",
                            "7": "Manuell utgång",
                            "10": "Startar upp",
                            "2,001": "Utgång: Förblandning",
                            "2,002": "Utgång",
                            "2,003": "Utgång: Öppna utgångsventil",
                            "2,004": "Utgång: Öppna utgångsventil",
                            "2,005": "Utgång: Startar utgångspump",
                            "2,006": "Utgång",
                            "2,007": "Utgång: Pumpar gödsel",
                            "2,008": "Utgång: Stoppa utgång",
                            "2,009": "Utgång: Stoppa utgång",
                            "2,010": "Utgång: Stäng utgångsventil",
                            "2,011": "Utgång: Stäng utgångsventil",
                            "2,012": "Utgång: Stoppa utgång",
                            "3,001": "Intag: Förbereder",
                            "3,002": "Intag: Förbereder",
                            "3,003": "Intag: Förbereder",
                            "3,004": "Intag: Pumpar gödsel",
                            "3,005": "Intag: Pumpar gödsel",
                            "3,006": "Intag: Avslutar",
                            "3,007": "Intag: Avslutar",
                            "3,008": "Intag: Stoppa pump",
                            "3,009": "Intag: Stoppa pump",
                            "3,010": "Intag: Stoppa pump",
                            "3,011": "Intag: Stoppa pump",
                            "3,012": "Intag: Avslutar",
                            "5,001": "Avfrostning: Testar intag",
                            "5,002": "Avfrostning: Testar intag",
                            "5,003": "Avfrostning: Testar intag",
                            "5,004": "Avfrostning: Testar intag",
                            "5,005": "Avfrostning: Stoppa intag",
                            "5,006": "Avfrostning: Öppna utgångsventil",
                            "5,007": "Avfrostning: Öppna utgångsventil",
                            "5,008": "Avfrostning: Testar utgång",
                            "5,009": "Avfrostning: Testar utgång",
                            "5,010": "Avfrostning: Testar utgång",
                            "5,011": "Avfrostning: Testar utgång",
                            "5,012": "Avfrostning: Testar utgång",
                            "5,013": "Avfrostning: Stänger utloppsventil",
                            "5,014": "Avfrostning: Stänger utloppsventil",
                            "5,015": "Avfrostning: Avslutar",
                            "6,001": "Gasutsläpp: Öppnar utloppsventil",
                            "6,002": "Gasutsläpp: Öppnar utloppsventil",
                            "6,003": "Gasutsläpp: Stänger utloppsventil",
                            "6,004": "Gasutsläpp: Stänger utloppsventil",
                            "6,005": "Gasutsläpp",
                            "7,001": "Manuell utlopp: Öppnar utloppsventil",
                            "7,002": "Manuell utlopp: Öppnar utloppsventil",
                            "7,003": "Manuell utlopp: Pumpar gödsel",
                            "7,004": "Manuell utlopp: Stoppa pumpen",
                            "7,005": "Manuell utlopp: Stänger utloppsventil",
                            "7,006": "Manuell utlopp: Stänger utloppsventil",
                            "7,007": "Manuell utlopp: Avslutar",
                            "7,008": "Manuell utlopp: Avslutar",
                            "10,001": "Startar: Stänger ventil 2",
                            "10,002": "Startar: Stänger ventil 2",
                            "10,003": "Startar: Stänger utloppsventil",
                            "10,004": "Startar: Stänger utloppsventil",
                            "10,005": "Startar: Stänger ventil 4",
                            "10,006": "Startar: Stänger ventil 4",
                            "10,007": "Startar: Kontrollerar elektrisk anslutning",
                            "10,008": "Startar: Kontrollerar elektrisk anslutning",
                            "10,009": "Startar"
                        }
                    },
                    users: {
                        label: "Användare",
                        customers: "Kopplad kund ",
                        technicians: "Kopplad tekniker",
                        resellers: "Kopplad Säljare",
                    },
                    recommendations: {
                        label: "Rekommendationer",
                    },
                    firmware: {
                        invalidFile: "Välj en .hex-fil",
                        uploadStarted: "Firmwareuppladdning startad",
                        uploadFailed: "Firmwareuppladdning misslyckades",
                        uploading: "Laddar upp…",
                        uploadProgress: "Uppladdningsstatus: {{progress}}%",
                        currentVersion: "Aktuell version",
                    },
                    documents: {
                        label: "Dokument",
                        specificDocuments: "Specifika dokument",
                        specificImages: "Specifika bilder",
                        generalVideos: "Allmänna videor",
                        general: "Allmän dokumentation",
                        generalDocuments: "Allmänna dokument",
                        checklists: "Checklistor",
                        construction: "Checklista för konstruktion",
                        production: "Checklista för produktion",
                        upload: "Ladda upp",
                        uploadSuccess: "Du har laddat upp {{name}} framgångsrikt",
                        deleteSuccess: "Du har tagit bort filen {{name}} framgångsrikt",
                        noFilesAvailable: "Inga filer tillgängliga i kategorin {{category}}.",
                        fileSizeExceeds: "Filstorleken överskrider gränsen på {{size}}Mb",
                        invalidImageType: "Endast JPG- och PNG-bilder är tillåtna",
                        chooseFileFirst: "Vänligen välj en fil först.",
                        default: "Standard",
                        permits: "Tillstånd",
                        plans: "Planer",
                        planning: "Planering",
                        certification: "Certifiering",
                        regulations: "Föreskrifter",
                        instructions: "Instruktioner",
                        templates: "Mallar"
                    },
                    warnings: {
                        "W001": "Energiförbrukning som överskrider tröskeln de senaste 24 timmarna (72 kWh för 10-44kW installation, 250 kWh för 60-74kW installation)",
                        "W002": "Temperatur rötkammaren har sjunkit",
                        "W003": "Service inom 48 timmar",
                        "W004": "Bytt karbonfilter motor 1",
                        "W005": "Bytt karbonfilter motor 2",
                        "W006": "Gasbuffertmätning har frusit",
                        "W007": "Gasbuffertmätning trasig",
                        "W008": "Ingen matning igår",
                        "W009": "Flöde inpumpning 50% snabbare än genomsnittet från senaste månad",
                        "W010": "H₂S koncentration för hög",
                        "W011": "Luftinpumpning är 60 sekunder",
                        "W012": "Luftinpumpning är 3 sekunder eller lägre",
                        "W013": "Effektivitet igår var 0 men automatisk matning är aktiverad",
                        "W014": "Avvikelse H₂S mätningar i rötkammaren är större än 400ppm",
                        "W015": "Luftinpumpning väldigt hög, tänk på gaskvalitén",
                        "W016": "H₂S mätningar har inte fungerat de senaste 24 timmarna",
                        "W017": "Oljenivå omröraren för låg",
                        "W018": "Nivå motorolja för låg",
                        "W020": "Tryck kylvattensystem för låg",
                        "W104": "H₂S för hög (>200) eller luftinpumpning är 60 eller 3",
                        "W105": "Karbonfilter mättad",
                        "W114": "Effektivitet var inte 0 igår men automatisk matning är avstängd",
                    },
                    advanced: {
                        language: "LCD-skärmspråk",
                        lambdaUpperLimit: "Lambda övre gräns (narrow range)",
                        lambdaLowerLimit: "Lambda nedre gräns (narrow range)",
                        coolingValve: "Kylvattenventil",
                        maxPower: "Max effekt (Databas) Motor 1",
                        maxPower2: "Max effekt (Databas) Motor 2",
                        bioId: "Bio ID Motor 1",
                        bioId2: "Bio ID Motor 2",
                        currentSsrConfiguration: "Aktuell SSR-konfiguration",
                        SSRString: "SSR-sträng",
                    },
                    sms: {
                        duringDay: "Ta emot sms dagtid",
                        duringNight: "Ta emot sms nattetid",
                        sendSms: "Kontakt kund via sms",
                        sendTestSms: "Skicka testmeddelande",
                        testSms: "Test-SMS",
                        testSmsToAllSenders: "Skicka testmeddelande till alla avsändare (felsökning)",
                        recipients: "Mottagare",
                        settings: "SMS-inställningar",
                        enterMessage: "Skriv ditt meddelande här...",
                        smsSentSuccessfully: "SMS skickades framgångsrikt",
                        pleaseSelectAtLeastOneRecipient: "Välj minst en mottagare",
                        pleaseEnterAMessage: "Skriv ett meddelande",
                        failedToSendSmsMessages: "Det gick inte att skicka SMS",
                        smsSettingsUpdatedSuccessfully: "SMS-inställningar uppdaterades framgångsrikt",
                        message: "Meddelande",
                        testNotificationToAllSenders: "Skicka testmeddelande till alla avsändare (felsökning)",
                        sendTestNotification: "Skicka testmeddelande",
                        testNotificationsSentSuccessfully: "Testmeddelanden skickades framgångsrikt",
                        failedToSendTestNotifications: "Det gick inte att skicka testmeddelanden",
                    },
                    temperatures: {
                        label: "Temperaturer",
                        oilCoolerTemp: "Oljekylartemperatur",
                        biogasTempAfterReheat: "T5 Temperature After Reheating",
                        blowerOutTemp: "T2 Temperature Inlet Compressor",
                        compressorOutTemp: "T3 Temperature Outlet Compressor",
                        biogasTempAfterCool: "T4 Temperature After Cooling",
                    },
                    pressures: {
                        label: "Tryck",
                        biogasPressureBeforeMembrane: "P4 Pressure Inlet Membranes",
                        stage3Pressure: "P5 Pressure Membrane Stage 3",
                        pressureAfterMembrane: "P6 Pressure Outlet Membranes",
                        blowerPressure: "P1 Pressure Outlet Blower",
                        blowerPressureSetpoint: "Pressure Outlet Blower Setpoint",
                        compressorOutPressure: "P3 Pressure Outlet Compressor",
                    },
                    valves: {
                        label: "Ventiler",
                        valveCompressor: "Ventil kompressor",
                        valveMembrane: "Ventil membran",
                        valveGrid: "Ventil nät",
                        valveCo2: "Ventil CO2",
                    },
                    system: {
                        label: "System",
                        installationState: "Installationsstatus",
                        geuAvailable: "GEU tillgänglig",
                        geuAlarm: "GEU-larm",
                        geuDelivering: "GEU levererar",
                        gasTotalGeu: "Gas totalt GEU",
                        gasTotalInternGeu: "Gas totalt internt GEU",
                        biogasTotalizer: "Biogastotalisator",
                        biomethaneDewpoint: "Daggpunkt biometan",
                        compressorSpeed: "Kompressorhastighet",
                    },
                    filters: {
                        label: "Filter",
                        inletFilterPressuredrop: "Tryckfall inloppsfilter",
                        filterTrainPressuredrop: "Tryckfall filterenhet",
                        oilFilterPressuredrop: "Tryckfall oljefilter",
                    },
                    checks: {
                        yourImage: "Din bild:",
                        imageCommentsLabel: "Kommentarer till den här bilden (valfritt):",
                        imageCommentsPlaceholder: "Lägg till kommentarer om den här bilden",
                        exampleImage: "Exempelbild:",
                        textAnswerPlaceholder: "Skriv ditt svar här",
                        next: "Nästa",
                        completedMessage: "Du har slutfört alla konstruktionskontroller, skicka checklistan.",
                        skip: "Hoppa över",
                        downloadPdf: "Ladda ner PDF",
                        answerLabel: "Svar:",
                        commentsLabel: "Kommentarer:",
                        selectedOptionsLabel: "Valda alternativ:",
                        addEntry: "Lägg till post",
                        newEntryForCheck: "Ny post för den här kontrollen:",
                        commentsOptionalPlaceholder: "Kommentarer (valfritt)",
                        yourAnswerPlaceholder: "Ditt svar",
                        saveEntry: "Spara post",
                        cancel: "Avbryt",
                        entryAdded: "Post tillagd.",
                        entryAddFailedPrefix: "Det gick inte att lägga till posten: ",
                        validateBeforeSubmitting: "Ange ett svar innan du skickar.",
                        validateBeforeNextCheck: "Ange ett svar innan du går vidare till nästa kontroll.",
                        uploadSuccess: "Data skickades utan problem",
                        uploadFailedPrefix: "Det gick inte att skicka data: ",
                    }
                }
            },
            pl: {
                translation: {
                    dashboard: {
                        nameIdentifier: "Nazwa lub identyfikator",
                        efficiencyAll: "Wydajność wszystkich maszyn",
                        onlyErrors: "Tylko błędy",
                        toggleDisconnected: "Przełącz odłączone maszyny",
                        productionCombined: "Łączna produkcja (Wh)",
                        realisedTechnicalEfficiency: "Zrealizowana wydajność / Wydajność techniczna (%)",
                        efficiencyCombined: "Zrealizowana wydajność (%)",
                        technicalEfficiencyCombined: "Wydajność techniczna (%)",
                        bgp: "Bgp (m³/ton)",
                        consumption: "Zużycie (Wh)",
                        manureLifeTime: "Czas życia obornika (dni)",
                        feeding: "Karmienie (kg)"
                    },
                    common: {
                        on: "Włączone",
                        off: "Wyłączone",
                        add: "Dodaj",
                        save: "Zapisz",
                        monday: "Poniedziałek",
                        tuesday: "Wtorek",
                        wednesday: "Środa",
                        thursday: "Czwartek",
                        friday: "Piątek",
                        saturday: "Sobota",
                        sunday: "Niedziela",
                        from: "Od",
                        to: "Do",
                        hours: "godziny",
                        reset: "Resetuj",
                        confirmation: "Potwierdzenie",
                        cancel: "Anuluj",
                        yesIAmSure: "Tak, jestem pewien",
                        set: "Dostosuj",
                        auto: "Automatycznie",
                        manual: "Ręcznie",
                        minutes: "Minut",
                        seconds: "Sekund",
                        turnOn: "Włączone",
                        turnOff: "Wyłączone",
                        graphLoading: "Ładowanie wykresów...",
                        noData: "Brak dostępnych danych...",
                        hoursPerYear: "godzin / rok",
                        datetime: "Data i czas",
                        warning: "Ostrzeżenie",
                        error: "Błąd",
                        type: "Typ",
                        startdate: "Data rozpoczęcia",
                        enddate: "Data zakończenia",
                        all: "Wszystkie",
                        engine1: "Silnik 1",
                        engine2: "Silnik 2",
                        ongoing: "Trwający",
                        both: "Oba",
                        days: "Dni",
                        today: "Dzisiaj",
                        sendAnswers: "Wyślij odpowiedzi",
                        employee: "Pracownik",
                        customer: "Klient",
                        sales: "Sprzedaż",
                        technician: "Technik",
                        admin: "Administrator",
                        noDateKnown: "Brak daty",
                        command: "Polecenie",
                        user: "Użytkownik",
                        fillInSurvey: "Proszę wypełnić ankietę",
                        tons: "tona",
                        count: "Liczba",
                        disabled: "Wyłączony",
                        addField: "Dodaj pole",
                        deleteField: "Usuń pole",
                        releases: "Wydania",
                        open: "Otwórz",
                        close: "Zamknij",
                        opening: "Otwieranie",
                        closing: "Zamykanie",
                        zoomCancel: "Zoom anulowany, pozostań wewnątrz wykresu, aby powiększyć",
                        stuck: "Zablokowany"
                    },
                    errorPage: {
                        title: "Coś poszło nie tak.",
                        contact: "Zgłoś ten problem na it@biolectric.com i podaj, jakiego telefonu lub przeglądarki używasz.",
                        reload: "Przeładuj"
                    },
                    popups: {
                        engineIdle: "Silnik nie jest na biegu jałowym, proszę najpierw wyłączyć silnik",
                        valueBetween: "Wartość musi być pomiędzy {{min}} a {{max}}",
                        valueBetweenCustom: "Wartość musi być pomiędzy {{min}} a {{max}}",
                        powerTooLow: "Moc nie może być ustawiona poniżej {{watts}}W",
                        powerTooHigh: "Moc nie może być ustawiona powyżej {{maxPower}}",
                        maxCoolingTemp: "Nie może być wyższa niż {{max}}°C",
                        minValue: "Nie może być mniejsza niż {{min}}",
                        maxAirInjectionTime: "Nie może być dłuższy niż {{max}} sekund",
                        minGasBuffer: "Minimalny bufor gazu poza zakresem. Minimalna wartość dla twojej instalacji to {{min}}",
                        maxGasBuffer: "Maksymalny bufor gazu poza zakresem. Maksymalna wartość dla twojej instalacji to {{max}}",
                        reactorTemp: "Temperatura reaktora poza zakresem. Musi być pomiędzy {{min}} a {{max}}",
                        reactorLevel: "Nieprawidłowy poziom reaktora. Maksymalna wartość dla twojej instalacji to {{limit}}",
                        reactorLevelRange: "Wartość poziomu reaktora musi być pomiędzy {{min}} a {{max}}",
                        commandFailed: "Nie udało się wysłać polecenia",
                        commandSent: "Polecenie wysłane",
                        commandSuccess: "Pomyślnie zaktualizowano {{command}} z {{previousValue}} na {{value}}",
                        commandMix1Hour: "Mieszadło będzie pracować przez 1 godzinę",
                    },
                    menu: {
                        dashboard: 'Panel',
                        machines: 'maszyny',
                        questionnaires: 'Kwestionariusze',
                        banners: "Banery",
                        errors: "Błędy i ostrzeżenia",
                        pcb: "Płytki drukowane",
                        tasks: "Moje zadania",
                        releases: "Opis zmian",
                        resellers: "Sprzedawcy",
                        users: "Użytkownicy",
                        recommendations: "Zalecenia",
                        suggestions: "Wiadomości zaleceń",
                        faultTrees: "Drzewa bledow",
                        assistant: "Asystent",
                        language: "Język",
                        reconnection: "Ta maszyna jest obecnie offline. Spróbuj nawiązać nowe połączenie za pomocą przycisku powyżej.",
                        profile: "Profil",
                        logout: "Wyloguj się",
                        firmware: "Oprogramowanie",
                        sms: "SMS",
                        advanced: "Zaawansowane",
                        errorsSingle: "Błędy",
                        warnings: "Ostrzeżenia"
                    },
                    statistics: {
                        label: "Statystyki",
                        foamBeaterThermalStatus: "Termik ubijaczki piany",
                        exitPumpThermalStatus: "Termik pompy wylotowej",
                        thermalStatusOk: "Termik nieaktywny, odbiornik może działać normalnie",
                        thermalStatusFault: "Termik aktywny, odbiornik w stanie błędu",
                        group1: "Grupa 1",
                        group2: "Grupa 2",
                        addProperty: "Dodaj właściwość",
                        removeProperty: "Usuń właściwość",
                        startTutorial: "Rozpocznij samouczek",
                        exitTutorial: "Wyjdź ze samouczka",

                        welcomeStep: {
                            title: "Witaj na stronie statystyk",
                            content: "Tutaj możesz łatwo porównywać różne wartości i trendy."
                        },
                        propertyStep: {
                            title: "Wybór właściwości",
                            content: "Aby rozpocząć, po prostu wybierz właściwość, która cię interesuje z listy rozwijanej."
                        },
                        addPropertyStep: {
                            title: "Dodawanie i usuwanie właściwości",
                            content: "Spróbuj dodać lub usunąć właściwość. Możesz dodać maksymalnie 4 właściwości na grupę."
                        },
                        groupStep: {
                            title: "Włączenie grupy 2",
                            content: "Kliknij przycisk 'Dodaj właściwość', aby wybrać właściwość do Grupy 2. Właściwości w tej grupie będą wyświetlane po prawej stronie wykresu."
                        },
                        dateRangeStep: {
                            title: "Wybór zakresu dat",
                            content: "Użyj tego przycisku, aby wybrać zakres dat."
                        },
                        zoomInStep: {
                            title: "Powiększanie",
                            content: "Przeciągnij myszką po wykresie, aby wybrać obszar do powiększenia."
                        },
                        zoomOutStep: {
                            title: "Pomniejszanie",
                            content: "Zresetuj poprzednio wybrany zakres dat, używając przycisku 'Pomniejszanie'."
                        },
                        domainStep: {
                            title: "Dostosowanie dziedzin",
                            content: "Możesz dostosować maksymalną i minimalną dziedzinę na grupę, używając tych przycisków."
                        },
                        csvStep: {
                            title: "Pobierz dane CSV",
                            content: "Pobierz aktualnie wyświetlane dane wykresu w formacie CSV."
                        },
                        imageStep: {
                            title: "Pobierz obraz",
                            content: "Pobierz aktualnie wyświetlany wykres jako obraz."
                        },
                        configurationStep: {
                            title: "Konfiguracja predefinicji",
                            content: "Możesz zapisać swoją bieżącą konfigurację jako predefinicję. Możesz także zaktualizować lub usunąć istniejące predefinicje."
                        },
                        controlCardTemp: "Temperatura karty sterowania",
                        lowTensionError: "Błąd niskiego napięcia",
                        overTempFlueGasHeatExch: "Przekroczenie temperatury wymiennika ciepła gazów spalinowych",
                        feedingCycleLevel: "Poziom cyklu karmienia",
                        batteryVoltage: "Napięcie baterii",
                        waterPressure: "Ciśnienie wody",
                        shortInterval: "Interwały 10 minut",
                        dailyInterval: "Codzienne interwały",
                        configurationUpdated: "Twoja bieżąca konfiguracja została zapisana jako ta predefinicja",
                        presets: "Predefinicje",
                        savePreset: "Zapisz jako predefinicję",
                        applyPreset: "Zastosuj predefinicję",
                        updatePreset: "Aktualizuj predefinicję",
                        delete: "Usuń",
                        noPresets: "Nie masz jeszcze żadnych predefinicji",
                        givePresetName: "Podaj nazwę predefinicji",

                    },
                    smart: {
                        label: "Smart",
                        heightOffset: "Wysokość przesunięcia",
                        active: "Aktywny",
                        passive: "Pasywny",
                        preActive: "Przedaktywny",
                        prePassive: "Przepasywny",
                        postActive: "Poaktywny",
                        postPassive: "Popasywny",
                        activeDesc: "Podczas aktywnego okresu planowana produkcja energii jest maksymalizowana. Przed każdym aktywnym okresem automatycznie przewidziany jest okres 'przedaktywny', podczas którego bufor gazu jest budowany. Maksymalny czas trwania aktywnego okresu jest określany przez objętość bufora gazu, liczbę i rodzaj zainstalowanych jednostek kogeneracji oraz profil produkcji biogazu w instalacji. Gdy osiągnięty zostanie minimalny poziom napełnienia bufora gazu, produkcja energii zostanie zatrzymana (okres poaktywny).",
                        passiveDesc: "Podczas pasywnego okresu energia jest produkowana tylko w przypadku nadmiaru gazu. Przed każdym pasywnym okresem automatycznie przewidziany jest okres, podczas którego bufor gazu jest redukowany. Maksymalny czas trwania pasywnego okresu jest określany przez objętość bufora gazu oraz profil produkcji biogazu w instalacji. Gdy osiągnięty zostanie maksymalny poziom napełnienia bufora gazu, rozpocznie się produkcja energii (okres popasywny).",
                        permanence: "Stymulowanie stałej produkcji przez dynamiczne działanie na jednym silniku przy nie maksymalnym buforze gazu",
                        permanency: "Trwałość",
                        activateStep: {
                            title: "Aktywacja SMART",
                            content: "Aktywuj SMART, aby kontrolować profil produkcji instalacji"
                        },
                        timeslotStep: {
                            title: "Dodaj przedział czasowy",
                            content: "Dodaj aktywny lub pasywny przedział czasowy"
                        },
                        fromToStep: {
                            title: "Od / Do",
                            content: "Ustaw zarówno dzień rozpoczęcia, zakończenia oraz godzinę"
                        },
                        activePassiveStep: {
                            title: "Aktywny lub Pasywny",
                            content: "Wybierz, czy chcesz ustawić aktywny czy pasywny przedział czasowy"
                        },
                        saveStep: {
                            title: "Zapisz przedziały czasowe",
                            content: "Zapisz wprowadzone zmiany"
                        },
                        removeStep: {
                            title: "Usuń przedziały czasowe",
                            content: "Usuń swój przedział czasowy tutaj"
                        },
                        visualStep: {
                            title: "Reprezentacja wizualna",
                            content: "Ten wykres porównuje ustawienia SMART z profilem produkcji z ostatniego tygodnia"
                        },
                        daySwitchStep: {
                            title: "Reprezentacja wizualna",
                            content: "Łatwo nawiguj do następnego lub poprzedniego dnia"
                        },
                    },
                    gas: {
                        label: "Gaz",
                        minGasBufferLevel: "Min. poziom gazu",
                        maxGasBufferLevel: "Maks. poziom gazu",
                        gasBufferLevel: "Aktualny poziom gazu",
                        defaultMinGasBufferLevel: "Domyślny min poziom gazu",
                        defaultMaxGasBufferLevel: "Domyślny max poziom gazu",
                        airInjectionTime: "Poziom napowietrzenia",
                        maxAirInjectionTime: "Maks. napowietrzanie",
                        torch: "Flare",
                        torchType: "Flare type",
                        torchStatus: "Flare status",
                        torchError: "Flare silnika",
                        theoreticalTorchFlow: "Teoretyczny przepływ pochodni",
                        torchRunningTime: "Czas pracy pochodni",
                        torchFlaredVolume: "Spalona objętość",
                        h2s: "H₂S",
                        h2sLevelReactor: "H₂S w reaktorze",
                        h2sLevelMotor: "H₂S Silnik",
                        filterLoad: "Poziom wykorzystania filtra",
                        sample: "Próbka",
                        latestH2sReadings: "Ostatnie pomiary H₂S",
                        carbonFilterSize: "Rozmiar filtra węglowego",
                        h2sMeasurements: "Pomiary H₂S",
                        measurements: "Pomiary",
                        changeTo: "Zmień na",
                        none: "Brak",
                        container: "Pojemnik",
                        extern: "Zewnętrzny",
                        foamBeaterInstalled: "Ubijaczka do piany",
                        antiFoamInjectionsInstalled: "Wtryski na antyspieniacz",
                        containerCombinedOperation: "Kontener (operacja łączona)",
                        externCombinedOperation: "Zewnętrzny (operacja łączona)",
                        gasTemp: "T1 Temperature After Gascooler",
                        ch4BiogasSupply: "Dopływ biogazu CH4",
                        co2BiogasSupply: "Dopływ biogazu CO2",
                        o2BiogasSupply: "Dopływ biogazu O2",
                        h2sAfterFilter: "H2S po filtrze",
                        biomethaneFlowNorm: "Znormalizowany przepływ biometanu",
                        ch4Biomethane: "CH4 biometan",
                        co2Biomethane: "CO2 biometan",
                        o2Biomethane: "O2 biometan",
                        h2sBiomethane: "H2S biometan",
                        bufferRelease: "Uwolnienie bufora",
                        wobbe: "Wskaźnik Wobbe",
                        wobbeAvg: "Średni wskaźnik Wobbe",
                        wobbePidSetpoint: "Wartość zadana PID wskaźnika Wobbe",
                        wobbeBiomethanePronova: "Wskaźnik Wobbe biometanu Pronova",
                    },
                    engine: {
                        label: "silnik",
                        startEngine: "Włącz silnik",
                        stopEngine: "Wyłącz silnik",
                        power: "Moc",
                        desiredPower: "Ustawiona moc",
                        maxPower: "Maks. moc",
                        rpm: "RPM",
                        lambda: "Lambda",
                        throttleValve: "Pozycja serwomechanizmu	",
                        engineType: "Typ silnika",
                        engineStatus: "Status silnika",
                        engineError: "Błędy silników",
                        producedEnergy: "Produkcja zielonej energii",
                        operatingHours: "Liczba godzin",
                        totalOperatingHours: "Całkowity czas pracy",
                        gasUsage: "Zużycie gazu",
                        throttlePosition: "Pozycja przepustnicy",
                        noErrors: "Wszystkie systemy działają poprawnie.",
                        production: "Produkcja",
                        servoAuto: "Serwo jest ustawiane automatycznie",
                        servoControl: "Kontrola serwomechanizmu",
                        temperature: "Temperatura silnika",
                        restart: "Automatycznie ponowne uruchomienie, gdy ilość gazu będzie wystarczająca",
                        confirmStop: "Czy na pewno chcesz zatrzymać silnik {{number}}?",
                        confirmStopRestart: "Czy na pewno chcesz zatrzymać silnik {{number}}? Uruchomi się ponownie automatycznie, gdy gaz będzie dostępny.",
                        idle: "Bezczynność",
                        running: "Uruchomiony",
                        waiting: "Oczekiwanie na uruchomienie",
                        booting: "Uruchamianie",
                        shuttingDown: "Wyłączanie",
                        advanced: "Zaawansowane",
                        numberOfEngines: "Liczba silników",
                        predeterminedRunHours: "Określone godziny pracy",
                        easyStart1: "Easy start silnika 1",
                        easyStart2: "Easy start silnika 2",
                        setError1: "Ustaw błąd silnika 1",
                        setError2: "Ustaw błąd silnika 2",
                        fuel: "Paliwo",
                        airIntakeOpen: "Wlot powietrza otwarty",
                        airIntakeClosed: "Wlot powietrza zamknięty",
                        vfd: "VFD",
                    },
                    service: {
                        label: "Konserwacja",
                        lastMaintenance: "Godziny pracy do następnej wymiany oleju",
                        currentlyInstalled: "Przepracowana ilość godzin",
                        total: "Łączna liczba godzin pracy",
                        mixer: "Mikser",
                        foam_beater: "Ubijak piany",
                        intake_pump: "Pompa ssąca",
                        digestate_pump: "Pompa odwadniania",
                        newMixer: "Nowy mikser zainstalowany",
                        newEngine: "Nowy silnik zainstalowany",
                        newFoamBeater: "Nowy ubijak piany zainstalowany",
                        newIntakePump: "Nowa pompa ssąca zainstalowana",
                        newDigestatePump: "Nowa pompa odwadniania zainstalowana",
                        confirmationMessage: "Czy na pewno chcesz zresetować {{type}}",
                        maintenanceMessage: "Godziny konserwacji zostały zresetowane dla {{type}}",
                        newEquipmentMessage: "Nowy sprzęt zainstalowany:",
                        prints: "Prints",
                        firstOnline: "Pierwsze online",
                        lastOnline: "Ostatnie online",
                        serial: "Numer seryjny",
                        type: "Typ",
                        engine: "Silnik",
                        engine1: "Silnik 1",
                        engine2: "Silnik 2",
                        engine_new1: "Silnik 1",
                        engine_new2: "Silnik 2",
                        h2s1: "Silnik H₂S 1",
                        h2s2: "Silnik H₂S 2",
                        resetTo: "Resetuj do x godzin (domyślnie 0)",
                        timeFilterReplace: "Czas od wymiany filtra",
                        daysSinceOil: "Dni od wymiany oleju",
                        newGenerator: "Przekaźnik monitorujący",
                        generator: "Generator",
                        generator1: "Generator 1",
                        generator2: "Generator 2",
                        daysSinceOilChange: "Dni od wymiany oleju",
                        videoMessage: "Film o wymianie oleju => Strona Dokumenty, w sekcji Filmy ogólne.",
                        videoRoom: "Technik serwisowy otworzył pokój wideo dla tej maszyny. Kliknij tutaj, aby dołączyć.",
                        videoButton: "Rozpocznij pokój wideo dla tej maszyny",
                        videoButtonSub: "Użytkownicy z dostępem mogą dołączyć do połączenia z ich strony serwisowej.",
                        videoClose: "Zamknij pokój wideo",
                        serialNumber: "Numer seryjny",
                        defaultEngineReset: "Domyślne resetowanie silnika",
                        newInstalled: "Nowy {{type}} zainstalowany",
                        replace: "Wymień",
                        aircover: "Osłona powietrzna",
                        gascover: "Osłona gazu",
                        liner: "Podkład",
                        flow_meter: "Miernik przepływu",
                        energy_meter1: "Miernik energii 1",
                        energy_meter2: "Miernik energii 2",
                        energy_meter_own: "Licznik energii własne zużycie",
                        h2sPastille: "Czas do wymiany czujnika H2S",
                        pastille1: "Czujnik H₂S 1",
                        pastille2: "Czujnik H₂S 2",
                        engineLabel: "Następna konserwacja silnika za “XX” godzin",
                        engine1Conf: "Zresetuj interwał konserwacji silnika 1 tylko po wykonaniu konserwacji",
                        engine2Conf: "Zresetuj interwał konserwacji silnika 2 tylko po wykonaniu konserwacji",
                        h2s1Conf: "Zresetuj H2S Silnik 1 tylko po wymianie węgla aktywnego w filtrze",
                        h2s2Conf: "Zresetuj H2S Silnik 2 tylko po wymianie węgla aktywnego w filtrze",
                        filterResetOffline: "Maszyna jest offline. Reset filtra nie został zapisany. Połącz ponownie i spróbuj jeszcze raz.",
                        filterResetFailed: "Reset filtra nie powiódł się. Reset filtra nie został zapisany.",
                        consumables: {
                            title: "Materiały eksploatacyjne",
                            belowMin: "Poniżej stanu minimalnego",
                            noneBelow: "Brak artykułów poniżej stanu minimalnego",
                            notCounted: "Jeszcze nie policzono",
                            article: "Numer artykułu",
                            description: "Opis",
                            onSite: "Na miejscu",
                            minimum: "Minimum",
                            engineMaintenance: "Konserwacja silnika",
                            pendingStock: "{{confirmed}} potwierdzone + {{pending}} oczekuje na weryfikację",
                            send: "Wyślij",
                            shipmentSaved: "Wysyłka zapisana. Pozostaje oczekująca, aż klient potwierdzi.",
                            shipmentFailed: "Nie udało się zapisać wysyłki",
                            confirm: "Potwierdź odbiór",
                            confirmSaved: "Stan potwierdzony",
                            confirmFailed: "Nie udało się potwierdzić stanu",
                            confirmHint: "Potwierdź dostawę, aby doliczyć ją do stanu na miejscu.",
                            guideTitle: "Jak to działa",
                            guideIntro: "Olej, filtry oleju i świece zostają na każdej instalacji. Strona serwisowa instalacji i ta strona zamówień korzystają z tego samego stanu.",
                            guide1Role: "Technik",
                            guide1Title: "Policz, co jest na miejscu",
                            guide1Body: "Na stronie serwisowej instalacji otwórz Materiały eksploatacyjne i wpisz, ile każdego artykułu naprawdę jest. Ten stan jest od razu potwierdzony. Liczenie na miejscu nie czeka na nikogo innego.",
                            guide2Role: "Automatycznie",
                            guide2Title: "Przegląd silnika zużywa stan",
                            guide2Body: "Rejestracja przeglądu silnika odejmuje zużycie tego silnika od potwierdzonego stanu. Przegląd WG1605 zużywa 0,28 kanistra oleju 25 l, 1 filtr oleju i 4 świece. WG972 i WG3800 używają ilości z tabeli konserwacji silnika. Dzieje się to, gdy instalacja ma rekord statystyk z typem silnika.",
                            guide3Role: "Kierownik serwisu",
                            guide3Title: "Wyślij to, czego brakuje",
                            guide3Body: "Ta strona pokazuje instalacje, których potwierdzony stan jest mniejszy lub równy minimum. Wpisz ilość do wysyłki i naciśnij Wyślij. Zostaje oczekująca, na przykład 0,5 potwierdzone + 5 oczekuje na weryfikację, i jeszcze nie liczy się jako stan. Minimum ustawia się dla typu silnika. Instalacja używa sumy zainstalowanych silników, zaokrąglonej do liczby całkowitej. Jedna sztuka oleju to kanister 25 l.",
                            guide4Role: "Każdy z dostępem",
                            guide4Title: "Potwierdź dostawę",
                            guide4Body: "Gdy towar jest na miejscu, klient, technik lub pracownik potwierdza odbiór na stronie serwisowej instalacji. Ilość oczekująca jest dodawana do potwierdzonego stanu. 0,5 potwierdzone i 5 oczekujące staje się wtedy 5,5 na miejscu.",
                            correction: "Korekta stanu",
                            save: "Zapisz stan magazynowy",
                            saved: "Stan magazynowy zapisany",
                            saveFailed: "Nie udało się zapisać stanu magazynowego",
                            minSaved: "Stan minimalny zapisany",
                            minFailed: "Nie udało się zapisać stanu minimalnego",
                            minHint: "Ustaw minimum dla typu silnika. Instalacja używa sumy zainstalowanych silników, zaokrąglonej do liczby całkowitej. Pojawia się, gdy stan jest mniejszy lub równy temu minimum. Jedna sztuka oleju to kanister 25 l.",
                            usage: "Zużycie na przegląd silnika",
                            usageHint: "Rejestracja przeglądu silnika odejmuje to zużycie od policzonego stanu. DF972 i WG972 korzystają z kolumny WG972. WG3800-L korzysta z kolumny WG3800.",
                            orders: "Zamówienia do uruchomienia",
                            ordersEmpty: "Brak instalacji na poziomie lub poniżej stanu minimalnego",
                            shortage: "Brak",
                            installation: "Instalacja",
                            engines: "Silniki",
                        },
                        pastille1Conf: "Zresetuj żywotność czujnika H2S 1 tylko po wymianie elementu czujnika.",
                        pastille2Conf: "Zresetuj żywotność czujnika H2S 2 tylko po wymianie elementu czujnika.",
                        pastilleLabel: "Przewidywana żywotność elementu czujnika XX dni",
                        valve_interval: "Godziny pracy do kontroli luzu zaworowego",
                        cylinder_interval: "Godziny pracy do przeglądu głowicy cylindra",
                        valve_interval_engine1: "Godziny pracy do kontroli luzu zaworowego silnika 1",
                        cylinder_interval_engine1: "Godziny pracy do przeglądu głowicy cylindra silnika 1",
                        valve_interval_engine2: "Godziny pracy do kontroli luzu zaworowego silnika 2",
                        cylinder_interval_engine2: "Godziny pracy do przeglądu głowicy cylindra silnika 2",
                        pipe: "Rura",
                        transmitter: "Nadajnik",
                        elektromotor: "Silnik elektryczny",
                        pump: "Pompa",
                        roofsolation: "Izolacja dachu",
                        airPump: "Pompa wtrysku powietrza",
                        oxygenConcentrator: "Koncentrator tlenu",
                        flowmeterBiogas: "Przepływomierz biogazu",
                        pronovaBiomethaan: "ProNova biometan",
                        pronovaBiogas: "ProNova biogaz",
                        h2s1Gpi: "Filtr węglowy 1",
                        h2s2Gpi: "Filtr węglowy 2",
                        coolant: "Płyn chłodzący",
                        daysSinceCoolantReplace: "Dni od wymiany",
                        coolantConf: "Resetuj godziny pracy płynu chłodzącego dopiero po jego wymianie",
                        daysSinceInhibitor: "Dni od pakietu inhibitorów",
                        inhibitorPackage: "Pakiet inhibitorów",
                        registerInhibitor: "Zarejestruj",
                        inhibitorConf: "Rejestruj dopiero po uzupełnieniu płynu chłodzącego pakietem inhibitorów (co 12 miesięcy)",
                        restoreValues: {
                            button: "Przywróć wartości PLC",
                            title: "Przywróć wartości PLC",
                            description: "Wybierz dzień z ostatnich 7 dni, który wygląda poprawnie, sprawdź wstępnie wypełnione wartości i wyślij je do PLC.",
                            pickDay: "Wybierz dzień",
                            snapshotTime: "Czas próbki",
                            noSnapshots: "Nie znaleziono statystyk z ostatnich 7 dni.",
                            send: "Wyślij",
                            sendAll: "Wyślij wszystko",
                            sending: "Wysyłanie…",
                            confirmSendAll: "Wysłać wszystkie wstępnie wypełnione wartości do PLC?",
                            sendAllDone: "Wysłano {{count}} wartości do PLC",
                            emptyValue: "Wartość jest pusta",
                            invalidValue: "Wartość nie jest liczbą",
                            invalidEngineCount: "Liczba silników musi wynosić 1 lub 2",
                            noConnection: "Maszyna nie ma aktywnego połączenia",
                            readOnly: "tylko do odczytu",
                            fromMachine: "z rekordu maszyny",
                            current: "Teraz",
                            currentHint: "Aktualna wartość slow/fast na CU",
                            ups: "UPS",
                            groupEngines: "Silniki",
                            groupReactor: "Reaktor i mieszanie",
                            groupFeeding: "Karmienie",
                            groupGas: "Gaz",
                            groupEnergy: "Liczniki energii",
                            groupSsr: "SSR",
                        },
                        tabs: {
                            engine: "Silnik",
                            reactor: "Reaktor / Kontener",
                            gas: "Gaz / Oczyszczanie",
                            consumables: "Materiały eksploatacyjne",
                            options: "Opcje maszyny",
                            prints: "Wydruki",
                            restoreValues: "Przywróć wartości PLC",
                        },
                    },
                    net: {
                        net: "Sieć elektryczna",
                        meterSettings: "Ustawienia miernika",
                        voltagePerPhase1: "Napięcie na fazę (1)",
                        voltagePerPhase2: "Napięcie na fazę (2)",
                        voltagePerPhase3: "Napięcie na fazę (3)",
                        frequencyPerPhase: "Częstotliwość na fazę",
                        angleBetweenPhase1And2: "Kąt pomiędzy fazą 1 i 2",
                        ownPowerConsumption: "Bieżące zużycie energii",
                        ownEnergyConsumption: "Zużycie energii na potrzeby własne",
                        bioguardVersion: "Wersja bioguard",
                        brutoProducedEnergy: "Wyprodukowana energia brutto",
                        nettoProducedEnergy: "Wyprodukowana energia netto",
                        producedEnergy: "Wyprodukowana energia",
                        producedEnergyEngine1: "Wyprodukowana energia silnik 1",
                        producedEnergyEngine2: "Wyprodukowana energia silnik 2",
                        monitoringRelay: "Przekaźnik monitorujący",
                        powerNonFit: "Własne zużycie energii bez FIT",
                        energyMeterNonFit: "Miernik własnego zużycia energii bez FIT",
                    },
                    reactor: {
                        label: "Reaktor",
                        reactorTemp: "Temperatura reaktora",
                        reactorTempTarget: "Docelowa temperatura reaktora",
                        reactorLevel: "Ustawiony poziom",
                        hydrostaticPressure: "Aktualny poziom reaktora",
                        siloType: "Typ reaktora",
                        extraHeating: "Dodatkowe ogrzewanie",
                        antiFrost: "Sterowanie indeksem mrozu",
                        antiFrostIndex: "Indeks Sterowanie indeksem mrozu",
                        antiFrostAuto: "Wskaźnik zamarzania jest ustawiany automatycznie na podstawie temperatury lokalnej",
                        antiFrostMessageNew: "Każdy cykl zabezpieczenia przed zamarzaniem uruchomi pompę zasilania gnojowicą na 4 s, a pompa do pofermentu wypompuje ok. 100 l, w zależności od ustawionego parametru.",
                        antiFrostMessageOld: "Każdy cykl wskaźnika mrozu aktywuje pompę karmiącą na 4 sekund, a pompę do pofermentu na 120 sekund.",
                        coolwater: "Woda chłodząca",
                        statusCoolingValve: "Zawór obiegu chłodzącego",
                        waterTempIn: "Temperatura wody wchodzącej do reaktora",
                        waterTempOut: "Temperatura wody wychodzącej z reaktora",
                        waterTempMotorOut: "Temperatura wody wychodzącej z silnika 1",
                        waterTempMotorOut2: "Temperatura wody wychodzącej z silnika 2",
                        coolingWaterTemp: "Ustawienia temperatury obiegu chłodzącego",
                        maxCoolingWaterTemp: "Limit temperatury obiegu chłodzącego",
                        waterPressure: "Ciśnienie wody w obiegu chłodzenia",
                        foamBeater: "Piana",
                        foambeatEveryXMinutes: "Rozbijaj pianę co",
                        foambeatForXSeconds: "Przez",
                        mixer: "Mieszadło",
                        mixerMaxPower: "Maksymalna moc miksera",
                        mixerActive: "Status mieszadła",
                        mixerBlockedLowLevel: "Mieszadło zablokowane z powodu niskiego poziomu reaktora",
                        mixEveryXMinutes: "Mieszaj co",
                        mixForXSeconds: "Przez",
                        blockMixingFrom: "Brak mieszania od",
                        blockMixingTo: "Do",
                        mixerInfo: "Mikser włącza się automatycznie na wybrany czas z wybranym przedziałem czasowym. W oknie czasowym blokady mieszacza mieszacz jest zatrzymywany, gdy moc zainstalowana mieszacza przekroczy aktualną moc wytwarzaną przez instalację. Mikser jest tymczasowo zatrzymywany podczas rozruchu CHP do momentu osiągnięcia 50% mocy znamionowej, aby umożliwić prąd rozruchowy",
                        mixerInfoGpi: "Mikser włącza się automatycznie na wybrany czas z wybranym przedziałem czasowym. W oknie czasowym blokady mieszacza mieszacz jest zatrzymywany, gdy moc zainstalowana mieszacza przekroczy aktualną moc wytwarzaną przez instalację.",
                        mix1Hour: "Mieszaj 1 godz",
                        coolwaterValveInstalled: "Regulowany zawór trójdrożny",
                        coolwaterValveBinary: "Binarny zawór trójdrożny",
                        coolwaterValveMaximizeHeat: "Maksymalizacja wykorzystania ciepła",
                        coolwaterValveMaximizeHeatInfo: "Maksymalizacja wykorzystania ciepła może powodować okresy bez dostępności ciepła na płytowym wymienniku ciepła",
                        coolwaterValvePlatePriority: "Priorytet płytowego wymiennika ciepła",
                        coolwaterValvePlatePriorityInfo: "Priorytetyzuj dostępność ciepła na płytowym wymienniku ciepła przy zachowaniu stabilnej temperatury fermentora",
                        bypassFan: "Obejście zaworu sterującego / wentylator",
                        digester: "Zawór sterujący komory fermentacyjnej / zewnętrzne zużycie ciepła ",
                        silo: "Silo",
                        bag: "Worek",
                        plateHeatExchanger: "Płytowy wymiennik ciepła",
                        timesPerDay: "razy / dzień",
                        intern: "Wewnętrznie",
                        extern: "Zewnętrznie",
                        tempHigh: "Wysoka temperatura",
                        externMessage: "Następujący błąd nie zostanie wywołany, jeśli mikser jest ustawiony na zewnętrzny: Mikser nie działa, proszę zresetować termicznie.",
                        bypass: "Obejście",
                        ventilator: "Wentylator",
                        tempCoolHeatExchOut: "Temperatura wody wychodzącej z wymiennika ciepła",
                        overtempMixer1: "Przegrzanie mieszalnika 1",
                        overtempMixer2: "Przegrzanie mieszalnika 2",
                        mixerSettings: "Ustawienia mieszalnika",
                        premixing: "Wstępne mieszanie",
                        intakeMixing: "Mieszanie przy poborze",
                        premixingInfo: "Wstępne mieszanie to mieszanie przed karmieniem, czyli przed i podczas wypompowywania. Czas zawsze odnosi się do czasu mieszania.",
                        intakeMixingInfo: "Mieszanie przy poborze pozwala mieszać jednocześnie z poborem. Przy OFF mieszanie nie jest wykonywane, gdy karmienie trwa.",
                        gpiMixDuringIntake: "Mieszanie podczas karmienia płynnego",
                        gpiMixDuringIntakeInfo: "Mieszanie przez cały okres karmienia płynnego.",
                        gpiMixDuringIntakeHelp: "Mieszanie podczas karmienia płynnego: mieszanie przez cały okres karmienia. Przy OFF: zależy od typu silosu.\n\nTypy S: tylko wstępne mieszanie podczas wypompowywania i mieszanie po karmieniu przez czas mieszalnika.\n\nTypy C: brak wstępnego mieszania; mieszanie po karmieniu przez czas mieszalnika.",
                        gpiMixDuringIntakeOffGeneric: "Przy OFF: zależy od typu silosu.",
                        gpiMixDuringIntakeOffS: "Typy S: tylko wstępne mieszanie podczas wypompowywania i mieszanie po karmieniu przez czas mieszalnika.",
                        gpiMixDuringIntakeOffC: "Typy C: brak wstępnego mieszania; mieszanie po karmieniu przez czas mieszalnika.",
                        gpiMixDuringSolidFeedIntake: "Mieszanie podczas karmienia stałego",
                        gpiMixDuringSolidFeedIntakeInfo: "Przy ON: mieszanie przez całe karmienie stałe. Przy OFF: mieszanie tylko przed i po karmieniu stałym, każdorazowo przez czas (w sekundach) ustawiony w „{{durationSetting}}”.",
                        gpiMixTimeBeforeAfterSolidIntake: "Czas mieszania przed/po karmieniu stałym",
                    },
                    efficiency: {
                        label: "Sprawność",
                        production: "Produkcja energii w ostatnich 30 dniach",
                        consumption: "Zużycie energii w ostatnich 30 dniach",
                        nettoProduction: "Produkcja energii netto w ostatnich 30 dniach",
                        averageEfficiency: "Średnia sprawność w ostatnich 30 dniach",
                        averageTechnicalEfficiency: "Średnia dostępność techniczna w ostatnich 30 dniach",
                        bgp: "Jakość obornika (BGP batch)",
                        top10: "Top 10 najlepszych biogazowni z ostatniego miesiąca",
                        realised: "Zrealizowana wydajność",
                        technical: "Dostępność techniczna",
                        bgpInfo: "Szacowane BGP (Ocena Potencjału Biogazu) [m³/tonę]. Nie uwzględnia strat spowodowanych przestojami, nadprodukcją lub zużyciem biogazu przez flarę.",
                        pointPerDay: "%/dzień",
                        trendline: "Linia trendu",

                    },
                    general: {
                        label: "Ogólne",
                        hardwareVersion: "Wersja sprzętu",
                        otGenContact: "Kontakt OT Gen",
                        engine1And2Off: "Silnik 1 i 2 wyłączone",
                        engine1On: "Silnik 1 włączony",
                        engine2On: "Silnik 2 włączony",
                        engine1And2On: "Silnik 1 i 2 włączone",
                        notes: "Notatki",
                        h2sSensorFirmwareVersion: "Wersja oprogramowania czujnika H₂S",
                        idH2s: "S/N ID H₂S",
                        bioId: "S/N ID Biotronic",
                        identifier: "Identyfikator instalacji",
                        collabContract: "Umowa o współpracy",
                        own: "Umowa serwisowa",
                        sold: "Sprzedana instalacja",
                        productionDate: "Data produkcji",
                        commissioningDate: "Data uruchomienia",
                        controlCardTemp: "Temperatura karty sterującej",
                        batteryVoltage: "Napięcie baterii",
                        motorVoltage: "Napięcie silnika",
                        overtempFlueGasHeatExch: "Przegrzanie silnika wymiennika ciepła spalin",
                        rebootMainBoard: "Restartuj płytę główną",
                        rebootNow: "Zrestartuj teraz",
                        utcOffset: "Offset UTC",
                        location: "Lokalizacja",
                        network: "Sieć",
                        ip: "IP",
                        mask: "Maska",
                        gateway: "Brama",
                        dns: "DNS",
                        pcb: "PCB",
                        firmware: "Oprogramowanie",
                        mainControlUnit: "Główna jednostka sterująca",
                        bioguard: "Bioguard",
                        biotronicEngine1: "Silnik Biotronic 1",
                        biotronicEngine2: "Silnik Biotronic 2",
                        h2sEngine1: "Silnik H₂S 1",
                        h2sEngine2: "Silnik H₂S 2",
                        bioIdEngine1: "Silnik Bio ID 1",
                        bioIdEngine2: "Silnik Bio ID 2",
                        modificationsToMachine: "Modyfikacje maszyny",
                        name: "Nazwa",
                        hostNameFirmware: "Firmware",
                        hostNameDatabase: "Baza danych",
                        normal: "Normalny",
                        lowError: "Niski (błąd)",
                        nta8080Title: "Raport NTA 8080",
                        nta8080Description: "Pobierz miesięczny raport NTA 8080. Dane są ładowane dopiero po żądaniu raportu.",
                        nta8080Month: "Miesiąc",
                        nta8080Download: "Pobierz raport",
                        nta8080DownloadPdf: "Pobierz PDF",
                        nta8080DownloadCsv: "Pobierz CSV",
                        nta8080Loading: "Przygotowywanie…",
                        nta8080SelectMonth: "Najpierw wybierz miesiąc",
                        nta8080InvalidMonth: "Wybrano nieprawidłowy miesiąc",
                        nta8080DownloadError: "Nie udało się pobrać raportu",
                    },
                    feeding: {
                        label: "Karmienie",
                        feedingVolume: "Maksymalna objętość świeżego karmienia na cykl",
                        feedingCyclesPerDay: "Liczba cykli na dzień",
                        feedingCyclesPerDayInfo: "Objętość wypompowana mniejsza niż 75% żądanej objętości powoduje błąd karmienia „brak przepływu przy poborze świeżego obornika”. Objętość wypompowana od 75% do 100% żądanej objętości powoduje komunikat „Cykl karmienia częściowo wykonany. Wykryto pustą jamę przed osiągnięciem ustawionej objętości”.",
                        feedingBalance: "Bilans karmienia",
                        autoFeedingActive: "Automatyczne karmienie",
                        blockHighElectricalConsumption: "Blokuj ogrzewanie fermentora pompą ciepła podczas okna mieszania",
                        blockHighElectricalConsumptionInfo: "Przy ON: ogrzewanie fermentora pompą ciepła jest blokowane podczas okna mieszania. Przy OFF: brak blokady.",
                        minimizeElectricalConsumptionFrom: "Minimalizuj zużycie energii od",
                        minimizeElectricalConsumptionTo: "do",
                        autoFeedingStartHour: "Automatyczne karmienie",
                        exitPumpRunning: "Rozpocznij wypompowywanie",
                        feedingCycle: "Cykl karmienia",
                        onlyInput: "Wyłącznie wpompowywanie",
                        onlyOutput: "Wyłącznie wypompowywanie",
                        startFeeding: "Start karmienia",
                        stopFeeding: "Wyłącz karmienie",
                        customAmount: "Ilość niestandardowa",
                        customAmountHint: "Wstępnie wypełnione ustawioną objętością karmienia. Zmień tylko dla ilości niestandardowej. Maks. {{maxRiseCm}} cm wzrostu poziomu ({{maxLiters}} l dla tego silosu).",
                        customAmountInvalid: "Wprowadź wartość między {{min}} a {{max}} l",
                        customAmountExceedsLevelRise: "Wprowadzona ilość ({{amount}} l) podniosłaby poziom zbiornika o więcej niż {{maxRiseCm}} cm. Maksimum dla tego silosu to {{maxLiters}} l.",
                        customAmountUnknownSilo: "Nie można obliczyć maksymalnej ilości: nieznany typ silosu.",
                        customAmountExceedsWarning: "Wprowadzona ilość ({{amount}} l) jest wyższa niż ustawiona objętość karmienia ({{feedingVolume}} l). Czy na pewno chcesz kontynuować?",
                        pumpOutFlowRate: "Ustawienie prędkości wypompowywania",
                        pumpOutFlowRateInfo: "Teoretyczny przepływ wypompowywania jest używany do obliczenia czasu potrzebnego na wypompowanie digestatu z fermentora. Przy zbyt niskim ustawieniu wypompuje się zbyt dużo digestatu; przy zbyt wysokim — zbyt mało. Typowe wartości to:",
                        pumpOutFlowRateBellowsPump: "Pompa membranowa: ± 3 m³/h",
                        pumpOutFlowRateCentrifugalPump: "Pompa wirowa: ± 50 m³/h",
                        pumpOutFlowRateGravityOutlet: "Wylot grawitacyjny: ± 50 m³/h",
                        kiloPerPulse: "Impuls przepływomierza",
                        intakeTimeout: "Karmienie: Limit czasu pompowania",
                        averageDailyFeeding: "Średnie dzienne karmienie w ostatnim miesiącu",
                        retentionTime: "Czas przebywania w komorze",
                        statusValvePumpIn: "Zawór wejściowy do - 2",
                        statusValvePumpOut: "Zawór wyjściowy reaktora - 3",
                        statusValveRetourReactor: "Zawór zwrotny reaktora - 4",
                        valveCurrentActuator: "Zawór aktualnie",
                        actuatorSetting: "Ustawienie siłownika",
                        actuatorSettingV1: "Linak",
                        actuatorSettingV2: "Hiwin / Mikrosystem",
                        lastFeeding: "Aktualne - Ostatnie",
                        startHourLastFeeding: "Czas rozpoczęcia ostatniego cyklu karmienia",
                        feedingStatus: "Status karmienia",
                        feedingError: "Błąd karmienia",
                        intakePumpTime: "Czas pompowania",
                        intakePumpAmount: "Wpompowywana ilość",
                        exitPumpTime: "Czas wypompowywania",
                        exitPumpAmount: "Ilość wypompowana",
                        feedingHistory: "Historia karmienia",
                        startedOn: "Rozpoczęto",
                        temperature: "Temperatura",
                        reactorLevel: "Poziom",
                        balance: "Bilans",
                        acknowledge: "Potwierdzenie błędu",
                        intakeSpeed: "Prędkość pompowania",
                        balanceWarning: "Ostrzeżenie, to nie rozpocznie normalnego cyklu karmienia, ale zamiast tego wpompuje pozostałą wartość salda do reaktora",
                        automaticFeedingSettings: "Ustawienia automatycznego karmienia",
                        manualFeeding: "Ręczne karmienie",
                        pumpSettings: "Ustawienia pompy",
                        lastFeedingTime: "Czas ostatniego karmienia",
                        status: {
                            "0": "Bezczynność",
                            "1": "Wykrywanie poziomu",
                            "2": "Wyjście",
                            "3": "Wlot",
                            "5": "Odszranianie",
                            "6": "Uwolnienie gazu",
                            "7": "Wyjście manualne",
                            "10": "Uruchamianie",
                            "2,001": "Wyjście: mieszanie",
                            "2,002": "Wyjście",
                            "2,003": "Wyjście: otwarcie zaworu",
                            "2,004": "Wyjście: otwarcie zaworu",
                            "2,005": "Wyjście: włączenie pompy",
                            "2,006": "Wyjście",
                            "2,007": "Wyjście: opróżnianie zbiornika",
                            "2,008": "Wyjście: zatrzymanie pompy",
                            "2,009": "Wyjście: zatrzymanie pompy",
                            "2,010": "Wyjście: zamknięcie zaworu",
                            "2,011": "Wyjście: zamknięcie zaworu",
                            "2,012": "Wyjście: zatrzymanie pompy",
                            "3,001": "Wlot: przygotowanie",
                            "3,002": "Wlot: przygotowanie",
                            "3,003": "Wlot: przygotowanie",
                            "3,004": "Wlot: włączenie pompy",
                            "3,005": "Wlot: włączenie pompy",
                            "3,006": "Wlot: zakończenie",
                            "3,007": "Wlot: zakończenie",
                            "3,008": "Wlot: zatrzymanie pompy",
                            "3,009": "Wlot: zatrzymanie pompy",
                            "3,010": "Wlot: zatrzymanie pompy",
                            "3,011": "Wlot: zatrzymanie pompy",
                            "3,012": "Wlot: zakończenie",
                            "5,001": "Odszranianie: testowanie wlotu",
                            "5,002": "Odszranianie: testowanie wlotu",
                            "5,003": "Odszranianie: testowanie wlotu",
                            "5,004": "Odszranianie: testowanie wlotu",
                            "5,005": "Odszranianie: zatrzymanie wlotu",
                            "5,006": "Odszranianie: otwarcie zaworu wyjścia",
                            "5,007": "Odszranianie: otwarcie zaworu wyjścia",
                            "5,008": "Odszranianie: testowanie wyjścia",
                            "5,009": "Odszranianie: testowanie wyjścia",
                            "5,010": "Odszranianie: testowanie wyjścia",
                            "5,011": "Odszranianie: Testowanie poboru",
                            "5,012": "Odszranianie: Testowanie poboru",
                            "5,013": "Odszranianie: Zamykanie zaworu wyjściowego",
                            "5,014": "Odszranianie: Zamykanie zaworu wyjściowego",
                            "5,015": "Odszranianie: Kończenie",
                            "6,001": "Uwolnienie gazu: Otwieranie zaworu wyjściowego",
                            "6,002": "Uwolnienie gazu: Otwieranie zaworu wyjściowego",
                            "6,003": "Uwolnienie gazu: Zamykanie zaworu wyjściowego",
                            "6,004": "Uwolnienie gazu: Zamykanie zaworu wyjściowego",
                            "6,005": "Uwolnienie gazu",
                            "7,001": "Ręczne opróżnianie: Otwieranie zaworu wyjściowego",
                            "7,002": "Ręczne opróżnianie: Otwieranie zaworu wyjściowego",
                            "7,003": "Ręczne opróżnianie: Pompowanie gnojowicy",
                            "7,004": "Ręczne opróżnianie: Zatrzymanie pompy",
                            "7,005": "Ręczne opróżnianie: Zamykanie zaworu wyjściowego",
                            "7,006": "Ręczne opróżnianie: Zamykanie zaworu wyjściowego",
                            "7,007": "Ręczne opróżnianie: Kończenie",
                            "7,008": "Ręczne opróżnianie: Kończenie",
                            "10,001": "Uruchamianie: Zamykanie zaworu 2",
                            "10,002": "Uruchamianie: Zamykanie zaworu 2",
                            "10,003": "Uruchamianie: Zamykanie zaworu wyjściowego",
                            "10,004": "Uruchamianie: Zamykanie zaworu wyjściowego",
                            "10,005": "Uruchamianie: Zamykanie zaworu 4",
                            "10,006": "Uruchamianie: Zamykanie zaworu 4",
                            "10,007": "Uruchamianie: Sprawdzanie połączenia elektrycznego",
                            "10,008": "Uruchamianie: Sprawdzanie połączenia elektrycznego",
                            "10,009": "Uruchamianie"
                        }
                    },
                    users: {
                        label: "Użytkownicy",
                        customers: "Podłączeni klienci",
                        technicians: "Podłączeni technicy",
                        resellers: "Podłączeni sprzedawcy",
                    },
                    recommendations: {
                        label: "Rekomendacje",
                    },
                    firmware: {
                        invalidFile: "Wybierz plik .hex",
                        uploadStarted: "Rozpoczęto przesyłanie oprogramowania",
                        uploadFailed: "Przesyłanie oprogramowania nie powiodło się",
                        uploading: "Przesyłanie…",
                        uploadProgress: "Postęp: {{progress}}%",
                        currentVersion: "Bieżąca wersja",
                    },
                    documents: {
                        label: "Dokumenty",
                        specificDocuments: "Dokumenty szczegółowe",
                        specificImages: "Obrazy szczegółowe",
                        generalVideos: "Filmy ogólne",
                        general: "Dokumentacja ogólna",
                        generalDocuments: "Dokumenty ogólne",
                        checklists: "Listy kontrolne",
                        construction: "Lista kontrolna budowy",
                        production: "Lista kontrolna produkcji",
                        upload: "Prześlij",
                        uploadSuccess: "Pomyślnie przesłano {{name}}",
                        deleteSuccess: "Pomyślnie usunięto plik: {{name}}",
                        noFilesAvailable: "Brak dostępnych plików w kategorii {{category}}.",
                        fileSizeExceeds: "Rozmiar pliku przekracza limit {{size}}Mb",
                        invalidImageType: "Dozwolone są tylko obrazy JPG i PNG",
                        chooseFileFirst: "Najpierw wybierz plik.",
                        default: "Domyślne",
                        permits: "Pozwolenia",
                        plans: "Plany",
                        planning: "Planowanie",
                        certification: "Certyfikacja",
                        regulations: "Przepisy",
                        instructions: "Instrukcje",
                        templates: "Szablony"
                    },
                    warnings: {
                        "W001": "Zużycie energii przekraczające próg w ciągu ostatnich 24 godzin (72 kWh dla instalacji 10-44 kW, 250 kWh dla instalacji 60-74 kW)",
                        "W002": "Temperatura w reaktorze znacznie spadła",
                        "W003": "Pozostało 48h do wymiany serwisowej",
                        "W004": "Należy wymienić węgiel aktywny w filtrze węglowym przy silniku 1",
                        "W005": "Należy wymienić węgiel aktywny w filtrze węglowym przy silniku 2",
                        "W006": "Zamarzł miernik poziomu gazu w reaktorze",
                        "W007": "Błąd pomiaru poziomu gazu w reaktorze",
                        "W008": "Brak podania świeżej dawki gnojowicy od wczoraj",
                        "W009": "Prędkość ostatniego pompowania była większa o 50% niż średnia w ostatnim miesiącu",
                        "W010": "Za wysoki poziom H₂S (>1500)",
                        "W011": "Poziom napowietrzania wynosi 60",
                        "W012": "Napowietrzanie jest mniejsze lub równe 3",
                        "W013": "Wczorajsza wydajność wynosi 0, natomiast automatyczne pompowanie jest włączone",
                        "W014": "Pomiar poziomu H₂S w reaktorze - różnica ponad 400ppm",
                        "W015": "Wysokie napowietrzanie - średnia jakość gazu",
                        "W016": "Nieudany pomiar H₂S w ciągu ostatnich 24h",
                        "W017": "Niski poziom oleju w mieszadle",
                        "W018": "Niski poziom oleju w silniku",
                        "W020": "Niski poziom ciśnienia wody w obiegu",
                        "W104": "Poziom H₂S za wysoki (>200) napowietrzanie = 60 lub 3",
                        "W105": "Zbyt wysokie wyeksploatowanie filtra węglowego",
                        "W114": "Wczorajsza wydajność wynosi 0, natomiast automatyczne pompowanie jest wyłączone",
                    },
                    advanced: {
                        language: "Język ekranu LCD",
                        lambdaUpperLimit: "Górna granica lambda (Narrow range)",
                        lambdaLowerLimit: "Dolna granica lambda (Narrow range)",
                        coolingValve: "Zawór obiegu chłodzącego	",
                        maxPower: "Maks. moc (Baza danych) Silnik 1",
                        maxPower2: "Maks. moc (Baza danych) Silnik 2",
                        bioId: "Bio ID Silnik 1",
                        bioId2: "Bio ID Silnik 2",
                        currentSsrConfiguration: "Aktualna konfiguracja SSR",
                        SSRString: "Ciąg SSR",
                    },
                    sms: {
                        duringDay: "Otrzymuj wiadomości tekstowe w ciągu dnia",
                        duringNight: "Otrzymuj wiadomości tekstowe w nocy",
                        sendSms: "Powiadamiaj klientów przez SMS",
                        sendTestSms: "Wyślij wiadomość testową",
                        testSms: "SMS testowy",
                        testSmsToAllSenders: "Wyślij wiadomość testową do wszystkich nadawców (rozwiązywanie problemów)",
                        recipients: "Odbiorcy",
                        settings: "Ustawienia SMS",
                        enterMessage: "Wpisz swoją wiadomość tutaj...",
                        smsSentSuccessfully: "Wiadomości SMS zostały wysłane pomyślnie",
                        pleaseSelectAtLeastOneRecipient: "Wybierz co najmniej jednego odbiorcę",
                        pleaseEnterAMessage: "Wprowadź wiadomość",
                        failedToSendSmsMessages: "Nie udało się wysłać wiadomości SMS",
                        smsSettingsUpdatedSuccessfully: "Ustawienia SMS zostały pomyślnie zaktualizowane",
                        message: "Wiadomość",
                        testNotificationToAllSenders: "Wyślij testowe powiadomienie (rozwiązywanie problemów)",
                        sendTestNotification: "Wyślij testowe powiadomienie",
                        testNotificationsSentSuccessfully: "Testowe powiadomienia zostały wysłane pomyślnie",
                        failedToSendTestNotifications: "Nie udało się wysłać testowych powiadomień",
                    },
                    temperatures: {
                        label: "Temperatury",
                        oilCoolerTemp: "Temperatura chłodnicy oleju",
                        biogasTempAfterReheat: "T5 Temperature After Reheating",
                        blowerOutTemp: "T2 Temperature Inlet Compressor",
                        compressorOutTemp: "T3 Temperature Outlet Compressor",
                        biogasTempAfterCool: "T4 Temperature After Cooling",
                    },
                    pressures: {
                        label: "Ciśnienia",
                        biogasPressureBeforeMembrane: "P4 Pressure Inlet Membranes",
                        stage3Pressure: "P5 Pressure Membrane Stage 3",
                        pressureAfterMembrane: "P6 Pressure Outlet Membranes",
                        blowerPressure: "P1 Pressure Outlet Blower",
                        blowerPressureSetpoint: "Pressure Outlet Blower Setpoint",
                        compressorOutPressure: "P3 Pressure Outlet Compressor",
                    },
                    valves: {
                        label: "Zawory",
                        valveCompressor: "Zawór sprężarki",
                        valveMembrane: "Zawór membrany",
                        valveGrid: "Zawór sieci",
                        valveCo2: "Zawór CO2",
                    },
                    system: {
                        label: "System",
                        installationState: "Stan instalacji",
                        geuAvailable: "GEU dostępny",
                        geuAlarm: "Alarm GEU",
                        geuDelivering: "GEU dostarcza",
                        gasTotalGeu: "Gaz całkowity GEU",
                        gasTotalInternGeu: "Gaz całkowity wewnętrzny GEU",
                        biogasTotalizer: "Totalizator biogazu",
                        biomethaneDewpoint: "Punkt rosy biometanu",
                        compressorSpeed: "Prędkość sprężarki",
                    },
                    filters: {
                        label: "Filtry",
                        inletFilterPressuredrop: "Spadek ciśnienia filtra wlotowego",
                        filterTrainPressuredrop: "Spadek ciśnienia układu filtrów",
                        oilFilterPressuredrop: "Spadek ciśnienia filtra oleju",
                    },
                    checks: {
                        yourImage: "Twoje zdjęcie:",
                        imageCommentsLabel: "Komentarze do tego zdjęcia (opcjonalnie):",
                        imageCommentsPlaceholder: "Dodaj komentarze do tego zdjęcia",
                        exampleImage: "Przykładowe zdjęcie:",
                        textAnswerPlaceholder: "Wpisz tutaj swoją odpowiedź",
                        next: "Dalej",
                        completedMessage: "Zakończyłeś wszystkie kontrole budowy, wyślij listę kontrolną.",
                        skip: "Pomiń",
                        downloadPdf: "Pobierz PDF",
                        answerLabel: "Odpowiedź:",
                        commentsLabel: "Komentarze:",
                        selectedOptionsLabel: "Wybrane opcje:",
                        addEntry: "Dodaj wpis",
                        newEntryForCheck: "Nowy wpis dla tej kontroli:",
                        commentsOptionalPlaceholder: "Komentarze (opcjonalnie)",
                        yourAnswerPlaceholder: "Twoja odpowiedź",
                        saveEntry: "Zapisz wpis",
                        cancel: "Anuluj",
                        entryAdded: "Wpis dodany.",
                        entryAddFailedPrefix: "Nie udało się dodać wpisu: ",
                        validateBeforeSubmitting: "Podaj odpowiedź przed wysłaniem.",
                        validateBeforeNextCheck: "Podaj odpowiedź przed przejściem do następnej kontroli.",
                        uploadSuccess: "Dane wysłano pomyślnie",
                        uploadFailedPrefix: "Nie udało się wysłać danych: ",
                    }
                }
            },
            ja: {
                translation: {
                    dashboard: {
                        nameIdentifier: "プラント名・番号",
                        efficiencyAll: "プラントの総合効率",
                        onlyErrors: "異常のみ",
                        toggleDisconnected: "オフラインプラントを含む",
                        productionCombined: "エネルギー生産量（Wh）",
                        realisedTechnicalEfficiency: "生産及び技術効率（％）",
                        efficiencyCombined: "生産効率(％)",
                        technicalEfficiencyCombined: "技術効率（％）",
                        bgp: "バイオガス発生量（m³/t）",
                        consumption: "消費量（Wh）",
                        manureLifeTime: "滞留時間（日）",
                        feeding: "投入量（kg）"
                    },
                    common: {
                        on: "オン",
                        off: "オフ",
                        add: "追加",
                        save: "変更を保存",
                        monday: "月曜日",
                        tuesday: "火曜日",
                        wednesday: "水曜日",
                        thursday: "木曜日",
                        friday: "金曜日",
                        saturday: "土曜日",
                        sunday: "日曜日",
                        from: "変更前",
                        to: "変更後",
                        hours: "時間",
                        reset: "リセット",
                        confirmation: "確認",
                        cancel: "戻る",
                        yesIAmSure: "はい、確認しました",
                        set: "設定",
                        auto: "自動",
                        manual: "手動",
                        minutes: "分",
                        seconds: "秒",
                        turnOn: "始動",
                        turnOff: "停止",
                        graphLoading: "読み込み中",
                        noData: "データがありません",
                        hoursPerYear: "時間／年",
                        datetime: "日付と時刻",
                        warning: "警告",
                        error: "異常",
                        type: "種類",
                        startdate: "開始の日付と時刻",
                        enddate: "完了の日付と時刻",
                        all: "全部",
                        engine1: "エンジン１",
                        engine2: "エンジン２",
                        ongoing: "進行中",
                        both: "全部",
                        days: "日間",
                        today: "今日",
                        sendAnswers: "回答を送信",
                        employee: "従業員",
                        customer: "オペレーター",
                        sales: "セールス",
                        technician: "テクニシャン",
                        admin: "アドミン",
                        noDateKnown: "日付不明",
                        command: "コマンド",
                        user: "ユーザー",
                        fillInSurvey: "情報を入力してください。",
                        tons: "トン",
                        count: "数",
                        disabled: "無効",
                        addField: "フィールドを追加",
                        deleteField: "フィールドを削除",
                        releases: "リリース",
                        open: "開放",
                        close: "締切",
                        opening: "開いている",
                        closing: "閉じている",
                        zoomCancel: "ズームがキャンセルされました。ズームするにはグラフ内にとどまってください",
                        stuck: "詰まった"
                    },
                    errorPage: {
                        title: "問題が発生しました。",
                        contact: "この問題を it@biolectric.com までご報告ください。ご利用の携帯電話またはブラウザもお知らせください。",
                        reload: "再読み込み"
                    },
                    popups: {
                        engineIdle: "エンジンがアイドル状態ではありません。先にエンジンを停止してください",
                        valueBetween: "値は{{min}}から{{max}}の間である必要があります",
                        valueBetweenCustom: "値は{{min}}から{{max}}の間である必要があります",
                        powerTooLow: "電力を{{watts}}W未満に設定することはできません",
                        powerTooHigh: "電力を{{maxPower}}より高く設定することはできません",
                        maxCoolingTemp: "{{max}}°Cを超えることはできません",
                        minValue: "{{min}}未満にすることはできません",
                        maxAirInjectionTime: "{{max}}秒を超えることはできません",
                        minGasBuffer: "最小ガスバッファが範囲外です。お使いの設備の最小値は{{min}}です",
                        maxGasBuffer: "最大ガスバッファが範囲外です。お使いの設備の最大値は{{max}}です",
                        reactorTemp: "リアクター温度が範囲外です。{{min}}から{{max}}の間である必要があります",
                        reactorLevel: "リアクターレベルが無効です。お使いの設備の最大値は{{limit}}です",
                        reactorLevelRange: "リアクターレベルの値は{{min}}から{{max}}の間である必要があります",
                        commandFailed: "コマンドの送信に失敗しました",
                        commandSent: "コマンドを送信しました",
                        commandSuccess: "{{command}}を{{previousValue}}から{{value}}に正常に更新しました",
                        commandMix1Hour: "ミキサーは1時間動作します",
                    },
                    menu: {
                        dashboard: "ダッシュボード",
                        machines: "プラント",
                        questionnaires: "アンケート",
                        banners: "通知",
                        errors: "異常・警告",
                        pcb: "プリント基板",
                        tasks: "メモ",
                        releases: "リリースノート",
                        resellers: "代理店",
                        users: "ユーザー",
                        recommendations: "ヒント",
                        suggestions: "ヒントメッセージ",
                        faultTrees: "フォールトツリー",
                        assistant: "アシスタント",
                        language: "言語",
                        reconnection: "プラントはオフラインです。接続を再試行するには上記のボタンを押してください。",
                        profile: "会員情報",
                        logout: "ログアウト",
                        firmware: "ファームウェア",
                        sms: "SMS",
                        advanced: "上級機能",
                        errorsSingle: "異常",
                        warnings: "警告"
                    },
                    statistics: {
                        label: "データ解析",
                        foamBeaterThermalStatus: "泡消ミキサー サーマル",
                        exitPumpThermalStatus: "排出ポンプ サーマル",
                        thermalStatusOk: "サーマル非作動、機器は正常に動作可能",
                        thermalStatusFault: "サーマル作動、機器は異常状態",
                        group1: "グループ１",
                        group2: "グループ２",
                        addProperty: "物性を追加",
                        removeProperty: "物性を削除",
                        startTutorial: "チュートリアルを開始",
                        exitTutorial: "チュートリアルを停止",
                        welcomeStep: {
                            title: "データ解析画面へようこそ！",
                            content: "この画面では簡単に様々な物性とその傾向を比較できます。"
                        },
                        propertyStep: {
                            title: "物性の選択",
                            content: "物性を監視するには、\nこの選択リストから物性を選択してください。"
                        },
                        addPropertyStep: {
                            title: "物性の追加及び削除",
                            content: "物性を追加・削除するには、\nこれらのボタンを押してください。\nグループごとに最大４つの物性を追加できます。"
                        },
                        groupStep: {
                            title: "グループ２の有効化",
                            content: "グループ２を有効にするにはグループ２の\n「物性を追加」ボタンを押してください。\nグループ２の物性はグラフの右側に表示されています。"
                        },
                        dateRangeStep: {
                            title: "日付範囲の選択",
                            content: "日付範囲を選択するにはこのボタンを押してください。\n２ヶ月前までの履歴を確認できます。"
                        },
                        zoomInStep: {
                            title: "グラフの拡大",
                            content: "グラフを拡大するには領域をマウスの左ボタンで\nドラッグしながら囲むと拡大してください。"
                        },
                        zoomOutStep: {
                            title: "グラフの縮小",
                            content: "選択した日付範囲に戻るには、\n「縮小」ボタンを押してください。"
                        },
                        domainStep: {
                            title: "グラフの最小値・最大値の調整",
                            content: "グループごとの最小値・最大値を調整するにはこれらの\n青いペンボタンを押してください。"
                        },
                        csvStep: {
                            title: "CSVデータのダウンロード",
                            content: "現在表示されているグラフをCSVデータとして（エクセル）\nダウンロードするにはこのボタンを押してください。"
                        },
                        imageStep: {
                            title: "写真のダウンロード",
                            content: "現在表示されているグラフを写真として\nダウンロードするにはこの「写真」ボタンを\n押してください。"
                        },
                        configurationStep: {
                            title: "プリセット設定",
                            content: "現在の設定をプリセットとして保存できます。また、既存のプリセットを更新または削除することもできます。"
                        },
                        controlCardTemp: "制御基板の温度（℃）",
                        lowTensionError: "低電圧異常",
                        overTempFlueGasHeatExch: "排気ガス熱交換器の過熱",
                        feedingCycleLevel: "発酵槽レベル（cm）",
                        batteryVoltage: "バッテリー電圧（V）",
                        waterPressure: "温水循環回路の水圧（mbar）",
                        shortInterval: "10分間あたり",
                        dailyInterval: "毎日の間隔",
                        configurationUpdated: "現在の設定はこのプリセットに保存されました",
                        presets: "プリセット",
                        savePreset: "プリセットとして保存",
                        applyPreset: "プリセットを適用",
                        updatePreset: "プリセットを更新",
                        delete: "削除",
                        noPresets: "まだプリセットがありません",
                        givePresetName: "プリセットに名前を付けてください",

                    },
                    smart: {
                        label: "スマート",
                        heightOffset: "ガスホルダーの高さオフセット",
                        active: "パワーモード",
                        passive: "エコモード",
                        preActive: "パワーモードの準備",
                        prePassive: "エコモードの準備",
                        postActive: "パワーモードの終了",
                        postPassive: "エコモードの終了",
                        activeDesc: "パワーモードの期間には、計画された発電が最大化されます。各パワーモード期間の前に、ガスホルダーが膨張されるように「パワーモードの準備」期間が自動的に行われます。\nパワーモードの最大期間は、ガスホルダーの容量及び発電機の電力、プラントのバイオガス生産傾向によって計算されています。\nガスホルダーレベルの最小値に達すると、発電は停止されます (「パワーモードの終了」期間)。",
                        passiveDesc: "エコモードの期間には、ガスが余っている場合のみ発電されます。各エコモード期間の前に、ガスホルダーが減少されるように「エコモードの準備」期間が自動的に行われます。\nエコモードの最大期間は、ガスホルダーの容量及びプラントのバイオガス生産傾向によって計算されています。\nガスホルダーレベルの最大値に達すると、発電は開始されます (「エコモードの終了」期間)。",
                        permanence: "ガスホルダーレベルが最大に達していない時に動的に１台の\nエンジンで運転することにより、一定の発電が最適化されます。",
                        permanency: "継続発電",
                        activateStep: {
                            title: "【スマート】の有効化",
                            content: "プラントの発電量を制御する為に、\n【スマート】を有効化してください。"
                        },
                        timeslotStep: {
                            title: "期間を追加",
                            content: "パワーかエコモードの期間を追加するには、\n「追加」のボタンを押してください。"
                        },
                        fromToStep: {
                            title: "開始・終了",
                            content: "ここは期間の開始・終了の\n日付と時刻を入力してください。"
                        },
                        activePassiveStep: {
                            title: "パワーモードかエコモード",
                            content: "パワーモードかエコモードを選択するには、\nこれらのラジオボタンで選択してください"
                        },
                        saveStep: {
                            title: "期間を保存",
                            content: "期間を保存するには「保存」のボタンを押してください。"
                        },
                        removeStep: {
                            title: "期間を削除",
                            content: "期間を削除するには、ゴミ箱アイコンを押して下さい。"
                        },
                        visualStep: {
                            title: "グラフ",
                            content: "グラフは、\n【スマート】設定と１週間前の発電量を比較します。"
                        },
                        daySwitchStep: {
                            title: "グラフ",
                            content: "次・前の日に移動するには、\nこれらの矢印を押してください。"
                        },
                    },
                    gas: {
                        label: "ガス",
                        minGasBufferLevel: "ガスホルダーレベルの設定最低値",
                        maxGasBufferLevel: "ガスホルダーレベルの設定最大値",
                        gasBufferLevel: "ガスホルダーレベルの実際値",
                        defaultMinGasBufferLevel: "ガスホルダーレベルのデフォルト最小値",
                        defaultMaxGasBufferLevel: "ガスホルダーレベルのデフォルト最大値",
                        airInjectionTime: "生物脱硫のエア注入",
                        maxAirInjectionTime: "生物脱硫の最大エア注入",
                        airIndexManual: "エア注入制御",
                        maxLimitH2SAeration: "H₂S上限（エア注入減少）",
                        minLimitH2SAeration: "H₂S下限（エア注入増加）",
                        torch: "ガスフレア",
                        torchType: "ガスフレアモデル",
                        torchStatus: "ガスフレア状態",
                        torchError: "ガスフレア異常",
                        theoreticalTorchFlow: "理論ガスフレア流量",
                        torchRunningTime: "ガスフレア稼働時間",
                        torchFlaredVolume: "フレア量",
                        h2s: "硫化水素",
                        h2sLevelReactor: "硫化水素濃度・発酵槽",
                        h2sLevelMotor: "硫化水素濃度・エンジン",
                        filterLoad: "活性炭塔の破過率",
                        sample: "サンプル",
                        latestH2sReadings: "最新の硫化水素測定",
                        carbonFilterSize: "活性炭塔のサイズ",
                        h2sMeasurements: "硫化水素濃度測定",
                        measurements: "測定",
                        changeTo: "測定回数変更",
                        none: "未設置",
                        container: "コンテナ型",
                        extern: "スタンドアロン型",
                        foamBeaterInstalled: "泡消ミキサー",
                        antiFoamInjectionsInstalled: "泡消剤投入",
                        containerCombinedOperation: "コンテナ（複合操作）",
                        externCombinedOperation: "外部（複合操作）",
                        gasTemp: "T1 Temperature After Gascooler",
                        ch4BiogasSupply: "CH4 バイオガス供給",
                        co2BiogasSupply: "CO2 バイオガス供給",
                        o2BiogasSupply: "O2 バイオガス供給",
                        h2sAfterFilter: "フィルター後の H2S",
                        biomethaneFlowNorm: "標準化バイオメタン流量",
                        ch4Biomethane: "CH4 バイオメタン",
                        co2Biomethane: "CO2 バイオメタン",
                        o2Biomethane: "O2 バイオメタン",
                        h2sBiomethane: "H2S バイオメタン",
                        bufferRelease: "バッファ解放",
                        wobbe: "ウォッベ指数",
                        wobbeAvg: "平均ウォッベ指数",
                        wobbePidSetpoint: "ウォッベ PID 設定値",
                        wobbeBiomethanePronova: "ウォッベ バイオメタン Pronova",
                    },
                    engine: {
                        label: "エンジン",
                        startEngine: "エンジン始動",
                        stopEngine: "エンジン停止",
                        power: "出力",
                        desiredPower: "設定電力",
                        maxPower: "最大電力",
                        rpm: "回転数",
                        lambda: "ラムダ",
                        throttleValve: "サーボモーター閉度",
                        engineType: "エンジンモデル",
                        engineStatus: "エンジン状態",
                        engineError: "エンジン異常",
                        producedEnergy: "総合エネルギー生産量",
                        operatingHours: "エンジンの運転時間",
                        totalOperatingHours: "エンジンの総合運転時間",
                        gasUsage: "バイオガス消費量",
                        throttlePosition: "スロットルバルブ開度",
                        noErrors: "エンジンは運転可能です",
                        production: "生産",
                        servoManually: "サーボモーター閉度の設定は手動的です。",
                        servoAuto: "サーボモーター閉度の設定は自動的です。",
                        servoControl: "サーボモーター制御",
                        temperature: "エンジン温度",
                        restart: "ガス生産量が十分な時自動的に再始動されます",
                        confirmStop: "エンジン {{number}} を停止してもよろしいですか？",
                        confirmStopRestart: "エンジン {{number}} を停止してもよろしいですか？ガスが十分な時に自動的に再始動されます。",
                        idle: "待機",
                        running: "運転",
                        waiting: "始動準備",
                        booting: "始動",
                        shuttingDown: "停止",
                        advanced: "上級機能",
                        numberOfEngines: "エンジン数量",
                        predeterminedRunHours: "目標運転時間",
                        easyStart1: "イージースタート・エンジン１",
                        easyStart2: "イージースタート・エンジン２",
                        setError1: "エラー設定・エンジン１",
                        setError2: "エラー設定・エンジン２",
                        fuel: "燃料",
                        airIntakeOpen: "エアインテーク開放",
                        airIntakeClosed: "エアインテーク締切",
                        vfd: "インバータ",
                    },
                    service: {
                        label: "機器",
                        lastMaintenance: "定期的なメンテナンス",
                        currentlyInstalled: "本機器の運転時間",
                        total: "総合運転時間",
                        mixer: "撹拌機",
                        foam_beater: "泡消ミキサー",
                        intake_pump: "投入ポンプ",
                        digestate_pump: "排出ポンプ",
                        newMixer: "撹拌機交換",
                        newEngine: "エンジン交換",
                        newFoamBeater: "泡消ミキサー交換",
                        newIntakePump: "投入ポンプ交換",
                        newDigestatePump: "排出ポンプ交換",
                        confirmationMessage: "{{type}} の運転時間をリセットします、よろしいでしょうか", // The name of the equipment needs to be BEFORE the sentence.
                        maintenanceMessage: "{{type}} の運転時間がリセットされました", // The name of the equipment needs to be BEFORE the sentence.
                        newEquipmentMessage: "機器が交換されました",
                        prints: "プリント基板",
                        firstOnline: "最新日付",
                        lastOnline: "最古日付",
                        serial: " シリアル番号",
                        type: "種類",
                        engine: "エンジン",
                        engine1: "エンジン 1",
                        engine2: "エンジン 2",
                        engine_new1: "エンジン 1",
                        engine_new2: "エンジン 2",
                        h2s1: "硫化水素エンジン1",
                        h2s2: "硫化水素エンジン2",
                        resetTo: "運転時間のリセットを選択してください（デフォルト＝０）",
                        timeFilterReplace: "活性炭交換後の経過時間",
                        daysSinceOil: "定期的なメンテナンスの経過時間",
                        daysSinceOilChange: "定期的なメンテナンスの経過時間",
                        newGenerator: "ジェネレーター交換",
                        generator: "ジェネレーター",
                        generator1: "ジェネレーター 1",
                        generator2: "ジェネレーター 2",
                        videoMessage: "定期的なメンテナンスのビデオは「書類」ページ・一般的なビデオにあります。",
                        videoRoom: "サービス技術者がこの機械のためにビデオルームを開設しました。参加するにはここをクリックしてください。",
                        videoButton: "本プラントに関するビデオ通話を開始",
                        videoButtonSub: "ユーザーは「機器」ページからビデオ通話を参加できます",
                        videoClose: "ビデオルームを閉じる",
                        serialNumber: "シリアル番号",
                        defaultEngineReset: "定期的なメンテナンスのデフォルトリセット値",
                        newInstalled: "{{type}}交換",
                        replace: "交換",
                        aircover: "エアホルダー",
                        gascover: "ガスホルダー",
                        liner: "ライナー",
                        flow_meter: "流量計",
                        energy_meter1: "エネルギーメーター・発電機１",
                        energy_meter2: "エネルギーメーター・発電機２",
                        energy_meter_own: "エネルギーメーター・消費線",
                        h2sPastille: "硫化水素濃度センサーの交換",
                        pastille1: "H₂S センサー 1",
                        pastille2: "H₂S センサー 2",
                        engineLabel: "次回のエンジンメンテナンスまで “XX” 時間",
                        engine1Conf: "エンジン1のメンテナンス間隔は、メンテナンスが実施された後のみリセットしてください",
                        engine2Conf: "エンジン2のメンテナンス間隔は、メンテナンスが実施された後のみリセットしてください",
                        h2s1Conf: "H2Sエンジン1は、フィルター内の活性炭が交換された場合のみリセットしてください",
                        h2s2Conf: "H2Sエンジン2は、フィルター内の活性炭が交換された場合のみリセットしてください",
                        filterResetOffline: "マシンはオフラインです。フィルターリセットは保存されませんでした。再接続して再試行してください。",
                        filterResetFailed: "フィルターリセットに失敗しました。フィルターリセットは保存されませんでした。",
                        consumables: {
                            title: "消耗品",
                            belowMin: "最低在庫を下回る",
                            noneBelow: "最低在庫を下回る品目はありません",
                            notCounted: "未計上",
                            article: "品目番号",
                            description: "説明",
                            onSite: "現場在庫",
                            minimum: "最低在庫",
                            engineMaintenance: "エンジンメンテナンス",
                            pendingStock: "{{confirmed}} 確認済み + {{pending}} 確認待ち",
                            send: "発送",
                            shipmentSaved: "発送を保存しました。お客様が確認するまで保留です。",
                            shipmentFailed: "発送を保存できませんでした",
                            confirm: "受領を確認",
                            confirmSaved: "在庫を確認しました",
                            confirmFailed: "在庫を確認できませんでした",
                            confirmHint: "納品を確認すると、現場在庫に加算されます。",
                            guideTitle: "仕組み",
                            guideIntro: "オイル、オイルフィルター、点火プラグは各設置に置きます。設置のサービスページとこの発注ページは同じ在庫を使います。",
                            guide1Role: "技術者",
                            guide1Title: "現場にある数を数える",
                            guide1Body: "設置のサービスページで消耗品を開き、各品目が実際にいくつあるかを入力します。その計上はすぐに確認済みになります。現場の計上は他の人の承認を待ちません。",
                            guide2Role: "自動",
                            guide2Title: "エンジン整備は在庫を消費する",
                            guide2Body: "エンジン整備を登録すると、そのエンジンの消費量が確認済み在庫から差し引かれます。WG1605の整備は25 lオイル缶の0.28、オイルフィルター1個、点火プラグ4個を使います。WG972とWG3800はエンジンメンテナンス表の数量を使います。設置にエンジン型式の統計レコードがあるときに行われます。",
                            guide3Role: "サービス管理者",
                            guide3Title: "不足分を送る",
                            guide3Body: "このページは、確認済み在庫が最低在庫以下の設置を一覧します。送る数量を入力して発送を押します。たとえば「0.5 確認済み + 5 確認待ち」のように保留のままで、まだ在庫には数えません。最低在庫はエンジン種別ごとに設定します。設置では搭載エンジンの合計を整数に丸めます。オイル1個は25リットル缶1つです。",
                            guide4Role: "アクセスできる人",
                            guide4Title: "納品を確認する",
                            guide4Body: "品物が現場に着いたら、お客様、技術者、または社員が設置のサービスページで受領を確認します。確認待ちの数量が確認済み在庫に加算されます。0.5確認済みと5確認待ちは、現場で5.5になります。",
                            correction: "在庫修正",
                            save: "在庫数を保存",
                            saved: "在庫数を保存しました",
                            saveFailed: "在庫数を保存できませんでした",
                            minSaved: "最低在庫を保存しました",
                            minFailed: "最低在庫を保存できませんでした",
                            minHint: "最低在庫はエンジン種別ごとに設定します。設置では搭載エンジンの合計を整数に丸めます。在庫がその最低在庫以下になると一覧に出ます。オイル1個は25リットル缶1つです。",
                            usage: "エンジン整備ごとの消費量",
                            usageHint: "エンジン整備を登録すると、計上済み在庫からこの消費量が差し引かれます。DF972とWG972はWG972列を共有します。WG3800-LはWG3800列を使用します。",
                            orders: "発注対象",
                            ordersEmpty: "最低在庫以下の設置はありません",
                            shortage: "不足",
                            installation: "設置",
                            engines: "エンジン",
                        },
                        pastille1Conf: "H2Sセンサー1の寿命は、センサー要素が交換された場合のみリセットしてください。",
                        pastille2Conf: "H2Sセンサー2の寿命は、センサー要素が交換された場合のみリセットしてください。",
                        pastilleLabel: "センサー要素の推定寿命 XX 日",
                        valve_interval: "バルブクリアランス点検までの運転時間",
                        cylinder_interval: "シリンダーヘッドオーバーホールまでの運転時間",
                        valve_interval_engine1: "エンジン1のバルブクリアランス点検までの運転時間",
                        cylinder_interval_engine1: "エンジン1のシリンダーヘッドオーバーホールまでの運転時間",
                        valve_interval_engine2: "エンジン2のバルブクリアランス点検までの運転時間",
                        cylinder_interval_engine2: "エンジン2のシリンダーヘッドオーバーホールまでの運転時間",
                        pipe: "パイプ",
                        transmitter: "送信機",
                        elektromotor: "電動モーター",
                        pump: "ポンプ",
                        roofsolation: "屋根断熱材",
                        airPump: "エアインジェクションポンプ",
                        oxygenConcentrator: "酸素濃縮装置",
                        flowmeterBiogas: "バイオガス流量計",
                        pronovaBiomethaan: "ProNova バイオメタン",
                        pronovaBiogas: "ProNova バイオガス",
                        h2s1Gpi: "カーボンフィルター1",
                        h2s2Gpi: "カーボンフィルター2",
                        coolant: "冷却液",
                        daysSinceCoolantReplace: "交換からの日数",
                        coolantConf: "冷却液を交換した後にのみ稼働時間をリセットしてください",
                        daysSinceInhibitor: "インヒビターパッケージからの日数",
                        inhibitorPackage: "インヒビターパッケージ",
                        registerInhibitor: "登録",
                        inhibitorConf: "冷却液にインヒビターパッケージを補充した後にのみ登録してください（12ヶ月ごと）",
                        restoreValues: {
                            button: "PLC値を復元",
                            title: "PLC値を復元",
                            description: "過去7日間から正しい日を選び、事前入力された値を確認してからPLCへ送信してください。",
                            pickDay: "日を選択",
                            snapshotTime: "サンプル時刻",
                            noSnapshots: "過去7日間の統計が見つかりません。",
                            send: "送信",
                            sendAll: "すべて送信",
                            sending: "送信中…",
                            confirmSendAll: "事前入力されたすべての値をPLCに送信しますか？",
                            sendAllDone: "{{count}}件の値をPLCに送信しました",
                            emptyValue: "値が空です",
                            invalidValue: "値が数値ではありません",
                            invalidEngineCount: "エンジン数は1または2である必要があります",
                            noConnection: "マシンにアクティブな接続がありません",
                            readOnly: "読み取り専用",
                            fromMachine: "マシン記録から",
                            current: "現在",
                            currentHint: "CU上の現在のslow/fast値",
                            ups: "UPS",
                            groupEngines: "エンジン",
                            groupReactor: "リアクターと混合",
                            groupFeeding: "給餌",
                            groupGas: "ガス",
                            groupEnergy: "エネルギーカウンタ",
                            groupSsr: "SSR",
                        },
                        tabs: {
                            engine: "エンジン",
                            reactor: "リアクター / コンテナ",
                            gas: "ガス / 精製",
                            consumables: "消耗品",
                            options: "マシンオプション",
                            prints: "プリント",
                            restoreValues: "PLC値を復元",
                        },
                    },
                    net: {
                        net: "系統",
                        meterSettings: "エネルギーメーターの設定",
                        voltagePerPhase1: "第１相の電圧",
                        voltagePerPhase2: "第２相の電圧",
                        voltagePerPhase3: "第３相の電圧",
                        frequencyPerPhase: "周波数",
                        angleBetweenPhase1And2: "第１相と第２相の間の位相差",
                        ownPowerConsumption: "消費電力",
                        ownEnergyConsumption: "エネルギー消費量",
                        bioguardVersion: "BIOGUARDバージョン",
                        brutoProducedEnergy: "エネルギー生産量",
                        nettoProducedEnergy: "正味エネルギー生産量",
                        producedEnergy: "エネルギー生産量",
                        producedEnergyEngine1: "エネルギー生産量・エンジン１",
                        producedEnergyEngine2: "エネルギー生産量・エンジン２",
                        monitoringRelay: "プラント保護リレー",
                        powerNonFit: "エネルギーメーター自消費量（非FIT）",
                        energyMeterNonFit: "エネルギーメーター自消費量（非FIT）",
                    },
                    reactor: {
                        label: "発酵槽",
                        reactorTemp: "発酵槽温度",
                        reactorTempTarget: "発酵槽設定温度",
                        reactorLevel: "発酵槽設定レベル",
                        hydrostaticPressure: "発酵槽実際レベル",
                        siloType: "発酵槽モデル",
                        extraHeating: "追加加温",
                        antiFrost: "凍結防止",
                        antiFrostIndex: "凍結防止レベル",
                        antiFrostAuto: "凍結防止レベルは敷地気温に基づいて自動的に設定されます。",
                        antiFrostMessageNew: "各凍結防止サイクルには、投入ポンプが４秒間作動され、「排出ポンプ流量」の設定に基づいて排出ポンプが約100lの消化液が排出されます。",
                        antiFrostMessageOld: "各凍結防止サイクルには、投入ポンプが４秒間作動され、排出ポンプが120秒間作動されます。",
                        coolwater: "温水",
                        statusCoolingValve: "温水の三方弁",
                        waterTempIn: "発酵槽上流の温水温度",
                        waterTempOut: "発酵槽下流の温水温度",
                        waterTempMotorOut: "エンジン１下流の温水温度",
                        waterTempMotorOut2: "エンジン２下流の温水温度",
                        coolingWaterTemp: "温水設定温度",
                        maxCoolingWaterTemp: "温水最大温度",
                        waterPressure: "温水循環回路の水圧",
                        foamBeater: "泡消ミキサー",
                        foambeatEveryXMinutes: "運転頻度",
                        foambeatForXSeconds: "内運転時間",
                        mixer: "撹拌機",
                        mixerMaxPower: "撹拌機最大電力",
                        mixerActive: "撹拌機状態",
                        mixerBlockedLowLevel: "撹拌機は発酵槽レベルが低いためブロックされています",
                        mixEveryXMinutes: "運転頻度",
                        mixForXSeconds: "内運転時間",
                        blockMixingFrom: "撹拌禁止:", // "No mixing from" 9 "to" 10 = "撹拌禁止：" 9 "～" 10
                        blockMixingTo: "～", // See above
                        mixerInfo: "撹拌機は、設定した「運転頻度」及び「オン時間」で自動的に始動されます。\n「撹拌禁止」の期間中、「撹拌機最大電力」がプラントの現在発電量を超える場合、撹拌機が停止されます。\n発電機が始動されるからエンジン定格電力の50％に達するまで撹拌機が一時的に停止されます。",
                        mixerInfoGpi: "撹拌機は、設定した「運転頻度」及び「オン時間」で自動的に始動されます。\n「撹拌禁止」の期間中、「撹拌機最大電力」がプラントの現在発電量を超える場合、撹拌機が停止されます。",
                        mix1Hour: "１時間撹拌",
                        coolwaterValveInstalled: "制御式三方弁",
                        coolwaterValveBinary: "バイナリ三方弁",
                        coolwaterValveMaximizeHeat: "熱利用の最大化",
                        coolwaterValveMaximizeHeatInfo: "熱利用を最大化すると、プレート式熱交換器で熱が利用できない期間が生じる場合があります",
                        coolwaterValvePlatePriority: "プレート式熱交換器の優先",
                        coolwaterValvePlatePriorityInfo: "発酵槽温度を安定に保ちつつ、プレート式熱交換器での熱利用可能性を優先します",
                        bypassFan: "三方弁（バイパス・空冷式熱交換器）",
                        digester: "三方弁（発酵槽・余剰熱利用の熱交換器）",
                        silo: "発酵槽",
                        bag: "バルーン",
                        plateHeatExchanger: " プレート式熱交換器",
                        timesPerDay: "回/日",
                        intern: "内部接続",
                        extern: "外部接続",
                        tempHigh: "発酵槽最大温度",
                        externMessage: "（撹拌機が「外部接続」に設定された場合、次のエラーは発生されません）サーマルリレーをリセットしてください。",
                        bypass: "バイパス",
                        ventilator: "空冷式熱交換器",
                        tempCoolHeatExchOut: "プレート式熱交換器下流の温水温度",
                        overtempMixer1: "過熱 ミキサー 1",
                        overtempMixer2: "過熱 ミキサー 2",
                        mixerSettings: "ミキサー設定",
                        premixing: "プレミキシング",
                        intakeMixing: "投入時ミキシング",
                        premixingInfo: "プレミキシングは給餌前、つまり排出前および排出中の混合です。時間は常に混合時間を指します。",
                        intakeMixingInfo: "投入時ミキシングは投入と同時に混合することを許可します。OFFの場合、給餌中は混合は実行されません。",
                        gpiMixDuringIntake: "液体給餌中の混合",
                        gpiMixDuringIntakeInfo: "液体給餌の全期間中に混合します。",
                        gpiMixDuringIntakeHelp: "液体給餌中の混合：給餌の全期間中に混合します。OFF時：サイロタイプにより動作が異なります。\n\nSタイプ：排出中のみプレミックス、給餌後にミキサー時間分混合。\n\nCタイプ：プレミックスなし、給餌後にミキサー時間分混合。",
                        gpiMixDuringIntakeOffGeneric: "OFF時：サイロタイプにより動作が異なります。",
                        gpiMixDuringIntakeOffS: "Sタイプ：排出中のみプレミックス、給餌後にミキサー時間分混合。",
                        gpiMixDuringIntakeOffC: "Cタイプ：プレミックスなし、給餌後にミキサー時間分混合。",
                        gpiMixDuringSolidFeedIntake: "固形給餌中の混合",
                        gpiMixDuringSolidFeedIntakeInfo: "ON時：固形給餌の全期間中に混合。OFF時：固形給餌の前後のみ混合し、それぞれ「{{durationSetting}}」で設定した時間（秒）です。",
                        gpiMixTimeBeforeAfterSolidIntake: "固形給餌前後の混合時間",
                    },
                    efficiency: {
                        label: "効率",
                        production: "エネルギー生産量・30日間",
                        consumption: "エネルギー消費量・30日間",
                        nettoProduction: "正味エネルギー生産量・30日間",
                        averageEfficiency: "平均生産効率・30日間",
                        averageTechnicalEfficiency: "平均技術効率・30日間",
                        bgp: "バイオガス発生量",
                        top10: "ランキングトップ10・30日間",
                        realised: "生産効率",
                        technical: "技術効率",
                        bgpInfo: "この「バイオガス発生量」【m³/t】は過小推定値です。停止期間及び過剰ガス生産、ガスフレア運転による生産ロスは考慮されません。",
                        pointPerDay: "％/日",
                        trendline: "傾向線",
                    },
                    general: {
                        label: "一般情報",
                        hardwareVersion: "ハードウェア版",
                        otGenContact: "発電機の過熱",
                        engine1And2Off: "エンジン１及び２停止中",
                        engine1On: "エンジン１運転中",
                        engine2On: "エンジン２運転中",
                        engine1And2On: "エンジン１及び２運転中",
                        notes: "メモ",
                        h2sSensorFirmwareVersion: "H₂Sバージョン",
                        idH2s: "H₂Sシリアル番号",
                        bioId: "BIOTRONICシリアル番号",
                        identifier: "プラント番号",
                        collabContract: "共同経営契約",
                        own: "メンテナンス契約",
                        sold: "共同経営終了",
                        productionDate: "製造日",
                        commissioningDate: "試運転日",
                        controlCardTemp: "制御基板の温度",
                        batteryVoltage: "バッテリー電圧",
                        motorVoltage: "エンジン電圧",
                        overtempFlueGasHeatExch: "排気ガス熱交換器の過熱",
                        rebootMainBoard: "制御基板の再起動",
                        rebootNow: "再起動",
                        utcOffset: "UTCとの偏差",
                        location: "住所",
                        network: "ネットワーク",
                        ip: "IP",
                        mask: "マスク",
                        gateway: "ゲートウェイ",
                        dns: "DNS",
                        pcb: "プリント基板",
                        firmware: "ファームウェア",
                        mainControlUnit: "制御基板",
                        bioguard: "BIOGUARD",
                        biotronicEngine1: "BIOTRONIC・エンジン１",
                        biotronicEngine2: "BIOTRONIC・エンジン２",
                        h2sEngine1: "H₂S・エンジン１",
                        h2sEngine2: "H₂S・エンジン２",
                        bioIdEngine1: "BioID・エンジン１",
                        bioIdEngine2: "BioID・エンジン２",
                        modificationsToMachine: "変更履歴",
                        name: "プラント名",
                        hostNameFirmware: "ファームウェア",
                        hostNameDatabase: "データベース",
                        normal: "普通",
                        lowError: "低（異常）",
                        nta8080Title: "NTA 8080 report",
                        nta8080Description: "Download a monthly NTA 8080 report. Data is loaded only when you request the report.",
                        nta8080Month: "Month",
                        nta8080Download: "Download report",
                        nta8080DownloadPdf: "Download PDF",
                        nta8080DownloadCsv: "Download CSV",
                        nta8080Loading: "Preparing…",
                        nta8080SelectMonth: "Select a month first",
                        nta8080InvalidMonth: "Invalid month selected",
                        nta8080DownloadError: "Could not download the report",
                    },
                    feeding: {
                        label: "投入・排出",
                        feedingVolume: "サイクルあたりの新鮮給餌最大量",
                        feedingCyclesPerDay: "1日あたり投入回数",
                        feedingCyclesPerDayInfo: "ポンプ量が希望量の75%未満の場合、給餌エラー「新鮮肥料の投入時に流量なし」が発生します。希望量の75%から100%の場合、メッセージ「給餌サイクルが部分的に実行されました。設定量に達する前に空のピットが検出されました」が表示されます。",
                        feedingBalance: "投入バランス",
                        autoFeedingActive: "自動投入",
                        blockHighElectricalConsumption: "混合ウィンドウ中のヒートポンプ消化槽加熱をブロック",
                        blockHighElectricalConsumptionInfo: "ON時：混合ウィンドウ中にヒートポンプによる消化槽加熱がブロックされます。OFF時：ブロックしません。",
                        minimizeElectricalConsumptionFrom: "電力消費を最小化（開始）",
                        minimizeElectricalConsumptionTo: "～",
                        autoFeedingStartHour: "1日の最初自動投入",
                        exitPumpRunning: "手動排出",
                        feedingCycle: "投入サイクル",
                        onlyInput: "投入のみ",
                        onlyOutput: "排出のみ",
                        startFeeding: "開始",
                        stopFeeding: "停止",
                        customAmount: "カスタム量",
                        customAmountHint: "設定された給餌量であらかじめ入力されています。カスタム量の場合のみ変更してください。最大レベル上昇 {{maxRiseCm}} cm（このサイロでは {{maxLiters}} l）。",
                        customAmountInvalid: "{{min}}〜{{max}} l の値を入力してください",
                        customAmountExceedsLevelRise: "入力した量（{{amount}} l）はタンクレベルを {{maxRiseCm}} cm 超上昇させます。このサイロの最大は {{maxLiters}} l です。",
                        customAmountUnknownSilo: "最大量を計算できません：サイロタイプが不明です。",
                        customAmountExceedsWarning: "入力した量（{{amount}} l）は設定された給餌量（{{feedingVolume}} l）より多いです。続行してもよろしいですか？",
                        pumpOutFlowRate: "排出ポンプ流量",
                        pumpOutFlowRateInfo: "理論排出流量は、消化槽から消化液をポンプで排出するのにかかる時間の計算に使用されます。設定が低すぎると消化液が多く排出され、高すぎると少なくなります。典型的な値は次のとおりです：",
                        pumpOutFlowRateBellowsPump: "ベローズポンプ：± 3 m³/h",
                        pumpOutFlowRateCentrifugalPump: "遠心ポンプ：± 50 m³/h",
                        pumpOutFlowRateGravityOutlet: "重力排出：± 50 m³/h",
                        kiloPerPulse: "流量計パルス",
                        intakeTimeout: "投入タイムアウト",
                        averageDailyFeeding: "先月の平均1日あたり投入量",
                        retentionTime: "滞留時間",
                        statusValvePumpIn: "投入自動弁",
                        statusValvePumpOut: "排出自動弁",
                        statusValveRetourReactor: "循環自動弁",
                        valveCurrentActuator: "排出自動弁電流",
                        actuatorSetting: "アクチュエータ設定",
                        actuatorSettingV1: "Linak",
                        actuatorSettingV2: "Hiwin / Mikrosystem",
                        lastFeeding: "現在・最新",
                        startHourLastFeeding: "サイクルの開始時間",
                        feedingStatus: "サイクル状態",
                        feedingError: "発酵槽異常",
                        intakePumpTime: "投入時間",
                        intakePumpAmount: "投入量",
                        exitPumpTime: "排出時間",
                        exitPumpAmount: "排出量",
                        feedingHistory: "投入履歴",
                        startedOn: "開始時間",
                        temperature: "発酵槽温度",
                        reactorLevel: "発酵槽レベル",
                        balance: "バランス",
                        acknowledge: "異常を消去",
                        intakeSpeed: "投入流量",
                        balanceWarning: "注意：このボタンを押すと、普通の投入サイクルが開始されるのではなく、バランス量の原料が発酵槽に投入されます。",
                        automaticFeedingSettings: "自動投入設定",
                        manualFeeding: "手動制御",
                        pumpSettings: "ポンプ設定",
                        mixBeforeExit: "排出前の撹拌時間",
                        mixDuringExit: "排出中の最大攪拌時間",
                        lastFeedingTime: "最後の投入時間",
                        status: {
                            "0": "待機",
                            "1": "レベル測定",
                            "2": "排出",
                            "3": "投入",
                            "5": "凍結防止",
                            "6": "ガス排気",
                            "7": "手動排出",
                            "10": "起動",
                            "2,001": "排出・撹拌",
                            "2,002": "排出",
                            "2,003": "排出・排出自動弁の開放",
                            "2,004": "排出・排出自動弁の開放",
                            "2,005": "排出・排出ポンプの始動",
                            "2,006": "排出",
                            "2,007": "排出・消化液排出",
                            "2,008": "排出・停止",
                            "2,009": "排出・停止",
                            "2,010": "排出・排出自動弁の締切",
                            "2,011": "排出・排出自動弁の締切",
                            "2,012": "排出・停止",
                            "3,001": "投入・用意",
                            "3,002": "投入・用意",
                            "3,003": "投入・用意",
                            "3,004": "投入・開始",
                            "3,005": "投入・開始",
                            "3,006": "投入・完了",
                            "3,007": "投入・完了",
                            "3,008": "投入・投入ポンプの停止",
                            "3,009": "投入・投入ポンプの停止",
                            "3,010": "投入・投入ポンプの停止",
                            "3,011": "投入・投入ポンプの停止",
                            "3,012": "投入・完了",
                            "5,001": "凍結防止・投入側開始",
                            "5,002": "凍結防止・投入側開始",
                            "5,003": "凍結防止・投入側開始",
                            "5,004": "凍結防止・投入側開始",
                            "5,005": "凍結防止・投入側停止",
                            "5,006": "凍結防止・排出自動弁の開放",
                            "5,007": "凍結防止・排出自動弁の開放",
                            "5,008": "凍結防止・排出側開始",
                            "5,009": "凍結防止・排出側開始",
                            "5,010": "凍結防止・排出側開始",
                            "5,011": "凍結防止・排出側開始",
                            "5,012": "凍結防止・排出側開始",
                            "5,013": "凍結防止・排出自動弁の締切",
                            "5,014": "凍結防止・排出自動弁の締切",
                            "5,015": "凍結防止・完了",
                            "6,001": "ガス排気・排出自動弁の開放",
                            "6,002": "ガス排気・排出自動弁の開放",
                            "6,003": "ガス排気・排出自動弁の締切",
                            "6,004": "ガス排気・排出自動弁の締切",
                            "6,005": "ガス排気",
                            "7,001": "手動排出・排出自動弁の開放",
                            "7,002": "手動排出・排出自動弁の開放",
                            "7,003": "手動排出・投入開始",
                            "7,004": "手動排出・投入ポンプの停止",
                            "7,005": "手動排出・排出自動弁の締切",
                            "7,006": "手動排出・排出自動弁の締切",
                            "7,007": "手動排出・完了",
                            "7,008": "手動排出・完了",
                            "10,001": "起動・投入自動弁の締切",
                            "10,002": "起動・投入自動弁の締切",
                            "10,003": "起動・排出自動弁の締切",
                            "10,004": "起動・排出自動弁の締切",
                            "10,005": "起動・循環自動弁の締切",
                            "10,006": "起動・循環自動弁の締切",
                            "10,007": "起動・電気接続確認",
                            "10,008": "起動・電気接続確認",
                            "10,009": "起動"
                        }
                    },
                    users: {
                        label: "ユーザー",
                        customers: "オペレーター",
                        technicians: "テクニシャン",
                        resellers: "ディストリビューター",
                    },
                    recommendations: {
                        label: "ヒント",
                    },
                    firmware: {
                        invalidFile: ".hexファイルを選択してください",
                        uploadStarted: "ファームウェアのアップロードを開始しました",
                        uploadFailed: "ファームウェアのアップロードに失敗しました",
                        uploading: "アップロード中…",
                        uploadProgress: "進捗: {{progress}}%",
                        currentVersion: "現在のバージョン",
                    },
                    documents: {
                        label: "書類",
                        specificDocuments: "特殊書類",
                        specificImages: "特殊写真",
                        generalVideos: "一般ビデオ",
                        general: "一般ドキュメント",
                        generalDocuments: "一般書類",
                        checklists: "チェックリスト",
                        construction: "建設チェックリスト",
                        production: "生産チェックリスト",
                        upload: "アップロード",
                        uploadSuccess: "{{name}}のアップロードは正常終了されました。",
                        deleteSuccess: "{{name}}の削除は正常終了されました。",
                        noFilesAvailable: "{{category}}のカテゴリに利用可能なファイルがありません。",
                        fileSizeExceeds: "ファイルのサイズが{{size}}Mbを越えています。",
                        invalidImageType: "JPGとPNG画像のみ許可されています",
                        chooseFileFirst: "ファイルを選択してください。",
                        default: "デフォルト",
                        permits: "許可証",
                        plans: "図面",
                        planning: "計画",
                        certification: "証明書",
                        regulations: "規制",
                        instructions: "取扱説明書",
                        templates: "テンプレート"
                    },
                    warnings: {
                        "W001": "過去24時間のエネルギー消費量が閾値を超えました（10～44kWプラント＝72 kWh・60～74kWプラント＝250 kWh）",
                        "W002": "発酵槽温度が非常に低下しました",
                        "W003": "定期的なメンテナンスは48時間以内に行う必要です",
                        "W004": "活性炭塔１の活性炭を交換する必要です",
                        "W005": "活性炭塔２の活性炭を交換する必要です",
                        "W006": "ガスホルダーレベル測定のチューブが凍結しました（圧力が高過）",
                        "W007": "ガスホルダーレベル測定が非論理的です（圧力が低過）",
                        "W008": "昨日投入がありませんでした",
                        "W009": "最新投入の時に投入ポンプの流量は先月の平均より50％高かったです",
                        "W010": "硫化水素濃度は高いです（＞1500 ppm）",
                        "W011": "生物脱硫のエア注入は最大になりました（60 秒/分）",
                        "W012": "生物脱硫のエア注入は最低になりました（＜3 秒/分）",
                        "W013": "昨日自動投入はオンでしたが生産効率は0％でした。",
                        "W014": "発酵槽側の硫化水素濃度の両方測定の差は大き過ぎます（＞400 ppm）",
                        "W015": "生物脱硫のエア注入は長時に高いです",
                        "W016": "過去24時間に全ての硫化水素濃度測定は失敗しました",
                        "W017": "撹拌機のオイルレベルは低過ぎます",
                        "W018": "エンジンのオイルレベルは低過ぎます",
                        "W020": "温水の水圧は低過ぎます",
                        "W104": "硫化水素濃度は高過ぎます（＞200 ppm）又は生物脱硫のエア注入は最大・最低です",
                        "W105": "活性炭塔の破過率は高過ぎます",
                        "W114": "昨日生産効率は＞0％でしたが自動投入はオフでした。",
                    },
                    advanced: {
                        language: "LCD画面言語",
                        lambdaUpperLimit: "Lambda upper limit (narrow range)",
                        lambdaLowerLimit: "Lambda lower limit (narrow range)",
                        coolingValve: "三方弁",
                        maxPower: "最大電力（データベース）エンジン1",
                        maxPower2: "最大電力（データベース）エンジン2",
                        bioId: "BioID エンジン1",
                        bioId2: "BioID エンジン2",
                        currentSsrConfiguration: "SSR文字列の現況",
                        SSRString: "SSRの文字列",
                    },
                    sms: {
                        duringDay: "昼間にショートメール受信",
                        duringNight: "夜間にショートメール受信",
                        sendSms: "ショートメールでオペレーターを通知",
                        sendTestSms: "テストメッセージを送信",
                        testSms: "テストSMS",
                        testSmsToAllSenders: "全送信者にテストメッセージを送信（トラブルシューティング）",
                        recipients: "受信者",
                        settings: "ショートメールの設定",
                        enterMessage: "メッセージを入力してください...",
                        smsSentSuccessfully: "SMSの送信に成功しました",
                        pleaseSelectAtLeastOneRecipient: "少なくとも1人の受信者を選択してください",
                        pleaseEnterAMessage: "メッセージを入力してください",
                        failedToSendSmsMessages: "SMSの送信に失敗しました",
                        smsSettingsUpdatedSuccessfully: "SMS設定が正常に更新されました",
                        message: "メッセージ",
                        testNotificationToAllSenders: "全送信者にテスト通知を送信（トラブルシューティング）",
                        sendTestNotification: "テスト通知を送信",
                        testNotificationsSentSuccessfully: "テスト通知が正常に送信されました",
                        failedToSendTestNotifications: "テスト通知の送信に失敗しました",
                    },
                    temperatures: {
                        label: "温度",
                        oilCoolerTemp: "オイルクーラー温度",
                        biogasTempAfterReheat: "T5 Temperature After Reheating",
                        blowerOutTemp: "T2 Temperature Inlet Compressor",
                        compressorOutTemp: "T3 Temperature Outlet Compressor",
                        biogasTempAfterCool: "T4 Temperature After Cooling",
                    },
                    pressures: {
                        label: "圧力",
                        biogasPressureBeforeMembrane: "biogas_pressure_before_membrane",
                        stage3Pressure: "P5 Pressure Membrane Stage 3",
                        pressureAfterMembrane: "P6 Pressure Outlet Membranes",
                        blowerPressure: "P1 Pressure Outlet Blower",
                        blowerPressureSetpoint: "Pressure Outlet Blower Setpoint",
                        compressorOutPressure: "P3 Pressure Outlet Compressor",
                    },
                    valves: {
                        label: "バルブ",
                        valveCompressor: "コンプレッサーバルブ",
                        valveMembrane: "膜バルブ",
                        valveGrid: "グリッドバルブ",
                        valveCo2: "CO2バルブ",
                    },
                    system: {
                        label: "システム",
                        installationState: "設置状態",
                        geuAvailable: "GEU利用可能",
                        geuAlarm: "GEUアラーム",
                        geuDelivering: "GEU稼働中",
                        gasTotalGeu: "GEUガス合計",
                        gasTotalInternGeu: "内部GEUガス合計",
                        biogasTotalizer: "バイオガス積算計",
                        biomethaneDewpoint: "バイオメタン露点",
                        compressorSpeed: "コンプレッサー回転速度",
                    },
                    filters: {
                        label: "フィルター",
                        inletFilterPressuredrop: "入口フィルター圧力損失",
                        filterTrainPressuredrop: "フィルタートレイン圧力損失",
                        oilFilterPressuredrop: "オイルフィルター圧力損失",
                    },
                    checks: {
                        yourImage: "画像:",
                        imageCommentsLabel: "この画像に関するコメント（任意）:",
                        imageCommentsPlaceholder: "この画像についてのコメントを入力してください",
                        exampleImage: "サンプル画像:",
                        textAnswerPlaceholder: "ここに回答を入力してください",
                        next: "次へ",
                        completedMessage: "すべての施工チェックが完了しました。チェックリストを送信してください。",
                        skip: "スキップ",
                        downloadPdf: "PDF をダウンロード",
                        answerLabel: "回答:",
                        commentsLabel: "コメント:",
                        selectedOptionsLabel: "選択したオプション:",
                        addEntry: "エントリを追加",
                        newEntryForCheck: "このチェックの新しいエントリ:",
                        commentsOptionalPlaceholder: "コメント（任意）",
                        yourAnswerPlaceholder: "あなたの回答",
                        saveEntry: "エントリを保存",
                        cancel: "キャンセル",
                        entryAdded: "エントリが追加されました。",
                        entryAddFailedPrefix: "エントリを追加できませんでした: ",
                        validateBeforeSubmitting: "送信する前に回答を入力してください。",
                        validateBeforeNextCheck: "次のチェックに進む前に回答を入力してください。",
                        uploadSuccess: "データは正常に送信されました",
                        uploadFailedPrefix: "データの送信に失敗しました: ",
                    }
                }
            },
            lt: {
                translation: {
                    dashboard: {
                        nameIdentifier: "Vardas arba identifikatorius",
                        efficiencyAll: "Visų mašinų efektyvumas",
                        onlyErrors: "Tik klaidos",
                        toggleDisconnected: "Perjungti atsijungusias mašinas",
                        productionCombined: "Kombinuota produkcija (Wh)",
                        realisedTechnicalEfficiency: "Realizuotas/Techninis našumas (%)",
                        efficiencyCombined: "Realizuotas efektyvumas (%)",
                        technicalEfficiencyCombined: "Techninis našumas (%)",
                        bgp: "Bgp (m³/ton))",
                        consumption: "Suvartojimas (Wh)",
                        manureLifeTime: "Mėšlo gyvavimo laikas (dienos)",
                        feeding: "Maitinimas (kg)"
                    },
                    common: {
                        on: "Įjungti",
                        off: "šjungti",
                        add: "Pridėti",
                        save: "Išsaugoti",
                        monday: "Pirmadienis",
                        tuesday: "Antradienis",
                        wednesday: "Trečiadienis",
                        thursday: "Ketvirtadienis",
                        friday: "Penktadienis",
                        saturday: "Šeštadienis",
                        sunday: "Sekmadienis",
                        from: "Nuo",
                        to: "Kam",
                        hours: "valandos",
                        reset: "reset",
                        confirmation: "patvirtinimas",
                        cancel: "atšaukti",
                        yesIAmSure: "Taip, esu tikras",
                        set: "nustatyti",
                        auto: "auto",
                        manual: "manual",
                        minutes: "minutės",
                        seconds: "sekundės",
                        turnOn: "įjungti",
                        turnOff: "išjungti",
                        graphLoading: "grafa kraunasi...",
                        noData: "duomenų nerasta...",
                        hoursPerYear: "valandos/metus",
                        datetime: "data/laikas",
                        warning: "įspėjimas",
                        error: "klaida",
                        type: "tipas",
                        startdate: "Pradžios data",
                        enddate: "Pabaiga data",
                        all: "visi",
                        engine1: "variklis 1",
                        engine2: "variklis 2",
                        ongoing: "tęsiasi",
                        both: "abu",
                        days: "Dienos",
                        today: "Šiandiena",
                        sendAnswers: "Siųsti atsakymus",
                        employee: "Darbuotojas",
                        customer: "Klientas",
                        sales: "Pardavimai",
                        technician: "Technikas",
                        admin: "Admin",
                        noDateKnown: "No date known",
                        command: "Command",
                        user: "Vartotojas",
                        fillInSurvey: "Prašome užpildyti klausimyną",
                        tons: "tonos",
                        count: "Skaičiuoti",
                        disabled: "Disabled",
                        addField: "Pridėti laukelį",
                        deleteField: "Ištrinti laukelį",
                        releases: "Releases",
                        open: "Atidaryti",
                        close: "Uždaryti",
                        opening: "Atidaroma",
                        closing: "Uždaroma",
                        zoomCancel: "Mastelis atšauktas, norėdami padidinti, likite grafiko viduje",
                        stuck: "įstrigęs"
                    },
                    errorPage: {
                        title: "Kažkas nutiko.",
                        contact: "Praneškite apie šią problemą adresu it@biolectric.com ir nurodykite, kokį telefoną ar naršyklę naudojate.",
                        reload: "Įkelti iš naujo"
                    },
                    popups: {
                        engineIdle: "Variklis nėra tuščioje eigoje, prašome pirmiausia išjungti variklį",
                        valueBetween: "Reikšmė turi būti tarp {{min}} ir {{max}}",
                        valueBetweenCustom: "Reikšmė turi būti tarp {{min}} ir {{max}}",
                        powerTooLow: "Galia negali būti nustatyta žemiau nei {{watts}}W",
                        powerTooHigh: "Galia negali būti nustatyta aukščiau nei {{maxPower}}",
                        maxCoolingTemp: "Negali būti daugiau nei {{max}}°C",
                        minValue: "Negali būti mažiau nei {{min}}",
                        maxAirInjectionTime: "Negali būti ilgiau nei {{max}} sekundžių",
                        minGasBuffer: "Minimalus dujų buferis už ribų. Minimali reikšmė jūsų įrenginiui yra {{min}}",
                        maxGasBuffer: "Maksimalus dujų buferis už ribų. Maksimali reikšmė jūsų įrenginiui yra {{max}}",
                        reactorTemp: "Reaktoriaus temperatūra už ribų. Turi būti tarp {{min}} ir {{max}}",
                        reactorLevel: "Neleistinas reaktoriaus lygis. Maksimali reikšmė jūsų įrenginiui yra {{limit}}",
                        reactorLevelRange: "Reaktoriaus lygio reikšmė turi būti tarp {{min}} ir {{max}}",
                        commandFailed: "Nepavyko išsiųsti komandos",
                        commandSent: "Komanda išsiųsta",
                        commandSuccess: "Sėkmingai atnaujinote {{command}} iš {{previousValue}} į {{value}}",
                        commandMix1Hour: "Maišytuvas veiks 1 valandą",
                    },
                    menu: {
                        dashboard: 'Dashboard',
                        machines: 'Instaliacijos',
                        questionnaires: 'Klausimynai',
                        banners: "Banners",
                        errors: "Klaidos ir įspėjimai",
                        pcb: "Spausdintinės plokštės",
                        tasks: "Mano užduotys",
                        releases: "Release notes",
                        resellers: "Perpardavėjai",
                        users: "Vartotojai",
                        recommendations: "Rekomendacijos",
                        suggestions: "Rekomendacijų žinutės",
                        faultTrees: "Klaidų medziai",
                        assistant: "Asistentas",
                        language: "Kalba",
                        reconnection: "Ši instaliacija yra neprisijungusi. Pamėginkite gauti naują prisijungimą paspausdami mygtuką esantį žemiau.",
                        profile: "Profile",
                        logout: "Log out",
                        firmware: "Firmware",
                        sms: "SMS",
                        advanced: "Advanced",
                        errorsSingle: "Errors",
                        warnings: "Warnings",
                    },
                    statistics: {
                        label: "pavadinimas",
                        foamBeaterThermalStatus: "Putų plakiklio termikas",
                        exitPumpThermalStatus: "Išpumpavimo siurblio termikas",
                        thermalStatusOk: "Termikas neaktyvus, vartotojas gali veikti normaliai",
                        thermalStatusFault: "Termikas aktyvus, vartotojas sugedęs",
                        group1: "Grupė 1",
                        group2: "Grupė 2",
                        addProperty: "Pridėti nuosavybę",
                        removeProperty: "Ištrinti nuosavybę",
                        startTutorial: "Pradėti pamoką",
                        exitTutorial: "Baigti pamoką",

                        welcomeStep: {
                            title: "Sveiki atvykę į statistikos puslapį.",
                            content: "Čia galite palyginti skirtingas vertes ir tendencijas. "
                        },
                        propertyStep: {
                            title: "Nuosavybės pasirinkimas.",
                            content: "Norėdami pradėti, pasirinkite jus dominančią nuosavybę iš pasirinkimo laukelio."
                        },
                        addPropertyStep: {
                            title: "Nuosavybių pridėjimas ir pašalinimas",
                            content: "Pabandykite pridėti arba pašalinti nuosavybę, vienoje grupėje galite pridėti iki 4 nuosavybių."
                        },
                        groupStep: {
                            title: "Įjungiama 2 grupė.",
                            content: "Paspauskite pridėti nuosavybę, jog galėtumėte pasirinkti nuosavybę grupei 2. Nuosavybės šioje grupėje bus rodomos dešinėje grafiko pusėje."
                        },
                        dateRangeStep: {
                            title: "Pasirinkite datas",
                            content: "Naudokite šį mygtuką norėdami pasirinkti datas. Šiuo metu turite prieigą prie dviejų mėnesių istorijos."
                        },
                        zoomInStep: {
                            title: "Priartinti",
                            content: "Vilkite pelės žymeklį virš grafiko, kad pasirinktumėte sritį, kurią norite priartinti."
                        },
                        zoomOutStep: {
                            title: "Nutolinti",
                            content: "Iš naujo nustatykite anksčiau pasirinktas datas naudodami mygtuką Nutolinti."
                        },
                        domainStep: {
                            title: "Domenų koregavimas",
                            content: "Galite rinktis max ir min duomenis naudodami šiuos mygtukus."
                        },
                        csvStep: {
                            title: "Parsisiųsti csv duomenis",
                            content: "Atsisiųskite šiuo metu rodomus diagramos duomenis CSV formatu."
                        },
                        imageStep: {
                            title: "Parsisiųsti paveikslėlį",
                            content: "Atsisiųskite šiuo metu rodomą diagramą kaip paveikslėlį."
                        },
                        configurationStep: {
                            title: "Išankstinių nustatymų konfigūracija",
                            content: "Galite išsaugoti savo dabartinę konfigūraciją kaip išankstinį nustatymą. Taip pat galite atnaujinti arba ištrinti esamus išankstinius nustatymus."
                        },
                        controlCardTemp: "Kontrolės kortelės temperatūra (°C)",
                        lowTensionError: "Žemos įtampos klaida",
                        overTempFlueGasHeatExch: "Perkaitęs išmetamųjų dujų šilumokaitis",
                        feedingCycleLevel: "Maitinimo ciklo lygis (cm)",
                        batteryVoltage: "Akumuliatoriaus įtampa (V)",
                        waterPressure: "Vandens slėgis (mbar)",
                        shortInterval: "10 Minute Intervals",
                        dailyInterval: "Daily Intervals",
                        configurationUpdated: "Jūsų dabartinė konfigūracija buvo išsaugota šiame išankstinėje nustatyme",
                        presets: "Išankstiniai nustatymai",
                        savePreset: "Išsaugoti kaip išankstinį nustatymą",
                        applyPreset: "Taikyti išankstinį nustatymą",
                        updatePreset: "Atnaujinti išankstinį nustatymą",
                        delete: "Ištrinti",
                        noPresets: "Dar neturite išankstinių nustatymų",
                        givePresetName: "Suteikite savo išankstiniam nustatymui pavadinimą",

                    },
                    smart: {
                        label: "Smart",
                        heightOffset: "Aukščio poslinkis",
                        active: "Active",
                        passive: "Passive",
                        preActive: "Pre Active",
                        prePassive: "Pre Passive",
                        postActive: "Post Active",
                        postPassive: "Post Passive",
                        activeDesc: "Aktyvaus laikotarpio metu planuojama energijos gamyba maksimaliai padidinama. Prieš kiekvieną aktyvų laikotarpį automatiškai suteikiamas „ikiaktyvus“ laiko tarpas, kuriame kaupiamas dujų buferis. Maksimali aktyvaus laikotarpio trukmė nustatoma pagal dujų buferio tūrį, įrengtų CHP skaičių ir tipą bei įrenginio biodujų gamybos profilį. Pasiekus minimalų dujų buferio užpildymo lygį, energijos gamyba bus sustabdyta (poaktyvusis laikotarpis).",
                        passiveDesc: "Pasyviuoju periodu energija gaminama tik esant dujų pertekliui. Prieš kiekvieną pasyvųjį periodą automatiškai suteikiamas laiko tarpas, kurio metu sumažinamas dujų buferis. Maksimali pasyvaus laikotarpio trukmė nustatoma pagal dujų buferio tūrį ir įrenginio biodujų gamybos profilį. Pasiekus maksimalų dujų buferio užpildymo lygį, prasidės energijos gamyba (postpasyvus laikotarpis).",
                        permanence: "Stimulate constant production by dynamically running on one engine with a non-maximum gas buffer",
                        permanency: "Permanence",
                        activateStep: {
                            title: "SMART aktyvinimas",
                            content: "Suaktyvinkite SMART, kad galėtumėte valdyti įrenginio gamybos profilį"
                        },
                        timeslotStep: {
                            title: "Pridėkite laiko tarpą",
                            content: "Pridėkite aktyvų arba pasyvų laiko tarpą"
                        },
                        fromToStep: {
                            title: "Nuo / Iki",
                            content: "Jūs nustatote pradžios ir pabaigos dieną bei laiką"
                        },
                        activePassiveStep: {
                            title: "Actyvus ar pasyvus",
                            content: "Pasirinkite, ar norite nustatyti aktyvų ar pasyvų laiko tarpą"
                        },
                        saveStep: {
                            title: "Išsaugoti laiko tarpu",
                            content: "Išsaugokite pakeitimų nustatymus"
                        },
                        removeStep: {
                            title: "Pašalinkite laiko tarpus",
                            content: "Pašalinkite savo laiko tarpą čia"
                        },
                        visualStep: {
                            title: "Vizuali reprezentacija",
                            content: "Šioje diagramoje SMART nustatymai lyginami su praėjusios savaitės gamybos profiliu"
                        },
                        daySwitchStep: {
                            title: "Vizuali reprezentacija",
                            content: "Lengvai naviguokite į kitą ar ankstesnę dieną"
                        },
                    },
                    gas: {
                        label: "Dujos",
                        minGasBufferLevel: "Min dujų lygis buferyje",
                        maxGasBufferLevel: "Max dujų lygis buferyje",
                        gasBufferLevel: "Dujų lygis buferyje",
                        defaultMinGasBufferLevel: "Numatytasis min. dujų lygis buferyje ",
                        defaultMaxGasBufferLevel: "Numatytasis max. dujų lygis buferyje",
                        airInjectionTime: "Aeracija",
                        maxAirInjectionTime: "Max aeracija",
                        torch: "Degiklis",
                        torchType: "Degiklio tipas",
                        torchStatus: "Degiklio statusas",
                        torchError: "Degiklio klaida",
                        theoreticalTorchFlow: "Teorinis degiklio srautas",
                        torchRunningTime: "Degiklio veikimo laikas",
                        torchFlaredVolume: "Deginto dujų kiekis",
                        h2s: "H₂S",
                        h2sLevelReactor: "H₂S lygis reaktoriuje",
                        h2sLevelMotor: "H₂S lygis variklyje",
                        filterLoad: "Anglies filtro apkrova",
                        sample: "Mėginys",
                        latestH2sReadings: "Naujausi H₂S rodmenys",
                        carbonFilterSize: "Anglies filtro dydis",
                        h2sMeasurements: "H₂S matavimai",
                        measurements: "Matavimai",
                        changeTo: "Pakeisti į",
                        none: "Jokios",
                        container: "Konteineris",
                        extern: "Išorinis",
                        foamBeaterInstalled: "Putų plakiklis įdiegtas",
                        antiFoamInjectionsInstalled: "Antiputų injekcijos įdiegtos",
                        containerCombinedOperation: "Konteineris (kombinuota operacija)",
                        externCombinedOperation: "Išorinis (kombinuota operacija)",
                        gasTemp: "T1 Temperature After Gascooler",
                        ch4BiogasSupply: "CH4 biodujų tiekimas",
                        co2BiogasSupply: "CO2 biodujų tiekimas",
                        o2BiogasSupply: "O2 biodujų tiekimas",
                        h2sAfterFilter: "H2S po filtro",
                        biomethaneFlowNorm: "Normalizuota biometano tėkmė",
                        ch4Biomethane: "CH4 biometanas",
                        co2Biomethane: "CO2 biometanas",
                        o2Biomethane: "O2 biometanas",
                        h2sBiomethane: "H2S biometanas",
                        bufferRelease: "Buferio išleidimas",
                        wobbe: "Wobbe indeksas",
                        wobbeAvg: "Vidutinis Wobbe indeksas",
                        wobbePidSetpoint: "Wobbe PID nustatyta reikšmė",
                        wobbeBiomethanePronova: "Wobbe biometanas Pronova",
                    },
                    engine: {
                        label: "Variklis",
                        startEngine: "Užvesti variklį",
                        stopEngine: "Sustabdyti variklį",
                        power: "Galia",
                        desiredPower: "Nustatyta galia",
                        maxPower: "Max galia",
                        rpm: "Apsisukimai per minutę (RPM)",
                        lambda: "Lambda",
                        throttleValve: "Servo padėtis",
                        engineType: "Variklio tipas",
                        engineStatus: "Variklio statusas",
                        engineError: "Variklio klaidos",
                        producedEnergy: "Visa pagaminta energija",
                        operatingHours: "Darbo valandos",
                        totalOperatingHours: "Visos darbo valandos",
                        gasUsage: "Dujų sunaudojimas",
                        throttlePosition: "Droselio pozicija",
                        noErrors: "Visos sistemos veikia.",
                        production: "Produkcija",
                        servoManually: "Servo nustatytas rankiniu būdu",
                        servoAuto: "Servo nustatytas automatiniu būdu",
                        servoControl: "Servo valdymas",
                        temperature: "Variklio temperatūra",
                        restart: "Perkraukite automatiškai kai bus dujų",
                        confirmStop: "Ar tikrai norite sustabdyti variklį {{number}}?",
                        confirmStopRestart: "Ar tikrai norite sustabdyti variklį {{number}}? Jis persikraus automatiškai, kai bus dujų.",
                        idle: "Idle",
                        running: "Veikia",
                        waiting: "Laukiama paleidimo",
                        booting: "Paleidžiama",
                        shuttingDown: "Išjungiama",
                        advanced: "Pažengęs",
                        numberOfEngines: "variklių kiekis",
                        predeterminedRunHours: "Nustatytos veikimo valandos",
                        easyStart1: "Easy start engine 1",
                        easyStart2: "Easy start engine 2",
                        setError1: "Set error engine 1",
                        setError2: "Set error engine 2",
                        fuel: "Kuras",
                        airIntakeOpen: "Oro įsiurbimas atidarytas",
                        airIntakeClosed: "Oro įsiurbimas uždarytas",
                        vfd: "VFD",
                    },
                    service: {
                        label: "Servisas",
                        lastMaintenance: "Darbo valandos iki kito tepalų keitimo",
                        currentlyInstalled: "Šiuo metu įdiegtos darbo valandos",
                        total: "Visos darbo valandos",
                        mixer: "Maišytuvas",
                        foam_beater: "Putų plakiklis",
                        intake_pump: "Įsiurbimo pompa",
                        digestate_pump: "Digestato pompa",
                        newEngine: "Sumontuotas naujas variklis",
                        newMixer: "Sumontuotas naujas maišytuvas",
                        newEngine: "Sumontuotas naujas variklis",
                        newFoamBeater: "Sumontuotas naujas putų plaktuvas",
                        newIntakePump: "Sumontuotas naujas įsiurbimo siurblys",
                        newDigestatePump: "Sumontuota nauja digestato pompa",
                        confirmationMessage: "Ar tikrai norite iš naujo nustatyti",
                        maintenanceMessage: "Techninės priežiūros valandos buvo nustatytos iš naujo",
                        newEquipmentMessage: "Sumontuota nauja įranga:",
                        prints: "spaudiniai",
                        firstOnline: "First online",
                        lastOnline: "Last online",
                        serial: "Serijinis",
                        type: "Tipas",
                        engine: "Variklis",
                        engine1: "Engine 1",
                        engine2: "Engine 2",
                        engine_new1: "Engine 1",
                        engine_new2: "Engine 2",
                        h2s1: "H₂S Engine 1",
                        h2s2: "H₂S Engine 2",
                        resetTo: "Reset to x hours (default 0)",
                        timeFilterReplace: "Laikas nuo filtro pakeitimo",
                        daysSinceOil: "Dienos nuo tepalų keitimo",
                        newGenerator: "Sumontuotas naujas generatorius",
                        generator: "Generatorius",
                        daysSinceOilChange: "Dienos nuo tepalų keitimo",
                        videoMessage: "Vaizdo įrašas apie tepalų keitimą => Dokumentų puslapis, skiltyje. Bendrieji vaizdo įrašai.",
                        videoRoom: "A service technician has opened a video room for this machine, Click here to join",
                        videoButton: "Start a video room for this machine",
                        videoButtonSub: "Users with access can join the call from their service page",
                        videoClose: "Close video room",
                        serialNumber: "Serijos numeris",
                        defaultEngineReset: "Numatytasis variklio atkūrimas",
                        newInstalled: "Naujas {{type}} įdiegtas",
                        replace: "Pakeisti",
                        aircover: "Oro apsauga",
                        gascover: "Dujų apsauga",
                        liner: "Pamušalas",
                        flow_meter: "Debito matuoklis",
                        energy_meter1: "Energijos skaitiklis 1",
                        energy_meter2: "Energijos skaitiklis 2",
                        energy_meter_own: "Energijos skaitiklis savas suvartojimas",
                        h2sPastille: "Laikas iki H2S jutiklio pakeitimo",
                        pastille1: "H₂S jutiklis 1",
                        pastille2: "H₂S jutiklis 2",
                        engineLabel: "Kitas variklio aptarnavimas po “XX” valandų",
                        engine1Conf: "Nustatykite variklio 1 aptarnavimo intervalą iš naujo tik po atlikto aptarnavimo",
                        engine2Conf: "Nustatykite variklio 2 aptarnavimo intervalą iš naujo tik po atlikto aptarnavimo",
                        h2s1Conf: "Nustatykite H2S variklį 1 iš naujo tik tada, kai pakeistas aktyvintos anglies filtras",
                        h2s2Conf: "Nustatykite H2S variklį 2 iš naujo tik tada, kai pakeistas aktyvintos anglies filtras",
                        filterResetOffline: "Įrenginys neprisijungęs. Filtro atstatymas nebuvo išsaugotas. Prisijunkite iš naujo ir bandykite dar kartą.",
                        filterResetFailed: "Filtro atstatymas nepavyko. Filtro atstatymas nebuvo išsaugotas.",
                        consumables: {
                            title: "Eksploatacinės medžiagos",
                            belowMin: "Žemiau minimalaus likučio",
                            noneBelow: "Nėra gaminių žemiau minimalaus likučio",
                            notCounted: "Dar nesuskaičiuota",
                            article: "Gaminio numeris",
                            description: "Aprašymas",
                            onSite: "Yra vietoje",
                            minimum: "Minimumas",
                            engineMaintenance: "Variklio aptarnavimas",
                            pendingStock: "{{confirmed}} patvirtinta + {{pending}} laukia patvirtinimo",
                            send: "Siųsti",
                            shipmentSaved: "Siunta išsaugota. Ji lieka laukianti, kol klientas patvirtins.",
                            shipmentFailed: "Nepavyko išsaugoti siuntos",
                            confirm: "Patvirtinti gavimą",
                            confirmSaved: "Likutis patvirtintas",
                            confirmFailed: "Nepavyko patvirtinti likučio",
                            confirmHint: "Patvirtinkite pristatymą, kad jis būtų pridėtas prie likučio vietoje.",
                            guideTitle: "Kaip tai veikia",
                            guideIntro: "Alyva, alyvos filtrai ir uždegimo žvakės lieka kiekviename įrenginyje. Įrenginio aptarnavimo puslapis ir šis užsakymų puslapis naudoja tą patį likutį.",
                            guide1Role: "Technikas",
                            guide1Title: "Suskaičiuokite, kas yra vietoje",
                            guide1Body: "Įrenginio aptarnavimo puslapyje atidarykite Eksploatacines medžiagas ir įrašykite, kiek kiekvieno gaminio iš tikrųjų yra. Šis skaičius iš karto patvirtinamas. Skaičiavimas vietoje nelaukia nieko kito.",
                            guide2Role: "Automatiškai",
                            guide2Title: "Variklio aptarnavimas naudoja likutį",
                            guide2Body: "Užregistravus variklio aptarnavimą, to variklio sąnaudos atimamos iš patvirtinto likučio. WG1605 aptarnavimas sunaudoja 0,28 iš 25 l alyvos bakelio, 1 alyvos filtrą ir 4 žvakes. WG972 ir WG3800 naudoja variklio aptarnavimo lentelės kiekius. Tai vyksta, kai įrenginys turi statistikos įrašą su variklio tipu.",
                            guide3Role: "Aptarnavimo vadovas",
                            guide3Title: "Išsiųskite tai, ko trūksta",
                            guide3Body: "Šiame puslapyje rodomi įrenginiai, kurių patvirtintas likutis yra mažesnis arba lygus minimumui. Įrašykite siunčiamą kiekį ir paspauskite Siųsti. Jis lieka laukiantis, pavyzdžiui 0,5 patvirtinta + 5 laukia patvirtinimo, ir dar neskaičiuojamas kaip likutis. Minimumas nustatomas pagal variklio tipą. Įrenginys naudoja įdiegtų variklių sumą, suapvalintą iki sveikojo skaičiaus. Vienas alyvos vienetas yra 25 l bakelis.",
                            guide4Role: "Kiekvienas, turintis prieigą",
                            guide4Title: "Patvirtinkite pristatymą",
                            guide4Body: "Kai prekės yra vietoje, klientas, technikas arba darbuotojas patvirtina gavimą įrenginio aptarnavimo puslapyje. Laukiančio kiekio pridedama prie patvirtinto likučio. 0,5 patvirtinta ir 5 laukiantys tada tampa 5,5 vietoje.",
                            correction: "Likučio korekcija",
                            save: "Išsaugoti likutį",
                            saved: "Likutis išsaugotas",
                            saveFailed: "Nepavyko išsaugoti likučio",
                            minSaved: "Minimalus likutis išsaugotas",
                            minFailed: "Nepavyko išsaugoti minimalaus likučio",
                            minHint: "Nustatykite minimumą pagal variklio tipą. Įrenginys naudoja įdiegtų variklių sumą, suapvalintą iki sveikojo skaičiaus. Jis rodomas, kai likutis yra mažesnis arba lygus tam minimumui. Vienas alyvos vienetas yra 25 l bakelis.",
                            usage: "Sąnaudos vienam variklio aptarnavimui",
                            usageHint: "Užregistravus variklio aptarnavimą, šios sąnaudos atimamos iš suskaičiuoto likučio. DF972 ir WG972 naudoja stulpelį WG972. WG3800-L naudoja stulpelį WG3800.",
                            orders: "Užsakymai paleidimui",
                            ordersEmpty: "Nėra įrenginių, kurių likutis lygus minimumui ar mažesnis",
                            shortage: "Trūkumas",
                            installation: "Įrenginys",
                            engines: "Varikliai",
                        },
                        pastille1Conf: "Nustatykite H2S jutiklio 1 tarnavimo laiką iš naujo tik tada, kai pakeistas jutiklio elementas.",
                        pastille2Conf: "Nustatykite H2S jutiklio 2 tarnavimo laiką iš naujo tik tada, kai pakeistas jutiklio elementas.",
                        pastilleLabel: "Numatomas jutiklio elemento tarnavimo laikas XX dienų",
                        valve_interval: "Darbo valandos iki vožtuvų tarpų tikrinimo",
                        cylinder_interval: "Darbo valandos iki cilindro galvutės kapitalinio remonto",
                        valve_interval_engine1: "Darbo valandos iki vožtuvų tarpų tikrinimo – variklis 1",
                        cylinder_interval_engine1: "Darbo valandos iki cilindro galvutės kapitalinio remonto – variklis 1",
                        valve_interval_engine2: "Darbo valandos iki vožtuvų tarpų tikrinimo – variklis 2",
                        cylinder_interval_engine2: "Darbo valandos iki cilindro galvutės kapitalinio remonto – variklis 2",
                        pipe: "Vamzdis",
                        transmitter: "Siųstuvas",
                        elektromotor: "Elektros variklis",
                        pump: "Siurblys",
                        roofsolation: "Stogo izoliacija",
                        airPump: "Oro įpurškimo siurblys",
                        oxygenConcentrator: "Deguonies koncentratorius",
                        flowmeterBiogas: "Dujų srauto matuoklis",
                        pronovaBiomethaan: "ProNova biometanas",
                        pronovaBiogas: "ProNova dujos",
                        h2s1Gpi: "Anglies filtras 1",
                        h2s2Gpi: "Anglies filtras 2",
                        coolant: "Aušinimo skystis",
                        daysSinceCoolantReplace: "Dienos nuo pakeitimo",
                        coolantConf: "Aušinimo skysčio darbo valandas nustatykite iš naujo tik jį pakeitę",
                        daysSinceInhibitor: "Dienos nuo inhibitorių paketo",
                        inhibitorPackage: "Inhibitorių paketas",
                        registerInhibitor: "Registruoti",
                        inhibitorConf: "Registruokite tik po to, kai aušinimo skystis papildytas inhibitorių paketu (kas 12 mėnesių)",
                        restoreValues: {
                            button: "Atkurti PLC reikšmes",
                            title: "Atkurti PLC reikšmes",
                            description: "Pasirinkite teisingą dieną iš paskutinių 7 dienų, peržiūrėkite iš anksto užpildytas reikšmes ir siųskite jas į PLC.",
                            pickDay: "Pasirinkite dieną",
                            snapshotTime: "Mėginio laikas",
                            noSnapshots: "Paskutinių 7 dienų statistikos nerasta.",
                            send: "Siųsti",
                            sendAll: "Siųsti viską",
                            sending: "Siunčiama…",
                            confirmSendAll: "Siųsti visas iš anksto užpildytas reikšmes į PLC?",
                            sendAllDone: "Į PLC išsiųsta {{count}} reikšmių",
                            emptyValue: "Reikšmė tuščia",
                            invalidValue: "Reikšmė nėra skaičius",
                            invalidEngineCount: "Variklių skaičius turi būti 1 arba 2",
                            noConnection: "Mašina neturi aktyvaus ryšio",
                            readOnly: "tik skaitymui",
                            fromMachine: "iš mašinos įrašo",
                            current: "Dabar",
                            currentHint: "Dabartinė slow/fast reikšmė CU",
                            ups: "UPS",
                            groupEngines: "Varikliai",
                            groupReactor: "Reaktorius ir maišymas",
                            groupFeeding: "Šėrimas",
                            groupGas: "Dujos",
                            groupEnergy: "Energijos skaitikliai",
                            groupSsr: "SSR",
                        },
                        tabs: {
                            engine: "Variklis",
                            reactor: "Reaktorius / Konteineris",
                            gas: "Dujos / Valymas",
                            consumables: "Eksploatacinės medžiagos",
                            options: "Mašinos parinktys",
                            prints: "Spausdinimai",
                            restoreValues: "Atkurti PLC reikšmes",
                        },
                    },
                    net: {
                        net: "Tinklas",
                        meterSettings: "Skaitiklio nustatymai",
                        voltagePerPhase1: "Fazės įtampa 1",
                        voltagePerPhase2: "Fazės įtampa 2",
                        voltagePerPhase3: "Fazės įtampa 3",
                        frequencyPerPhase: "Fazės dažnis",
                        angleBetweenPhase1And2: "Kampas tarp 1 ir 2 fazės",
                        ownPowerConsumption: "Savos galios suvartojimas",
                        ownEnergyConsumption: "Savos energijos sunaudojimas",
                        bioguardVersion: "Bioguard versija",
                        brutoProducedEnergy: "Bruto pagaminta energija",
                        nettoProducedEnergy: "Neto pagaminta energija",
                        producedEnergy: "Pagaminta energija",
                        producedEnergyEngine1: "Pagaminta energija varikls 1",
                        producedEnergyEngine2: "Pagaminta energija variklis 2",
                        monitoringRelay: "Stebėjimo rėlė",
                        powerNonFit: "Savos galios suvartojimas",
                        energyMeterNonFit: "Savos energijos sunaudojimas",
                    },
                    reactor: {
                        label: "Reaktorius",
                        reactorTemp: "Reaktoriaus temperatūra",
                        reactorTempTarget: "Reaktoriaus temperatūros tikslas",
                        reactorLevel: "Norimas reaktoriaus lygis",
                        hydrostaticPressure: "Dabartinis reaktoriaus lygis",
                        siloType: "Silo tipas",
                        extraHeating: "Papildomas šildymas aktyvus",
                        antiFrost: "Anti frost",
                        antiFrostIndex: "AntiFrost indeksas",
                        antiFrostAuto: "Užšalimo indeksas nustatomas automatiškai, atsižvelgiant į vietinę temperatūrą",
                        antiFrostMessageNew: "Kiekvienas užšalimo indekso ciklas suaktyvins įsiurbimo siurblį 4 s, o išėjimo siurblys išsikraus apytiksliai. 100 l digestato, remiantis srauto greičiu. ",
                        antiFrostMessageOld: "Kiekvienas užšalimo indekso ciklas suaktyvins įsiurbimo siurblį 4 s, o išleidimo siurblį 120 s.",
                        coolwater: "Šaltas vanduo",
                        statusCoolingValve: "Šalto vandens vožtuvas",
                        waterTempIn: "Įeinančio šalto vandens temperatūra",
                        waterTempOut: "Išeinančio šalto vandens temperatūra",
                        waterTempMotorOut: "Vandens temperatūra išeinanti iš 1 variklio",
                        waterTempMotorOut2: "Vandens temperatūra išeinanti iš 2 varklio",
                        coolingWaterTemp: "Pageidaujama vėsaus vandens temperatūra",
                        maxCoolingWaterTemp: "Max aušinimo vandens temp",
                        waterPressure: "Vandens slėgis šalto vandens grandinėje",
                        foamBeater: "Putos",
                        foambeatEveryXMinutes: "Maišyti putas kas",
                        foambeatForXSeconds: "For",
                        mixer: "Maišytuvas",
                        mixerMaxPower: "Max maišytuvo jėga",
                        mixerActive: "Maišytuvas aktyvus",
                        mixerBlockedLowLevel: "Maišytuvas užblokuotas dėl žemo reaktoriaus lygio",
                        mixEveryXMinutes: "Maišyti kas",
                        mixForXSeconds: "For",
                        blockMixingFrom: "Jokio maišymo nuo",
                        blockMixingTo: "To",
                        mixerInfo: "Maišytuvas automatiškai įsijungia pasirinktam laikui su pasirinktu laiko intervalu. Maišytuvo bloko laiko lango metu maišytuvas sustabdomas, kai sumontuota maišytuvo galia viršija esamą įrenginio galią. Maišytuvas laikinai sustabdomas paleidžiant CHP, kol pasiekiama 50% vardinės galios, kad būtų užtikrinta įsijungimo srovė.",
                        mixerInfoGpi: "Maišytuvas automatiškai įsijungia pasirinktam laikui su pasirinktu laiko intervalu. Maišytuvo bloko laiko lango metu maišytuvas sustabdomas, kai sumontuota maišytuvo galia viršija esamą įrenginio galią.",
                        mix1Hour: "Maišyti 1val. ",
                        coolwaterValveInstalled: "Control valve by-pass / fan",
                        coolwaterValveBinary: "Dvejetainis trijų krypčių vožtuvas",
                        coolwaterValveMaximizeHeat: "Maksimizuoti šilumos naudojimą",
                        coolwaterValveMaximizeHeatInfo: "Šilumos naudojimo maksimizavimas gali lemti laikotarpius be šilumos prieinamumo plokšteliniame šilumokaityje",
                        coolwaterValvePlatePriority: "Plokštelinio šilumokaičio prioritetas",
                        coolwaterValvePlatePriorityInfo: "Prioritetizuoti šilumos prieinamumą plokšteliniame šilumokaityje, palaikant stabilią digesterio temperatūrą",
                        bypass: "Valdymo vožtuvo apėjimas/ventiliatorius",
                        digester: "Control valve digester / external heat consumption",
                        silo: "Silo",
                        bag: "Maišas",
                        plateHeatExchanger: "Plokštelinis šilumokaitis",
                        timesPerDay: "laikas / dieną",
                        intern: "Vidinis",
                        extern: "Išorinis",
                        tempHigh: "Aukšta temperatūra",
                        externMessage: "Jei maišytuvas nustatytas išoriškai, ši klaida nebus suaktyvinta: Maišytuvas neveikia, iš naujo nustatykite thermal.",
                        bypass: "By-pass",
                        ventilator: "Ventiliatorius",
                        tempCoolHeatExchOut: "Vandens temperatūra šilumokaities išėjime",
                        overtempMixer1: "Per aukšta temperatūra maišytuvo 1",
                        overtempMixer2: "Per aukšta temperatūra maišytuvo 2",
                        mixerSettings: "Maišytuvo nustatymai",
                        premixing: "Išankstinis maišymas",
                        intakeMixing: "Maišymas įleidžiant",
                        premixingInfo: "Išankstinis maišymas – maišymas prieš šėrimą, t. y. prieš ir per išpumpavimą. Laikas visada reiškia maišymo trukmę.",
                        intakeMixingInfo: "Maišymas įleidžiant leidžia maišyti tuo pačiu metu kaip įleidžiant. Kai OFF, maišymas nevykdomas, kol vyksta šėrimas.",
                        gpiMixDuringIntake: "Maišymas skysto šėrimo metu",
                        gpiMixDuringIntakeInfo: "Maišymas visą skysto šėrimo laiką.",
                        gpiMixDuringIntakeHelp: "Maišymas skysto šėrimo metu: maišymas visą šėrimo laiką. Kai OFF: priklauso nuo silo tipo.\n\nS tipai: tik išankstinis maišymas išpumpuojant ir maišymas po šėrimo maišytuvo trukmę.\n\nC tipai: be išankstinio maišymo; maišymas po šėrimo maišytuvo trukmę.",
                        gpiMixDuringIntakeOffGeneric: "Kai OFF: priklauso nuo silo tipo.",
                        gpiMixDuringIntakeOffS: "S tipai: tik išankstinis maišymas išpumpuojant ir maišymas po šėrimo maišytuvo trukmę.",
                        gpiMixDuringIntakeOffC: "C tipai: be išankstinio maišymo; maišymas po šėrimo maišytuvo trukmę.",
                        gpiMixDuringSolidFeedIntake: "Maišymas kieto šėrimo metu",
                        gpiMixDuringSolidFeedIntakeInfo: "Kai ON: maišymas visą kieto šėrimo laiką. Kai OFF: maišymas tik prieš ir po kieto šėrimo, kiekvieną kartą tiek laiko (sekundėmis), kiek nustatyta „{{durationSetting}}“.",
                        gpiMixTimeBeforeAfterSolidIntake: "Maišymo laikas prieš/po kieto šėrimo",
                    },
                    efficiency: {
                        label: "Našumas",
                        production: "Energijos produkcija per paskutines 30 dienų",
                        consumption: "Energijos suvartojimas per paskutines 30 dienų",
                        nettoProduction: "Neto energijos produkcija per paskutines 30 dienų",
                        averageEfficiency: "30 dienų produktyvumo vidurkis",
                        averageTechnicalEfficiency: "30 dienų techninio prieinamumo vidurkis",
                        bgp: "Mėšlo kokybė (BGP batch)",
                        top10: "Top 10 projektų praėjusį mėnesį",
                        realised: "Realizuotas efektyvumas",
                        technical: "Techninis prieinamumas",
                        bgpInfo: "BGP įvertinimas [m³/t]. Neatsižvelgiama į nuostolius, atsiradusius dėl prastovos, perprodukcijos ar deginimo.",
                        pointPerDay: "%/dieną",
                        trendline: "Tendencijos linija",
                    },
                    general: {
                        label: "Pagrindini",
                        hardwareVersion: "Aparatinės įrangos versija",
                        otGenContact: "OT Gen kontaktas",
                        engine1And2Off: "Variklis 1 ir 2 išjungti",
                        engine1On: "Variklis 1 įjungtas",
                        engine2On: "Variklis 2 įjungtas",
                        engine1And2On: "Variklis 1 ir 2 įjungti",
                        notes: "Pastabos",
                        h2sSensorFirmwareVersion: "H₂S programinės įrangos versija",
                        idH2s: "S/N H₂S ID",
                        bioId: "S/N Biotronic ID",
                        identifier: "Instaliacijos identifikatorius",
                        collabContract: "Bendradarbiavimo sutartis",
                        own: "Techninės priežiūros sutartis",
                        sold: "Parduota instaliacija",
                        productionDate: "Pagaminimo data",
                        commissioningDate: "Paleidimo data",
                        controlCardTemp: "Kontroliuoti kortelės temperatūrą",
                        batteryVoltage: "Akumuliatoriaus įtampa",
                        motorVoltage: "Variklio įtampa",
                        overtempFlueGasHeatExch: "Perkaitęs išmetamųjų dujų šilumokaičio variklis",
                        rebootMainBoard: "Perkraukite pagrindinę plokštę",
                        rebootNow: "Perkrauti dabar",
                        utcOffset: "UTC offset",
                        location: "Lokacija",
                        network: "Tinklas",
                        ip: "IP",
                        mask: "Mask",
                        gateway: "Vartai",
                        dns: "DNS",
                        pcb: "PCB",
                        firmware: "Programinė įranga",
                        mainControlUnit: "Pagrindinis valdymo blokas",
                        bioguard: "Bioguard",
                        biotronicEngine1: "Biotronic variklis 1",
                        biotronicEngine2: "Biotronic variklis 2",
                        h2sEngine1: "H₂S variklis 1",
                        h2sEngine2: "H₂S variklis 2",
                        bioIdEngine1: "Bio id variklis 1",
                        bioIdEngine2: "Bio id variklis 2",
                        modificationsToMachine: "Mašinos modifikacijos",
                        name: "Vardas",
                        hostNameFirmware: "Firmware",
                        hostNameDatabase: "Duomenų bazė",
                        normal: "Normalus",
                        lowError: "Žemas (klaida)",
                        nta8080Title: "NTA 8080 ataskaita",
                        nta8080Description: "Atsisiųskite mėnesinę NTA 8080 ataskaitą. Duomenys įkeliami tik paprašius ataskaitos.",
                        nta8080Month: "Mėnuo",
                        nta8080Download: "Atsisiųsti ataskaitą",
                        nta8080DownloadPdf: "Atsisiųsti PDF",
                        nta8080DownloadCsv: "Atsisiųsti CSV",
                        nta8080Loading: "Ruošiama…",
                        nta8080SelectMonth: "Pirmiausia pasirinkite mėnesį",
                        nta8080InvalidMonth: "Pasirinktas neteisingas mėnuo",
                        nta8080DownloadError: "Nepavyko atsisiųsti ataskaitos",
                    },
                    feeding: {
                        label: "Maitinimas",
                        feedingVolume: "Maksimalus šviežio šėrimo tūris per ciklą",
                        feedingCyclesPerDay: "maitinimo dienos ciklas",
                        feedingCyclesPerDayInfo: "Jei išpumpuotas tūris yra mažesnis nei 75 % norimo tūrio, sukeliama šėrimo klaida „nėra srauto įleidžiant šviežią mėšlą“. Jei išpumpuotas tūris yra nuo 75 % iki 100 % norimo tūrio, rodomas pranešimas „Maitinimo ciklas iš dalies atliktas. Tuščia duobė aptikta prieš pasiekiant nustatytą tūrį“.",
                        feedingBalance: "maitinimo balansas",
                        autoFeedingActive: "Auto maitinimas aktyvus",
                        blockHighElectricalConsumption: "Blokuoti šilumos siurblio fermentoriaus šildymą maišymo lango metu",
                        blockHighElectricalConsumptionInfo: "Kai ON: šilumos siurblio fermentoriaus šildymas blokuojamas maišymo lango metu. Kai OFF: neblokuojama.",
                        minimizeElectricalConsumptionFrom: "Sumažinti elektros suvartojimą nuo",
                        minimizeElectricalConsumptionTo: "iki",
                        autoFeedingStartHour: "Automatinio maitinimo pradžios laikas",
                        exitPumpRunning: "Išpumpuokite būdu",
                        feedingCycle: "Maitinimo ciklas",
                        onlyInput: "Tik įsiurbimas",
                        onlyOutput: "Tik išsiurbimas",
                        startFeeding: "Pradėti maitinimą",
                        stopFeeding: "Sustabdyti maitinimą",
                        customAmount: "Pasirinktinis kiekis",
                        customAmountHint: "Iš anksto užpildyta nustatyta maitinimo apimtimi. Keiskite tik pasirinktiniam kiekiui. Maks. {{maxRiseCm}} cm lygio kilimas ({{maxLiters}} l šiam silosui).",
                        customAmountInvalid: "Įveskite reikšmę tarp {{min}} ir {{max}} l",
                        customAmountExceedsLevelRise: "Įvestas kiekis ({{amount}} l) pakeltų bako lygį daugiau nei {{maxRiseCm}} cm. Maksimumas šiam silosui – {{maxLiters}} l.",
                        customAmountUnknownSilo: "Negalima apskaičiuoti maksimalaus kiekio: nežinomas siloso tipas.",
                        customAmountExceedsWarning: "Įvestas kiekis ({{amount}} l) yra didesnis nei nustatyta maitinimo apimtis ({{feedingVolume}} l). Ar tikrai norite tęsti?",
                        pumpOutFlowRate: "Pageidaujamas išpumpavimo srautas",
                        pumpOutFlowRateInfo: "Teorinis išpumpavimo srautas naudojamas apskaičiuoti, kiek laiko užtruks išpumpuoti digestatą iš fermentatoriaus. Per žemas nustatymas išpumpuos per daug digestato, per aukštas – per mažai. Tipinės vertės:",
                        pumpOutFlowRateBellowsPump: "Membraninė siurblys: ± 3 m³/h",
                        pumpOutFlowRateCentrifugalPump: "Centrifuginis siurblys: ± 50 m³/h",
                        pumpOutFlowRateGravityOutlet: "Gravitacinis išleidimas: ± 50 m³/h",
                        kiloPerPulse: "Srauto matuoklio impulsas",
                        intakeTimeout: "Įsiurbimas baigėsi",
                        averageDailyFeeding: "Kasdienio maitinimo mėnesio vidurkis",
                        retentionTime: "Sulaikymo laikas",
                        statusValvePumpIn: "Valve fresh in - 2",
                        statusValvePumpOut: "Išėjmo vožtuvas reaktoriuje - 3",
                        statusValveRetourReactor: "Valve retour reactor - 4",
                        valveCurrentActuator: "Vožtuvo srovė",
                        actuatorSetting: "Aktuatoriaus nustatymas",
                        actuatorSettingV1: "Linak",
                        actuatorSettingV2: "Hiwin / Mikrosystem",
                        lastFeeding: "Dabartinis – paskutinis",
                        startHourLastFeeding: "Paskutinio maitinimo pradžios laikas",
                        feedingStatus: "Maitinimo būssena",
                        feedingError: "Maitinimo klaidos",
                        intakePumpTime: "Įsiurbimo laikas",
                        intakePumpAmount: "Įsiurbimo kiekis",
                        exitPumpTime: "Išėjimo laikas",
                        exitPumpAmount: "Išėjimo kiekis",
                        feedingHistory: "Maitinimo istorija",
                        startedOn: "Prasidėjo",
                        temperature: "Temperatūra",
                        reactorLevel: "reaktoriaus lygis",
                        balance: "Balansas",
                        acknowledge: "Klaidos patvirtinimas",
                        intakeSpeed: "įsiurbimo greitis",
                        balanceWarning: "Įspėjimas, tai nepradės normalaus maitinimo ciklo, o į reaktorių pumpuos likusią balanso vertę",
                        automaticFeedingSettings: "Automatinio maitinimo nustatymai",
                        manualFeeding: "Rankinis maitinimas",
                        pumpSettings: "Pumpavimo nustatymai",
                        lastFeedingTime: "Paskutinio maitinimo laikas",
                        status: {
                            "0": "Tuščia eiga",
                            "1": "Lygio jutimas",
                            "2": "Exit",
                            "3": "Įsiurbimas",
                            "5": "Defrost",
                            "6": "Dujų paleidimas",
                            "7": "Rankinis išėjimas",
                            "10": "Paleidimas",
                            "2,001": "Exit: Išankstinis maišymas",
                            "2,002": "Exit",
                            "2,003": "Exit: Atidarykite išėjimo vožtuvą",
                            "2,004": "Exit: Atidarykite išėjimo vožtuvą",
                            "2,005": "Exit: Paleidžiamas išėjimo siurblys",
                            "2,006": "Exit",
                            "2,007": "Exit: Mėšlo siurbimas",
                            "2,008": "Exit: Stop exit",
                            "2,009": "Exit: Stop exit",
                            "2,010": "Exit: Uždarykite išėjimo vožtuvą",
                            "2,011": "Exit: Uždarykite išėjimo vožtuvą",
                            "2,012": "Exit: Stop exit",
                            "3,001": "Įsiurbimas: Ruošiama",
                            "3,002": "Įsiurbimas: Ruošiama",
                            "3,003": "Įsiurbimas: Ruošiama",
                            "3,004": "Įsiurbimas: Mėšlo siurbimas",
                            "3,005": "Įsiurbimas: Mėšlo siurbimas",
                            "3,006": "Įsiurbimas: Baigiamas",
                            "3,007": "Įsiurbimas: Baigiamas",
                            "3,008": "Įsiurbimas: Stop pump",
                            "3,009": "Įsiurbimas: Stop pump",
                            "3,010": "Įsiurbimas: Stop pump",
                            "3,011": "Įsiurbimas: Stop pump",
                            "3,012": "Įsiurbimas: Finishing",
                            "5,001": "Defrost: Testuojamas įsiurbimas",
                            "5,002": "Defrost: Testuojamas įsiurbimas",
                            "5,003": "Defrost: Testuojamas įsiurbimas",
                            "5,004": "Defrost: Testuojamas įsiurbimas",
                            "5,005": "Defrost: Stabdomas siurbimas",
                            "5,006": "Defrost: Atidaromas išėjimo vožtuvas",
                            "5,007": "Defrost: Atidaromas išėjimo vožtuvas",
                            "5,008": "Defrost: Testing exit",
                            "5,009": "Defrost: Testing exit",
                            "5,010": "Defrost: Testing exit",
                            "5,011": "Defrost: Testing exit",
                            "5,012": "Defrost: Testing exit",
                            "5,013": "Defrost: Išėjimo vožtuvo uždarymas",
                            "5,014": "Defrost: Išėjimo vožtuvo uždarymas",
                            "5,015": "Defrost: Finishing",
                            "6,001": "Dujų paleidimas: Atidarykite išėjimo vožtuvą",
                            "6,002": "Dujų paleidimas: Atidarykite išėjimo vožtuvą",
                            "6,003": "Dujų paleidimas: Uždarykite išėjimo vožtuvą",
                            "6,004": "Dujų paleidimas: Uždarykite išėjimo vožtuvą",
                            "6,005": "Dujų paleidimas",
                            "7,001": "Rankinis išėjimas: Atidarykite išėjimo vožtuvą",
                            "7,002": "Rankinis išėjimas: Atidarykite išėjimo vožtuvą",
                            "7,003": "Rankinis išėjimas: Mėšlo siurbimas",
                            "7,004": "Rankinis išėjimas: Sustabdyti siurblį",
                            "7,005": "Rankinis išėjimas: Uždarykite išėjimo vožtuvą",
                            "7,006": "Rankinis išėjimas: Uždarykite išėjimo vožtuvą",
                            "7,007": "Rankinis išėjimas: Baigiamas",
                            "7,008": "Rankinis išėjimas: Baigiamas",
                            "10,001": "Paleidimas: Uždarykite vožtuvą 2",
                            "10,002": "Paleidimas: Uždarykite vožtuvą 2",
                            "10,003": "Paleidimas: Uždarykite išėjimo vožtuvą",
                            "10,004": "Paleidimas: Uždarykite išėjimo vožtuvą",
                            "10,005": "Paleidimas: Uždarykite vožtuvą 4",
                            "10,006": "Paleidimas: Uždarykite vožtuvą 4",
                            "10,007": "Paleidimas: Tikrinamas elektros ryšys",
                            "10,008": "Paleidimas: Tikrinamas elektros ryšys",
                            "10,009": "Paleidimas"

                        }
                    },
                    users: {
                        label: "Vartotojai",
                        customers: "Susieti klientai",
                        technicians: "Susieti technikai",
                        resellers: "Susieti perpardavėjai",
                    },
                    recommendations: {
                        label: "Rekomendacijos",
                    },
                    firmware: {
                        invalidFile: "Pasirinkite .hex failą",
                        uploadStarted: "Pradėtas programinės įrangos įkėlimas",
                        uploadFailed: "Programinės įrangos įkėlimas nepavyko",
                        uploading: "Įkeliama…",
                        uploadProgress: "Eiga: {{progress}}%",
                        currentVersion: "Dabartinė versija",
                    },
                    documents: {
                        label: "Dokumentai",
                        specificDocuments: "Specifiniai dokumentai",
                        specificImages: "Specifiniai paveikslėliai",
                        generalVideos: "Bendrieji vaizdo įrašai",
                        general: "Bendra dokumentacija",
                        generalDocuments: "Bendrieji dokumentai",
                        checklists: "Kontroliniai sąrašai",
                        construction: "Statybos kontrolinis sąrašas",
                        production: "Gamybos kontrolinis sąrašas",
                        upload: "Įkelti",
                        uploadSuccess: "Sėkmingai įkėlėte {{name}}",
                        deleteSuccess: "Sėkmingai ištrynėte failą: {{name}}",
                        noFilesAvailable: "Kategorijoje {{category}} nėra failų.",
                        fileSizeExceeds: "Failo dydis viršija {{size}}Mb limitą",
                        invalidImageType: "Leidžiami tik JPG ir PNG paveikslėliai",
                        chooseFileFirst: "Pirmiausia pasirinkite failą.",
                        default: "Numatytasis",
                        permits: "Leidimai",
                        plans: "Planai",
                        planning: "Planavimas",
                        certification: "Sertifikavimas",
                        regulations: "Taisyklės",
                        instructions: "Instrukcijos",
                        templates: "Šablonai"
                    },
                    warnings: {
                        "W001": "W001: Energijos suvartojimas viršija ribą per pastarąsias 24 valandas (72 kWh 10-44kW įrenginiui, 250 kWh 60-74 kW įrenginiui)",
                        "W002": "W002: Reaktoriaus temperatūra smarkiai nukrito",
                        "W003": "W003: Servisas per 48 valandas",
                        "W004": "W004: Reikia pakeisti anglies filtrą 1 variklyje",
                        "W005": "W005: Reikia pakeisti anglies filtrą 2 variklyje",
                        "W006": "W006: Dujų buferio matavimas užšalo",
                        "W007": "W007: Dujų buferio matavimo defektas",
                        "W008": "W008: Vakar nemaitintas",
                        "W009": "W009: Siurblio greitis paskutinio šėrimo metu buvo 50% didenis nei praėjusio mėnesio vidurkis",
                        "W010": "W010: H₂S vertė per didelė (>1500)",
                        "W011": "W011: Aeracija yra 60",
                        "W012": "W012: Aeracija yra mažesnė arba lygi 3",
                        "W013": "W013: Vakar efektyvumas buvo 0, o automatinis tiekimas įjungtas",
                        "W014": "W014: H₂S reaktoriaus matavimas – skirtumas viršija 400ppm",
                        "W015": "W015: Oro tiekimas labai aukštas - turėti omenyje dujų kokybę",
                        "W016": "W016: H₂S matavimas nevyko 24 valandas",
                        "W017": "W017: Per mažai maišytuvo alyvos",
                        "W018": "W018: Mažai variklio alyvos",
                        "W020": "W020: Žemas vandens slėgis",
                        "W104": "W104: H₂S vertė per didelė (>200) arba aeracija = 60 arba 3",
                        "W105": "W105: Anglies filtro apkrova per didelė",
                        "W114": "W114: Efektyvumas vakar nebuvo 0, o automatinis tiekimas išjungtas",
                    },
                    advanced: {
                        language: "LCD ekrano kalba",
                        lambdaUpperLimit: "Lambda viršutinė riba (narrow range)",
                        lambdaLowerLimit: "Lambda apatinė riba (narrow range)",
                        coolingValve: "Aušinimo vožtuvas",
                        maxPower: "Maks. galia (Duomenų bazė) Variklis 1",
                        maxPower2: "Maks. galia (Duomenų bazė) Variklis 2",
                        bioId: "Bio ID Variklis 1",
                        bioId2: "Bio ID Variklis 2",
                        currentSsrConfiguration: "Dabartinė SSR konfiguracija",
                        SSRString: "SSR eilutė",
                    },
                    sms: {
                        duringDay: "Gauti SMS žinutes dienos metu",
                        duringNight: "Gauti SMS žinutes nakties metu",
                        sendSms: "Siųsti SMS",
                        sendTestSms: "Siųsti bandomąją žinutę",
                        testSms: "Bandomoji SMS",
                        testSmsToAllSenders: "Siųsti bandomąją žinutę visiems siuntėjams (trikčių šalinimas)",
                        recipients: "Gavėjai",
                        settings: "SMS nustatymai",
                        enterMessage: "Įveskite savo žinutę čia...",
                        smsSentSuccessfully: "SMS žinutės sėkmingai išsiųstos",
                        pleaseSelectAtLeastOneRecipient: "Pasirinkite bent vieną gavėją",
                        pleaseEnterAMessage: "Įveskite žinutę",
                        failedToSendSmsMessages: "Nepavyko išsiųsti SMS žinučių",
                        smsSettingsUpdatedSuccessfully: "SMS nustatymai sėkmingai atnaujinti",
                        message: "Žinutė",
                        testNotificationToAllSenders: "Siųsti bandomąją pranešimą visiems siuntėjams (trikčių šalinimas)",
                        sendTestNotification: "Siųsti bandomąjį pranešimą",
                        testNotificationsSentSuccessfully: "Bandomieji pranešimai sėkmingai išsiųsti",
                        failedToSendTestNotifications: "Nepavyko išsiųsti bandomųjų pranešimų",
                    },
                    temperatures: {
                        label: "Temperatūros",
                        oilCoolerTemp: "Alyvos aušintuvo temperatūra",
                        biogasTempAfterReheat: "T5 Temperature After Reheating",
                        blowerOutTemp: "T2 Temperature Inlet Compressor",
                        compressorOutTemp: "T3 Temperature Outlet Compressor",
                        biogasTempAfterCool: "T4 Temperature After Cooling",
                    },
                    pressures: {
                        label: "Slėgiai",
                        biogasPressureBeforeMembrane: "P4 Pressure Inlet Membranes",
                        stage3Pressure: "P5 Pressure Membrane Stage 3",
                        pressureAfterMembrane: "P6 Pressure Outlet Membranes",
                        blowerPressure: "P1 Pressure Outlet Blower",
                        blowerPressureSetpoint: "Pressure Outlet Blower Setpoint",
                        compressorOutPressure: "P3 Pressure Outlet Compressor",
                    },
                    valves: {
                        label: "Vožtuvai",
                        valveCompressor: "Kompresoriaus vožtuvas",
                        valveMembrane: "Membranos vožtuvas",
                        valveGrid: "Tinklo vožtuvas",
                        valveCo2: "CO2 vožtuvas",
                    },
                    system: {
                        label: "Sistema",
                        installationState: "Įrenginio būsena",
                        geuAvailable: "GEU prieinamas",
                        geuAlarm: "GEU aliarmas",
                        geuDelivering: "GEU tiekia",
                        gasTotalGeu: "Dujų kiekis GEU",
                        gasTotalInternGeu: "Vidinis GEU dujų kiekis",
                        biogasTotalizer: "Biodujų skaitiklis",
                        biomethaneDewpoint: "Biometano rasos taškas",
                        compressorSpeed: "Kompresoriaus greitis",
                    },
                    filters: {
                        label: "Filtrai",
                        inletFilterPressuredrop: "Įleidimo filtro slėgio kritimas",
                        filterTrainPressuredrop: "Filtrų grandinės slėgio kritimas",
                        oilFilterPressuredrop: "Alyvos filtro slėgio kritimas",
                    },
                }
            }
        }
    });

export default i18n;